(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["CLSP"] = factory();
	else
		root["CLSP"] = factory();
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 909:
/***/ ((module) => {

"use strict";


/* eslint no-console: off */

/**
 * This file needs to use `require` rather than `import` to be able to be used
 * by webpack.
 *
 * We use this in the router as well, so keep it light and ES5 only!
 */
module.exports = function (version, logLevel, disableLogging) {
  function Logger(prefix, prefixStyle) {
    if (logLevel === undefined && typeof window !== 'undefined') {
      var storedVersion = window.localStorage.getItem('skylineos.clsp-player.version');

      // Always reset the log level when the version changes
      if (storedVersion !== version) {
        window.localStorage.setItem('skylineos.clsp-player.logLevel', 0);
        window.localStorage.setItem('skylineos.clsp-player.version', version);
      }
      var storedLogLevel = Number(window.localStorage.getItem('skylineos.clsp-player.logLevel'));

      // The logLevel may be set in localstorage
      // e.g. localStorage.setItem('skylineos.clsp-player.logLevel', 3), then refresh
      logLevel = isNaN(storedLogLevel) || storedLogLevel < 0 ? 0 : storedLogLevel;
      window.localStorage.setItem('skylineos.clsp-player.logLevel', logLevel);
    }
    this.logLevel = logLevel;
    this.prefix = prefix;
    this.prefixStyle = prefixStyle;
  }
  Logger.logLevels = ['critical', 'error', 'warn', 'info', 'debug', 'silly'];
  Logger.factory = function (prefix, prefixStyle) {
    return new Logger(prefix || '', prefixStyle);
  };
  Logger.prototype._constructMessage = function (type, message) {
    var logMessage = '(' + type + ')' + ' --> ' + message;

    // @see - https://developers.google.com/web/tools/chrome-devtools/console/console-write#string_substitution_and_formatting
    if (this.prefix && this.prefixStyle && this.logLevel > 1) {
      return ['%c' + this.prefix, this.prefixStyle, logMessage];
    }
    if (this.prefix) {
      return [this.prefix, logMessage];
    }
    return [logMessage];
  };
  var sillyIndex = 5;
  var debugIndex = 4;
  var infoIndex = 3;
  var warnIndex = 2;
  var errorIndex = 1;
  var criticalIndex = 0;
  Logger.prototype.silly = function (message) {
    if (this.logLevel < sillyIndex || disableLogging) {
      return;
    }
    console.log.apply(console, this._constructMessage(Logger.logLevels[sillyIndex], message));
  };
  Logger.prototype.debug = function (message) {
    if (this.logLevel < debugIndex || disableLogging) {
      return;
    }
    console.log.apply(console, this._constructMessage(Logger.logLevels[debugIndex], message));
  };
  Logger.prototype.info = function (message) {
    if (this.logLevel < infoIndex || disableLogging) {
      return;
    }
    console.log.apply(console, this._constructMessage(Logger.logLevels[infoIndex], message));
  };
  Logger.prototype.warn = function (message) {
    if (this.logLevel < warnIndex || disableLogging) {
      return;
    }
    console.warn.apply(console, this._constructMessage(Logger.logLevels[warnIndex], message));
  };
  Logger.prototype.error = function (message) {
    if (this.logLevel < errorIndex || disableLogging) {
      return;
    }
    console.error.apply(console, this._constructMessage(Logger.logLevels[errorIndex], message));
  };
  Logger.prototype.critical = function (message) {
    if (disableLogging) {
      return;
    }
    console.error.apply(console, this._constructMessage(Logger.logLevels[criticalIndex], message));
  };
  return Logger;
};

/***/ }),

/***/ 8192:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/**
 * This file needs to use `require` rather than `import` to be able to be used
 * by webpack.
 */
var _indexOfInstanceProperty = __webpack_require__(4007);
var _parseInt = __webpack_require__(6586);
var packageJson = __webpack_require__(8330);
var Logger = __webpack_require__(909);
var _isPlayerLoggingEnabled = true;

// CLSP default port for SFS >= 5.2.0 is 80
// CLSP default port for SFS < 5.2.0 is 9001
var DEFAULT_CLSP_PORT = 80;
var DEFAULT_CLSPS_PORT = 443;

// Locally-scoped value that maintains the clsp and clsps port states.
//
// @see - getDefaultStreamPort
// @see - setDefaultStreamPort
//
// @todo - state / config could be managed better than this
var streamPorts = {
  clsp: DEFAULT_CLSP_PORT,
  clsps: DEFAULT_CLSPS_PORT
};

/**
 * The name of the CLSP Player library as defined in `package.json` without the
 * group name.
 *
 * @type {String}
 */
var name = packageJson.name.split('/').pop();

/**
 * The version of the CLSP Player library.  Follows semver.
 *
 * @type {String}
 */
var version = packageJson.version;

// @todo - remove this side-effect
var logger = Logger(version).factory();

/**
 * The oldest Chrome browser version supported by CLSP Player.
 *
 * @type {Number}
 */
var MINIMUM_CHROME_VERSION = 53;

/**
 * The MIME type required for CLSP Player to be able to play the stream.
 *
 * @todo - this mime type, though used in the videojs plugin, and
 * seemingly enforced, is not actually enforced.  The only enforcement
 * done is requiring the user provide this string on the video element
 * in the DOM.  The codecs that are supplied by the SFS's vary.  Here
 * are some "valid", though not enforced mimeCodec values I have come
 * across:
 * - video/mp4; codecs="avc1.4DE016"
 * - video/mp4; codecs="avc1.42E00C"
 * - video/mp4; codecs="avc1.42E00D"
 *
 * @type {String}
 */
var SUPPORTED_MIME_TYPE = "video/mp4; codecs='avc1.42E01E'";

/**
 * The amount of time (in seconds) before a stream times out.
 *
 * Note that this timeout value should be treated as the minimum value to
 * support Vero tours and high-quality streams.
 *
 * @type {Number}
 */
var DEFAULT_STREAM_TIMEOUT = 20;

/**
 * Determine whether or not the CLSP Player is supported in the current browser.
 *
 * @todo - we are currently manually checking useragentstring - we should find a
 *   library that can check browser type for us
 *
 * @returns {Boolean}
 *   `true` if the browser is supported by CLSP Player
 *   `false` if the browser is not supported by CLSP Player
 */
function isBrowserCompatable() {
  var _context, _context2, _context3;
  // @todo - at one time, this was needed for browsers on MacOS - is this still
  // necessary?
  window.MediaSource = window.MediaSource || window.WebKitMediaSource;
  if (!window.MediaSource) {
    console.error('Media Source Extensions not supported in your browser, unable to load CLSP Player');
    return false;
  }
  var isInternetExplorer = _indexOfInstanceProperty(_context = navigator.userAgent.toLowerCase()).call(_context, 'trident') > -1;
  if (isInternetExplorer) {
    logger.debug('Detected Internet Explorer browser, which is not supported.');
    return false;
  }
  var isEdge = _indexOfInstanceProperty(_context2 = navigator.userAgent.toLowerCase()).call(_context2, 'edge') > -1;
  if (isEdge) {
    logger.debug('Detected older Edge browser, which is not supported');
    return false;
  }
  var isFirefox = _indexOfInstanceProperty(_context3 = navigator.userAgent.toLowerCase()).call(_context3, 'firefox') > -1;
  if (isFirefox) {
    logger.debug('Detected Firefox browser');
    return true;
  }

  // Most browsers have "Chrome" in their user agent.  The above filters rule
  // out Internet Explorer and Edge, so we are going to assume that if we're at
  // this point, we're really dealing with Chrome.
  var isChrome = Boolean(window.chrome);
  if (!isChrome) {
    return false;
  }
  try {
    // Rather than accounting for match returning null, we'll catch the error
    var chromeVersion = _parseInt(navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)[2], 10);
    logger.debug("Detected Chrome version ".concat(chromeVersion));
    return chromeVersion >= MINIMUM_CHROME_VERSION;
  } catch (error) {
    logger.critical('Unable to detect Chrome version');
    logger.critical(error);
    return false;
  }
}

/**
 * Check to see if the passed mimeType is supported by CLSP Player.
 *
 * @param {String} mimeType
 *   Will check to see if this mimeType is supported
 *
 * @returns {Boolean}
 *   `true` if the mimeType is supported by CLSP Player
 *   `false` if the mimeType is not supported by CLSP Player
 */
function isSupportedMimeType(mimeType) {
  return mimeType === SUPPORTED_MIME_TYPE;
}

/**
 * @typedef {Object} PageVisibilityApiPropertyNames
 * @property {String} hiddenStateName
 *   The property name used for the `document.hidden` property
 * @property {String} visibilityChangeEventName
 *   The property name used for the `document.visibilityChange` event name
 */

/**
 * Get the property names used by this browser for the Page Visibility API.
 *
 * @returns {PageVisibilityApiPropertyNames}
 */
function getWindowStateNames() {
  logger.debug('Determining Page_Visibility_API property names.');

  // @todo - this check is needed to support these utils being imported by
  // webpack.  there is probably a more elegant way to handle this scenario.
  if (typeof document === 'undefined') {
    return {
      hiddenStateName: '',
      visibilityChangeEventName: ''
    };
  }

  // @see - https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
  if (typeof document.hidden !== 'undefined') {
    logger.debug('Using standard Page_Visibility_API property names.');
    return {
      hiddenStateName: 'hidden',
      visibilityChangeEventName: 'visibilitychange'
    };
  }

  // @todo - do we need this since we don't support IE or old Edge?
  if (typeof document.msHidden !== 'undefined') {
    logger.debug('Using Microsoft Page_Visibility_API property names.');
    return {
      hiddenStateName: 'msHidden',
      visibilityChangeEventName: 'msvisibilitychange'
    };
  }
  if (typeof document.webkitHidden !== 'undefined') {
    logger.debug('Using Webkit Page_Visibility_API property names.');
    return {
      hiddenStateName: 'webkitHidden',
      visibilityChangeEventName: 'webkitvisibilitychange'
    };
  }
  logger.critical('Unable to use the page visibility api - switching tabs and minimizing the page may result in slow downs and page crashes.');
  return {
    hiddenStateName: '',
    visibilityChangeEventName: ''
  };
}

/**
 * Get the default port number for the given protocol.
 *
 * @param {String} protocol
 *   The protocol to get the default port for.  Must be a known protocol (e.g.
 *   `clsp` or `clsps`)
 */
function getDefaultStreamPort(protocol) {
  return streamPorts[protocol];
}

/**
 * Set the default port number for the given protocol.
 *
 * @param {String} protocol
 *   The protocol to set the default port for.  Must be a known protocol (e.g.
 *   `clsp` or `clsps`)
 */
function setDefaultStreamPort(protocol, port) {
  streamPorts[protocol] = port;
}
function enablePlayerLogging() {
  _isPlayerLoggingEnabled = true;
}
function disablePlayerLogging() {
  _isPlayerLoggingEnabled = false;
}
function isPlayerLoggingDisabled() {
  return !_isPlayerLoggingEnabled;
}
var windowStateNames = getWindowStateNames();
function isDocumentHidden() {
  return document[windowStateNames.hiddenStateName];
}
function isOnline() {
  return window.navigator.onLine;
}
module.exports = {
  name: name,
  version: version,
  MINIMUM_CHROME_VERSION: MINIMUM_CHROME_VERSION,
  SUPPORTED_MIME_TYPE: SUPPORTED_MIME_TYPE,
  DEFAULT_STREAM_TIMEOUT: DEFAULT_STREAM_TIMEOUT,
  supported: isBrowserCompatable,
  isSupportedMimeType: isSupportedMimeType,
  windowStateNames: windowStateNames,
  isDocumentHidden: isDocumentHidden,
  isOnline: isOnline,
  getDefaultStreamPort: getDefaultStreamPort,
  setDefaultStreamPort: setDefaultStreamPort,
  enablePlayerLogging: enablePlayerLogging,
  disablePlayerLogging: disablePlayerLogging,
  isPlayerLoggingDisabled: isPlayerLoggingDisabled
};

/***/ }),

/***/ 228:
/***/ ((module) => {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ 2973:
/***/ ((module) => {

/**
 * @param {*} val - value to check
 * 
 * @returns {boolean} true if the value is then-able
 */
function isPromise(val) {
    return val != null && typeof val.then === 'function'
}

/**
 * @param {function} func - function to execute
 * @param {number|function(number):number} intervalLength - length in ms to wait before executing again
 * @param {{iterations: Infinity|number, stopOnError: boolean}} [options]
 * 
 * @returns {Promise} Promise object with no result
 */
function interval(func, intervalLength, options = {}) {    

    validateArgs(func, intervalLength, options)

    const defaults = {
        iterations: Infinity,
        stopOnError: true
    }
    const settings = Object.assign(defaults, options)

    return new Promise((rootPromiseResolve, rootPromiseReject) => {

        const callFunction = currentIteration => {
            
            // Set up a way to track if a "stop" was requested by the user function
            let stopRequested = false
            const stop = () => {
                stopRequested = true
            }
        
            // Set up a function to call the next iteration. This is abstracted so it can be called by .then(), or in .catch(), if options allow.
            const callNext = () => {
                // If we've hit the desired number of iterations, or stop was called, resolve the root promise and return
                if (currentIteration === settings.iterations || stopRequested) {
                    rootPromiseResolve()
                    return
                }
        
                // Otherwise, call the next iteration
                callFunction(currentIteration + 1)
            }

            // Calculate our interval length
            const calculatedIntervalLength = (typeof intervalLength === 'function') ? intervalLength(currentIteration) : intervalLength
            
            // If the interval length was calculated, validate the result
            if (typeof intervalLength === 'function') {
                if (!Number.isInteger(calculatedIntervalLength) || calculatedIntervalLength < 0) {
                    rootPromiseReject(new Error('Function for "intervalLength" argument must return a non-negative integer.'))
                    return 
                }
            }
                
            // Call the user function after the desired interval length. After, call the next iteration (and/or handle error)
            setTimeout(() => {

                const returnVal = func(currentIteration, stop)
                
                // Ensure that the value returned is a promise
                if (!isPromise(returnVal)) {
                    rootPromiseReject(new Error('Return value of "func" must be a Promise.'))
                    return
                }

                returnVal.then(callNext).catch(err => {
                    if (!settings.stopOnError) {
                        callNext()
                        return
                    }
        
                    rootPromiseReject(err)
                })
            }, calculatedIntervalLength)
        }

        callFunction(1)        
    })
}

/**
 * A helper function to validate the arguments passed to interval(...)
 * 
 * @param {*} func 
 * @param {*} intervalLength 
 * @param {*} options
 */
function validateArgs(func, intervalLength, options) {

    // Validate "func"
    if (typeof func !== 'function') {
        throw new TypeError('Argument 1, "func", must be a function.')
    }

    // Validate "intervalLength"
    if (typeof intervalLength === 'number') {
        if (!Number.isInteger(intervalLength) || intervalLength < 0) {
            throw new TypeError('Argument 2, "intervalLength", must be a non-negative integer or a function that returns a non-negative integer.')
        }
    } else if (typeof intervalLength !== 'function') {
        throw new TypeError('Argument 2, "intervalLength", must be a non-negative integer or a function that returns a non-negative integer.')
    }

    // Validate options...
    if (typeof options !== 'object') {
        throw new TypeError('Argument 3, "options", must be an object.')
    }

    // Validate passed keys
    const allowedKeys = ['iterations', 'stopOnError']

    Object.keys(options).forEach(key => {
        if (!allowedKeys.includes(key)) {
            throw new TypeError('Option "' + key + '" is not a valid option.')
        }
    })
    
    // validate "iterations" option (if passed)
    if (typeof options.iterations !== 'undefined') {
        if (options.iterations !== Infinity && (!Number.isInteger(options.iterations) || options.iterations < 1)) {
            throw new TypeError('Option "iterations" must be Infinity or an integer greater than 0.')
        }
    }
    
    // validate "stopOnError" option (if passed)
    if (typeof options.stopOnError !== 'undefined') {
        if (typeof options.stopOnError !== 'boolean') {
            throw new TypeError('Option "stopOnError" must be a boolean.')
        }
    }
}

module.exports = interval


/***/ }),

/***/ 9843:
/***/ ((module) => {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ 7924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*******************************************************************************
 * Copyright (c) 2013 IBM Corp.
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License v1.0
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *    http://www.eclipse.org/legal/epl-v10.html
 * and the Eclipse Distribution License is available at
 *   http://www.eclipse.org/org/documents/edl-v10.php.
 *
 * Contributors:
 *    Andrew Banks - initial API and implementation and initial documentation
 *******************************************************************************/


// Only expose a single object name in the global namespace.
// Everything must go through this module. Global Paho module
// only has a single public function, client, which returns
// a Paho client object given connection details.

/**
 * Send and receive messages using web browsers.
 * <p>
 * This programming interface lets a JavaScript client application use the MQTT V3.1 or
 * V3.1.1 protocol to connect to an MQTT-supporting messaging server.
 *
 * The function supported includes:
 * <ol>
 * <li>Connecting to and disconnecting from a server. The server is identified by its host name and port number.
 * <li>Specifying options that relate to the communications link with the server,
 * for example the frequency of keep-alive heartbeats, and whether SSL/TLS is required.
 * <li>Subscribing to and receiving messages from MQTT Topics.
 * <li>Publishing messages to MQTT Topics.
 * </ol>
 * <p>
 * The API consists of two main objects:
 * <dl>
 * <dt><b>{@link Paho.Client}</b></dt>
 * <dd>This contains methods that provide the functionality of the API,
 * including provision of callbacks that notify the application when a message
 * arrives from or is delivered to the messaging server,
 * or when the status of its connection to the messaging server changes.</dd>
 * <dt><b>{@link Paho.Message}</b></dt>
 * <dd>This encapsulates the payload of the message along with various attributes
 * associated with its delivery, in particular the destination to which it has
 * been (or is about to be) sent.</dd>
 * </dl>
 * <p>
 * The programming interface validates parameters passed to it, and will throw
 * an Error containing an error message intended for developer use, if it detects
 * an error with any parameter.
 * <p>
 * Example:
 *
 * <code><pre>
var client = new Paho.MQTT.Client(location.hostname, Number(location.port), "clientId");
client.onConnectionLost = onConnectionLost;
client.onMessageArrived = onMessageArrived;
client.connect({onSuccess:onConnect});

function onConnect() {
  // Once a connection has been made, make a subscription and send a message.
  console.log("onConnect");
  client.subscribe("/World");
  var message = new Paho.MQTT.Message("Hello");
  message.destinationName = "/World";
  client.send(message);
};
function onConnectionLost(responseObject) {
  if (responseObject.errorCode !== 0)
	console.log("onConnectionLost:"+responseObject.errorMessage);
};
function onMessageArrived(message) {
  console.log("onMessageArrived:"+message.payloadString);
  client.disconnect();
};
 * </pre></code>
 * @namespace Paho
 */

/* jshint shadow:true */
(function ExportLibrary(root, factory) {
	if(true){
		module.exports = factory();
	} else {}
})(this, function LibraryFactory(){


	var PahoMQTT = (function (global) {

	// Private variables below, these are only visible inside the function closure
	// which is used to define the module.
	var version = "@VERSION@-@BUILDLEVEL@";

	/**
	 * @private
	 */
	var localStorage = global.localStorage || (function () {
		var data = {};

		return {
			setItem: function (key, item) { data[key] = item; },
			getItem: function (key) { return data[key]; },
			removeItem: function (key) { delete data[key]; },
		};
	})();

		/**
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private
	 */
		var MESSAGE_TYPE = {
			CONNECT: 1,
			CONNACK: 2,
			PUBLISH: 3,
			PUBACK: 4,
			PUBREC: 5,
			PUBREL: 6,
			PUBCOMP: 7,
			SUBSCRIBE: 8,
			SUBACK: 9,
			UNSUBSCRIBE: 10,
			UNSUBACK: 11,
			PINGREQ: 12,
			PINGRESP: 13,
			DISCONNECT: 14
		};

		// Collection of utility methods used to simplify module code
		// and promote the DRY pattern.

		/**
	 * Validate an object's parameter names to ensure they
	 * match a list of expected variables name for this option
	 * type. Used to ensure option object passed into the API don't
	 * contain erroneous parameters.
	 * @param {Object} obj - User options object
	 * @param {Object} keys - valid keys and types that may exist in obj.
	 * @throws {Error} Invalid option parameter found.
	 * @private
	 */
		var validate = function(obj, keys) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					if (keys.hasOwnProperty(key)) {
						if (typeof obj[key] !== keys[key])
							throw new Error(format(ERROR.INVALID_TYPE, [typeof obj[key], key]));
					} else {
						var errorStr = "Unknown property, " + key + ". Valid properties are:";
						for (var validKey in keys)
							if (keys.hasOwnProperty(validKey))
								errorStr = errorStr+" "+validKey;
						throw new Error(errorStr);
					}
				}
			}
		};

		/**
	 * Return a new function which runs the user function bound
	 * to a fixed scope.
	 * @param {function} User function
	 * @param {object} Function scope
	 * @return {function} User function bound to another scope
	 * @private
	 */
		var scope = function (f, scope) {
			return function () {
				return f.apply(scope, arguments);
			};
		};

		/**
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private
	 */
		var ERROR = {
			OK: {code:0, text:"AMQJSC0000I OK."},
			CONNECT_TIMEOUT: {code:1, text:"AMQJSC0001E Connect timed out."},
			SUBSCRIBE_TIMEOUT: {code:2, text:"AMQJS0002E Subscribe timed out."},
			UNSUBSCRIBE_TIMEOUT: {code:3, text:"AMQJS0003E Unsubscribe timed out."},
			PING_TIMEOUT: {code:4, text:"AMQJS0004E Ping timed out."},
			INTERNAL_ERROR: {code:5, text:"AMQJS0005E Internal error. Error Message: {0}, Stack trace: {1}"},
			CONNACK_RETURNCODE: {code:6, text:"AMQJS0006E Bad Connack return code:{0} {1}."},
			SOCKET_ERROR: {code:7, text:"AMQJS0007E Socket error:{0}."},
			SOCKET_CLOSE: {code:8, text:"AMQJS0008I Socket closed."},
			MALFORMED_UTF: {code:9, text:"AMQJS0009E Malformed UTF data:{0} {1} {2}."},
			UNSUPPORTED: {code:10, text:"AMQJS0010E {0} is not supported by this browser."},
			INVALID_STATE: {code:11, text:"AMQJS0011E Invalid state {0}."},
			INVALID_TYPE: {code:12, text:"AMQJS0012E Invalid type {0} for {1}."},
			INVALID_ARGUMENT: {code:13, text:"AMQJS0013E Invalid argument {0} for {1}."},
			UNSUPPORTED_OPERATION: {code:14, text:"AMQJS0014E Unsupported operation."},
			INVALID_STORED_DATA: {code:15, text:"AMQJS0015E Invalid data in local storage key={0} value={1}."},
			INVALID_MQTT_MESSAGE_TYPE: {code:16, text:"AMQJS0016E Invalid MQTT message type {0}."},
			MALFORMED_UNICODE: {code:17, text:"AMQJS0017E Malformed Unicode string:{0} {1}."},
			BUFFER_FULL: {code:18, text:"AMQJS0018E Message buffer is full, maximum buffer size: {0}."},
		};

		/** CONNACK RC Meaning. */
		var CONNACK_RC = {
			0:"Connection Accepted",
			1:"Connection Refused: unacceptable protocol version",
			2:"Connection Refused: identifier rejected",
			3:"Connection Refused: server unavailable",
			4:"Connection Refused: bad user name or password",
			5:"Connection Refused: not authorized"
		};

	/**
	 * Format an error message text.
	 * @private
	 * @param {error} ERROR value above.
	 * @param {substitutions} [array] substituted into the text.
	 * @return the text with the substitutions made.
	 */
		var format = function(error, substitutions) {
			var text = error.text;
			if (substitutions) {
				var field,start;
				for (var i=0; i<substitutions.length; i++) {
					field = "{"+i+"}";
					start = text.indexOf(field);
					if(start > 0) {
						var part1 = text.substring(0,start);
						var part2 = text.substring(start+field.length);
						text = part1+substitutions[i]+part2;
					}
				}
			}
			return text;
		};

		//MQTT protocol and version          6    M    Q    I    s    d    p    3
		var MqttProtoIdentifierv3 = [0x00,0x06,0x4d,0x51,0x49,0x73,0x64,0x70,0x03];
		//MQTT proto/version for 311         4    M    Q    T    T    4
		var MqttProtoIdentifierv4 = [0x00,0x04,0x4d,0x51,0x54,0x54,0x04];

		/**
	 * Construct an MQTT wire protocol message.
	 * @param type MQTT packet type.
	 * @param options optional wire message attributes.
	 *
	 * Optional properties
	 *
	 * messageIdentifier: message ID in the range [0..65535]
	 * payloadMessage:	Application Message - PUBLISH only
	 * connectStrings:	array of 0 or more Strings to be put into the CONNECT payload
	 * topics:			array of strings (SUBSCRIBE, UNSUBSCRIBE)
	 * requestQoS:		array of QoS values [0..2]
	 *
	 * "Flag" properties
	 * cleanSession:	true if present / false if absent (CONNECT)
	 * willMessage:  	true if present / false if absent (CONNECT)
	 * isRetained:		true if present / false if absent (CONNECT)
	 * userName:		true if present / false if absent (CONNECT)
	 * password:		true if present / false if absent (CONNECT)
	 * keepAliveInterval:	integer [0..65535]  (CONNECT)
	 *
	 * @private
	 * @ignore
	 */
		var WireMessage = function (type, options) {
			this.type = type;
			for (var name in options) {
				if (options.hasOwnProperty(name)) {
					this[name] = options[name];
				}
			}
		};

		WireMessage.prototype.encode = function() {
		// Compute the first byte of the fixed header
			var first = ((this.type & 0x0f) << 4);

			/*
		 * Now calculate the length of the variable header + payload by adding up the lengths
		 * of all the component parts
		 */

			var remLength = 0;
			var topicStrLength = [];
			var destinationNameLength = 0;
			var willMessagePayloadBytes;

			// if the message contains a messageIdentifier then we need two bytes for that
			if (this.messageIdentifier !== undefined)
				remLength += 2;

			switch(this.type) {
			// If this a Connect then we need to include 12 bytes for its header
			case MESSAGE_TYPE.CONNECT:
				switch(this.mqttVersion) {
				case 3:
					remLength += MqttProtoIdentifierv3.length + 3;
					break;
				case 4:
					remLength += MqttProtoIdentifierv4.length + 3;
					break;
				}

				remLength += UTF8Length(this.clientId) + 2;
				if (this.willMessage !== undefined) {
					remLength += UTF8Length(this.willMessage.destinationName) + 2;
					// Will message is always a string, sent as UTF-8 characters with a preceding length.
					willMessagePayloadBytes = this.willMessage.payloadBytes;
					if (!(willMessagePayloadBytes instanceof Uint8Array))
						willMessagePayloadBytes = new Uint8Array(payloadBytes);
					remLength += willMessagePayloadBytes.byteLength +2;
				}
				if (this.userName !== undefined)
					remLength += UTF8Length(this.userName) + 2;
				if (this.password !== undefined)
					remLength += UTF8Length(this.password) + 2;
				break;

			// Subscribe, Unsubscribe can both contain topic strings
			case MESSAGE_TYPE.SUBSCRIBE:
				first |= 0x02; // Qos = 1;
				for ( var i = 0; i < this.topics.length; i++) {
					topicStrLength[i] = UTF8Length(this.topics[i]);
					remLength += topicStrLength[i] + 2;
				}
				remLength += this.requestedQos.length; // 1 byte for each topic's Qos
				// QoS on Subscribe only
				break;

			case MESSAGE_TYPE.UNSUBSCRIBE:
				first |= 0x02; // Qos = 1;
				for ( var i = 0; i < this.topics.length; i++) {
					topicStrLength[i] = UTF8Length(this.topics[i]);
					remLength += topicStrLength[i] + 2;
				}
				break;

			case MESSAGE_TYPE.PUBREL:
				first |= 0x02; // Qos = 1;
				break;

			case MESSAGE_TYPE.PUBLISH:
				if (this.payloadMessage.duplicate) first |= 0x08;
				first  = first |= (this.payloadMessage.qos << 1);
				if (this.payloadMessage.retained) first |= 0x01;
				destinationNameLength = UTF8Length(this.payloadMessage.destinationName);
				remLength += destinationNameLength + 2;
				var payloadBytes = this.payloadMessage.payloadBytes;
				remLength += payloadBytes.byteLength;
				if (payloadBytes instanceof ArrayBuffer)
					payloadBytes = new Uint8Array(payloadBytes);
				else if (!(payloadBytes instanceof Uint8Array))
					payloadBytes = new Uint8Array(payloadBytes.buffer);
				break;

			case MESSAGE_TYPE.DISCONNECT:
				break;

			default:
				break;
			}

			// Now we can allocate a buffer for the message

			var mbi = encodeMBI(remLength);  // Convert the length to MQTT MBI format
			var pos = mbi.length + 1;        // Offset of start of variable header
			var buffer = new ArrayBuffer(remLength + pos);
			var byteStream = new Uint8Array(buffer);    // view it as a sequence of bytes

			//Write the fixed header into the buffer
			byteStream[0] = first;
			byteStream.set(mbi,1);

			// If this is a PUBLISH then the variable header starts with a topic
			if (this.type == MESSAGE_TYPE.PUBLISH)
				pos = writeString(this.payloadMessage.destinationName, destinationNameLength, byteStream, pos);
			// If this is a CONNECT then the variable header contains the protocol name/version, flags and keepalive time

			else if (this.type == MESSAGE_TYPE.CONNECT) {
				switch (this.mqttVersion) {
				case 3:
					byteStream.set(MqttProtoIdentifierv3, pos);
					pos += MqttProtoIdentifierv3.length;
					break;
				case 4:
					byteStream.set(MqttProtoIdentifierv4, pos);
					pos += MqttProtoIdentifierv4.length;
					break;
				}
				var connectFlags = 0;
				if (this.cleanSession)
					connectFlags = 0x02;
				if (this.willMessage !== undefined ) {
					connectFlags |= 0x04;
					connectFlags |= (this.willMessage.qos<<3);
					if (this.willMessage.retained) {
						connectFlags |= 0x20;
					}
				}
				if (this.userName !== undefined)
					connectFlags |= 0x80;
				if (this.password !== undefined)
					connectFlags |= 0x40;
				byteStream[pos++] = connectFlags;
				pos = writeUint16 (this.keepAliveInterval, byteStream, pos);
			}

			// Output the messageIdentifier - if there is one
			if (this.messageIdentifier !== undefined)
				pos = writeUint16 (this.messageIdentifier, byteStream, pos);

			switch(this.type) {
			case MESSAGE_TYPE.CONNECT:
				pos = writeString(this.clientId, UTF8Length(this.clientId), byteStream, pos);
				if (this.willMessage !== undefined) {
					pos = writeString(this.willMessage.destinationName, UTF8Length(this.willMessage.destinationName), byteStream, pos);
					pos = writeUint16(willMessagePayloadBytes.byteLength, byteStream, pos);
					byteStream.set(willMessagePayloadBytes, pos);
					pos += willMessagePayloadBytes.byteLength;

				}
				if (this.userName !== undefined)
					pos = writeString(this.userName, UTF8Length(this.userName), byteStream, pos);
				if (this.password !== undefined)
					pos = writeString(this.password, UTF8Length(this.password), byteStream, pos);
				break;

			case MESSAGE_TYPE.PUBLISH:
				// PUBLISH has a text or binary payload, if text do not add a 2 byte length field, just the UTF characters.
				byteStream.set(payloadBytes, pos);

				break;

				//    	    case MESSAGE_TYPE.PUBREC:
				//    	    case MESSAGE_TYPE.PUBREL:
				//    	    case MESSAGE_TYPE.PUBCOMP:
				//    	    	break;

			case MESSAGE_TYPE.SUBSCRIBE:
				// SUBSCRIBE has a list of topic strings and request QoS
				for (var i=0; i<this.topics.length; i++) {
					pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
					byteStream[pos++] = this.requestedQos[i];
				}
				break;

			case MESSAGE_TYPE.UNSUBSCRIBE:
				// UNSUBSCRIBE has a list of topic strings
				for (var i=0; i<this.topics.length; i++)
					pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
				break;

			default:
				// Do nothing.
			}

			return buffer;
		};

		function decodeMessage(input,pos) {
			var startingPos = pos;
			var first = input[pos];
			var type = first >> 4;
			var messageInfo = first &= 0x0f;
			pos += 1;


			// Decode the remaining length (MBI format)

			var digit;
			var remLength = 0;
			var multiplier = 1;
			do {
				if (pos == input.length) {
					return [null,startingPos];
				}
				digit = input[pos++];
				remLength += ((digit & 0x7F) * multiplier);
				multiplier *= 128;
			} while ((digit & 0x80) !== 0);

			var endPos = pos+remLength;
			if (endPos > input.length) {
				return [null,startingPos];
			}

			var wireMessage = new WireMessage(type);
			switch(type) {
			case MESSAGE_TYPE.CONNACK:
				var connectAcknowledgeFlags = input[pos++];
				if (connectAcknowledgeFlags & 0x01)
					wireMessage.sessionPresent = true;
				wireMessage.returnCode = input[pos++];
				break;

			case MESSAGE_TYPE.PUBLISH:
				var qos = (messageInfo >> 1) & 0x03;

				var len = readUint16(input, pos);
				pos += 2;
				var topicName = parseUTF8(input, pos, len);
				pos += len;
				// If QoS 1 or 2 there will be a messageIdentifier
				if (qos > 0) {
					wireMessage.messageIdentifier = readUint16(input, pos);
					pos += 2;
				}

				var message = new Message(input.subarray(pos, endPos));
				if ((messageInfo & 0x01) == 0x01)
					message.retained = true;
				if ((messageInfo & 0x08) == 0x08)
					message.duplicate =  true;
				message.qos = qos;
				message.destinationName = topicName;
				wireMessage.payloadMessage = message;
				break;

			case  MESSAGE_TYPE.PUBACK:
			case  MESSAGE_TYPE.PUBREC:
			case  MESSAGE_TYPE.PUBREL:
			case  MESSAGE_TYPE.PUBCOMP:
			case  MESSAGE_TYPE.UNSUBACK:
				wireMessage.messageIdentifier = readUint16(input, pos);
				break;

			case  MESSAGE_TYPE.SUBACK:
				wireMessage.messageIdentifier = readUint16(input, pos);
				pos += 2;
				wireMessage.returnCode = input.subarray(pos, endPos);
				break;

			default:
				break;
			}

			return [wireMessage,endPos];
		}

		function writeUint16(input, buffer, offset) {
			buffer[offset++] = input >> 8;      //MSB
			buffer[offset++] = input % 256;     //LSB
			return offset;
		}

		function writeString(input, utf8Length, buffer, offset) {
			offset = writeUint16(utf8Length, buffer, offset);
			stringToUTF8(input, buffer, offset);
			return offset + utf8Length;
		}

		function readUint16(buffer, offset) {
			return 256*buffer[offset] + buffer[offset+1];
		}

		/**
	 * Encodes an MQTT Multi-Byte Integer
	 * @private
	 */
		function encodeMBI(number) {
			var output = new Array(1);
			var numBytes = 0;

			do {
				var digit = number % 128;
				number = number >> 7;
				if (number > 0) {
					digit |= 0x80;
				}
				output[numBytes++] = digit;
			} while ( (number > 0) && (numBytes<4) );

			return output;
		}

		/**
	 * Takes a String and calculates its length in bytes when encoded in UTF8.
	 * @private
	 */
		function UTF8Length(input) {
			var output = 0;
			for (var i = 0; i<input.length; i++)
			{
				var charCode = input.charCodeAt(i);
				if (charCode > 0x7FF)
				{
					// Surrogate pair means its a 4 byte character
					if (0xD800 <= charCode && charCode <= 0xDBFF)
					{
						i++;
						output++;
					}
					output +=3;
				}
				else if (charCode > 0x7F)
					output +=2;
				else
					output++;
			}
			return output;
		}

		/**
	 * Takes a String and writes it into an array as UTF8 encoded bytes.
	 * @private
	 */
		function stringToUTF8(input, output, start) {
			var pos = start;
			for (var i = 0; i<input.length; i++) {
				var charCode = input.charCodeAt(i);

				// Check for a surrogate pair.
				if (0xD800 <= charCode && charCode <= 0xDBFF) {
					var lowCharCode = input.charCodeAt(++i);
					if (isNaN(lowCharCode)) {
						throw new Error(format(ERROR.MALFORMED_UNICODE, [charCode, lowCharCode]));
					}
					charCode = ((charCode - 0xD800)<<10) + (lowCharCode - 0xDC00) + 0x10000;

				}

				if (charCode <= 0x7F) {
					output[pos++] = charCode;
				} else if (charCode <= 0x7FF) {
					output[pos++] = charCode>>6  & 0x1F | 0xC0;
					output[pos++] = charCode     & 0x3F | 0x80;
				} else if (charCode <= 0xFFFF) {
					output[pos++] = charCode>>12 & 0x0F | 0xE0;
					output[pos++] = charCode>>6  & 0x3F | 0x80;
					output[pos++] = charCode     & 0x3F | 0x80;
				} else {
					output[pos++] = charCode>>18 & 0x07 | 0xF0;
					output[pos++] = charCode>>12 & 0x3F | 0x80;
					output[pos++] = charCode>>6  & 0x3F | 0x80;
					output[pos++] = charCode     & 0x3F | 0x80;
				}
			}
			return output;
		}

		function parseUTF8(input, offset, length) {
			var output = "";
			var utf16;
			var pos = offset;

			while (pos < offset+length)
			{
				var byte1 = input[pos++];
				if (byte1 < 128)
					utf16 = byte1;
				else
				{
					var byte2 = input[pos++]-128;
					if (byte2 < 0)
						throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16),""]));
					if (byte1 < 0xE0)             // 2 byte character
						utf16 = 64*(byte1-0xC0) + byte2;
					else
					{
						var byte3 = input[pos++]-128;
						if (byte3 < 0)
							throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16), byte3.toString(16)]));
						if (byte1 < 0xF0)        // 3 byte character
							utf16 = 4096*(byte1-0xE0) + 64*byte2 + byte3;
						else
						{
							var byte4 = input[pos++]-128;
							if (byte4 < 0)
								throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16), byte3.toString(16), byte4.toString(16)]));
							if (byte1 < 0xF8)        // 4 byte character
								utf16 = 262144*(byte1-0xF0) + 4096*byte2 + 64*byte3 + byte4;
							else                     // longer encodings are not supported
								throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16), byte3.toString(16), byte4.toString(16)]));
						}
					}
				}

				if (utf16 > 0xFFFF)   // 4 byte character - express as a surrogate pair
				{
					utf16 -= 0x10000;
					output += String.fromCharCode(0xD800 + (utf16 >> 10)); // lead character
					utf16 = 0xDC00 + (utf16 & 0x3FF);  // trail character
				}
				output += String.fromCharCode(utf16);
			}
			return output;
		}

		/**
	 * Repeat keepalive requests, monitor responses.
	 * @ignore
	 */
		var Pinger = function(client, keepAliveInterval) {
			this._client = client;
			this._keepAliveInterval = keepAliveInterval*1000;
			this.isReset = false;

			var pingReq = new WireMessage(MESSAGE_TYPE.PINGREQ).encode();

			var doTimeout = function (pinger) {
				return function () {
					return doPing.apply(pinger);
				};
			};

			/** @ignore */
			var doPing = function() {
				if (!this.isReset) {
					this._client._trace("Pinger.doPing", "Timed out");
					this._client._disconnected( ERROR.PING_TIMEOUT.code , format(ERROR.PING_TIMEOUT));
				} else {
					this.isReset = false;
					this._client._trace("Pinger.doPing", "send PINGREQ");
					this._client.socket.send(pingReq);
					this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
				}
			};

			this.reset = function() {
				this.isReset = true;
				clearTimeout(this.timeout);
				if (this._keepAliveInterval > 0)
					this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
			};

			this.cancel = function() {
				clearTimeout(this.timeout);
			};
		};

		/**
	 * Monitor request completion.
	 * @ignore
	 */
		var Timeout = function(client, timeoutSeconds, action, args) {
			if (!timeoutSeconds)
				timeoutSeconds = 30;

			var doTimeout = function (action, client, args) {
				return function () {
					return action.apply(client, args);
				};
			};
			this.timeout = setTimeout(doTimeout(action, client, args), timeoutSeconds * 1000);

			this.cancel = function() {
				clearTimeout(this.timeout);
			};
		};

	/**
	 * Internal implementation of the Websockets MQTT V3.1 client.
	 *
	 * @name Paho.ClientImpl @constructor
	 * @param {String} host the DNS nameof the webSocket host.
	 * @param {Number} port the port number for that host.
	 * @param {String} clientId the MQ client identifier.
	 */
		var ClientImpl = function (uri, host, port, path, clientId) {
		// Check dependencies are satisfied in this browser.
			if (!("WebSocket" in global && global.WebSocket !== null)) {
				throw new Error(format(ERROR.UNSUPPORTED, ["WebSocket"]));
			}
			if (!("ArrayBuffer" in global && global.ArrayBuffer !== null)) {
				throw new Error(format(ERROR.UNSUPPORTED, ["ArrayBuffer"]));
			}
			this._trace("Paho.Client", uri, host, port, path, clientId);

			this.host = host;
			this.port = port;
			this.path = path;
			this.uri = uri;
			this.clientId = clientId;
			this._wsuri = null;

			// Local storagekeys are qualified with the following string.
			// The conditional inclusion of path in the key is for backward
			// compatibility to when the path was not configurable and assumed to
			// be /mqtt
			this._localKey=host+":"+port+(path!="/mqtt"?":"+path:"")+":"+clientId+":";

			// Create private instance-only message queue
			// Internal queue of messages to be sent, in sending order.
			this._msg_queue = [];
			this._buffered_msg_queue = [];

			// Messages we have sent and are expecting a response for, indexed by their respective message ids.
			this._sentMessages = {};

			// Messages we have received and acknowleged and are expecting a confirm message for
			// indexed by their respective message ids.
			this._receivedMessages = {};

			// Internal list of callbacks to be executed when messages
			// have been successfully sent over web socket, e.g. disconnect
			// when it doesn't have to wait for ACK, just message is dispatched.
			this._notify_msg_sent = {};

			// Unique identifier for SEND messages, incrementing
			// counter as messages are sent.
			this._message_identifier = 1;

			// Used to determine the transmission sequence of stored sent messages.
			this._sequence = 0;


			// Load the local state, if any, from the saved version, only restore state relevant to this client.
			for (var key in localStorage)
				if (   key.indexOf("Sent:"+this._localKey) === 0 || key.indexOf("Received:"+this._localKey) === 0)
					this.restore(key);
		};

		// Messaging Client public instance members.
		ClientImpl.prototype.host = null;
		ClientImpl.prototype.port = null;
		ClientImpl.prototype.path = null;
		ClientImpl.prototype.uri = null;
		ClientImpl.prototype.clientId = null;

		// Messaging Client private instance members.
		ClientImpl.prototype.socket = null;
		/* true once we have received an acknowledgement to a CONNECT packet. */
		ClientImpl.prototype.connected = false;
		/* The largest message identifier allowed, may not be larger than 2**16 but
		 * if set smaller reduces the maximum number of outbound messages allowed.
		 */
		ClientImpl.prototype.maxMessageIdentifier = 65536;
		ClientImpl.prototype.connectOptions = null;
		ClientImpl.prototype.hostIndex = null;
		ClientImpl.prototype.onConnected = null;
		ClientImpl.prototype.onConnectionLost = null;
		ClientImpl.prototype.onMessageDelivered = null;
		ClientImpl.prototype.onMessageArrived = null;
		ClientImpl.prototype.traceFunction = null;
		ClientImpl.prototype._msg_queue = null;
		ClientImpl.prototype._buffered_msg_queue = null;
		ClientImpl.prototype._connectTimeout = null;
		/* The sendPinger monitors how long we allow before we send data to prove to the server that we are alive. */
		ClientImpl.prototype.sendPinger = null;
		/* The receivePinger monitors how long we allow before we require evidence that the server is alive. */
		ClientImpl.prototype.receivePinger = null;
		ClientImpl.prototype._reconnectInterval = 1; // Reconnect Delay, starts at 1 second
		ClientImpl.prototype._reconnecting = false;
		ClientImpl.prototype._reconnectTimeout = null;
		ClientImpl.prototype.disconnectedPublishing = false;
		ClientImpl.prototype.disconnectedBufferSize = 5000;

		ClientImpl.prototype.receiveBuffer = null;

		ClientImpl.prototype._traceBuffer = null;
		ClientImpl.prototype._MAX_TRACE_ENTRIES = 100;

		ClientImpl.prototype.connect = function (connectOptions) {
			var connectOptionsMasked = this._traceMask(connectOptions, "password");
			this._trace("Client.connect", connectOptionsMasked, this.socket, this.connected);

			if (this.connected)
				throw new Error(format(ERROR.INVALID_STATE, ["already connected"]));
			if (this.socket)
				throw new Error(format(ERROR.INVALID_STATE, ["already connected"]));

			if (this._reconnecting) {
			// connect() function is called while reconnect is in progress.
			// Terminate the auto reconnect process to use new connect options.
				this._reconnectTimeout.cancel();
				this._reconnectTimeout = null;
				this._reconnecting = false;
			}

			this.connectOptions = connectOptions;
			this._reconnectInterval = 1;
			this._reconnecting = false;
			if (connectOptions.uris) {
				this.hostIndex = 0;
				this._doConnect(connectOptions.uris[0]);
			} else {
				this._doConnect(this.uri);
			}

		};

		ClientImpl.prototype.subscribe = function (filter, subscribeOptions) {
			this._trace("Client.subscribe", filter, subscribeOptions);

			if (!this.connected)
				throw new Error(format(ERROR.INVALID_STATE, ["not connected"]));

            var wireMessage = new WireMessage(MESSAGE_TYPE.SUBSCRIBE);
            wireMessage.topics = filter.constructor === Array ? filter : [filter];
            if (subscribeOptions.qos === undefined)
                subscribeOptions.qos = 0;
            wireMessage.requestedQos = [];
            for (var i = 0; i < wireMessage.topics.length; i++)
                wireMessage.requestedQos[i] = subscribeOptions.qos;

			if (subscribeOptions.onSuccess) {
				wireMessage.onSuccess = function(grantedQos) {subscribeOptions.onSuccess({invocationContext:subscribeOptions.invocationContext,grantedQos:grantedQos});};
			}

			if (subscribeOptions.onFailure) {
				wireMessage.onFailure = function(errorCode) {subscribeOptions.onFailure({invocationContext:subscribeOptions.invocationContext,errorCode:errorCode, errorMessage:format(errorCode)});};
			}

			if (subscribeOptions.timeout) {
				wireMessage.timeOut = new Timeout(this, subscribeOptions.timeout, subscribeOptions.onFailure,
					[{invocationContext:subscribeOptions.invocationContext,
						errorCode:ERROR.SUBSCRIBE_TIMEOUT.code,
						errorMessage:format(ERROR.SUBSCRIBE_TIMEOUT)}]);
			}

			// All subscriptions return a SUBACK.
			this._requires_ack(wireMessage);
			this._schedule_message(wireMessage);
		};

		/** @ignore */
		ClientImpl.prototype.unsubscribe = function(filter, unsubscribeOptions) {
			this._trace("Client.unsubscribe", filter, unsubscribeOptions);

			if (!this.connected)
				throw new Error(format(ERROR.INVALID_STATE, ["not connected"]));

            var wireMessage = new WireMessage(MESSAGE_TYPE.UNSUBSCRIBE);
            wireMessage.topics = filter.constructor === Array ? filter : [filter];

			if (unsubscribeOptions.onSuccess) {
				wireMessage.callback = function() {unsubscribeOptions.onSuccess({invocationContext:unsubscribeOptions.invocationContext});};
			}
			if (unsubscribeOptions.timeout) {
				wireMessage.timeOut = new Timeout(this, unsubscribeOptions.timeout, unsubscribeOptions.onFailure,
					[{invocationContext:unsubscribeOptions.invocationContext,
						errorCode:ERROR.UNSUBSCRIBE_TIMEOUT.code,
						errorMessage:format(ERROR.UNSUBSCRIBE_TIMEOUT)}]);
			}

			// All unsubscribes return a SUBACK.
			this._requires_ack(wireMessage);
			this._schedule_message(wireMessage);
		};

		ClientImpl.prototype.send = function (message) {
			this._trace("Client.send", message);

			var wireMessage = new WireMessage(MESSAGE_TYPE.PUBLISH);
			wireMessage.payloadMessage = message;

			if (this.connected) {
			// Mark qos 1 & 2 message as "ACK required"
			// For qos 0 message, invoke onMessageDelivered callback if there is one.
			// Then schedule the message.
				if (message.qos > 0) {
					this._requires_ack(wireMessage);
				} else if (this.onMessageDelivered) {
					this._notify_msg_sent[wireMessage] = this.onMessageDelivered(wireMessage.payloadMessage);
				}
				this._schedule_message(wireMessage);
			} else {
			// Currently disconnected, will not schedule this message
			// Check if reconnecting is in progress and disconnected publish is enabled.
				if (this._reconnecting && this.disconnectedPublishing) {
				// Check the limit which include the "required ACK" messages
					var messageCount = Object.keys(this._sentMessages).length + this._buffered_msg_queue.length;
					if (messageCount > this.disconnectedBufferSize) {
						throw new Error(format(ERROR.BUFFER_FULL, [this.disconnectedBufferSize]));
					} else {
						if (message.qos > 0) {
						// Mark this message as "ACK required"
							this._requires_ack(wireMessage);
						} else {
							wireMessage.sequence = ++this._sequence;
							// Add messages in fifo order to array, by adding to start
							this._buffered_msg_queue.unshift(wireMessage);
						}
					}
				} else {
					throw new Error(format(ERROR.INVALID_STATE, ["not connected"]));
				}
			}
		};

		ClientImpl.prototype.disconnect = function () {
			this._trace("Client.disconnect");

			if (this._reconnecting) {
			// disconnect() function is called while reconnect is in progress.
			// Terminate the auto reconnect process.
				this._reconnectTimeout.cancel();
				this._reconnectTimeout = null;
				this._reconnecting = false;
			}

			if (!this.socket)
				throw new Error(format(ERROR.INVALID_STATE, ["not connecting or connected"]));

			var wireMessage = new WireMessage(MESSAGE_TYPE.DISCONNECT);

			// Run the disconnected call back as soon as the message has been sent,
			// in case of a failure later on in the disconnect processing.
			// as a consequence, the _disconected call back may be run several times.
			this._notify_msg_sent[wireMessage] = scope(this._disconnected, this);

			this._schedule_message(wireMessage);
		};

		ClientImpl.prototype.getTraceLog = function () {
			if ( this._traceBuffer !== null ) {
				this._trace("Client.getTraceLog", new Date());
				this._trace("Client.getTraceLog in flight messages", this._sentMessages.length);
				for (var key in this._sentMessages)
					this._trace("_sentMessages ",key, this._sentMessages[key]);
				for (var key in this._receivedMessages)
					this._trace("_receivedMessages ",key, this._receivedMessages[key]);

				return this._traceBuffer;
			}
		};

		ClientImpl.prototype.startTrace = function () {
			if ( this._traceBuffer === null ) {
				this._traceBuffer = [];
			}
			this._trace("Client.startTrace", new Date(), version);
		};

		ClientImpl.prototype.stopTrace = function () {
			delete this._traceBuffer;
		};

		ClientImpl.prototype._doConnect = function (wsurl) {
		// When the socket is open, this client will send the CONNECT WireMessage using the saved parameters.
			if (this.connectOptions.useSSL) {
				var uriParts = wsurl.split(":");
				uriParts[0] = "wss";
				wsurl = uriParts.join(":");
			}
			this._wsuri = wsurl;
			this.connected = false;



			if (this.connectOptions.mqttVersion < 4) {
				this.socket = new WebSocket(wsurl, ["mqttv3.1"]);
			} else {
				this.socket = new WebSocket(wsurl, ["mqtt"]);
			}
			this.socket.binaryType = "arraybuffer";
			this.socket.onopen = scope(this._on_socket_open, this);
			this.socket.onmessage = scope(this._on_socket_message, this);
			this.socket.onerror = scope(this._on_socket_error, this);
			this.socket.onclose = scope(this._on_socket_close, this);

			this.sendPinger = new Pinger(this, this.connectOptions.keepAliveInterval);
			this.receivePinger = new Pinger(this, this.connectOptions.keepAliveInterval);
			if (this._connectTimeout) {
				this._connectTimeout.cancel();
				this._connectTimeout = null;
			}
			this._connectTimeout = new Timeout(this, this.connectOptions.timeout, this._disconnected,  [ERROR.CONNECT_TIMEOUT.code, format(ERROR.CONNECT_TIMEOUT)]);
		};


		// Schedule a new message to be sent over the WebSockets
		// connection. CONNECT messages cause WebSocket connection
		// to be started. All other messages are queued internally
		// until this has happened. When WS connection starts, process
		// all outstanding messages.
		ClientImpl.prototype._schedule_message = function (message) {
			// Add messages in fifo order to array, by adding to start
			this._msg_queue.unshift(message);
			// Process outstanding messages in the queue if we have an  open socket, and have received CONNACK.
			if (this.connected) {
				this._process_queue();
			}
		};

		ClientImpl.prototype.store = function(prefix, wireMessage) {
			var storedMessage = {type:wireMessage.type, messageIdentifier:wireMessage.messageIdentifier, version:1};

			switch(wireMessage.type) {
			case MESSAGE_TYPE.PUBLISH:
				if(wireMessage.pubRecReceived)
					storedMessage.pubRecReceived = true;

				// Convert the payload to a hex string.
				storedMessage.payloadMessage = {};
				var hex = "";
				var messageBytes = wireMessage.payloadMessage.payloadBytes;
				for (var i=0; i<messageBytes.length; i++) {
					if (messageBytes[i] <= 0xF)
						hex = hex+"0"+messageBytes[i].toString(16);
					else
						hex = hex+messageBytes[i].toString(16);
				}
				storedMessage.payloadMessage.payloadHex = hex;

				storedMessage.payloadMessage.qos = wireMessage.payloadMessage.qos;
				storedMessage.payloadMessage.destinationName = wireMessage.payloadMessage.destinationName;
				if (wireMessage.payloadMessage.duplicate)
					storedMessage.payloadMessage.duplicate = true;
				if (wireMessage.payloadMessage.retained)
					storedMessage.payloadMessage.retained = true;

				// Add a sequence number to sent messages.
				if ( prefix.indexOf("Sent:") === 0 ) {
					if ( wireMessage.sequence === undefined )
						wireMessage.sequence = ++this._sequence;
					storedMessage.sequence = wireMessage.sequence;
				}
				break;

			default:
				throw Error(format(ERROR.INVALID_STORED_DATA, [prefix+this._localKey+wireMessage.messageIdentifier, storedMessage]));
			}
			localStorage.setItem(prefix+this._localKey+wireMessage.messageIdentifier, JSON.stringify(storedMessage));
		};

		ClientImpl.prototype.restore = function(key) {
			var value = localStorage.getItem(key);
			var storedMessage = JSON.parse(value);

			var wireMessage = new WireMessage(storedMessage.type, storedMessage);

			switch(storedMessage.type) {
			case MESSAGE_TYPE.PUBLISH:
				// Replace the payload message with a Message object.
				var hex = storedMessage.payloadMessage.payloadHex;
				var buffer = new ArrayBuffer((hex.length)/2);
				var byteStream = new Uint8Array(buffer);
				var i = 0;
				while (hex.length >= 2) {
					var x = parseInt(hex.substring(0, 2), 16);
					hex = hex.substring(2, hex.length);
					byteStream[i++] = x;
				}
				var payloadMessage = new Message(byteStream);

				payloadMessage.qos = storedMessage.payloadMessage.qos;
				payloadMessage.destinationName = storedMessage.payloadMessage.destinationName;
				if (storedMessage.payloadMessage.duplicate)
					payloadMessage.duplicate = true;
				if (storedMessage.payloadMessage.retained)
					payloadMessage.retained = true;
				wireMessage.payloadMessage = payloadMessage;

				break;

			default:
				throw Error(format(ERROR.INVALID_STORED_DATA, [key, value]));
			}

			if (key.indexOf("Sent:"+this._localKey) === 0) {
				wireMessage.payloadMessage.duplicate = true;
				this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
			} else if (key.indexOf("Received:"+this._localKey) === 0) {
				this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
			}
		};

		ClientImpl.prototype._process_queue = function () {
			var message = null;

			// Send all queued messages down socket connection
			while ((message = this._msg_queue.pop())) {
				this._socket_send(message);
				// Notify listeners that message was successfully sent
				if (this._notify_msg_sent[message]) {
					this._notify_msg_sent[message]();
					delete this._notify_msg_sent[message];
				}
			}
		};

		/**
	 * Expect an ACK response for this message. Add message to the set of in progress
	 * messages and set an unused identifier in this message.
	 * @ignore
	 */
		ClientImpl.prototype._requires_ack = function (wireMessage) {
			var messageCount = Object.keys(this._sentMessages).length;
			if (messageCount > this.maxMessageIdentifier)
				throw Error ("Too many messages:"+messageCount);

			while(this._sentMessages[this._message_identifier] !== undefined) {
				this._message_identifier++;
			}
			wireMessage.messageIdentifier = this._message_identifier;
			this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
			if (wireMessage.type === MESSAGE_TYPE.PUBLISH) {
				this.store("Sent:", wireMessage);
			}
			if (this._message_identifier === this.maxMessageIdentifier) {
				this._message_identifier = 1;
			}
		};

		/**
	 * Called when the underlying websocket has been opened.
	 * @ignore
	 */
		ClientImpl.prototype._on_socket_open = function () {
		// Create the CONNECT message object.
			var wireMessage = new WireMessage(MESSAGE_TYPE.CONNECT, this.connectOptions);
			wireMessage.clientId = this.clientId;
			this._socket_send(wireMessage);
		};

		/**
	 * Called when the underlying websocket has received a complete packet.
	 * @ignore
	 */
		ClientImpl.prototype._on_socket_message = function (event) {
			this._trace("Client._on_socket_message", event.data);
			var messages = this._deframeMessages(event.data);
			for (var i = 0; i < messages.length; i+=1) {
				this._handleMessage(messages[i]);
			}
		};

		ClientImpl.prototype._deframeMessages = function(data) {
			var byteArray = new Uint8Array(data);
			var messages = [];
			if (this.receiveBuffer) {
				var newData = new Uint8Array(this.receiveBuffer.length+byteArray.length);
				newData.set(this.receiveBuffer);
				newData.set(byteArray,this.receiveBuffer.length);
				byteArray = newData;
				delete this.receiveBuffer;
			}
			try {
				var offset = 0;
				while(offset < byteArray.length) {
					var result = decodeMessage(byteArray,offset);
					var wireMessage = result[0];
					offset = result[1];
					if (wireMessage !== null) {
						messages.push(wireMessage);
					} else {
						break;
					}
				}
				if (offset < byteArray.length) {
					this.receiveBuffer = byteArray.subarray(offset);
				}
			} catch (error) {
				var errorStack = ((error.hasOwnProperty("stack") == "undefined") ? error.stack.toString() : "No Error Stack Available");
				this._disconnected(ERROR.INTERNAL_ERROR.code , format(ERROR.INTERNAL_ERROR, [error.message,errorStack]));
				return;
			}
			return messages;
		};

		ClientImpl.prototype._handleMessage = function(wireMessage) {

			this._trace("Client._handleMessage", wireMessage);

			try {
				switch(wireMessage.type) {
				case MESSAGE_TYPE.CONNACK:
					this._connectTimeout.cancel();
					if (this._reconnectTimeout)
						this._reconnectTimeout.cancel();

					// If we have started using clean session then clear up the local state.
					if (this.connectOptions.cleanSession) {
						for (var key in this._sentMessages) {
							var sentMessage = this._sentMessages[key];
							localStorage.removeItem("Sent:"+this._localKey+sentMessage.messageIdentifier);
						}
						this._sentMessages = {};

						for (var key in this._receivedMessages) {
							var receivedMessage = this._receivedMessages[key];
							localStorage.removeItem("Received:"+this._localKey+receivedMessage.messageIdentifier);
						}
						this._receivedMessages = {};
					}
					// Client connected and ready for business.
					if (wireMessage.returnCode === 0) {

						this.connected = true;
						// Jump to the end of the list of uris and stop looking for a good host.

						if (this.connectOptions.uris)
							this.hostIndex = this.connectOptions.uris.length;

					} else {
						this._disconnected(ERROR.CONNACK_RETURNCODE.code , format(ERROR.CONNACK_RETURNCODE, [wireMessage.returnCode, CONNACK_RC[wireMessage.returnCode]]));
						break;
					}

					// Resend messages.
					var sequencedMessages = [];
					for (var msgId in this._sentMessages) {
						if (this._sentMessages.hasOwnProperty(msgId))
							sequencedMessages.push(this._sentMessages[msgId]);
					}

					// Also schedule qos 0 buffered messages if any
					if (this._buffered_msg_queue.length > 0) {
						var msg = null;
						while ((msg = this._buffered_msg_queue.pop())) {
							sequencedMessages.push(msg);
							if (this.onMessageDelivered)
								this._notify_msg_sent[msg] = this.onMessageDelivered(msg.payloadMessage);
						}
					}

					// Sort sentMessages into the original sent order.
					var sequencedMessages = sequencedMessages.sort(function(a,b) {return a.sequence - b.sequence;} );
					for (var i=0, len=sequencedMessages.length; i<len; i++) {
						var sentMessage = sequencedMessages[i];
						if (sentMessage.type == MESSAGE_TYPE.PUBLISH && sentMessage.pubRecReceived) {
							var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {messageIdentifier:sentMessage.messageIdentifier});
							this._schedule_message(pubRelMessage);
						} else {
							this._schedule_message(sentMessage);
						}
					}

					// Execute the connectOptions.onSuccess callback if there is one.
					// Will also now return if this connection was the result of an automatic
					// reconnect and which URI was successfully connected to.
					if (this.connectOptions.onSuccess) {
						this.connectOptions.onSuccess({invocationContext:this.connectOptions.invocationContext});
					}

					var reconnected = false;
					if (this._reconnecting) {
						reconnected = true;
						this._reconnectInterval = 1;
						this._reconnecting = false;
					}

					// Execute the onConnected callback if there is one.
					this._connected(reconnected, this._wsuri);

					// Process all queued messages now that the connection is established.
					this._process_queue();
					break;

				case MESSAGE_TYPE.PUBLISH:
					this._receivePublish(wireMessage);
					break;

				case MESSAGE_TYPE.PUBACK:
					var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
					// If this is a re flow of a PUBACK after we have restarted receivedMessage will not exist.
					if (sentMessage) {
						delete this._sentMessages[wireMessage.messageIdentifier];
						localStorage.removeItem("Sent:"+this._localKey+wireMessage.messageIdentifier);
						if (this.onMessageDelivered)
							this.onMessageDelivered(sentMessage.payloadMessage);
					}
					break;

				case MESSAGE_TYPE.PUBREC:
					var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
					// If this is a re flow of a PUBREC after we have restarted receivedMessage will not exist.
					if (sentMessage) {
						sentMessage.pubRecReceived = true;
						var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {messageIdentifier:wireMessage.messageIdentifier});
						this.store("Sent:", sentMessage);
						this._schedule_message(pubRelMessage);
					}
					break;

				case MESSAGE_TYPE.PUBREL:
					var receivedMessage = this._receivedMessages[wireMessage.messageIdentifier];
					localStorage.removeItem("Received:"+this._localKey+wireMessage.messageIdentifier);
					// If this is a re flow of a PUBREL after we have restarted receivedMessage will not exist.
					if (receivedMessage) {
						this._receiveMessage(receivedMessage);
						delete this._receivedMessages[wireMessage.messageIdentifier];
					}
					// Always flow PubComp, we may have previously flowed PubComp but the server lost it and restarted.
					var pubCompMessage = new WireMessage(MESSAGE_TYPE.PUBCOMP, {messageIdentifier:wireMessage.messageIdentifier});
					this._schedule_message(pubCompMessage);


					break;

				case MESSAGE_TYPE.PUBCOMP:
					var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
					delete this._sentMessages[wireMessage.messageIdentifier];
					localStorage.removeItem("Sent:"+this._localKey+wireMessage.messageIdentifier);
					if (this.onMessageDelivered)
						this.onMessageDelivered(sentMessage.payloadMessage);
					break;

				case MESSAGE_TYPE.SUBACK:
					var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
					if (sentMessage) {
						if(sentMessage.timeOut)
							sentMessage.timeOut.cancel();
						// This will need to be fixed when we add multiple topic support
						if (wireMessage.returnCode[0] === 0x80) {
							if (sentMessage.onFailure) {
								sentMessage.onFailure(wireMessage.returnCode);
							}
						} else if (sentMessage.onSuccess) {
							sentMessage.onSuccess(wireMessage.returnCode);
						}
						delete this._sentMessages[wireMessage.messageIdentifier];
					}
					break;

				case MESSAGE_TYPE.UNSUBACK:
					var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
					if (sentMessage) {
						if (sentMessage.timeOut)
							sentMessage.timeOut.cancel();
						if (sentMessage.callback) {
							sentMessage.callback();
						}
						delete this._sentMessages[wireMessage.messageIdentifier];
					}

					break;

				case MESSAGE_TYPE.PINGRESP:
				/* The sendPinger or receivePinger may have sent a ping, the receivePinger has already been reset. */
					this.sendPinger.reset();
					break;

				case MESSAGE_TYPE.DISCONNECT:
				// Clients do not expect to receive disconnect packets.
					this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code , format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [wireMessage.type]));
					break;

				default:
					this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code , format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [wireMessage.type]));
				}
			} catch (error) {
				var errorStack = ((error.hasOwnProperty("stack") == "undefined") ? error.stack.toString() : "No Error Stack Available");
				this._disconnected(ERROR.INTERNAL_ERROR.code , format(ERROR.INTERNAL_ERROR, [error.message,errorStack]));
				return;
			}
		};

		/** @ignore */
		ClientImpl.prototype._on_socket_error = function (error) {
			if (!this._reconnecting) {
				this._disconnected(ERROR.SOCKET_ERROR.code , format(ERROR.SOCKET_ERROR, [error.data]));
			}
		};

		/** @ignore */
		ClientImpl.prototype._on_socket_close = function () {
			if (!this._reconnecting) {
				this._disconnected(ERROR.SOCKET_CLOSE.code , format(ERROR.SOCKET_CLOSE));
			}
		};

		/** @ignore */
		ClientImpl.prototype._socket_send = function (wireMessage) {

			if (wireMessage.type == 1) {
				var wireMessageMasked = this._traceMask(wireMessage, "password");
				this._trace("Client._socket_send", wireMessageMasked);
			}
			else this._trace("Client._socket_send", wireMessage);

			this.socket.send(wireMessage.encode());
			/* We have proved to the server we are alive. */
			this.sendPinger.reset();
		};

		/** @ignore */
		ClientImpl.prototype._receivePublish = function (wireMessage) {
			switch(wireMessage.payloadMessage.qos) {
			case "undefined":
			case 0:
				this._receiveMessage(wireMessage);
				break;

			case 1:
				var pubAckMessage = new WireMessage(MESSAGE_TYPE.PUBACK, {messageIdentifier:wireMessage.messageIdentifier});
				this._schedule_message(pubAckMessage);
				this._receiveMessage(wireMessage);
				break;

			case 2:
				this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
				this.store("Received:", wireMessage);
				var pubRecMessage = new WireMessage(MESSAGE_TYPE.PUBREC, {messageIdentifier:wireMessage.messageIdentifier});
				this._schedule_message(pubRecMessage);

				break;

			default:
				throw Error("Invaild qos=" + wireMessage.payloadMessage.qos);
			}
		};

		/** @ignore */
		ClientImpl.prototype._receiveMessage = function (wireMessage) {
			if (this.onMessageArrived) {
				this.onMessageArrived(wireMessage.payloadMessage);
			}
		};

		/**
	 * Client has connected.
	 * @param {reconnect} [boolean] indicate if this was a result of reconnect operation.
	 * @param {uri} [string] fully qualified WebSocket URI of the server.
	 */
		ClientImpl.prototype._connected = function (reconnect, uri) {
		// Execute the onConnected callback if there is one.
			if (this.onConnected)
				this.onConnected(reconnect, uri);
		};

		/**
	 * Attempts to reconnect the client to the server.
   * For each reconnect attempt, will double the reconnect interval
   * up to 128 seconds.
	 */
		ClientImpl.prototype._reconnect = function () {
			this._trace("Client._reconnect");
			if (!this.connected) {
				this._reconnecting = true;
				this.sendPinger.cancel();
				this.receivePinger.cancel();
				if (this._reconnectInterval < 128)
					this._reconnectInterval = this._reconnectInterval * 2;
				if (this.connectOptions.uris) {
					this.hostIndex = 0;
					this._doConnect(this.connectOptions.uris[0]);
				} else {
					this._doConnect(this.uri);
				}
			}
		};

		/**
	 * Client has disconnected either at its own request or because the server
	 * or network disconnected it. Remove all non-durable state.
	 * @param {errorCode} [number] the error number.
	 * @param {errorText} [string] the error text.
	 * @ignore
	 */
		ClientImpl.prototype._disconnected = function (errorCode, errorText) {
			this._trace("Client._disconnected", errorCode, errorText);

			if (errorCode !== undefined && this._reconnecting) {
				//Continue automatic reconnect process
				this._reconnectTimeout = new Timeout(this, this._reconnectInterval, this._reconnect);
				return;
			}

			this.sendPinger.cancel();
			this.receivePinger.cancel();
			if (this._connectTimeout) {
				this._connectTimeout.cancel();
				this._connectTimeout = null;
			}

			// Clear message buffers.
			this._msg_queue = [];
			this._buffered_msg_queue = [];
			this._notify_msg_sent = {};

			if (this.socket) {
			// Cancel all socket callbacks so that they cannot be driven again by this socket.
				this.socket.onopen = null;
				this.socket.onmessage = null;
				this.socket.onerror = null;
				this.socket.onclose = null;
				if (this.socket.readyState === 1)
					this.socket.close();
				delete this.socket;
			}

			if (this.connectOptions.uris && this.hostIndex < this.connectOptions.uris.length-1) {
			// Try the next host.
				this.hostIndex++;
				this._doConnect(this.connectOptions.uris[this.hostIndex]);
			} else {

				if (errorCode === undefined) {
					errorCode = ERROR.OK.code;
					errorText = format(ERROR.OK);
				}

				// Run any application callbacks last as they may attempt to reconnect and hence create a new socket.
				if (this.connected) {
					this.connected = false;
					// Execute the connectionLostCallback if there is one, and we were connected.
					if (this.onConnectionLost) {
						this.onConnectionLost({errorCode:errorCode, errorMessage:errorText, reconnect:this.connectOptions.reconnect, uri:this._wsuri});
					}
					if (errorCode !== ERROR.OK.code && this.connectOptions.reconnect) {
					// Start automatic reconnect process for the very first time since last successful connect.
						this._reconnectInterval = 1;
						this._reconnect();
						return;
					}
				} else {
				// Otherwise we never had a connection, so indicate that the connect has failed.
					if (this.connectOptions.mqttVersion === 4 && this.connectOptions.mqttVersionExplicit === false) {
						this._trace("Failed to connect V4, dropping back to V3");
						this.connectOptions.mqttVersion = 3;
						if (this.connectOptions.uris) {
							this.hostIndex = 0;
							this._doConnect(this.connectOptions.uris[0]);
						} else {
							this._doConnect(this.uri);
						}
					} else if(this.connectOptions.onFailure) {
						this.connectOptions.onFailure({invocationContext:this.connectOptions.invocationContext, errorCode:errorCode, errorMessage:errorText});
					}
				}
			}
		};

		/** @ignore */
		ClientImpl.prototype._trace = function () {
		// Pass trace message back to client's callback function
			if (this.traceFunction) {
				var args = Array.prototype.slice.call(arguments);
				for (var i in args)
				{
					if (typeof args[i] !== "undefined")
						args.splice(i, 1, JSON.stringify(args[i]));
				}
				var record = args.join("");
				this.traceFunction ({severity: "Debug", message: record	});
			}

			//buffer style trace
			if ( this._traceBuffer !== null ) {
				for (var i = 0, max = arguments.length; i < max; i++) {
					if ( this._traceBuffer.length == this._MAX_TRACE_ENTRIES ) {
						this._traceBuffer.shift();
					}
					if (i === 0) this._traceBuffer.push(arguments[i]);
					else if (typeof arguments[i] === "undefined" ) this._traceBuffer.push(arguments[i]);
					else this._traceBuffer.push("  "+JSON.stringify(arguments[i]));
				}
			}
		};

		/** @ignore */
		ClientImpl.prototype._traceMask = function (traceObject, masked) {
			var traceObjectMasked = {};
			for (var attr in traceObject) {
				if (traceObject.hasOwnProperty(attr)) {
					if (attr == masked)
						traceObjectMasked[attr] = "******";
					else
						traceObjectMasked[attr] = traceObject[attr];
				}
			}
			return traceObjectMasked;
		};

		// ------------------------------------------------------------------------
		// Public Programming interface.
		// ------------------------------------------------------------------------

		/**
	 * The JavaScript application communicates to the server using a {@link Paho.Client} object.
	 * <p>
	 * Most applications will create just one Client object and then call its connect() method,
	 * however applications can create more than one Client object if they wish.
	 * In this case the combination of host, port and clientId attributes must be different for each Client object.
	 * <p>
	 * The send, subscribe and unsubscribe methods are implemented as asynchronous JavaScript methods
	 * (even though the underlying protocol exchange might be synchronous in nature).
	 * This means they signal their completion by calling back to the application,
	 * via Success or Failure callback functions provided by the application on the method in question.
	 * Such callbacks are called at most once per method invocation and do not persist beyond the lifetime
	 * of the script that made the invocation.
	 * <p>
	 * In contrast there are some callback functions, most notably <i>onMessageArrived</i>,
	 * that are defined on the {@link Paho.Client} object.
	 * These may get called multiple times, and aren't directly related to specific method invocations made by the client.
	 *
	 * @name Paho.Client
	 *
	 * @constructor
	 *
	 * @param {string} host - the address of the messaging server, as a fully qualified WebSocket URI, as a DNS name or dotted decimal IP address.
	 * @param {number} port - the port number to connect to - only required if host is not a URI
	 * @param {string} path - the path on the host to connect to - only used if host is not a URI. Default: '/mqtt'.
	 * @param {string} clientId - the Messaging client identifier, between 1 and 23 characters in length.
	 *
	 * @property {string} host - <i>read only</i> the server's DNS hostname or dotted decimal IP address.
	 * @property {number} port - <i>read only</i> the server's port.
	 * @property {string} path - <i>read only</i> the server's path.
	 * @property {string} clientId - <i>read only</i> used when connecting to the server.
	 * @property {function} onConnectionLost - called when a connection has been lost.
	 *                            after a connect() method has succeeded.
	 *                            Establish the call back used when a connection has been lost. The connection may be
	 *                            lost because the client initiates a disconnect or because the server or network
	 *                            cause the client to be disconnected. The disconnect call back may be called without
	 *                            the connectionComplete call back being invoked if, for example the client fails to
	 *                            connect.
	 *                            A single response object parameter is passed to the onConnectionLost callback containing the following fields:
	 *                            <ol>
	 *                            <li>errorCode
	 *                            <li>errorMessage
	 *                            </ol>
	 * @property {function} onMessageDelivered - called when a message has been delivered.
	 *                            All processing that this Client will ever do has been completed. So, for example,
	 *                            in the case of a Qos=2 message sent by this client, the PubComp flow has been received from the server
	 *                            and the message has been removed from persistent storage before this callback is invoked.
	 *                            Parameters passed to the onMessageDelivered callback are:
	 *                            <ol>
	 *                            <li>{@link Paho.Message} that was delivered.
	 *                            </ol>
	 * @property {function} onMessageArrived - called when a message has arrived in this Paho.client.
	 *                            Parameters passed to the onMessageArrived callback are:
	 *                            <ol>
	 *                            <li>{@link Paho.Message} that has arrived.
	 *                            </ol>
	 * @property {function} onConnected - called when a connection is successfully made to the server.
	 *                                  after a connect() method.
	 *                                  Parameters passed to the onConnected callback are:
	 *                                  <ol>
	 *                                  <li>reconnect (boolean) - If true, the connection was the result of a reconnect.</li>
	 *                                  <li>URI (string) - The URI used to connect to the server.</li>
	 *                                  </ol>
	 * @property {boolean} disconnectedPublishing - if set, will enable disconnected publishing in
	 *                                            in the event that the connection to the server is lost.
	 * @property {number} disconnectedBufferSize - Used to set the maximum number of messages that the disconnected
	 *                                             buffer will hold before rejecting new messages. Default size: 5000 messages
	 * @property {function} trace - called whenever trace is called. TODO
	 */
		var Client = function (host, port, path, clientId) {

			var uri;

			if (typeof host !== "string")
				throw new Error(format(ERROR.INVALID_TYPE, [typeof host, "host"]));

			if (arguments.length == 2) {
			// host: must be full ws:// uri
			// port: clientId
				clientId = port;
				uri = host;
				var match = uri.match(/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/);
				if (match) {
					host = match[4]||match[2];
					port = parseInt(match[7]);
					path = match[8];
				} else {
					throw new Error(format(ERROR.INVALID_ARGUMENT,[host,"host"]));
				}
			} else {
				if (arguments.length == 3) {
					clientId = path;
					path = "/mqtt";
				}
				if (typeof port !== "number" || port < 0)
					throw new Error(format(ERROR.INVALID_TYPE, [typeof port, "port"]));
				if (typeof path !== "string")
					throw new Error(format(ERROR.INVALID_TYPE, [typeof path, "path"]));

				var ipv6AddSBracket = (host.indexOf(":") !== -1 && host.slice(0,1) !== "[" && host.slice(-1) !== "]");
				uri = "ws://"+(ipv6AddSBracket?"["+host+"]":host)+":"+port+path;
			}

			var clientIdLength = 0;
			for (var i = 0; i<clientId.length; i++) {
				var charCode = clientId.charCodeAt(i);
				if (0xD800 <= charCode && charCode <= 0xDBFF)  {
					i++; // Surrogate pair.
				}
				clientIdLength++;
			}
			if (typeof clientId !== "string" || clientIdLength > 65535)
				throw new Error(format(ERROR.INVALID_ARGUMENT, [clientId, "clientId"]));

			var client = new ClientImpl(uri, host, port, path, clientId);

			//Public Properties
			Object.defineProperties(this,{
				"host":{
					get: function() { return host; },
					set: function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); }
				},
				"port":{
					get: function() { return port; },
					set: function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); }
				},
				"path":{
					get: function() { return path; },
					set: function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); }
				},
				"uri":{
					get: function() { return uri; },
					set: function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); }
				},
				"clientId":{
					get: function() { return client.clientId; },
					set: function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); }
				},
				"onConnected":{
					get: function() { return client.onConnected; },
					set: function(newOnConnected) {
						if (typeof newOnConnected === "function")
							client.onConnected = newOnConnected;
						else
							throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnConnected, "onConnected"]));
					}
				},
				"disconnectedPublishing":{
					get: function() { return client.disconnectedPublishing; },
					set: function(newDisconnectedPublishing) {
						client.disconnectedPublishing = newDisconnectedPublishing;
					}
				},
				"disconnectedBufferSize":{
					get: function() { return client.disconnectedBufferSize; },
					set: function(newDisconnectedBufferSize) {
						client.disconnectedBufferSize = newDisconnectedBufferSize;
					}
				},
				"onConnectionLost":{
					get: function() { return client.onConnectionLost; },
					set: function(newOnConnectionLost) {
						if (typeof newOnConnectionLost === "function")
							client.onConnectionLost = newOnConnectionLost;
						else
							throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnConnectionLost, "onConnectionLost"]));
					}
				},
				"onMessageDelivered":{
					get: function() { return client.onMessageDelivered; },
					set: function(newOnMessageDelivered) {
						if (typeof newOnMessageDelivered === "function")
							client.onMessageDelivered = newOnMessageDelivered;
						else
							throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnMessageDelivered, "onMessageDelivered"]));
					}
				},
				"onMessageArrived":{
					get: function() { return client.onMessageArrived; },
					set: function(newOnMessageArrived) {
						if (typeof newOnMessageArrived === "function")
							client.onMessageArrived = newOnMessageArrived;
						else
							throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnMessageArrived, "onMessageArrived"]));
					}
				},
				"trace":{
					get: function() { return client.traceFunction; },
					set: function(trace) {
						if(typeof trace === "function"){
							client.traceFunction = trace;
						}else{
							throw new Error(format(ERROR.INVALID_TYPE, [typeof trace, "onTrace"]));
						}
					}
				},
			});

			/**
		 * Connect this Messaging client to its server.
		 *
		 * @name Paho.Client#connect
		 * @function
		 * @param {object} connectOptions - Attributes used with the connection.
		 * @param {number} connectOptions.timeout - If the connect has not succeeded within this
		 *                    number of seconds, it is deemed to have failed.
		 *                    The default is 30 seconds.
		 * @param {string} connectOptions.userName - Authentication username for this connection.
		 * @param {string} connectOptions.password - Authentication password for this connection.
		 * @param {Paho.Message} connectOptions.willMessage - sent by the server when the client
		 *                    disconnects abnormally.
		 * @param {number} connectOptions.keepAliveInterval - the server disconnects this client if
		 *                    there is no activity for this number of seconds.
		 *                    The default value of 60 seconds is assumed if not set.
		 * @param {boolean} connectOptions.cleanSession - if true(default) the client and server
		 *                    persistent state is deleted on successful connect.
		 * @param {boolean} connectOptions.useSSL - if present and true, use an SSL Websocket connection.
		 * @param {object} connectOptions.invocationContext - passed to the onSuccess callback or onFailure callback.
		 * @param {function} connectOptions.onSuccess - called when the connect acknowledgement
		 *                    has been received from the server.
		 * A single response object parameter is passed to the onSuccess callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onSuccess method in the connectOptions.
		 * </ol>
	 * @param {function} connectOptions.onFailure - called when the connect request has failed or timed out.
		 * A single response object parameter is passed to the onFailure callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onFailure method in the connectOptions.
		 * <li>errorCode a number indicating the nature of the error.
		 * <li>errorMessage text describing the error.
		 * </ol>
	 * @param {array} connectOptions.hosts - If present this contains either a set of hostnames or fully qualified
		 * WebSocket URIs (ws://iot.eclipse.org:80/ws), that are tried in order in place
		 * of the host and port paramater on the construtor. The hosts are tried one at at time in order until
		 * one of then succeeds.
	 * @param {array} connectOptions.ports - If present the set of ports matching the hosts. If hosts contains URIs, this property
		 * is not used.
	 * @param {boolean} connectOptions.reconnect - Sets whether the client will automatically attempt to reconnect
	 * to the server if the connection is lost.
	 *<ul>
	 *<li>If set to false, the client will not attempt to automatically reconnect to the server in the event that the
	 * connection is lost.</li>
	 *<li>If set to true, in the event that the connection is lost, the client will attempt to reconnect to the server.
	 * It will initially wait 1 second before it attempts to reconnect, for every failed reconnect attempt, the delay
	 * will double until it is at 2 minutes at which point the delay will stay at 2 minutes.</li>
	 *</ul>
	 * @param {number} connectOptions.mqttVersion - The version of MQTT to use to connect to the MQTT Broker.
	 *<ul>
	 *<li>3 - MQTT V3.1</li>
	 *<li>4 - MQTT V3.1.1</li>
	 *</ul>
	 * @param {boolean} connectOptions.mqttVersionExplicit - If set to true, will force the connection to use the
	 * selected MQTT Version or will fail to connect.
	 * @param {array} connectOptions.uris - If present, should contain a list of fully qualified WebSocket uris
	 * (e.g. ws://iot.eclipse.org:80/ws), that are tried in order in place of the host and port parameter of the construtor.
	 * The uris are tried one at a time in order until one of them succeeds. Do not use this in conjunction with hosts as
	 * the hosts array will be converted to uris and will overwrite this property.
		 * @throws {InvalidState} If the client is not in disconnected state. The client must have received connectionLost
		 * or disconnected before calling connect for a second or subsequent time.
		 */
			this.connect = function (connectOptions) {
				connectOptions = connectOptions || {} ;
				validate(connectOptions,  {timeout:"number",
					userName:"string",
					password:"string",
					willMessage:"object",
					keepAliveInterval:"number",
					cleanSession:"boolean",
					useSSL:"boolean",
					invocationContext:"object",
					onSuccess:"function",
					onFailure:"function",
					hosts:"object",
					ports:"object",
					reconnect:"boolean",
					mqttVersion:"number",
					mqttVersionExplicit:"boolean",
					uris: "object"});

				// If no keep alive interval is set, assume 60 seconds.
				if (connectOptions.keepAliveInterval === undefined)
					connectOptions.keepAliveInterval = 60;

				if (connectOptions.mqttVersion > 4 || connectOptions.mqttVersion < 3) {
					throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.mqttVersion, "connectOptions.mqttVersion"]));
				}

				if (connectOptions.mqttVersion === undefined) {
					connectOptions.mqttVersionExplicit = false;
					connectOptions.mqttVersion = 4;
				} else {
					connectOptions.mqttVersionExplicit = true;
				}

				//Check that if password is set, so is username
				if (connectOptions.password !== undefined && connectOptions.userName === undefined)
					throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.password, "connectOptions.password"]));

				if (connectOptions.willMessage) {
					if (!(connectOptions.willMessage instanceof Message))
						throw new Error(format(ERROR.INVALID_TYPE, [connectOptions.willMessage, "connectOptions.willMessage"]));
					// The will message must have a payload that can be represented as a string.
					// Cause the willMessage to throw an exception if this is not the case.
					connectOptions.willMessage.stringPayload = null;

					if (typeof connectOptions.willMessage.destinationName === "undefined")
						throw new Error(format(ERROR.INVALID_TYPE, [typeof connectOptions.willMessage.destinationName, "connectOptions.willMessage.destinationName"]));
				}
				if (typeof connectOptions.cleanSession === "undefined")
					connectOptions.cleanSession = true;
				if (connectOptions.hosts) {

					if (!(connectOptions.hosts instanceof Array) )
						throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts, "connectOptions.hosts"]));
					if (connectOptions.hosts.length <1 )
						throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts, "connectOptions.hosts"]));

					var usingURIs = false;
					for (var i = 0; i<connectOptions.hosts.length; i++) {
						if (typeof connectOptions.hosts[i] !== "string")
							throw new Error(format(ERROR.INVALID_TYPE, [typeof connectOptions.hosts[i], "connectOptions.hosts["+i+"]"]));
						if (/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/.test(connectOptions.hosts[i])) {
							if (i === 0) {
								usingURIs = true;
							} else if (!usingURIs) {
								throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts[i], "connectOptions.hosts["+i+"]"]));
							}
						} else if (usingURIs) {
							throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts[i], "connectOptions.hosts["+i+"]"]));
						}
					}

					if (!usingURIs) {
						if (!connectOptions.ports)
							throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.ports, "connectOptions.ports"]));
						if (!(connectOptions.ports instanceof Array) )
							throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.ports, "connectOptions.ports"]));
						if (connectOptions.hosts.length !== connectOptions.ports.length)
							throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.ports, "connectOptions.ports"]));

						connectOptions.uris = [];

						for (var i = 0; i<connectOptions.hosts.length; i++) {
							if (typeof connectOptions.ports[i] !== "number" || connectOptions.ports[i] < 0)
								throw new Error(format(ERROR.INVALID_TYPE, [typeof connectOptions.ports[i], "connectOptions.ports["+i+"]"]));
							var host = connectOptions.hosts[i];
							var port = connectOptions.ports[i];

							var ipv6 = (host.indexOf(":") !== -1);
							uri = "ws://"+(ipv6?"["+host+"]":host)+":"+port+path;
							connectOptions.uris.push(uri);
						}
					} else {
						connectOptions.uris = connectOptions.hosts;
					}
				}

				client.connect(connectOptions);
			};

			/**
		 * Subscribe for messages, request receipt of a copy of messages sent to the destinations described by the filter.
		 *
		 * @name Paho.Client#subscribe
		 * @function
		 * @param {string} filter describing the destinations to receive messages from.
		 * <br>
		 * @param {object} subscribeOptions - used to control the subscription
		 *
		 * @param {number} subscribeOptions.qos - the maximum qos of any publications sent
		 *                                  as a result of making this subscription.
		 * @param {object} subscribeOptions.invocationContext - passed to the onSuccess callback
		 *                                  or onFailure callback.
		 * @param {function} subscribeOptions.onSuccess - called when the subscribe acknowledgement
		 *                                  has been received from the server.
		 *                                  A single response object parameter is passed to the onSuccess callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext if set in the subscribeOptions.
		 *                                  </ol>
		 * @param {function} subscribeOptions.onFailure - called when the subscribe request has failed or timed out.
		 *                                  A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext - if set in the subscribeOptions.
		 *                                  <li>errorCode - a number indicating the nature of the error.
		 *                                  <li>errorMessage - text describing the error.
		 *                                  </ol>
		 * @param {number} subscribeOptions.timeout - which, if present, determines the number of
		 *                                  seconds after which the onFailure calback is called.
		 *                                  The presence of a timeout does not prevent the onSuccess
		 *                                  callback from being called when the subscribe completes.
		 * @throws {InvalidState} if the client is not in connected state.
		 */
			this.subscribe = function (filter, subscribeOptions) {
				if (typeof filter !== "string" && filter.constructor !== Array)
					throw new Error("Invalid argument:"+filter);
				subscribeOptions = subscribeOptions || {} ;
				validate(subscribeOptions,  {qos:"number",
					invocationContext:"object",
					onSuccess:"function",
					onFailure:"function",
					timeout:"number"
				});
				if (subscribeOptions.timeout && !subscribeOptions.onFailure)
					throw new Error("subscribeOptions.timeout specified with no onFailure callback.");
				if (typeof subscribeOptions.qos !== "undefined" && !(subscribeOptions.qos === 0 || subscribeOptions.qos === 1 || subscribeOptions.qos === 2 ))
					throw new Error(format(ERROR.INVALID_ARGUMENT, [subscribeOptions.qos, "subscribeOptions.qos"]));
				client.subscribe(filter, subscribeOptions);
			};

		/**
		 * Unsubscribe for messages, stop receiving messages sent to destinations described by the filter.
		 *
		 * @name Paho.Client#unsubscribe
		 * @function
		 * @param {string} filter - describing the destinations to receive messages from.
		 * @param {object} unsubscribeOptions - used to control the subscription
		 * @param {object} unsubscribeOptions.invocationContext - passed to the onSuccess callback
											  or onFailure callback.
		 * @param {function} unsubscribeOptions.onSuccess - called when the unsubscribe acknowledgement has been received from the server.
		 *                                    A single response object parameter is passed to the
		 *                                    onSuccess callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.
		 *                                    </ol>
		 * @param {function} unsubscribeOptions.onFailure called when the unsubscribe request has failed or timed out.
		 *                                    A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.
		 *                                    <li>errorCode - a number indicating the nature of the error.
		 *                                    <li>errorMessage - text describing the error.
		 *                                    </ol>
		 * @param {number} unsubscribeOptions.timeout - which, if present, determines the number of seconds
		 *                                    after which the onFailure callback is called. The presence of
		 *                                    a timeout does not prevent the onSuccess callback from being
		 *                                    called when the unsubscribe completes
		 * @throws {InvalidState} if the client is not in connected state.
		 */
			this.unsubscribe = function (filter, unsubscribeOptions) {
				if (typeof filter !== "string" && filter.constructor !== Array)
					throw new Error("Invalid argument:"+filter);
				unsubscribeOptions = unsubscribeOptions || {} ;
				validate(unsubscribeOptions,  {invocationContext:"object",
					onSuccess:"function",
					onFailure:"function",
					timeout:"number"
				});
				if (unsubscribeOptions.timeout && !unsubscribeOptions.onFailure)
					throw new Error("unsubscribeOptions.timeout specified with no onFailure callback.");
				client.unsubscribe(filter, unsubscribeOptions);
			};

			/**
		 * Send a message to the consumers of the destination in the Message.
		 *
		 * @name Paho.Client#send
		 * @function
		 * @param {string|Paho.Message} topic - <b>mandatory</b> The name of the destination to which the message is to be sent.
		 * 					   - If it is the only parameter, used as Paho.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be sent.
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
		 *                     A received message has the retained boolean set to true if the message was published
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published.
		 * @throws {InvalidState} if the client is not connected.
		 */
			this.send = function (topic,payload,qos,retained) {
				var message ;

				if(arguments.length === 0){
					throw new Error("Invalid argument."+"length");

				}else if(arguments.length == 1) {

					if (!(topic instanceof Message) && (typeof topic !== "string"))
						throw new Error("Invalid argument:"+ typeof topic);

					message = topic;
					if (typeof message.destinationName === "undefined")
						throw new Error(format(ERROR.INVALID_ARGUMENT,[message.destinationName,"Message.destinationName"]));
					client.send(message);

				}else {
				//parameter checking in Message object
					message = new Message(payload);
					message.destinationName = topic;
					if(arguments.length >= 3)
						message.qos = qos;
					if(arguments.length >= 4)
						message.retained = retained;
					client.send(message);
				}
			};

			/**
		 * Publish a message to the consumers of the destination in the Message.
		 * Synonym for Paho.Mqtt.Client#send
		 *
		 * @name Paho.Client#publish
		 * @function
		 * @param {string|Paho.Message} topic - <b>mandatory</b> The name of the topic to which the message is to be published.
		 * 					   - If it is the only parameter, used as Paho.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be published.
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
		 *                     A received message has the retained boolean set to true if the message was published
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published.
		 * @throws {InvalidState} if the client is not connected.
		 */
			this.publish = function(topic,payload,qos,retained) {
				var message ;

				if(arguments.length === 0){
					throw new Error("Invalid argument."+"length");

				}else if(arguments.length == 1) {

					if (!(topic instanceof Message) && (typeof topic !== "string"))
						throw new Error("Invalid argument:"+ typeof topic);

					message = topic;
					if (typeof message.destinationName === "undefined")
						throw new Error(format(ERROR.INVALID_ARGUMENT,[message.destinationName,"Message.destinationName"]));
					client.send(message);

				}else {
					//parameter checking in Message object
					message = new Message(payload);
					message.destinationName = topic;
					if(arguments.length >= 3)
						message.qos = qos;
					if(arguments.length >= 4)
						message.retained = retained;
					client.send(message);
				}
			};

			/**
		 * Normal disconnect of this Messaging client from its server.
		 *
		 * @name Paho.Client#disconnect
		 * @function
		 * @throws {InvalidState} if the client is already disconnected.
		 */
			this.disconnect = function () {
				client.disconnect();
			};

			/**
		 * Get the contents of the trace log.
		 *
		 * @name Paho.Client#getTraceLog
		 * @function
		 * @return {Object[]} tracebuffer containing the time ordered trace records.
		 */
			this.getTraceLog = function () {
				return client.getTraceLog();
			};

			/**
		 * Start tracing.
		 *
		 * @name Paho.Client#startTrace
		 * @function
		 */
			this.startTrace = function () {
				client.startTrace();
			};

			/**
		 * Stop tracing.
		 *
		 * @name Paho.Client#stopTrace
		 * @function
		 */
			this.stopTrace = function () {
				client.stopTrace();
			};

			this.isConnected = function() {
				return client.connected;
			};
		};

		/**
	 * An application message, sent or received.
	 * <p>
	 * All attributes may be null, which implies the default values.
	 *
	 * @name Paho.Message
	 * @constructor
	 * @param {String|ArrayBuffer} payload The message data to be sent.
	 * <p>
	 * @property {string} payloadString <i>read only</i> The payload as a string if the payload consists of valid UTF-8 characters.
	 * @property {ArrayBuffer} payloadBytes <i>read only</i> The payload as an ArrayBuffer.
	 * <p>
	 * @property {string} destinationName <b>mandatory</b> The name of the destination to which the message is to be sent
	 *                    (for messages about to be sent) or the name of the destination from which the message has been received.
	 *                    (for messages received by the onMessage function).
	 * <p>
	 * @property {number} qos The Quality of Service used to deliver the message.
	 * <dl>
	 *     <dt>0 Best effort (default).
	 *     <dt>1 At least once.
	 *     <dt>2 Exactly once.
	 * </dl>
	 * <p>
	 * @property {Boolean} retained If true, the message is to be retained by the server and delivered
	 *                     to both current and future subscriptions.
	 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
	 *                     A received message has the retained boolean set to true if the message was published
	 *                     with the retained boolean set to true
	 *                     and the subscrption was made after the message has been published.
	 * <p>
	 * @property {Boolean} duplicate <i>read only</i> If true, this message might be a duplicate of one which has already been received.
	 *                     This is only set on messages received from the server.
	 *
	 */
		var Message = function (newPayload) {
			var payload;
			if (   typeof newPayload === "string" ||
		newPayload instanceof ArrayBuffer ||
		(ArrayBuffer.isView(newPayload) && !(newPayload instanceof DataView))
			) {
				payload = newPayload;
			} else {
				throw (format(ERROR.INVALID_ARGUMENT, [newPayload, "newPayload"]));
			}

			var destinationName;
			var qos = 0;
			var retained = false;
			var duplicate = false;

			Object.defineProperties(this,{
				"payloadString":{
					enumerable : true,
					get : function () {
						if (typeof payload === "string")
							return payload;
						else
							return parseUTF8(payload, 0, payload.length);
					}
				},
				"payloadBytes":{
					enumerable: true,
					get: function() {
						if (typeof payload === "string") {
							var buffer = new ArrayBuffer(UTF8Length(payload));
							var byteStream = new Uint8Array(buffer);
							stringToUTF8(payload, byteStream, 0);

							return byteStream;
						} else {
							return payload;
						}
					}
				},
				"destinationName":{
					enumerable: true,
					get: function() { return destinationName; },
					set: function(newDestinationName) {
						if (typeof newDestinationName === "string")
							destinationName = newDestinationName;
						else
							throw new Error(format(ERROR.INVALID_ARGUMENT, [newDestinationName, "newDestinationName"]));
					}
				},
				"qos":{
					enumerable: true,
					get: function() { return qos; },
					set: function(newQos) {
						if (newQos === 0 || newQos === 1 || newQos === 2 )
							qos = newQos;
						else
							throw new Error("Invalid argument:"+newQos);
					}
				},
				"retained":{
					enumerable: true,
					get: function() { return retained; },
					set: function(newRetained) {
						if (typeof newRetained === "boolean")
							retained = newRetained;
						else
							throw new Error(format(ERROR.INVALID_ARGUMENT, [newRetained, "newRetained"]));
					}
				},
				"topic":{
					enumerable: true,
					get: function() { return destinationName; },
					set: function(newTopic) {destinationName=newTopic;}
				},
				"duplicate":{
					enumerable: true,
					get: function() { return duplicate; },
					set: function(newDuplicate) {duplicate=newDuplicate;}
				}
			});
		};

		// Module contents.
		return {
			Client: Client,
			Message: Message
		};
	// eslint-disable-next-line no-nested-ternary
	})(typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	return PahoMQTT;
});


/***/ }),

/***/ 7320:
/***/ ((module) => {

"use strict";
var __webpack_unused_export__;
// Copyright (c) 2015-2017 David M. Lee, II


/**
 * Local reference to TimeoutError
 * @private
 */
var TimeoutError;

/**
 * Rejects a promise with a {@link TimeoutError} if it does not settle within
 * the specified timeout.
 *
 * @param {Promise} promise The promise.
 * @param {number} timeoutMillis Number of milliseconds to wait on settling.
 * @returns {Promise} Either resolves/rejects with `promise`, or rejects with
 *                   `TimeoutError`, whichever settles first.
 */
var timeout = module.exports.w = function(promise, timeoutMillis) {
  var error = new TimeoutError(),
      timeout;

  return Promise.race([
    promise,
    new Promise(function(resolve, reject) {
      timeout = setTimeout(function() {
        reject(error);
      }, timeoutMillis);
    }),
  ]).then(function(v) {
    clearTimeout(timeout);
    return v;
  }, function(err) {
    clearTimeout(timeout);
    throw err;
  });
};

/**
 * Exception indicating that the timeout expired.
 */
TimeoutError = __webpack_unused_export__ = function() {
  Error.call(this)
  this.stack = Error().stack
  this.message = 'Timeout';
};

TimeoutError.prototype = Object.create(Error.prototype);
TimeoutError.prototype.name = "TimeoutError";


/***/ }),

/***/ 1630:
/***/ ((module) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 9106:
/***/ ((module) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 7186:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports.decode = exports.parse = __webpack_require__(1630);
exports.encode = exports.stringify = __webpack_require__(9106);


/***/ }),

/***/ 4224:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const sleep = (time) => __awaiter(void 0, void 0, void 0, function* () { return new Promise(resolve => setTimeout(() => resolve(time), time)); });
exports.sleep = sleep;
exports.sleepMilliseconds = sleep;
const sleepSeconds = (timeInSeconds) => __awaiter(void 0, void 0, void 0, function* () { return sleep(timeInSeconds * 1000); });
exports.sleepSeconds = sleepSeconds;
const sleepMinutes = (timeInMinutes) => __awaiter(void 0, void 0, void 0, function* () { return sleepSeconds(timeInMinutes * 60); });
exports.sleepMinutes = sleepMinutes;
const sleepHours = (timeInHours) => __awaiter(void 0, void 0, void 0, function* () { return sleepMinutes(timeInHours * 60); });
exports.sleepHours = sleepHours;
const sleepDays = (timeInDays) => __awaiter(void 0, void 0, void 0, function* () { return sleepHours(timeInDays * 24); });
exports.sleepDays = sleepDays;


/***/ }),

/***/ 255:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	// `root` does not resolve to the global window object in a Browserified
	// bundle, so a direct reference to that object is used instead.
	var _srcDoc = window.srcDoc;

	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function(exports) {
			factory(exports, _srcDoc);
			root.srcDoc = exports;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
})(this, function(exports, _srcDoc) {
	var idx, iframes;
	var isCompliant = !!("srcdoc" in document.createElement("iframe"));
	var sandboxMsg = "Polyfill may not function in the presence of the " +
		"`sandbox` attribute. Consider using the `force` option.";
	var sandboxAllow = /\ballow-same-origin\b/;
	/**
	 * Determine if the operation may be blocked by the `sandbox` attribute in
	 * some environments, and optionally issue a warning or remove the
	 * attribute.
	 */
	var validate = function( iframe, options ) {
		var sandbox = iframe.getAttribute("sandbox");
		if (typeof sandbox === "string" && !sandboxAllow.test(sandbox)) {
			if (options && options.force) {
				iframe.removeAttribute("sandbox");
			} else if (!options || options.force !== false) {
				logError(sandboxMsg);
				iframe.setAttribute("data-srcdoc-polyfill", sandboxMsg);
			}
		}
	};
	var implementations = {
		compliant: function( iframe, content, options ) {

			if (content) {
				validate(iframe, options);
				iframe.setAttribute("srcdoc", content);
			}
		},
		legacy: function( iframe, content, options ) {

			var jsUrl;

			if (!iframe || !iframe.getAttribute) {
				return;
			}

			if (!content) {
				content = iframe.getAttribute("srcdoc");
			} else {
				iframe.setAttribute("srcdoc", content);
			}

			if (content) {
				validate(iframe, options);

				// The value returned by a script-targeted URL will be used as
				// the iFrame's content. Create such a URL which returns the
				// iFrame element's `srcdoc` attribute.
				jsUrl = "javascript: window.frameElement.getAttribute('srcdoc');";

				// Explicitly set the iFrame's window.location for
				// compatability with IE9, which does not react to changes in
				// the `src` attribute when it is a `javascript:` URL, for
				// some reason
				if (iframe.contentWindow) {
					iframe.contentWindow.location = jsUrl;
				}

				iframe.setAttribute("src", jsUrl);
			}
		}
	};
	var srcDoc = exports;
	var logError;

	if (window.console && window.console.error) {
		logError = function(msg) {
			window.console.error("[srcdoc-polyfill] " + msg);
		};
	} else {
		logError = function() {};
	}

	// Assume the best
	srcDoc.set = implementations.compliant;
	srcDoc.noConflict = function() {
		window.srcDoc = _srcDoc;
		return srcDoc;
	};

	// If the browser supports srcdoc, no shimming is necessary
	if (isCompliant) {
		return;
	}

	srcDoc.set = implementations.legacy;

	// Automatically shim any iframes already present in the document
	iframes = document.getElementsByTagName("iframe");
	idx = iframes.length;

	while (idx--) {
		srcDoc.set( iframes[idx] );
	}

});


/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.3.2 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports =  true && exports &&
		!exports.nodeType && exports;
	var freeModule =  true && module &&
		!module.nodeType && module;
	var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}(this));


/***/ }),

/***/ 8835:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(1270);
var util = __webpack_require__(2268);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(7186);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),

/***/ 2268:
/***/ ((module) => {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),

/***/ 6615:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(8402);

/***/ }),

/***/ 7169:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(7867);

/***/ }),

/***/ 1393:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(530);

/***/ }),

/***/ 6319:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(2616);

/***/ }),

/***/ 6226:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(4525);

/***/ }),

/***/ 8628:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(6343);

/***/ }),

/***/ 4007:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(7852);

/***/ }),

/***/ 5413:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(1618);

/***/ }),

/***/ 8079:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(8894);

/***/ }),

/***/ 3363:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(9528);

/***/ }),

/***/ 8979:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(6686);

/***/ }),

/***/ 385:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(26);

/***/ }),

/***/ 1265:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(4598);

/***/ }),

/***/ 5110:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(9703);

/***/ }),

/***/ 1549:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(8251);

/***/ }),

/***/ 8573:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(4532);

/***/ }),

/***/ 8928:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(6513);

/***/ }),

/***/ 6751:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(3220);

/***/ }),

/***/ 6100:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(9563);

/***/ }),

/***/ 697:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(6490);

/***/ }),

/***/ 7119:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(5980);

/***/ }),

/***/ 6586:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(1921);

/***/ }),

/***/ 1240:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(5204);

/***/ }),

/***/ 2574:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(5177);

/***/ }),

/***/ 4607:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(4674);

/***/ }),

/***/ 6255:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(568);

/***/ }),

/***/ 6984:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(9792);

/***/ }),

/***/ 7842:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(9428);

/***/ }),

/***/ 2472:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(4062);

/***/ }),

/***/ 5953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(1234)["default"]);
var _Object$defineProperty = __webpack_require__(591);
var _Symbol = __webpack_require__(3071);
var _Object$create = __webpack_require__(4006);
var _Object$getPrototypeOf = __webpack_require__(5169);
var _forEachInstanceProperty = __webpack_require__(3113);
var _pushInstanceProperty = __webpack_require__(1958);
var _Object$setPrototypeOf = __webpack_require__(6269);
var _Promise = __webpack_require__(6160);
var _reverseInstanceProperty = __webpack_require__(734);
var _sliceInstanceProperty = __webpack_require__(5186);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = _Object$defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof _Symbol ? _Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return _Object$defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = _Object$create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = _Object$getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = _Object$create(p);
  function defineIteratorMethods(t) {
    var _context;
    _forEachInstanceProperty(_context = ["next", "throw", "return"]).call(_context, function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var _context2;
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), _pushInstanceProperty(_context2 = this.tryEntries).call(_context2, e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], _forEachInstanceProperty(t).call(t, pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return _Object$setPrototypeOf ? _Object$setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = _Object$create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = _Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) _pushInstanceProperty(r).call(r, n);
    return _reverseInstanceProperty(r).call(r), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      var _context3;
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, _forEachInstanceProperty(_context3 = this.tryEntries).call(_context3, resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+_sliceInstanceProperty(r).call(r, 1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1234:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _Symbol = __webpack_require__(3071);
var _Symbol$iterator = __webpack_require__(4473);
function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof _Symbol && o.constructor === _Symbol && o !== _Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 4828:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(5953)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 7985:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(6450);

module.exports = parent;


/***/ }),

/***/ 7725:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(8402);

module.exports = parent;


/***/ }),

/***/ 8690:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(3067);

module.exports = parent;


/***/ }),

/***/ 3700:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(9709);

module.exports = parent;


/***/ }),

/***/ 2544:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(4525);

module.exports = parent;


/***/ }),

/***/ 5779:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(3266);

module.exports = parent;


/***/ }),

/***/ 9433:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(4106);

module.exports = parent;


/***/ }),

/***/ 6221:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(6686);

module.exports = parent;


/***/ }),

/***/ 6975:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(3658);

module.exports = parent;


/***/ }),

/***/ 6040:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(8251);

module.exports = parent;


/***/ }),

/***/ 4842:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(6513);

module.exports = parent;


/***/ }),

/***/ 1168:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(9261);

module.exports = parent;


/***/ }),

/***/ 4972:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(7777);

module.exports = parent;


/***/ }),

/***/ 9645:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(5204);
// TODO: Remove from `core-js@4`
__webpack_require__(7637);
__webpack_require__(3568);

module.exports = parent;


/***/ }),

/***/ 8377:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(9416);

module.exports = parent;


/***/ }),

/***/ 7264:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(4139);

__webpack_require__(768);
__webpack_require__(8549);
__webpack_require__(7152);
__webpack_require__(1372);

module.exports = parent;


/***/ }),

/***/ 9692:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(7045);

module.exports = parent;


/***/ }),

/***/ 5663:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(70);

module.exports = parent;


/***/ }),

/***/ 3607:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(7057);
__webpack_require__(7277);
var path = __webpack_require__(2046);

module.exports = path.Array.from;


/***/ }),

/***/ 3531:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(2425);
var path = __webpack_require__(2046);

module.exports = path.Array.isArray;


/***/ }),

/***/ 6275:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(8545);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Array', 'concat');


/***/ }),

/***/ 6177:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(9295);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Array', 'filter');


/***/ }),

/***/ 2092:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(5650);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Array', 'forEach');


/***/ }),

/***/ 1362:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(9748);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Array', 'includes');


/***/ }),

/***/ 3309:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(6391);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Array', 'indexOf');


/***/ }),

/***/ 6535:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(9363);
__webpack_require__(3643);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Array', 'keys');


/***/ }),

/***/ 8253:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(6687);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Array', 'map');


/***/ }),

/***/ 1127:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(5745);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Array', 'push');


/***/ }),

/***/ 6693:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(6339);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Array', 'reduce');


/***/ }),

/***/ 6429:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(8559);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Array', 'reverse');


/***/ }),

/***/ 5265:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(2099);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Array', 'slice');


/***/ }),

/***/ 4923:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(8334);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Array', 'splice');


/***/ }),

/***/ 5354:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(5362);
var path = __webpack_require__(2046);

module.exports = path.Date.now;


/***/ }),

/***/ 2567:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(9307);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('Function', 'bind');


/***/ }),

/***/ 4712:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(9363);
__webpack_require__(7057);
var getIteratorMethod = __webpack_require__(3448);

module.exports = getIteratorMethod;


/***/ }),

/***/ 3034:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(2567);

var FunctionPrototype = Function.prototype;

module.exports = function (it) {
  var own = it.bind;
  return it === FunctionPrototype || (isPrototypeOf(FunctionPrototype, it) && own === FunctionPrototype.bind) ? method : own;
};


/***/ }),

/***/ 8218:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(6275);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.concat;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.concat) ? method : own;
};


/***/ }),

/***/ 3155:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(6177);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.filter;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.filter) ? method : own;
};


/***/ }),

/***/ 6880:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);
var arrayMethod = __webpack_require__(1362);
var stringMethod = __webpack_require__(4378);

var ArrayPrototype = Array.prototype;
var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.includes;
  if (it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.includes)) return arrayMethod;
  if (typeof it == 'string' || it === StringPrototype || (isPrototypeOf(StringPrototype, it) && own === StringPrototype.includes)) {
    return stringMethod;
  } return own;
};


/***/ }),

/***/ 4507:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(3309);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.indexOf;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.indexOf) ? method : own;
};


/***/ }),

/***/ 9299:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(8253);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.map;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.map) ? method : own;
};


/***/ }),

/***/ 8685:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(1127);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.push;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.push) ? method : own;
};


/***/ }),

/***/ 8823:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(6693);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.reduce;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.reduce) ? method : own;
};


/***/ }),

/***/ 8059:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(6429);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.reverse;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.reverse) ? method : own;
};


/***/ }),

/***/ 303:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(5265);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.slice;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.slice) ? method : own;
};


/***/ }),

/***/ 5029:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(4923);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.splice;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.splice) ? method : own;
};


/***/ }),

/***/ 3423:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(7511);

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.trim;
  return typeof it == 'string' || it === StringPrototype
    || (isPrototypeOf(StringPrototype, it) && own === StringPrototype.trim) ? method : own;
};


/***/ }),

/***/ 149:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(5837);
var path = __webpack_require__(2046);

var Object = path.Object;

module.exports = function create(P, D) {
  return Object.create(P, D);
};


/***/ }),

/***/ 8970:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(7810);
var path = __webpack_require__(2046);

var Object = path.Object;

var defineProperties = module.exports = function defineProperties(T, D) {
  return Object.defineProperties(T, D);
};

if (Object.defineProperties.sham) defineProperties.sham = true;


/***/ }),

/***/ 1926:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(6750);
var path = __webpack_require__(2046);

var Object = path.Object;

var defineProperty = module.exports = function defineProperty(it, key, desc) {
  return Object.defineProperty(it, key, desc);
};

if (Object.defineProperty.sham) defineProperty.sham = true;


/***/ }),

/***/ 30:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(4729);
var path = __webpack_require__(2046);

module.exports = path.Object.entries;


/***/ }),

/***/ 5092:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(7052);
var path = __webpack_require__(2046);

var Object = path.Object;

var getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
  return Object.getOwnPropertyDescriptor(it, key);
};

if (Object.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor.sham = true;


/***/ }),

/***/ 9147:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(179);
var path = __webpack_require__(2046);

module.exports = path.Object.getOwnPropertyDescriptors;


/***/ }),

/***/ 4776:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(4452);
var path = __webpack_require__(2046);

module.exports = path.Object.getOwnPropertySymbols;


/***/ }),

/***/ 6286:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(8966);
var path = __webpack_require__(2046);

module.exports = path.Object.getPrototypeOf;


/***/ }),

/***/ 9661:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(3589);
var path = __webpack_require__(2046);

module.exports = path.Object.keys;


/***/ }),

/***/ 1418:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(1906);
var path = __webpack_require__(2046);

module.exports = path.Object.setPrototypeOf;


/***/ }),

/***/ 8699:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(5395);
var path = __webpack_require__(2046);

module.exports = path.Object.values;


/***/ }),

/***/ 4326:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(2193);
var path = __webpack_require__(2046);

module.exports = path.parseInt;


/***/ }),

/***/ 7027:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(4502);
__webpack_require__(9363);
__webpack_require__(3643);
__webpack_require__(5931);
__webpack_require__(7450);
__webpack_require__(6415);
__webpack_require__(7380);
__webpack_require__(5823);
__webpack_require__(7714);
__webpack_require__(7057);
var path = __webpack_require__(2046);

module.exports = path.Promise;


/***/ }),

/***/ 6098:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(1220);
var path = __webpack_require__(2046);

module.exports = path.Reflect.construct;


/***/ }),

/***/ 655:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(3357);
var path = __webpack_require__(2046);

module.exports = path.Reflect.get;


/***/ }),

/***/ 4378:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(9770);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('String', 'includes');


/***/ }),

/***/ 7511:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(727);
var getBuiltInPrototypeMethod = __webpack_require__(1747);

module.exports = getBuiltInPrototypeMethod('String', 'trim');


/***/ }),

/***/ 3842:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(8545);
__webpack_require__(3643);
__webpack_require__(4452);
__webpack_require__(3997);
__webpack_require__(5084);
__webpack_require__(2596);
__webpack_require__(5721);
__webpack_require__(4954);
__webpack_require__(4123);
__webpack_require__(3377);
__webpack_require__(2230);
__webpack_require__(5344);
__webpack_require__(1660);
__webpack_require__(4610);
__webpack_require__(3669);
__webpack_require__(4810);
__webpack_require__(3325);
__webpack_require__(7024);
__webpack_require__(8172);
__webpack_require__(5205);
var path = __webpack_require__(2046);

module.exports = path.Symbol;


/***/ }),

/***/ 1730:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(9363);
__webpack_require__(3643);
__webpack_require__(7057);
__webpack_require__(4954);
var WrappedWellKnownSymbolModule = __webpack_require__(560);

module.exports = WrappedWellKnownSymbolModule.f('iterator');


/***/ }),

/***/ 1661:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(8537);
__webpack_require__(3669);
var WrappedWellKnownSymbolModule = __webpack_require__(560);

module.exports = WrappedWellKnownSymbolModule.f('toPrimitive');


/***/ }),

/***/ 7173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(9363);
__webpack_require__(3643);
__webpack_require__(6571);
var path = __webpack_require__(2046);

module.exports = path.WeakMap;


/***/ }),

/***/ 7499:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(9363);
__webpack_require__(3643);
__webpack_require__(741);
var path = __webpack_require__(2046);

module.exports = path.WeakSet;


/***/ }),

/***/ 3113:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(8959);


/***/ }),

/***/ 1958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(3520);


/***/ }),

/***/ 734:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(288);


/***/ }),

/***/ 5186:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(4908);


/***/ }),

/***/ 4006:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(7764);


/***/ }),

/***/ 591:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(4997);


/***/ }),

/***/ 5169:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(7415);


/***/ }),

/***/ 6269:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(5363);


/***/ }),

/***/ 6160:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(7166);


/***/ }),

/***/ 3071:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(2321);


/***/ }),

/***/ 4473:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(2231);


/***/ }),

/***/ 8980:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(7985);

module.exports = parent;


/***/ }),

/***/ 1564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(7725);

module.exports = parent;


/***/ }),

/***/ 9029:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(8690);

module.exports = parent;


/***/ }),

/***/ 3375:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(3700);

module.exports = parent;


/***/ }),

/***/ 8959:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(2544);

module.exports = parent;


/***/ }),

/***/ 3520:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(5779);

module.exports = parent;


/***/ }),

/***/ 288:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(9433);

module.exports = parent;


/***/ }),

/***/ 4908:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(6221);

module.exports = parent;


/***/ }),

/***/ 7764:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(6975);

module.exports = parent;


/***/ }),

/***/ 4997:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(6040);

module.exports = parent;


/***/ }),

/***/ 5983:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(4842);

module.exports = parent;


/***/ }),

/***/ 7415:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(1168);

module.exports = parent;


/***/ }),

/***/ 5363:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(4972);

module.exports = parent;


/***/ }),

/***/ 7166:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(9645);
// TODO: Remove from `core-js@4`
__webpack_require__(1599);
__webpack_require__(7939);
__webpack_require__(4362);

module.exports = parent;


/***/ }),

/***/ 1138:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(8377);

module.exports = parent;


/***/ }),

/***/ 2321:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(7264);
__webpack_require__(3939);
__webpack_require__(1785);
__webpack_require__(1697);
__webpack_require__(4664);
// TODO: Remove from `core-js@4`
__webpack_require__(3422);
__webpack_require__(36);
__webpack_require__(8703);
__webpack_require__(6878);
__webpack_require__(9671);
__webpack_require__(359);

module.exports = parent;


/***/ }),

/***/ 2231:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(9692);

module.exports = parent;


/***/ }),

/***/ 9280:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(5663);

module.exports = parent;


/***/ }),

/***/ 2159:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isCallable = __webpack_require__(2250);
var tryToString = __webpack_require__(4640);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 2235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isConstructor = __webpack_require__(5468);
var tryToString = __webpack_require__(4640);

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ 43:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPossiblePrototype = __webpack_require__(4018);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 2156:
/***/ ((module) => {

"use strict";

module.exports = function () { /* empty */ };


/***/ }),

/***/ 9596:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(8280);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};


/***/ }),

/***/ 6624:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isObject = __webpack_require__(6285);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 6375:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__(8828);

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),

/***/ 2914:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $forEach = (__webpack_require__(726).forEach);
var arrayMethodIsStrict = __webpack_require__(7623);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 1229:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(8311);
var call = __webpack_require__(3930);
var toObject = __webpack_require__(9298);
var callWithSafeIterationClosing = __webpack_require__(6818);
var isArrayIteratorMethod = __webpack_require__(7812);
var isConstructor = __webpack_require__(5468);
var lengthOfArrayLike = __webpack_require__(575);
var createProperty = __webpack_require__(5543);
var getIterator = __webpack_require__(300);
var getIteratorMethod = __webpack_require__(3448);

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    result = IS_CONSTRUCTOR ? new this() : [];
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ 4436:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIndexedObject = __webpack_require__(7374);
var toAbsoluteIndex = __webpack_require__(4849);
var lengthOfArrayLike = __webpack_require__(575);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 726:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(8311);
var uncurryThis = __webpack_require__(1907);
var IndexedObject = __webpack_require__(6946);
var toObject = __webpack_require__(9298);
var lengthOfArrayLike = __webpack_require__(575);
var arraySpeciesCreate = __webpack_require__(6968);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(self);
    var boundFunction = bind(callbackfn, that);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 7171:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(8828);
var wellKnownSymbol = __webpack_require__(6264);
var V8_VERSION = __webpack_require__(798);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 7623:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(8828);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ 5043:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__(2159);
var toObject = __webpack_require__(9298);
var IndexedObject = __webpack_require__(6946);
var lengthOfArrayLike = __webpack_require__(575);

var $TypeError = TypeError;

var REDUCE_EMPTY = 'Reduce of empty array with no initial value';

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    aCallable(callbackfn);
    if (length === 0 && argumentsLength < 2) throw new $TypeError(REDUCE_EMPTY);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError(REDUCE_EMPTY);
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ 3130:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(9447);
var isArray = __webpack_require__(1793);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 3427:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);

module.exports = uncurryThis([].slice);


/***/ }),

/***/ 4321:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var arraySlice = __webpack_require__(3427);

var floor = Math.floor;

var sort = function (array, comparefn) {
  var length = array.length;

  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;

    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor(length / 2);
    var left = sort(arraySlice(array, 0, middle), comparefn);
    var right = sort(arraySlice(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;

    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = (lindex < llength && rindex < rlength)
        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
        : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }

  return array;
};

module.exports = sort;


/***/ }),

/***/ 4010:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isArray = __webpack_require__(1793);
var isConstructor = __webpack_require__(5468);
var isObject = __webpack_require__(6285);
var wellKnownSymbol = __webpack_require__(6264);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ 6968:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var arraySpeciesConstructor = __webpack_require__(4010);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 6818:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__(6624);
var iteratorClose = __webpack_require__(154);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ 473:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(6264);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 5807:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 3948:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(2623);
var isCallable = __webpack_require__(2250);
var classofRaw = __webpack_require__(5807);
var wellKnownSymbol = __webpack_require__(6264);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 1182:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);
var defineBuiltIns = __webpack_require__(2802);
var getWeakData = (__webpack_require__(1548).getWeakData);
var anInstance = __webpack_require__(9596);
var anObject = __webpack_require__(6624);
var isNullOrUndefined = __webpack_require__(7136);
var isObject = __webpack_require__(6285);
var iterate = __webpack_require__(4823);
var ArrayIterationModule = __webpack_require__(726);
var hasOwn = __webpack_require__(9724);
var InternalStateModule = __webpack_require__(4932);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis([].splice);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (state) {
  return state.frozen || (state.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice(this.entries, index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: null
      });
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    defineBuiltIns(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwn(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwn(data, state.id);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          if (data) return data[state.id];
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return Constructor;
  }
};


/***/ }),

/***/ 7081:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var globalThis = __webpack_require__(5951);
var InternalMetadataModule = __webpack_require__(1548);
var fails = __webpack_require__(8828);
var createNonEnumerableProperty = __webpack_require__(1626);
var iterate = __webpack_require__(4823);
var anInstance = __webpack_require__(9596);
var isCallable = __webpack_require__(2250);
var isObject = __webpack_require__(6285);
var isNullOrUndefined = __webpack_require__(7136);
var setToStringTag = __webpack_require__(4840);
var defineProperty = (__webpack_require__(4284).f);
var forEach = (__webpack_require__(726).forEach);
var DESCRIPTORS = __webpack_require__(9447);
var InternalStateModule = __webpack_require__(4932);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = globalThis[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var exported = {};
  var Constructor;

  if (!DESCRIPTORS || !isCallable(NativeConstructor)
    || !(IS_WEAK || NativePrototype.forEach && !fails(function () { new NativeConstructor().entries().next(); }))
  ) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else {
    Constructor = wrapper(function (target, iterable) {
      setInternalState(anInstance(target, Prototype), {
        type: CONSTRUCTOR_NAME,
        collection: new NativeConstructor()
      });
      if (!isNullOrUndefined(iterable)) iterate(iterable, target[ADDER], { that: target, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    forEach(['add', 'clear', 'delete', 'forEach', 'get', 'has', 'set', 'keys', 'values', 'entries'], function (KEY) {
      var IS_ADDER = KEY === 'add' || KEY === 'set';
      if (KEY in NativePrototype && !(IS_WEAK && KEY === 'clear')) {
        createNonEnumerableProperty(Prototype, KEY, function (a, b) {
          var collection = getInternalState(this).collection;
          if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY === 'get' ? undefined : false;
          var result = collection[KEY](a === 0 ? 0 : a, b);
          return IS_ADDER ? this : result;
        });
      }
    });

    IS_WEAK || defineProperty(Prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).collection.size;
      }
    });
  }

  setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: true }, exported);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ 9595:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var hasOwn = __webpack_require__(9724);
var ownKeys = __webpack_require__(1042);
var getOwnPropertyDescriptorModule = __webpack_require__(3846);
var definePropertyModule = __webpack_require__(4284);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 5735:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(6264);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ 7382:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(8828);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 9550:
/***/ ((module) => {

"use strict";

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ 1626:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(9447);
var definePropertyModule = __webpack_require__(4284);
var createPropertyDescriptor = __webpack_require__(5817);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 5817:
/***/ ((module) => {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 5543:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(9447);
var definePropertyModule = __webpack_require__(4284);
var createPropertyDescriptor = __webpack_require__(5817);

module.exports = function (object, key, value) {
  if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};


/***/ }),

/***/ 9251:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineProperty = __webpack_require__(4284);

module.exports = function (target, name, descriptor) {
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 8055:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var createNonEnumerableProperty = __webpack_require__(1626);

module.exports = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
  return target;
};


/***/ }),

/***/ 2802:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineBuiltIn = __webpack_require__(8055);

module.exports = function (target, src, options) {
  for (var key in src) {
    if (options && options.unsafe && target[key]) target[key] = src[key];
    else defineBuiltIn(target, key, src[key], options);
  } return target;
};


/***/ }),

/***/ 2532:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(globalThis, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis[key] = value;
  } return value;
};


/***/ }),

/***/ 4535:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var tryToString = __webpack_require__(4640);

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),

/***/ 9447:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(8828);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ 9552:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var isObject = __webpack_require__(6285);

var document = globalThis.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 8024:
/***/ ((module) => {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 9287:
/***/ ((module) => {

"use strict";

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 376:
/***/ ((module) => {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 8606:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var userAgent = __webpack_require__(6794);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),

/***/ 1829:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var userAgent = __webpack_require__(6794);

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ 7586:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ENVIRONMENT = __webpack_require__(2832);

module.exports = ENVIRONMENT === 'NODE';


/***/ }),

/***/ 9291:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var userAgent = __webpack_require__(6794);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ 6794:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);

var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;

module.exports = userAgent ? String(userAgent) : '';


/***/ }),

/***/ 798:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var userAgent = __webpack_require__(6794);

var process = globalThis.process;
var Deno = globalThis.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 2832:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* global Bun, Deno -- detection */
var globalThis = __webpack_require__(5951);
var userAgent = __webpack_require__(6794);
var classof = __webpack_require__(5807);

var userAgentStartsWith = function (string) {
  return userAgent.slice(0, string.length) === string;
};

module.exports = (function () {
  if (userAgentStartsWith('Bun/')) return 'BUN';
  if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
  if (userAgentStartsWith('Deno/')) return 'DENO';
  if (userAgentStartsWith('Node.js/')) return 'NODE';
  if (globalThis.Bun && typeof Bun.version == 'string') return 'BUN';
  if (globalThis.Deno && typeof Deno.version == 'object') return 'DENO';
  if (classof(globalThis.process) === 'process') return 'NODE';
  if (globalThis.window && globalThis.document) return 'BROWSER';
  return 'REST';
})();


/***/ }),

/***/ 5762:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable, sonarjs/slow-regex -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ 5884:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var createNonEnumerableProperty = __webpack_require__(1626);
var clearErrorStack = __webpack_require__(5762);
var ERROR_STACK_INSTALLABLE = __webpack_require__(3888);

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

module.exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};


/***/ }),

/***/ 3888:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(8828);
var createPropertyDescriptor = __webpack_require__(5817);

module.exports = !fails(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ 1091:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var apply = __webpack_require__(6024);
var uncurryThis = __webpack_require__(2361);
var isCallable = __webpack_require__(2250);
var getOwnPropertyDescriptor = (__webpack_require__(3846).f);
var isForced = __webpack_require__(7463);
var path = __webpack_require__(2046);
var bind = __webpack_require__(8311);
var createNonEnumerableProperty = __webpack_require__(1626);
var hasOwn = __webpack_require__(9724);
// add debugging info
__webpack_require__(6128);

var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof Wrapper) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return apply(NativeConstructor, this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? globalThis : STATIC ? globalThis[TARGET] : globalThis[TARGET] && globalThis[TARGET].prototype;

  var target = GLOBAL ? path : path[TARGET] || createNonEnumerableProperty(path, TARGET, {})[TARGET];
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && hasOwn(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (!FORCED && !PROTO && typeof targetProperty == typeof sourceProperty) continue;

    // bind methods to global for calling from export context
    if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, globalThis);
    // wrap global constructors for prevent changes in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && isCallable(sourceProperty)) resultProperty = uncurryThis(sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    createNonEnumerableProperty(target, key, resultProperty);

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!hasOwn(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      createNonEnumerableProperty(path[VIRTUAL_PROTOTYPE], key, sourceProperty);
      // export real prototype methods
      if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};


/***/ }),

/***/ 8828:
/***/ ((module) => {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 5681:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(8828);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ 6024:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_BIND = __webpack_require__(1505);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 8311:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(2361);
var aCallable = __webpack_require__(2159);
var NATIVE_BIND = __webpack_require__(1505);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 1505:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(8828);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 4673:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);
var aCallable = __webpack_require__(2159);
var isObject = __webpack_require__(6285);
var hasOwn = __webpack_require__(9724);
var arraySlice = __webpack_require__(3427);
var NATIVE_BIND = __webpack_require__(1505);

var $Function = Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    var list = [];
    var i = 0;
    for (; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),

/***/ 3930:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_BIND = __webpack_require__(1505);

var call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 6833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(9447);
var hasOwn = __webpack_require__(9724);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 1871:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);
var aCallable = __webpack_require__(2159);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 2361:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classofRaw = __webpack_require__(5807);
var uncurryThis = __webpack_require__(1907);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ 1907:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_BIND = __webpack_require__(1505);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 1747:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var path = __webpack_require__(2046);

module.exports = function (CONSTRUCTOR, METHOD) {
  var Namespace = path[CONSTRUCTOR + 'Prototype'];
  var pureMethod = Namespace && Namespace[METHOD];
  if (pureMethod) return pureMethod;
  var NativeConstructor = globalThis[CONSTRUCTOR];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  return NativePrototype && NativePrototype[METHOD];
};


/***/ }),

/***/ 5582:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var path = __webpack_require__(2046);
var globalThis = __webpack_require__(5951);
var isCallable = __webpack_require__(2250);

var aFunction = function (variable) {
  return isCallable(variable) ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(globalThis[namespace])
    : path[namespace] && path[namespace][method] || globalThis[namespace] && globalThis[namespace][method];
};


/***/ }),

/***/ 3448:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classof = __webpack_require__(3948);
var getMethod = __webpack_require__(9367);
var isNullOrUndefined = __webpack_require__(7136);
var Iterators = __webpack_require__(3742);
var wellKnownSymbol = __webpack_require__(6264);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 300:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(3930);
var aCallable = __webpack_require__(2159);
var anObject = __webpack_require__(6624);
var tryToString = __webpack_require__(4640);
var getIteratorMethod = __webpack_require__(3448);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw new $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ 6656:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);
var isArray = __webpack_require__(1793);
var isCallable = __webpack_require__(2250);
var classof = __webpack_require__(5807);
var toString = __webpack_require__(160);

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ 9367:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__(2159);
var isNullOrUndefined = __webpack_require__(7136);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 5951:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  check(typeof this == 'object' && this) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 9724:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);
var toObject = __webpack_require__(9298);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 8530:
/***/ ((module) => {

"use strict";

module.exports = {};


/***/ }),

/***/ 3904:
/***/ ((module) => {

"use strict";

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 2416:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(5582);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 3648:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(9447);
var fails = __webpack_require__(8828);
var createElement = __webpack_require__(9552);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ 6946:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);
var fails = __webpack_require__(8828);
var classof = __webpack_require__(5807);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 2647:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);
var isCallable = __webpack_require__(2250);
var store = __webpack_require__(6128);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 9259:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isObject = __webpack_require__(6285);
var createNonEnumerableProperty = __webpack_require__(1626);

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ 1548:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var uncurryThis = __webpack_require__(1907);
var hiddenKeys = __webpack_require__(8530);
var isObject = __webpack_require__(6285);
var hasOwn = __webpack_require__(9724);
var defineProperty = (__webpack_require__(4284).f);
var getOwnPropertyNamesModule = __webpack_require__(4443);
var getOwnPropertyNamesExternalModule = __webpack_require__(5407);
var isExtensible = __webpack_require__(7005);
var uid = __webpack_require__(6499);
var FREEZING = __webpack_require__(5681);

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ 4932:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(551);
var globalThis = __webpack_require__(5951);
var isObject = __webpack_require__(6285);
var createNonEnumerableProperty = __webpack_require__(1626);
var hasOwn = __webpack_require__(9724);
var shared = __webpack_require__(6128);
var sharedKey = __webpack_require__(2522);
var hiddenKeys = __webpack_require__(8530);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = globalThis.TypeError;
var WeakMap = globalThis.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 7812:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(6264);
var Iterators = __webpack_require__(3742);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 1793:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classof = __webpack_require__(5807);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),

/***/ 2250:
/***/ ((module) => {

"use strict";

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 5468:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);
var fails = __webpack_require__(8828);
var isCallable = __webpack_require__(2250);
var classof = __webpack_require__(3948);
var getBuiltIn = __webpack_require__(5582);
var inspectSource = __webpack_require__(2647);

var noop = function () { /* empty */ };
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 218:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var hasOwn = __webpack_require__(9724);

module.exports = function (descriptor) {
  return descriptor !== undefined && (hasOwn(descriptor, 'value') || hasOwn(descriptor, 'writable'));
};


/***/ }),

/***/ 7463:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(8828);
var isCallable = __webpack_require__(2250);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 7136:
/***/ ((module) => {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 6285:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isCallable = __webpack_require__(2250);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 4018:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isObject = __webpack_require__(6285);

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};


/***/ }),

/***/ 7376:
/***/ ((module) => {

"use strict";

module.exports = true;


/***/ }),

/***/ 2087:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isObject = __webpack_require__(6285);
var classof = __webpack_require__(5807);
var wellKnownSymbol = __webpack_require__(6264);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};


/***/ }),

/***/ 5594:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(5582);
var isCallable = __webpack_require__(2250);
var isPrototypeOf = __webpack_require__(8280);
var USE_SYMBOL_AS_UID = __webpack_require__(1175);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 4823:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(8311);
var call = __webpack_require__(3930);
var anObject = __webpack_require__(6624);
var tryToString = __webpack_require__(4640);
var isArrayIteratorMethod = __webpack_require__(7812);
var lengthOfArrayLike = __webpack_require__(575);
var isPrototypeOf = __webpack_require__(8280);
var getIterator = __webpack_require__(300);
var getIteratorMethod = __webpack_require__(3448);
var iteratorClose = __webpack_require__(154);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ 154:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(3930);
var anObject = __webpack_require__(6624);
var getMethod = __webpack_require__(9367);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 7181:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var IteratorPrototype = (__webpack_require__(5116).IteratorPrototype);
var create = __webpack_require__(8075);
var createPropertyDescriptor = __webpack_require__(5817);
var setToStringTag = __webpack_require__(4840);
var Iterators = __webpack_require__(3742);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 183:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var call = __webpack_require__(3930);
var IS_PURE = __webpack_require__(7376);
var FunctionName = __webpack_require__(6833);
var isCallable = __webpack_require__(2250);
var createIteratorConstructor = __webpack_require__(7181);
var getPrototypeOf = __webpack_require__(5972);
var setPrototypeOf = __webpack_require__(9192);
var setToStringTag = __webpack_require__(4840);
var createNonEnumerableProperty = __webpack_require__(1626);
var defineBuiltIn = __webpack_require__(8055);
var wellKnownSymbol = __webpack_require__(6264);
var Iterators = __webpack_require__(3742);
var IteratorsCore = __webpack_require__(5116);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ 5116:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(8828);
var isCallable = __webpack_require__(2250);
var isObject = __webpack_require__(6285);
var create = __webpack_require__(8075);
var getPrototypeOf = __webpack_require__(5972);
var defineBuiltIn = __webpack_require__(8055);
var wellKnownSymbol = __webpack_require__(6264);
var IS_PURE = __webpack_require__(7376);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 3742:
/***/ ((module) => {

"use strict";

module.exports = {};


/***/ }),

/***/ 575:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toLength = __webpack_require__(3121);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 1176:
/***/ ((module) => {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 2292:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var safeGetBuiltIn = __webpack_require__(2098);
var bind = __webpack_require__(8311);
var macrotask = (__webpack_require__(9472).set);
var Queue = __webpack_require__(9245);
var IS_IOS = __webpack_require__(1829);
var IS_IOS_PEBBLE = __webpack_require__(8606);
var IS_WEBOS_WEBKIT = __webpack_require__(9291);
var IS_NODE = __webpack_require__(7586);

var MutationObserver = globalThis.MutationObserver || globalThis.WebKitMutationObserver;
var document = globalThis.document;
var process = globalThis.process;
var Promise = globalThis.Promise;
var microtask = safeGetBuiltIn('queueMicrotask');
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, globalThis);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;


/***/ }),

/***/ 6254:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__(2159);

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 2096:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toString = __webpack_require__(160);

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ 2074:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isRegExp = __webpack_require__(2087);

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ 2778:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var fails = __webpack_require__(8828);
var uncurryThis = __webpack_require__(1907);
var toString = __webpack_require__(160);
var trim = (__webpack_require__(5993).trim);
var whitespaces = __webpack_require__(6395);

var $parseInt = globalThis.parseInt;
var Symbol = globalThis.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ 9538:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(9447);
var uncurryThis = __webpack_require__(1907);
var call = __webpack_require__(3930);
var fails = __webpack_require__(8828);
var objectKeys = __webpack_require__(2875);
var getOwnPropertySymbolsModule = __webpack_require__(7170);
var propertyIsEnumerableModule = __webpack_require__(193);
var toObject = __webpack_require__(9298);
var IndexedObject = __webpack_require__(6946);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  // eslint-disable-next-line es/no-array-prototype-foreach -- safe
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 8075:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(6624);
var definePropertiesModule = __webpack_require__(2220);
var enumBugKeys = __webpack_require__(376);
var hiddenKeys = __webpack_require__(8530);
var html = __webpack_require__(2416);
var documentCreateElement = __webpack_require__(9552);
var sharedKey = __webpack_require__(2522);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 2220:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(9447);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(8661);
var definePropertyModule = __webpack_require__(4284);
var anObject = __webpack_require__(6624);
var toIndexedObject = __webpack_require__(7374);
var objectKeys = __webpack_require__(2875);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 4284:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(9447);
var IE8_DOM_DEFINE = __webpack_require__(3648);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(8661);
var anObject = __webpack_require__(6624);
var toPropertyKey = __webpack_require__(470);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 3846:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(9447);
var call = __webpack_require__(3930);
var propertyIsEnumerableModule = __webpack_require__(193);
var createPropertyDescriptor = __webpack_require__(5817);
var toIndexedObject = __webpack_require__(7374);
var toPropertyKey = __webpack_require__(470);
var hasOwn = __webpack_require__(9724);
var IE8_DOM_DEFINE = __webpack_require__(3648);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 5407:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__(5807);
var toIndexedObject = __webpack_require__(7374);
var $getOwnPropertyNames = (__webpack_require__(4443).f);
var arraySlice = __webpack_require__(3427);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 4443:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var internalObjectKeys = __webpack_require__(3045);
var enumBugKeys = __webpack_require__(376);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 7170:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 5972:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var hasOwn = __webpack_require__(9724);
var isCallable = __webpack_require__(2250);
var toObject = __webpack_require__(9298);
var sharedKey = __webpack_require__(2522);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(7382);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 7005:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(8828);
var isObject = __webpack_require__(6285);
var classof = __webpack_require__(5807);
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(6375);

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),

/***/ 8280:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 3045:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);
var hasOwn = __webpack_require__(9724);
var toIndexedObject = __webpack_require__(7374);
var indexOf = (__webpack_require__(4436).indexOf);
var hiddenKeys = __webpack_require__(8530);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 2875:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var internalObjectKeys = __webpack_require__(3045);
var enumBugKeys = __webpack_require__(376);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 193:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 9192:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(1871);
var isObject = __webpack_require__(6285);
var requireObjectCoercible = __webpack_require__(4239);
var aPossiblePrototype = __webpack_require__(43);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 4298:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(9447);
var fails = __webpack_require__(8828);
var uncurryThis = __webpack_require__(1907);
var objectGetPrototypeOf = __webpack_require__(5972);
var objectKeys = __webpack_require__(2875);
var toIndexedObject = __webpack_require__(7374);
var $propertyIsEnumerable = (__webpack_require__(193).f);

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var IE_BUG = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-create -- safe
  var O = Object.create(null);
  O[2] = 2;
  return !propertyIsEnumerable(O, 2);
});

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ 4878:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(2623);
var classof = __webpack_require__(3948);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 581:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(3930);
var isCallable = __webpack_require__(2250);
var isObject = __webpack_require__(6285);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 1042:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(5582);
var uncurryThis = __webpack_require__(1907);
var getOwnPropertyNamesModule = __webpack_require__(4443);
var getOwnPropertySymbolsModule = __webpack_require__(7170);
var anObject = __webpack_require__(6624);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 2046:
/***/ ((module) => {

"use strict";

module.exports = {};


/***/ }),

/***/ 4420:
/***/ ((module) => {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ 1759:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var NativePromiseConstructor = __webpack_require__(5463);
var isCallable = __webpack_require__(2250);
var isForced = __webpack_require__(7463);
var inspectSource = __webpack_require__(2647);
var wellKnownSymbol = __webpack_require__(6264);
var ENVIRONMENT = __webpack_require__(2832);
var IS_PURE = __webpack_require__(7376);
var V8_VERSION = __webpack_require__(798);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(globalThis.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (ENVIRONMENT === 'BROWSER' || ENVIRONMENT === 'DENO') && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ 5463:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);

module.exports = globalThis.Promise;


/***/ }),

/***/ 3569:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__(6624);
var isObject = __webpack_require__(6285);
var newPromiseCapability = __webpack_require__(6254);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 3282:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NativePromiseConstructor = __webpack_require__(5463);
var checkCorrectnessOfIteration = __webpack_require__(473);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(1759).CONSTRUCTOR);

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ 9245:
/***/ ((module) => {

"use strict";

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ 4239:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isNullOrUndefined = __webpack_require__(7136);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 2098:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var DESCRIPTORS = __webpack_require__(9447);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
module.exports = function (name) {
  if (!DESCRIPTORS) return globalThis[name];
  var descriptor = getOwnPropertyDescriptor(globalThis, name);
  return descriptor && descriptor.value;
};


/***/ }),

/***/ 485:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var apply = __webpack_require__(6024);
var isCallable = __webpack_require__(2250);
var ENVIRONMENT = __webpack_require__(2832);
var USER_AGENT = __webpack_require__(6794);
var arraySlice = __webpack_require__(3427);
var validateArgumentsLength = __webpack_require__(4787);

var Function = globalThis.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(USER_AGENT) || ENVIRONMENT === 'BUN' && (function () {
  var version = globalThis.Bun.version.split('.');
  return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
})();

// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function (scheduler, hasTimeArg) {
  var firstParamIndex = hasTimeArg ? 2 : 1;
  return WRAP ? function (handler, timeout /* , ...arguments */) {
    var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
    var fn = isCallable(handler) ? handler : Function(handler);
    var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
    var callback = boundArgs ? function () {
      apply(fn, this, params);
    } : fn;
    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
  } : scheduler;
};


/***/ }),

/***/ 7118:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(5582);
var defineBuiltInAccessor = __webpack_require__(9251);
var wellKnownSymbol = __webpack_require__(6264);
var DESCRIPTORS = __webpack_require__(9447);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ 4840:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(2623);
var defineProperty = (__webpack_require__(4284).f);
var createNonEnumerableProperty = __webpack_require__(1626);
var hasOwn = __webpack_require__(9724);
var toString = __webpack_require__(4878);
var wellKnownSymbol = __webpack_require__(6264);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC, SET_METHOD) {
  var target = STATIC ? it : it && it.prototype;
  if (target) {
    if (!hasOwn(target, TO_STRING_TAG)) {
      defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !TO_STRING_TAG_SUPPORT) {
      createNonEnumerableProperty(target, 'toString', toString);
    }
  }
};


/***/ }),

/***/ 2522:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var shared = __webpack_require__(5816);
var uid = __webpack_require__(6499);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 6128:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var IS_PURE = __webpack_require__(7376);
var globalThis = __webpack_require__(5951);
var defineGlobalProperty = __webpack_require__(2532);

var SHARED = '__core-js_shared__';
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});

(store.versions || (store.versions = [])).push({
  version: '3.41.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.41.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 5816:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var store = __webpack_require__(6128);

module.exports = function (key, value) {
  return store[key] || (store[key] = value || {});
};


/***/ }),

/***/ 8450:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__(6624);
var aConstructor = __webpack_require__(2235);
var isNullOrUndefined = __webpack_require__(7136);
var wellKnownSymbol = __webpack_require__(6264);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ 1470:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);
var toIntegerOrInfinity = __webpack_require__(5482);
var toString = __webpack_require__(160);
var requireObjectCoercible = __webpack_require__(4239);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 9156:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis = __webpack_require__(1907);

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError = RangeError;
var exec = uncurryThis(regexSeparators.exec);
var floor = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis(''.charCodeAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var split = uncurryThis(''.split);
var toLowerCase = uncurryThis(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) === 0xDC00) { // Low surrogate.
        push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push(output, value);
        counter--;
      }
    } else {
      push(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor(delta / baseMinusTMin);
    k += base;
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw new $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw new $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue === n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
          k += base;
        }

        push(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join(output, '');
};

module.exports = function (input) {
  var encoded = [];
  var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join(encoded, '.');
};


/***/ }),

/***/ 5819:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var PROPER_FUNCTION_NAME = (__webpack_require__(6833).PROPER);
var fails = __webpack_require__(8828);
var whitespaces = __webpack_require__(6395);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ 5993:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);
var requireObjectCoercible = __webpack_require__(4239);
var toString = __webpack_require__(160);
var whitespaces = __webpack_require__(6395);

var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ 9846:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(798);
var fails = __webpack_require__(8828);
var globalThis = __webpack_require__(5951);

var $String = globalThis.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 3467:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(3930);
var getBuiltIn = __webpack_require__(5582);
var wellKnownSymbol = __webpack_require__(6264);
var defineBuiltIn = __webpack_require__(8055);

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ 2595:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(5582);
var uncurryThis = __webpack_require__(1907);

var Symbol = getBuiltIn('Symbol');
var keyFor = Symbol.keyFor;
var thisSymbolValue = uncurryThis(Symbol.prototype.valueOf);

// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
module.exports = Symbol.isRegisteredSymbol || function isRegisteredSymbol(value) {
  try {
    return keyFor(thisSymbolValue(value)) !== undefined;
  } catch (error) {
    return false;
  }
};


/***/ }),

/***/ 9197:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var shared = __webpack_require__(5816);
var getBuiltIn = __webpack_require__(5582);
var uncurryThis = __webpack_require__(1907);
var isSymbol = __webpack_require__(5594);
var wellKnownSymbol = __webpack_require__(6264);

var Symbol = getBuiltIn('Symbol');
var $isWellKnownSymbol = Symbol.isWellKnownSymbol;
var getOwnPropertyNames = getBuiltIn('Object', 'getOwnPropertyNames');
var thisSymbolValue = uncurryThis(Symbol.prototype.valueOf);
var WellKnownSymbolsStore = shared('wks');

for (var i = 0, symbolKeys = getOwnPropertyNames(Symbol), symbolKeysLength = symbolKeys.length; i < symbolKeysLength; i++) {
  // some old engines throws on access to some keys like `arguments` or `caller`
  try {
    var symbolKey = symbolKeys[i];
    if (isSymbol(Symbol[symbolKey])) wellKnownSymbol(symbolKey);
  } catch (error) { /* empty */ }
}

// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
module.exports = function isWellKnownSymbol(value) {
  if ($isWellKnownSymbol && $isWellKnownSymbol(value)) return true;
  try {
    var symbol = thisSymbolValue(value);
    for (var j = 0, keys = getOwnPropertyNames(WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++) {
      // eslint-disable-next-line eqeqeq -- polyfilled symbols case
      if (WellKnownSymbolsStore[keys[j]] == symbol) return true;
    }
  } catch (error) { /* empty */ }
  return false;
};


/***/ }),

/***/ 4411:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_SYMBOL = __webpack_require__(9846);

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ 9472:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var apply = __webpack_require__(6024);
var bind = __webpack_require__(8311);
var isCallable = __webpack_require__(2250);
var hasOwn = __webpack_require__(9724);
var fails = __webpack_require__(8828);
var html = __webpack_require__(2416);
var arraySlice = __webpack_require__(3427);
var createElement = __webpack_require__(9552);
var validateArgumentsLength = __webpack_require__(4787);
var IS_IOS = __webpack_require__(1829);
var IS_NODE = __webpack_require__(7586);

var set = globalThis.setImmediate;
var clear = globalThis.clearImmediate;
var process = globalThis.process;
var Dispatch = globalThis.Dispatch;
var Function = globalThis.Function;
var MessageChannel = globalThis.MessageChannel;
var String = globalThis.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = globalThis.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  globalThis.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    globalThis.addEventListener &&
    isCallable(globalThis.postMessage) &&
    !globalThis.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    globalThis.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ 4849:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIntegerOrInfinity = __webpack_require__(5482);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 7374:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(6946);
var requireObjectCoercible = __webpack_require__(4239);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 5482:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var trunc = __webpack_require__(1176);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 3121:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIntegerOrInfinity = __webpack_require__(5482);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 9298:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var requireObjectCoercible = __webpack_require__(4239);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 6028:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(3930);
var isObject = __webpack_require__(6285);
var isSymbol = __webpack_require__(5594);
var getMethod = __webpack_require__(9367);
var ordinaryToPrimitive = __webpack_require__(581);
var wellKnownSymbol = __webpack_require__(6264);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 470:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toPrimitive = __webpack_require__(6028);
var isSymbol = __webpack_require__(5594);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 2623:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(6264);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 160:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classof = __webpack_require__(3948);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 4640:
/***/ ((module) => {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 6499:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(1907);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 4791:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(8828);
var wellKnownSymbol = __webpack_require__(6264);
var DESCRIPTORS = __webpack_require__(9447);
var IS_PURE = __webpack_require__(7376);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'https://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (IS_PURE || !DESCRIPTORS))
    || !params.sort
    || url.href !== 'https://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('https://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('https://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('https://x', undefined).host !== 'x';
});


/***/ }),

/***/ 1175:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(9846);

module.exports = NATIVE_SYMBOL &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 8661:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(9447);
var fails = __webpack_require__(8828);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ 4787:
/***/ ((module) => {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var isCallable = __webpack_require__(2250);

var WeakMap = globalThis.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 366:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var path = __webpack_require__(2046);
var hasOwn = __webpack_require__(9724);
var wrappedWellKnownSymbolModule = __webpack_require__(560);
var defineProperty = (__webpack_require__(4284).f);

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 560:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(6264);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 6264:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var shared = __webpack_require__(5816);
var hasOwn = __webpack_require__(9724);
var uid = __webpack_require__(6499);
var NATIVE_SYMBOL = __webpack_require__(9846);
var USE_SYMBOL_AS_UID = __webpack_require__(1175);

var Symbol = globalThis.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 6395:
/***/ ((module) => {

"use strict";

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 2048:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var isPrototypeOf = __webpack_require__(8280);
var getPrototypeOf = __webpack_require__(5972);
var setPrototypeOf = __webpack_require__(9192);
var copyConstructorProperties = __webpack_require__(9595);
var create = __webpack_require__(8075);
var createNonEnumerableProperty = __webpack_require__(1626);
var createPropertyDescriptor = __webpack_require__(5817);
var installErrorCause = __webpack_require__(9259);
var installErrorStack = __webpack_require__(5884);
var iterate = __webpack_require__(4823);
var normalizeStringArgument = __webpack_require__(2096);
var wellKnownSymbol = __webpack_require__(6264);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Error = Error;
var push = [].push;

var $AggregateError = function AggregateError(errors, message /* , options */) {
  var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
  var that;
  if (setPrototypeOf) {
    that = setPrototypeOf(new $Error(), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
  } else {
    that = isInstance ? this : create(AggregateErrorPrototype);
    createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
  }
  if (message !== undefined) createNonEnumerableProperty(that, 'message', normalizeStringArgument(message));
  installErrorStack(that, $AggregateError, that.stack, 1);
  if (arguments.length > 2) installErrorCause(that, arguments[2]);
  var errorsArray = [];
  iterate(errors, push, { that: errorsArray });
  createNonEnumerableProperty(that, 'errors', errorsArray);
  return that;
};

if (setPrototypeOf) setPrototypeOf($AggregateError, $Error);
else copyConstructorProperties($AggregateError, $Error, { name: true });

var AggregateErrorPrototype = $AggregateError.prototype = create($Error.prototype, {
  constructor: createPropertyDescriptor(1, $AggregateError),
  message: createPropertyDescriptor(1, ''),
  name: createPropertyDescriptor(1, 'AggregateError')
});

// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$({ global: true, constructor: true, arity: 2 }, {
  AggregateError: $AggregateError
});


/***/ }),

/***/ 4502:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(2048);


/***/ }),

/***/ 8545:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var fails = __webpack_require__(8828);
var isArray = __webpack_require__(1793);
var isObject = __webpack_require__(6285);
var toObject = __webpack_require__(9298);
var lengthOfArrayLike = __webpack_require__(575);
var doesNotExceedSafeInteger = __webpack_require__(8024);
var createProperty = __webpack_require__(5543);
var arraySpeciesCreate = __webpack_require__(6968);
var arrayMethodHasSpeciesSupport = __webpack_require__(7171);
var wellKnownSymbol = __webpack_require__(6264);
var V8_VERSION = __webpack_require__(798);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 9295:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var $filter = (__webpack_require__(726).filter);
var arrayMethodHasSpeciesSupport = __webpack_require__(7171);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 5650:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var forEach = __webpack_require__(2914);

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$({ target: 'Array', proto: true, forced: [].forEach !== forEach }, {
  forEach: forEach
});


/***/ }),

/***/ 7277:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var from = __webpack_require__(1229);
var checkCorrectnessOfIteration = __webpack_require__(473);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ 9748:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var $includes = (__webpack_require__(4436).includes);
var fails = __webpack_require__(8828);
var addToUnscopables = __webpack_require__(2156);

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ 6391:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-array-prototype-indexof -- required for testing */
var $ = __webpack_require__(1091);
var uncurryThis = __webpack_require__(2361);
var $indexOf = (__webpack_require__(4436).indexOf);
var arrayMethodIsStrict = __webpack_require__(7623);

var nativeIndexOf = uncurryThis([].indexOf);

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
var FORCED = NEGATIVE_ZERO || !arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: FORCED }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf(this, searchElement, fromIndex) || 0
      : $indexOf(this, searchElement, fromIndex);
  }
});


/***/ }),

/***/ 2425:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var isArray = __webpack_require__(1793);

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});


/***/ }),

/***/ 9363:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIndexedObject = __webpack_require__(7374);
var addToUnscopables = __webpack_require__(2156);
var Iterators = __webpack_require__(3742);
var InternalStateModule = __webpack_require__(4932);
var defineProperty = (__webpack_require__(4284).f);
var defineIterator = __webpack_require__(183);
var createIterResultObject = __webpack_require__(9550);
var IS_PURE = __webpack_require__(7376);
var DESCRIPTORS = __webpack_require__(9447);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ 6687:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var $map = (__webpack_require__(726).map);
var arrayMethodHasSpeciesSupport = __webpack_require__(7171);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 5745:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var toObject = __webpack_require__(9298);
var lengthOfArrayLike = __webpack_require__(575);
var setArrayLength = __webpack_require__(3130);
var doesNotExceedSafeInteger = __webpack_require__(8024);
var fails = __webpack_require__(8828);

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ 6339:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var $reduce = (__webpack_require__(5043).left);
var arrayMethodIsStrict = __webpack_require__(7623);
var CHROME_VERSION = __webpack_require__(798);
var IS_NODE = __webpack_require__(7586);

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 8559:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var uncurryThis = __webpack_require__(1907);
var isArray = __webpack_require__(1793);

var nativeReverse = uncurryThis([].reverse);
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse(this);
  }
});


/***/ }),

/***/ 2099:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var isArray = __webpack_require__(1793);
var isConstructor = __webpack_require__(5468);
var isObject = __webpack_require__(6285);
var toAbsoluteIndex = __webpack_require__(4849);
var lengthOfArrayLike = __webpack_require__(575);
var toIndexedObject = __webpack_require__(7374);
var createProperty = __webpack_require__(5543);
var wellKnownSymbol = __webpack_require__(6264);
var arrayMethodHasSpeciesSupport = __webpack_require__(7171);
var nativeSlice = __webpack_require__(3427);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ 8334:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var toObject = __webpack_require__(9298);
var toAbsoluteIndex = __webpack_require__(4849);
var toIntegerOrInfinity = __webpack_require__(5482);
var lengthOfArrayLike = __webpack_require__(575);
var setArrayLength = __webpack_require__(3130);
var doesNotExceedSafeInteger = __webpack_require__(8024);
var arraySpeciesCreate = __webpack_require__(6968);
var createProperty = __webpack_require__(5543);
var deletePropertyOrThrow = __webpack_require__(4535);
var arrayMethodHasSpeciesSupport = __webpack_require__(7171);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    setArrayLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});


/***/ }),

/***/ 5362:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(1091);
var uncurryThis = __webpack_require__(1907);

var $Date = Date;
var thisTimeValue = uncurryThis($Date.prototype.getTime);

// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$({ target: 'Date', stat: true }, {
  now: function now() {
    return thisTimeValue(new $Date());
  }
});


/***/ }),

/***/ 8537:
/***/ (() => {

// empty


/***/ }),

/***/ 9307:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(1091);
var bind = __webpack_require__(4673);

// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$({ target: 'Function', proto: true, forced: Function.bind !== bind }, {
  bind: bind
});


/***/ }),

/***/ 9721:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var getBuiltIn = __webpack_require__(5582);
var apply = __webpack_require__(6024);
var call = __webpack_require__(3930);
var uncurryThis = __webpack_require__(1907);
var fails = __webpack_require__(8828);
var isCallable = __webpack_require__(2250);
var isSymbol = __webpack_require__(5594);
var arraySlice = __webpack_require__(3427);
var getReplacerFunction = __webpack_require__(6656);
var NATIVE_SYMBOL = __webpack_require__(9846);

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ 7024:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var globalThis = __webpack_require__(5951);
var setToStringTag = __webpack_require__(4840);

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(globalThis.JSON, 'JSON', true);


/***/ }),

/***/ 8172:
/***/ (() => {

// empty


/***/ }),

/***/ 5837:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(1091);
var DESCRIPTORS = __webpack_require__(9447);
var create = __webpack_require__(8075);

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  create: create
});


/***/ }),

/***/ 7810:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var DESCRIPTORS = __webpack_require__(9447);
var defineProperties = (__webpack_require__(2220).f);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$({ target: 'Object', stat: true, forced: Object.defineProperties !== defineProperties, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});


/***/ }),

/***/ 6750:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var DESCRIPTORS = __webpack_require__(9447);
var defineProperty = (__webpack_require__(4284).f);

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$({ target: 'Object', stat: true, forced: Object.defineProperty !== defineProperty, sham: !DESCRIPTORS }, {
  defineProperty: defineProperty
});


/***/ }),

/***/ 4729:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var $entries = (__webpack_require__(4298).entries);

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ 7052:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var fails = __webpack_require__(8828);
var toIndexedObject = __webpack_require__(7374);
var nativeGetOwnPropertyDescriptor = (__webpack_require__(3846).f);
var DESCRIPTORS = __webpack_require__(9447);

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ 179:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var DESCRIPTORS = __webpack_require__(9447);
var ownKeys = __webpack_require__(1042);
var toIndexedObject = __webpack_require__(7374);
var getOwnPropertyDescriptorModule = __webpack_require__(3846);
var createProperty = __webpack_require__(5543);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ 5264:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var NATIVE_SYMBOL = __webpack_require__(9846);
var fails = __webpack_require__(8828);
var getOwnPropertySymbolsModule = __webpack_require__(7170);
var toObject = __webpack_require__(9298);

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ 8966:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var fails = __webpack_require__(8828);
var toObject = __webpack_require__(9298);
var nativeGetPrototypeOf = __webpack_require__(5972);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(7382);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ 3589:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var toObject = __webpack_require__(9298);
var nativeKeys = __webpack_require__(2875);
var fails = __webpack_require__(8828);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 1906:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var setPrototypeOf = __webpack_require__(9192);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ 3643:
/***/ (() => {

// empty


/***/ }),

/***/ 5395:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var $values = (__webpack_require__(4298).values);

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ 2193:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var $parseInt = __webpack_require__(2778);

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt !== $parseInt }, {
  parseInt: $parseInt
});


/***/ }),

/***/ 7450:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var call = __webpack_require__(3930);
var aCallable = __webpack_require__(2159);
var newPromiseCapabilityModule = __webpack_require__(6254);
var perform = __webpack_require__(4420);
var iterate = __webpack_require__(4823);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(3282);

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 6630:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var call = __webpack_require__(3930);
var aCallable = __webpack_require__(2159);
var newPromiseCapabilityModule = __webpack_require__(6254);
var perform = __webpack_require__(4420);
var iterate = __webpack_require__(4823);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(3282);

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 6415:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var call = __webpack_require__(3930);
var aCallable = __webpack_require__(2159);
var getBuiltIn = __webpack_require__(5582);
var newPromiseCapabilityModule = __webpack_require__(6254);
var perform = __webpack_require__(4420);
var iterate = __webpack_require__(4823);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(3282);

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  any: function any(iterable) {
    var C = this;
    var AggregateError = getBuiltIn('AggregateError');
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 1866:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var IS_PURE = __webpack_require__(7376);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(1759).CONSTRUCTOR);
var NativePromiseConstructor = __webpack_require__(5463);
var getBuiltIn = __webpack_require__(5582);
var isCallable = __webpack_require__(2250);
var defineBuiltIn = __webpack_require__(8055);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ 3825:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var IS_PURE = __webpack_require__(7376);
var IS_NODE = __webpack_require__(7586);
var globalThis = __webpack_require__(5951);
var call = __webpack_require__(3930);
var defineBuiltIn = __webpack_require__(8055);
var setPrototypeOf = __webpack_require__(9192);
var setToStringTag = __webpack_require__(4840);
var setSpecies = __webpack_require__(7118);
var aCallable = __webpack_require__(2159);
var isCallable = __webpack_require__(2250);
var isObject = __webpack_require__(6285);
var anInstance = __webpack_require__(9596);
var speciesConstructor = __webpack_require__(8450);
var task = (__webpack_require__(9472).set);
var microtask = __webpack_require__(2292);
var hostReportErrors = __webpack_require__(3904);
var perform = __webpack_require__(4420);
var Queue = __webpack_require__(9245);
var InternalStateModule = __webpack_require__(4932);
var NativePromiseConstructor = __webpack_require__(5463);
var PromiseConstructorDetection = __webpack_require__(1759);
var newPromiseCapabilityModule = __webpack_require__(6254);

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = globalThis.TypeError;
var document = globalThis.document;
var process = globalThis.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && globalThis.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    globalThis.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = globalThis['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, globalThis, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, globalThis, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: null
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ 7714:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var IS_PURE = __webpack_require__(7376);
var NativePromiseConstructor = __webpack_require__(5463);
var fails = __webpack_require__(8828);
var getBuiltIn = __webpack_require__(5582);
var isCallable = __webpack_require__(2250);
var speciesConstructor = __webpack_require__(8450);
var promiseResolve = __webpack_require__(3569);
var defineBuiltIn = __webpack_require__(8055);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),

/***/ 5931:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(3825);
__webpack_require__(6630);
__webpack_require__(1866);
__webpack_require__(2736);
__webpack_require__(7286);
__webpack_require__(6761);


/***/ }),

/***/ 2736:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var call = __webpack_require__(3930);
var aCallable = __webpack_require__(2159);
var newPromiseCapabilityModule = __webpack_require__(6254);
var perform = __webpack_require__(4420);
var iterate = __webpack_require__(4823);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(3282);

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 7286:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var newPromiseCapabilityModule = __webpack_require__(6254);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(1759).CONSTRUCTOR);

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});


/***/ }),

/***/ 6761:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var getBuiltIn = __webpack_require__(5582);
var IS_PURE = __webpack_require__(7376);
var NativePromiseConstructor = __webpack_require__(5463);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(1759).CONSTRUCTOR);
var promiseResolve = __webpack_require__(3569);

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ 7380:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var globalThis = __webpack_require__(5951);
var apply = __webpack_require__(6024);
var slice = __webpack_require__(3427);
var newPromiseCapabilityModule = __webpack_require__(6254);
var aCallable = __webpack_require__(2159);
var perform = __webpack_require__(4420);

var Promise = globalThis.Promise;

var ACCEPT_ARGUMENTS = false;
// Avoiding the use of polyfills of the previous iteration of this proposal
// that does not accept arguments of the callback
var FORCED = !Promise || !Promise['try'] || perform(function () {
  Promise['try'](function (argument) {
    ACCEPT_ARGUMENTS = argument === 8;
  }, 8);
}).error || !ACCEPT_ARGUMENTS;

// `Promise.try` method
// https://tc39.es/ecma262/#sec-promise.try
$({ target: 'Promise', stat: true, forced: FORCED }, {
  'try': function (callbackfn /* , ...args */) {
    var args = arguments.length > 1 ? slice(arguments, 1) : [];
    var promiseCapability = newPromiseCapabilityModule.f(this);
    var result = perform(function () {
      return apply(aCallable(callbackfn), undefined, args);
    });
    (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
    return promiseCapability.promise;
  }
});


/***/ }),

/***/ 5823:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var newPromiseCapabilityModule = __webpack_require__(6254);

// `Promise.withResolvers` method
// https://tc39.es/ecma262/#sec-promise.withResolvers
$({ target: 'Promise', stat: true }, {
  withResolvers: function withResolvers() {
    var promiseCapability = newPromiseCapabilityModule.f(this);
    return {
      promise: promiseCapability.promise,
      resolve: promiseCapability.resolve,
      reject: promiseCapability.reject
    };
  }
});


/***/ }),

/***/ 1220:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var getBuiltIn = __webpack_require__(5582);
var apply = __webpack_require__(6024);
var bind = __webpack_require__(4673);
var aConstructor = __webpack_require__(2235);
var anObject = __webpack_require__(6624);
var isObject = __webpack_require__(6285);
var create = __webpack_require__(8075);
var fails = __webpack_require__(8828);

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target === newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ 3357:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var call = __webpack_require__(3930);
var isObject = __webpack_require__(6285);
var anObject = __webpack_require__(6624);
var isDataDescriptor = __webpack_require__(218);
var getOwnPropertyDescriptorModule = __webpack_require__(3846);
var getPrototypeOf = __webpack_require__(5972);

// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject(target) === receiver) return target[propertyKey];
  descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey);
  if (descriptor) return isDataDescriptor(descriptor)
    ? descriptor.value
    : descriptor.get === undefined ? undefined : call(descriptor.get, receiver);
  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}

$({ target: 'Reflect', stat: true }, {
  get: get
});


/***/ }),

/***/ 5205:
/***/ (() => {

// empty


/***/ }),

/***/ 1074:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var uncurryThis = __webpack_require__(1907);
var toAbsoluteIndex = __webpack_require__(4849);

var $RangeError = RangeError;
var fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;
var join = uncurryThis([].join);

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length !== 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$({ target: 'String', stat: true, arity: 1, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw new $RangeError(code + ' is not a valid code point');
      elements[i] = code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
    } return join(elements, '');
  }
});


/***/ }),

/***/ 9770:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var uncurryThis = __webpack_require__(1907);
var notARegExp = __webpack_require__(2074);
var requireObjectCoercible = __webpack_require__(4239);
var toString = __webpack_require__(160);
var correctIsRegExpLogic = __webpack_require__(5735);

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),

/***/ 7057:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var charAt = (__webpack_require__(1470).charAt);
var toString = __webpack_require__(160);
var InternalStateModule = __webpack_require__(4932);
var defineIterator = __webpack_require__(183);
var createIterResultObject = __webpack_require__(9550);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ 727:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var $trim = (__webpack_require__(5993).trim);
var forcedStringTrimMethod = __webpack_require__(5819);

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ 3997:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ 3674:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var globalThis = __webpack_require__(5951);
var call = __webpack_require__(3930);
var uncurryThis = __webpack_require__(1907);
var IS_PURE = __webpack_require__(7376);
var DESCRIPTORS = __webpack_require__(9447);
var NATIVE_SYMBOL = __webpack_require__(9846);
var fails = __webpack_require__(8828);
var hasOwn = __webpack_require__(9724);
var isPrototypeOf = __webpack_require__(8280);
var anObject = __webpack_require__(6624);
var toIndexedObject = __webpack_require__(7374);
var toPropertyKey = __webpack_require__(470);
var $toString = __webpack_require__(160);
var createPropertyDescriptor = __webpack_require__(5817);
var nativeObjectCreate = __webpack_require__(8075);
var objectKeys = __webpack_require__(2875);
var getOwnPropertyNamesModule = __webpack_require__(4443);
var getOwnPropertyNamesExternal = __webpack_require__(5407);
var getOwnPropertySymbolsModule = __webpack_require__(7170);
var getOwnPropertyDescriptorModule = __webpack_require__(3846);
var definePropertyModule = __webpack_require__(4284);
var definePropertiesModule = __webpack_require__(2220);
var propertyIsEnumerableModule = __webpack_require__(193);
var defineBuiltIn = __webpack_require__(8055);
var defineBuiltInAccessor = __webpack_require__(9251);
var shared = __webpack_require__(5816);
var sharedKey = __webpack_require__(2522);
var hiddenKeys = __webpack_require__(8530);
var uid = __webpack_require__(6499);
var wellKnownSymbol = __webpack_require__(6264);
var wrappedWellKnownSymbolModule = __webpack_require__(560);
var defineWellKnownSymbol = __webpack_require__(366);
var defineSymbolToPrimitive = __webpack_require__(3467);
var setToStringTag = __webpack_require__(4840);
var InternalStateModule = __webpack_require__(4932);
var $forEach = (__webpack_require__(726).forEach);

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = globalThis.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var RangeError = globalThis.RangeError;
var TypeError = globalThis.TypeError;
var QObject = globalThis.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var fallbackDefineProperty = function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
};

var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a !== 7;
}) ? fallbackDefineProperty : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, nativeObjectCreate(null)));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      var $this = this === undefined ? globalThis : this;
      if ($this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn($this, HIDDEN) && hasOwn($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
      var descriptor = createPropertyDescriptor(1, value);
      try {
        setSymbolDescriptor($this, tag, descriptor);
      } catch (error) {
        if (!(error instanceof RangeError)) throw error;
        fallbackDefineProperty($this, tag, descriptor);
      }
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 5084:
/***/ (() => {

// empty


/***/ }),

/***/ 3313:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var getBuiltIn = __webpack_require__(5582);
var hasOwn = __webpack_require__(9724);
var toString = __webpack_require__(160);
var shared = __webpack_require__(5816);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(4411);

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ 2596:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');


/***/ }),

/***/ 5721:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');


/***/ }),

/***/ 4954:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ 4452:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(3674);
__webpack_require__(3313);
__webpack_require__(751);
__webpack_require__(9721);
__webpack_require__(5264);


/***/ }),

/***/ 751:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var hasOwn = __webpack_require__(9724);
var isSymbol = __webpack_require__(5594);
var tryToString = __webpack_require__(4640);
var shared = __webpack_require__(5816);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(4411);

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ 3377:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol('matchAll');


/***/ }),

/***/ 4123:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');


/***/ }),

/***/ 2230:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');


/***/ }),

/***/ 5344:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');


/***/ }),

/***/ 1660:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');


/***/ }),

/***/ 4610:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');


/***/ }),

/***/ 3669:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);
var defineSymbolToPrimitive = __webpack_require__(3467);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();


/***/ }),

/***/ 4810:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(5582);
var defineWellKnownSymbol = __webpack_require__(366);
var setToStringTag = __webpack_require__(4840);

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ }),

/***/ 3325:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');


/***/ }),

/***/ 7249:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var FREEZING = __webpack_require__(5681);
var globalThis = __webpack_require__(5951);
var uncurryThis = __webpack_require__(1907);
var defineBuiltIns = __webpack_require__(2802);
var InternalMetadataModule = __webpack_require__(1548);
var collection = __webpack_require__(7081);
var collectionWeak = __webpack_require__(1182);
var isObject = __webpack_require__(6285);
var enforceInternalState = (__webpack_require__(4932).enforce);
var fails = __webpack_require__(8828);
var NATIVE_WEAK_MAP = __webpack_require__(551);

var $Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = $Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var isFrozen = $Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var isSealed = $Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var freeze = $Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var seal = $Object.seal;

var IS_IE11 = !globalThis.ActiveXObject && 'ActiveXObject' in globalThis;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection('WeakMap', wrapper, collectionWeak);
var WeakMapPrototype = $WeakMap.prototype;
var nativeSet = uncurryThis(WeakMapPrototype.set);

// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var hasMSEdgeFreezingBug = function () {
  return FREEZING && fails(function () {
    var frozenArray = freeze([]);
    nativeSet(new $WeakMap(), frozenArray, 1);
    return !isFrozen(frozenArray);
  });
};

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP) if (IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
  var nativeHas = uncurryThis(WeakMapPrototype.has);
  var nativeGet = uncurryThis(WeakMapPrototype.get);
  defineBuiltIns(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen['delete'](key);
      } return nativeDelete(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      } return nativeHas(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      } return nativeGet(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else nativeSet(this, key, value);
      return this;
    }
  });
// Chakra Edge frozen keys fix
} else if (hasMSEdgeFreezingBug()) {
  defineBuiltIns(WeakMapPrototype, {
    set: function set(key, value) {
      var arrayIntegrityLevel;
      if (isArray(key)) {
        if (isFrozen(key)) arrayIntegrityLevel = freeze;
        else if (isSealed(key)) arrayIntegrityLevel = seal;
      }
      nativeSet(this, key, value);
      if (arrayIntegrityLevel) arrayIntegrityLevel(key);
      return this;
    }
  });
}


/***/ }),

/***/ 6571:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(7249);


/***/ }),

/***/ 7575:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var collection = __webpack_require__(7081);
var collectionWeak = __webpack_require__(1182);

// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
collection('WeakSet', function (init) {
  return function WeakSet() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionWeak);


/***/ }),

/***/ 741:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(7575);


/***/ }),

/***/ 1599:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(4502);


/***/ }),

/***/ 768:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(6264);
var defineProperty = (__webpack_require__(4284).f);

var METADATA = wellKnownSymbol('metadata');
var FunctionPrototype = Function.prototype;

// Function.prototype[@@metadata]
// https://github.com/tc39/proposal-decorator-metadata
if (FunctionPrototype[METADATA] === undefined) {
  defineProperty(FunctionPrototype, METADATA, {
    value: null
  });
}


/***/ }),

/***/ 7939:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(7450);


/***/ }),

/***/ 4362:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(6415);


/***/ }),

/***/ 7637:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(7380);


/***/ }),

/***/ 3568:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(5823);


/***/ }),

/***/ 8549:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
defineWellKnownSymbol('asyncDispose');


/***/ }),

/***/ 1697:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.customMatcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('customMatcher');


/***/ }),

/***/ 7152:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
defineWellKnownSymbol('dispose');


/***/ }),

/***/ 3939:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var isRegisteredSymbol = __webpack_require__(2595);

// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$({ target: 'Symbol', stat: true }, {
  isRegisteredSymbol: isRegisteredSymbol
});


/***/ }),

/***/ 3422:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var isRegisteredSymbol = __webpack_require__(2595);

// `Symbol.isRegistered` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$({ target: 'Symbol', stat: true, name: 'isRegisteredSymbol' }, {
  isRegistered: isRegisteredSymbol
});


/***/ }),

/***/ 1785:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var isWellKnownSymbol = __webpack_require__(9197);

// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$({ target: 'Symbol', stat: true, forced: true }, {
  isWellKnownSymbol: isWellKnownSymbol
});


/***/ }),

/***/ 36:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var isWellKnownSymbol = __webpack_require__(9197);

// `Symbol.isWellKnown` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$({ target: 'Symbol', stat: true, name: 'isWellKnownSymbol', forced: true }, {
  isWellKnown: isWellKnownSymbol
});


/***/ }),

/***/ 8703:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('matcher');


/***/ }),

/***/ 6878:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4`
var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
defineWellKnownSymbol('metadataKey');


/***/ }),

/***/ 1372:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
defineWellKnownSymbol('metadata');


/***/ }),

/***/ 4664:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol('observable');


/***/ }),

/***/ 9671:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: remove from `core-js@4`
var defineWellKnownSymbol = __webpack_require__(366);

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('patternMatch');


/***/ }),

/***/ 359:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: remove from `core-js@4`
var defineWellKnownSymbol = __webpack_require__(366);

defineWellKnownSymbol('replaceAll');


/***/ }),

/***/ 237:
/***/ (() => {

// empty


/***/ }),

/***/ 2560:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(9363);
var DOMIterables = __webpack_require__(9287);
var globalThis = __webpack_require__(5951);
var setToStringTag = __webpack_require__(4840);
var Iterators = __webpack_require__(3742);

for (var COLLECTION_NAME in DOMIterables) {
  setToStringTag(globalThis[COLLECTION_NAME], COLLECTION_NAME);
  Iterators[COLLECTION_NAME] = Iterators.Array;
}


/***/ }),

/***/ 1978:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var globalThis = __webpack_require__(5951);
var schedulersFix = __webpack_require__(485);

var setInterval = schedulersFix(globalThis.setInterval, true);

// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$({ global: true, bind: true, forced: globalThis.setInterval !== setInterval }, {
  setInterval: setInterval
});


/***/ }),

/***/ 6496:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var globalThis = __webpack_require__(5951);
var schedulersFix = __webpack_require__(485);

var setTimeout = schedulersFix(globalThis.setTimeout, true);

// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$({ global: true, bind: true, forced: globalThis.setTimeout !== setTimeout }, {
  setTimeout: setTimeout
});


/***/ }),

/***/ 3342:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(1978);
__webpack_require__(6496);


/***/ }),

/***/ 7105:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(9363);
__webpack_require__(1074);
var $ = __webpack_require__(1091);
var globalThis = __webpack_require__(5951);
var safeGetBuiltIn = __webpack_require__(2098);
var getBuiltIn = __webpack_require__(5582);
var call = __webpack_require__(3930);
var uncurryThis = __webpack_require__(1907);
var DESCRIPTORS = __webpack_require__(9447);
var USE_NATIVE_URL = __webpack_require__(4791);
var defineBuiltIn = __webpack_require__(8055);
var defineBuiltInAccessor = __webpack_require__(9251);
var defineBuiltIns = __webpack_require__(2802);
var setToStringTag = __webpack_require__(4840);
var createIteratorConstructor = __webpack_require__(7181);
var InternalStateModule = __webpack_require__(4932);
var anInstance = __webpack_require__(9596);
var isCallable = __webpack_require__(2250);
var hasOwn = __webpack_require__(9724);
var bind = __webpack_require__(8311);
var classof = __webpack_require__(3948);
var anObject = __webpack_require__(6624);
var isObject = __webpack_require__(6285);
var $toString = __webpack_require__(160);
var create = __webpack_require__(8075);
var createPropertyDescriptor = __webpack_require__(5817);
var getIterator = __webpack_require__(300);
var getIteratorMethod = __webpack_require__(3448);
var createIterResultObject = __webpack_require__(9550);
var validateArgumentsLength = __webpack_require__(4787);
var wellKnownSymbol = __webpack_require__(6264);
var arraySort = __webpack_require__(4321);

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var TypeError = globalThis.TypeError;
var encodeURIComponent = globalThis.encodeURIComponent;
var fromCharCode = String.fromCharCode;
var fromCodePoint = getBuiltIn('String', 'fromCodePoint');
var $parseInt = parseInt;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var exec = uncurryThis(/./.exec);

var plus = /\+/g;
var FALLBACK_REPLACER = '\uFFFD';
var VALID_HEX = /^[0-9a-f]+$/i;

var parseHexOctet = function (string, start) {
  var substr = stringSlice(string, start, start + 2);
  if (!exec(VALID_HEX, substr)) return NaN;

  return $parseInt(substr, 16);
};

var getLeadingOnes = function (octet) {
  var count = 0;
  for (var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1) {
    count++;
  }
  return count;
};

var utf8Decode = function (octets) {
  var codePoint = null;

  switch (octets.length) {
    case 1:
      codePoint = octets[0];
      break;
    case 2:
      codePoint = (octets[0] & 0x1F) << 6 | (octets[1] & 0x3F);
      break;
    case 3:
      codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | (octets[2] & 0x3F);
      break;
    case 4:
      codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | (octets[3] & 0x3F);
      break;
  }

  return codePoint > 0x10FFFF ? null : codePoint;
};

var decode = function (input) {
  input = replace(input, plus, ' ');
  var length = input.length;
  var result = '';
  var i = 0;

  while (i < length) {
    var decodedChar = charAt(input, i);

    if (decodedChar === '%') {
      if (charAt(input, i + 1) === '%' || i + 3 > length) {
        result += '%';
        i++;
        continue;
      }

      var octet = parseHexOctet(input, i + 1);

      // eslint-disable-next-line no-self-compare -- NaN check
      if (octet !== octet) {
        result += decodedChar;
        i++;
        continue;
      }

      i += 2;
      var byteSequenceLength = getLeadingOnes(octet);

      if (byteSequenceLength === 0) {
        decodedChar = fromCharCode(octet);
      } else {
        if (byteSequenceLength === 1 || byteSequenceLength > 4) {
          result += FALLBACK_REPLACER;
          i++;
          continue;
        }

        var octets = [octet];
        var sequenceIndex = 1;

        while (sequenceIndex < byteSequenceLength) {
          i++;
          if (i + 3 > length || charAt(input, i) !== '%') break;

          var nextByte = parseHexOctet(input, i + 1);

          // eslint-disable-next-line no-self-compare -- NaN check
          if (nextByte !== nextByte) {
            i += 3;
            break;
          }
          if (nextByte > 191 || nextByte < 128) break;

          push(octets, nextByte);
          i += 2;
          sequenceIndex++;
        }

        if (octets.length !== byteSequenceLength) {
          result += FALLBACK_REPLACER;
          continue;
        }

        var codePoint = utf8Decode(octets);
        if (codePoint === null) {
          result += FALLBACK_REPLACER;
        } else {
          decodedChar = fromCodePoint(codePoint);
        }
      }
    }

    result += decodedChar;
    i++;
  }

  return result;
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind: kind
  });
}, URL_SEARCH_PARAMS, function next() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  var entry = target[index];
  switch (state.kind) {
    case 'keys': return createIterResultObject(entry.key, false);
    case 'values': return createIterResultObject(entry.value, false);
  } return createIterResultObject([entry.key, entry.value], false);
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var entries = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw new TypeError('Expected sequence with length 2');
        push(entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var entries = this.entries;
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(entries, {
            key: decode(shift(entry)),
            value: decode(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS) this.size = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 2);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    if (!DESCRIPTORS) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ 5042:
/***/ (() => {

// empty


/***/ }),

/***/ 7649:
/***/ (() => {

// empty


/***/ }),

/***/ 6299:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(7105);


/***/ }),

/***/ 3604:
/***/ (() => {

// empty


/***/ }),

/***/ 8669:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var getBuiltIn = __webpack_require__(5582);
var fails = __webpack_require__(8828);
var validateArgumentsLength = __webpack_require__(4787);
var toString = __webpack_require__(160);
var USE_NATIVE_URL = __webpack_require__(4791);

var URL = getBuiltIn('URL');

// https://github.com/nodejs/node/issues/47505
// https://github.com/denoland/deno/issues/18893
var THROWS_WITHOUT_ARGUMENTS = USE_NATIVE_URL && fails(function () {
  URL.canParse();
});

// Bun ~ 1.0.30 bug
// https://github.com/oven-sh/bun/issues/9250
var WRONG_ARITY = fails(function () {
  return URL.canParse.length !== 1;
});

// `URL.canParse` method
// https://url.spec.whatwg.org/#dom-url-canparse
$({ target: 'URL', stat: true, forced: !THROWS_WITHOUT_ARGUMENTS || WRONG_ARITY }, {
  canParse: function canParse(url) {
    var length = validateArgumentsLength(arguments.length, 1);
    var urlString = toString(url);
    var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
    try {
      return !!new URL(urlString, base);
    } catch (error) {
      return false;
    }
  }
});


/***/ }),

/***/ 6909:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(7057);
var $ = __webpack_require__(1091);
var DESCRIPTORS = __webpack_require__(9447);
var USE_NATIVE_URL = __webpack_require__(4791);
var globalThis = __webpack_require__(5951);
var bind = __webpack_require__(8311);
var uncurryThis = __webpack_require__(1907);
var defineBuiltIn = __webpack_require__(8055);
var defineBuiltInAccessor = __webpack_require__(9251);
var anInstance = __webpack_require__(9596);
var hasOwn = __webpack_require__(9724);
var assign = __webpack_require__(9538);
var arrayFrom = __webpack_require__(1229);
var arraySlice = __webpack_require__(3427);
var codeAt = (__webpack_require__(1470).codeAt);
var toASCII = __webpack_require__(9156);
var $toString = __webpack_require__(160);
var setToStringTag = __webpack_require__(4840);
var validateArgumentsLength = __webpack_require__(4787);
var URLSearchParamsModule = __webpack_require__(7105);
var InternalStateModule = __webpack_require__(4932);

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = globalThis.URL;
var TypeError = globalThis.TypeError;
var parseInt = globalThis.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.0.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var toLowerCase = uncurryThis(''.toLowerCase);
var unshift = uncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] === '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part === '') return input;
    radix = 10;
    if (part.length > 1 && charAt(part, 0) === '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice(part, radix === 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
      number = parseInt(part, radix);
    }
    push(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index === partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt(input, pointer);
  };

  if (chr() === ':') {
    if (charAt(input, 1) !== ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex === 8) return;
    if (chr() === ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() === '.') {
      if (length === 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() === '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec(DIGIT, chr())) return;
        while (exec(DIGIT, chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece === 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
      }
      if (numbersSeen !== 4) return;
      break;
    } else if (chr() === ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex !== 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex !== 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  return currLength > maxLength ? currStart : maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;

  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    }
    return join(result, '.');
  }

  // ipv6
  if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  }

  return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length === 2 && exec(ALPHA, charAt(string, 0))
    && ((second = charAt(string, 1)) === ':' || (!normalized && second === '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
    string.length === 2 ||
    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw new TypeError(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw new TypeError(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) {
            buffer += toLowerCase(chr);
          } else if (chr === ':') {
            if (stateOverride && (
              (url.isSpecial() !== hasOwn(specialSchemes, buffer)) ||
              (buffer === 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme === 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme === 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme === url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] === '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr !== '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr === '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme === 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr === '/' && codePoints[pointer + 1] === '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr === '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr === EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr === '/' || (chr === '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr === '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr === '/' || chr === '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr === '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr !== '/' || charAt(buffer, pointer + 1) !== '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr !== '/' && chr !== '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr === '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint === ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer === '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme === 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr === ':' && !seenBracket) {
            if (buffer === '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride === HOSTNAME) return;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer === '') return INVALID_HOST;
            if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr === '[') seenBracket = true;
            else if (chr === ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer !== '') {
              var port = parseInt(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr === '/' || chr === '\\') state = FILE_SLASH;
          else if (base && base.scheme === 'file') {
            switch (chr) {
              case EOF:
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                break;
              case '?':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = '';
                state = QUERY;
                break;
              case '#':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                url.fragment = '';
                state = FRAGMENT;
                break;
              default:
                if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                  url.host = base.host;
                  url.path = arraySlice(base.path);
                  url.shortenPath();
                }
                state = PATH;
                continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr === '/' || chr === '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme === 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer === '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host === 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr !== '/' && chr !== '\\') continue;
          } else if (!stateOverride && chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            state = PATH;
            if (chr !== '/') continue;
          } break;

        case PATH:
          if (
            chr === EOF || chr === '/' ||
            (chr === '\\' && url.isSpecial()) ||
            (!stateOverride && (chr === '?' || chr === '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else {
              if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
              }
              push(url.path, buffer);
            }
            buffer = '';
            if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr === '?') {
              url.query = '';
              state = QUERY;
            } else if (chr === '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            if (chr === "'" && url.isSpecial()) url.query += '%27';
            else if (chr === '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt(input, 0) === '[') {
      if (charAt(input, input.length - 1) !== ']') return INVALID_HOST;
      result = parseIPv6(stringSlice(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username !== '' || this.password !== '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme === 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw new TypeError(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme === 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme === 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString(port);
    if (port === '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString(search);
    if (search === '') {
      this.query = null;
    } else {
      if (charAt(search, 0) === '?') search = stringSlice(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString(hash);
    if (hash === '') {
      this.fragment = null;
      return;
    }
    if (charAt(hash, 0) === '#') hash = stringSlice(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),

/***/ 3487:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(6909);


/***/ }),

/***/ 8670:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(1091);
var getBuiltIn = __webpack_require__(5582);
var validateArgumentsLength = __webpack_require__(4787);
var toString = __webpack_require__(160);
var USE_NATIVE_URL = __webpack_require__(4791);

var URL = getBuiltIn('URL');

// `URL.parse` method
// https://url.spec.whatwg.org/#dom-url-canparse
$({ target: 'URL', stat: true, forced: !USE_NATIVE_URL }, {
  parse: function parse(url) {
    var length = validateArgumentsLength(arguments.length, 1);
    var urlString = toString(url);
    var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
    try {
      return new URL(urlString, base);
    } catch (error) {
      return null;
    }
  }
});


/***/ }),

/***/ 4783:
/***/ (() => {

// empty


/***/ }),

/***/ 6450:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(3607);

module.exports = parent;


/***/ }),

/***/ 8402:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(3531);

module.exports = parent;


/***/ }),

/***/ 1969:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(2092);

module.exports = parent;


/***/ }),

/***/ 1374:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(6535);

module.exports = parent;


/***/ }),

/***/ 7867:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(5354);

module.exports = parent;


/***/ }),

/***/ 3067:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(4712);
__webpack_require__(2560);

module.exports = parent;


/***/ }),

/***/ 9709:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(3034);

module.exports = parent;


/***/ }),

/***/ 530:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(8218);

module.exports = parent;


/***/ }),

/***/ 2616:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(3155);

module.exports = parent;


/***/ }),

/***/ 4525:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classof = __webpack_require__(3948);
var hasOwn = __webpack_require__(9724);
var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(1969);
__webpack_require__(237);

var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.forEach;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.forEach)
    || hasOwn(DOMIterables, classof(it)) ? method : own;
};


/***/ }),

/***/ 6343:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(6880);

module.exports = parent;


/***/ }),

/***/ 7852:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(4507);

module.exports = parent;


/***/ }),

/***/ 1618:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(2560);
var classof = __webpack_require__(3948);
var hasOwn = __webpack_require__(9724);
var isPrototypeOf = __webpack_require__(8280);
var method = __webpack_require__(1374);

var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.keys;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.keys)
    || hasOwn(DOMIterables, classof(it)) ? method : own;
};


/***/ }),

/***/ 8894:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(9299);

module.exports = parent;


/***/ }),

/***/ 3266:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(8685);

module.exports = parent;


/***/ }),

/***/ 9528:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(8823);

module.exports = parent;


/***/ }),

/***/ 4106:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(8059);

module.exports = parent;


/***/ }),

/***/ 6686:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(303);

module.exports = parent;


/***/ }),

/***/ 26:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(5029);

module.exports = parent;


/***/ }),

/***/ 4598:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(3423);

module.exports = parent;


/***/ }),

/***/ 3658:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(149);

module.exports = parent;


/***/ }),

/***/ 9703:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(8970);

module.exports = parent;


/***/ }),

/***/ 8251:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(1926);

module.exports = parent;


/***/ }),

/***/ 4532:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(30);

module.exports = parent;


/***/ }),

/***/ 6513:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(5092);

module.exports = parent;


/***/ }),

/***/ 3220:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(9147);

module.exports = parent;


/***/ }),

/***/ 9563:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(4776);

module.exports = parent;


/***/ }),

/***/ 9261:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(6286);

module.exports = parent;


/***/ }),

/***/ 6490:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(9661);

module.exports = parent;


/***/ }),

/***/ 7777:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(1418);

module.exports = parent;


/***/ }),

/***/ 5980:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(8699);

module.exports = parent;


/***/ }),

/***/ 1921:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(4326);

module.exports = parent;


/***/ }),

/***/ 5204:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(7027);
__webpack_require__(2560);

module.exports = parent;


/***/ }),

/***/ 5177:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(6098);

module.exports = parent;


/***/ }),

/***/ 9416:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(655);

module.exports = parent;


/***/ }),

/***/ 4674:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(3342);
var path = __webpack_require__(2046);

module.exports = path.setInterval;


/***/ }),

/***/ 568:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(3342);
var path = __webpack_require__(2046);

module.exports = path.setTimeout;


/***/ }),

/***/ 4139:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(3842);
__webpack_require__(2560);

module.exports = parent;


/***/ }),

/***/ 7045:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(1730);
__webpack_require__(2560);

module.exports = parent;


/***/ }),

/***/ 70:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(1661);

module.exports = parent;


/***/ }),

/***/ 9792:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(6908);

module.exports = parent;


/***/ }),

/***/ 9428:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(7173);
__webpack_require__(2560);

module.exports = parent;


/***/ }),

/***/ 4062:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var parent = __webpack_require__(7499);
__webpack_require__(2560);

module.exports = parent;


/***/ }),

/***/ 9076:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(6299);
__webpack_require__(5042);
__webpack_require__(7649);
__webpack_require__(3604);
var path = __webpack_require__(2046);

module.exports = path.URLSearchParams;


/***/ }),

/***/ 6908:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

__webpack_require__(9076);
__webpack_require__(3487);
__webpack_require__(8669);
__webpack_require__(8670);
__webpack_require__(4783);
var path = __webpack_require__(2046);

module.exports = path.URL;


/***/ }),

/***/ 8330:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"name":"@skylineos/clsp-player","title":"Skyline CLSP Player","version":"0.23.12","description":"Skyline Technology Solutions\' CLSP Video Player.  Stream video in near-real-time in modern browsers.","keywords":["html5","clsp","video","player","skyline"],"license":"MIT","repository":"https://github.com/skylineos/clsp-player.git","main":"dist/clsp-player.min.js","scripts":{"build":"./scripts/build/build.sh","serve":"./scripts/serve/serve.sh","lint":"eslint .","lint-fix":"eslint . --fix","prepack":"NODE_ENV=production yarn run build","postpack":"./scripts/build/pre-build.sh","preversion":"./scripts/version.sh --pre","version":"./scripts/version.sh","postversion":"./scripts/version.sh --post","test:jest":"jest && ./test/jest/scripts/echo-coverage-hyperlink.sh","test":"yarn run test:jest","test:dev":"jest --coverage=false","test:watch":"yarn run test:dev --watch","test:wdio":"start-server-and-test serve http://localhost:8080 wdio","validate:ts":"tsc index.d.ts","wdio":"wdio run wdio.conf.js"},"dependencies":{"@babel/runtime-corejs3":"7.26.10","eventemitter3":"4.0.7","interval-promise":"1.4.0","lodash":"4.17.21","paho-mqtt":"1.1.0","promise-timeout":"1.3.0","sleepjs":"4.0.2","srcdoc-polyfill":"1.0.0","url":"0.11.0","uuid":"8.3.0"},"devDependencies":{"@babel/core":"^7.26.10","@babel/eslint-parser":"^7.26.0","@babel/eslint-plugin":"^7.26.0","@babel/plugin-transform-class-properties":"7.25.9","@babel/plugin-transform-object-rest-spread":"7.25.9","@babel/plugin-transform-runtime":"^7.26.0","@babel/preset-env":"^7.26.0","@babel/register":"^7.16.5","@eslint/eslintrc":"^3.3.0","@eslint/js":"^9.22.0","@wdio/cli":"^9.12.1","@wdio/local-runner":"^9.12.1","@wdio/mocha-framework":"^9.12.1","@wdio/spec-reporter":"^9.11.0","babel-loader":"^9.2.1","chalk":"4.1.0","chromedriver":"^134.0.0","css-loader":"7.1.2","eslint":"^9.17.0","eslint-config-standard":"^17.1.0","eslint-plugin-import":"2.31.0","eslint-plugin-jest":"28.11.0","eslint-plugin-n":"^17.16.2","eslint-plugin-node":"11.1.0","eslint-plugin-promise":"7.2.1","globals":"^16.0.0","humanize":"0.0.9","jest":"29.7.0","jest-environment-jsdom":"^29.7.0","jest-extended":"4.0.2","jest-mock-console":"2.0.0","jquery":"3.5.1","mini-css-extract-plugin":"2.7.6","moment":"2.29.4","progress-bar-webpack-plugin":"2.1.0","standard":"14.3.4","start-server-and-test":"^2.0.11","style-loader":"1.2.1","typescript":"4.0.3","url-loader":"4.1.0","wdio-chromedriver-service":"^8.1.1","webpack":"5.95.0","webpack-bundle-analyzer":"4.10.0","webpack-dev-server":"5.2.0","write-file-webpack-plugin":"4.5.1"},"packageManager":"yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Iov: () => (/* reexport */ Iov),
  IovCollection: () => (/* reexport */ IovCollection),
  TourController: () => (/* reexport */ TourController),
  utils: () => (/* reexport */ (utils_default()))
});

// EXTERNAL MODULE: ./node_modules/srcdoc-polyfill/srcdoc-polyfill.js
var srcdoc_polyfill = __webpack_require__(255);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/construct.js
var construct = __webpack_require__(2574);
var construct_default = /*#__PURE__*/__webpack_require__.n(construct);
// EXTERNAL MODULE: ./node_modules/core-js-pure/full/promise/index.js
var promise = __webpack_require__(7166);
;// ./node_modules/@babel/runtime-corejs3/helpers/esm/asyncToGenerator.js

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/classCallCheck.js
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

// EXTERNAL MODULE: ./node_modules/core-js-pure/full/object/define-property.js
var define_property = __webpack_require__(4997);
// EXTERNAL MODULE: ./node_modules/core-js-pure/full/symbol/index.js
var symbol = __webpack_require__(2321);
// EXTERNAL MODULE: ./node_modules/core-js-pure/full/symbol/iterator.js
var iterator = __webpack_require__(2231);
;// ./node_modules/@babel/runtime-corejs3/helpers/esm/typeof.js


function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof symbol && "symbol" == typeof iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof symbol && o.constructor === symbol && o !== symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

// EXTERNAL MODULE: ./node_modules/core-js-pure/full/symbol/to-primitive.js
var to_primitive = __webpack_require__(9280);
;// ./node_modules/@babel/runtime-corejs3/helpers/esm/toPrimitive.js


function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[to_primitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/createClass.js


function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), define_property(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), define_property(e, "prototype", {
    writable: !1
  }), e;
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

// EXTERNAL MODULE: ./node_modules/core-js-pure/full/object/set-prototype-of.js
var set_prototype_of = __webpack_require__(5363);
// EXTERNAL MODULE: ./node_modules/core-js-pure/full/instance/bind.js
var bind = __webpack_require__(3375);
// EXTERNAL MODULE: ./node_modules/core-js-pure/full/object/get-prototype-of.js
var get_prototype_of = __webpack_require__(7415);
;// ./node_modules/@babel/runtime-corejs3/helpers/esm/getPrototypeOf.js



function _getPrototypeOf(t) {
  var _context;
  return _getPrototypeOf = set_prototype_of ? bind(_context = get_prototype_of).call(_context) : function (t) {
    return t.__proto__ || get_prototype_of(t);
  }, _getPrototypeOf(t);
}

// EXTERNAL MODULE: ./node_modules/core-js-pure/full/reflect/get.js
var get = __webpack_require__(1138);
// EXTERNAL MODULE: ./node_modules/core-js-pure/full/object/get-own-property-descriptor.js
var get_own_property_descriptor = __webpack_require__(5983);
;// ./node_modules/@babel/runtime-corejs3/helpers/esm/superPropBase.js

function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/get.js




function _get() {
  var _context;
  return _get = "undefined" != typeof Reflect && get ? bind(_context = get).call(_context) : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = get_own_property_descriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}

// EXTERNAL MODULE: ./node_modules/core-js-pure/full/object/create.js
var create = __webpack_require__(7764);
;// ./node_modules/@babel/runtime-corejs3/helpers/esm/setPrototypeOf.js


function _setPrototypeOf(t, e) {
  var _context;
  return _setPrototypeOf = set_prototype_of ? bind(_context = set_prototype_of).call(_context) : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/inherits.js



function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), define_property(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/defineProperty.js


function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? define_property(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/promise.js
var core_js_stable_promise = __webpack_require__(1240);
var core_js_stable_promise_default = /*#__PURE__*/__webpack_require__.n(core_js_stable_promise);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/date/now.js
var now = __webpack_require__(7169);
var now_default = /*#__PURE__*/__webpack_require__.n(now);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/weak-set.js
var weak_set = __webpack_require__(2472);
var weak_set_default = /*#__PURE__*/__webpack_require__.n(weak_set);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/regenerator/index.js
var regenerator = __webpack_require__(4828);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/sleepjs/dist/index.js
var dist = __webpack_require__(4224);
// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(9843);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ./src/js/utils/utils.js
var utils = __webpack_require__(8192);
var utils_default = /*#__PURE__*/__webpack_require__.n(utils);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/object/values.js
var values = __webpack_require__(7119);
var values_default = /*#__PURE__*/__webpack_require__.n(values);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/includes.js
var includes = __webpack_require__(8628);
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);
// EXTERNAL MODULE: ./node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__(228);
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/concat.js
var concat = __webpack_require__(1393);
var concat_default = /*#__PURE__*/__webpack_require__.n(concat);
// EXTERNAL MODULE: ./src/js/utils/Logger.js
var Logger = __webpack_require__(909);
var Logger_default = /*#__PURE__*/__webpack_require__.n(Logger);
;// ./src/js/utils/Destroyable.js






/**
 * A base class that supports destruction and logging.
 */



var Destroyable = /*#__PURE__*/function () {
  function Destroyable(options) {
    var _context;
    _classCallCheck(this, Destroyable);
    _defineProperty(this, "logId", null);
    _defineProperty(this, "isDestroyed", false);
    _defineProperty(this, "isDestroyComplete", false);
    if (!options) {
      throw new Error('Logging options are required');
    }
    if (typeof options === 'object') {
      this.logId = options.id;
      this.logColor = options.color;
    }
    if (typeof options === 'string') {
      this.logId = options;
    }
    if (!this.logId) {
      throw new Error("`logId` is required to construct a new ".concat(this.constructor.name));
    }
    if (!this.logColor) {
      this.logColor = 'black';
    }
    this.logger = Logger_default()((utils_default()).version).factory(concat_default()(_context = "".concat(this.constructor.name, " ")).call(_context, this.logId), "color: ".concat(this.logColor, ";"));
    this.logger.info("Constructing new ".concat(this.constructor.name, " instance"));
  }

  /**
   * Put your class's destroy logic in this method.
   */
  return _createClass(Destroyable, [{
    key: "_reset",
    value: (function () {
      var _reset2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }, _callee);
      }));
      function _reset() {
        return _reset2.apply(this, arguments);
      }
      return _reset;
    }())
  }, {
    key: "reset",
    value: function () {
      var _reset3 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.logger.info('Resetting...');
              this.isDestroyed = false;
              this.isDestroyComplete = false;
              _context3.next = 5;
              return this._reset();
            case 5:
              this.logger.info('Reset complete');
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
      function reset() {
        return _reset3.apply(this, arguments);
      }
      return reset;
    }()
    /**
     * Put your class's destroy logic in this method.
     *
     * @todo - should this be private?
     */
  }, {
    key: "_destroy",
    value: (function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
            case "end":
              return _context4.stop();
          }
        }, _callee3);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }()
    /**
     * @async
     *
     * This method will call the `_destroy` method of the instance's class
     *
     * @returns {void}
     */
    )
  }, {
    key: "destroy",
    value: (function () {
      var _destroy3 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4() {
        return regenerator_default().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!this.isDestroyed) {
                _context5.next = 3;
                break;
              }
              this.logger.info('Already destroyed');
              return _context5.abrupt("return");
            case 3:
              this.isDestroyed = true;
              this.logger.info('Destroying...');
              _context5.next = 7;
              return this._destroy();
            case 7:
              this.isDestroyComplete = true;
              this.logger.info('Destroy complete');
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this);
      }));
      function destroy() {
        return _destroy3.apply(this, arguments);
      }
      return destroy;
    }())
  }]);
}();

;// ./src/js/utils/EventEmitter.js












function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/**
 * A base class that is destroyable, supports logging, and events.
 */



var EventEmitter = /*#__PURE__*/function (_Destroyable) {
  function EventEmitter(logOptions) {
    var _this;
    _classCallCheck(this, EventEmitter);
    _this = _callSuper(this, EventEmitter, [logOptions]);
    _defineProperty(_this, "events", null);
    _this.events = new (eventemitter3_default())();
    return _this;
  }

  /**
   * Register an event listener for this IovPlayer.
   *
   * @param {string} eventName
   *   A valid event name, as defined on the class's static `events` property
   * @param {function} handler
   *   A function that will be executed every time the instance emits the
   *   event defined by the `eventName` argument.
   *
   * @returns {this}
   */
  _inherits(EventEmitter, _Destroyable);
  return _createClass(EventEmitter, [{
    key: "on",
    value: function on(eventName, handler) {
      var eventNames = values_default()(this.constructor.events);
      if (!includes_default()(eventNames).call(eventNames, eventName)) {
        throw new Error("Unable to register listener for unknown event \"".concat(eventName, "\""));
      }
      if (!handler) {
        throw new Error("Unable to register for event \"".concat(eventName, "\" without a handler"));
      }

      // @todo - should the caller have the ability to respond to this?
      if (this.isDestroyed) {
        // @todo - this should probably log as critical
        this.logger.error("Tried to register handler for event \"".concat(eventName, "\" while destroyed!"));
        return this;
      }
      this.events.on(eventName, handler);
      return this;
    }

    // @todo - should this be a private field?
  }, {
    key: "emit",
    value: function emit(eventName, data) {
      // @todo - should the caller have the ability to respond to this?
      if (this.isDestroyed) {
        // @todo - this should probably log as critical
        this.logger.error("Tried to emit \"".concat(eventName, "\" while destroyed!"));
        return;
      }
      this.events.emit(eventName, data);
    }
  }, {
    key: "_reset",
    value: function () {
      var _reset2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.events = new (eventemitter3_default())();
              _context.next = 3;
              return _superPropGet(EventEmitter, "_reset", this, 3)([]);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _reset() {
        return _reset2.apply(this, arguments);
      }
      return _reset;
    }()
  }, {
    key: "_destroy",
    value: function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.events.removeAllListeners();
              this.events = null;
              _context2.next = 4;
              return _superPropGet(EventEmitter, "_destroy", this, 3)([]);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }()
  }]);
}(Destroyable);
_defineProperty(EventEmitter, "events", {});

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/index-of.js
var index_of = __webpack_require__(4007);
var index_of_default = /*#__PURE__*/__webpack_require__.n(index_of);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/slice.js
var slice = __webpack_require__(8979);
var slice_default = /*#__PURE__*/__webpack_require__.n(slice);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/splice.js
var splice = __webpack_require__(385);
var splice_default = /*#__PURE__*/__webpack_require__.n(splice);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/map.js
var map = __webpack_require__(8079);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/reduce.js
var reduce = __webpack_require__(3363);
var reduce_default = /*#__PURE__*/__webpack_require__.n(reduce);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/for-each.js
var for_each = __webpack_require__(6226);
var for_each_default = /*#__PURE__*/__webpack_require__.n(for_each);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/object/keys.js
var keys = __webpack_require__(697);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);
;// ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
  }

  return getRandomValues(rnds8);
}
;// ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ const regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ const esm_browser_validate = (validate);
;// ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ const esm_browser_stringify = (stringify);
;// ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ const esm_browser_v4 = (v4);
;// ./src/js/ClspClient/Router/Router.js
/**
 * The Router contains the lowest-level logic of the actual CLSP connection.
 * The Router will manage a CLSP connection for a given clientId, and pass
 * the relevant data and messages back up to the Iframe Manager.
 *
 * Note that this is the code that gets duplicated in each iframe.
 * Keep the contents of the exported function light and ES5 only.
 *
 * @see - https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe
 * @see - https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body
 * @see - https://www.eclipse.org/paho/files/jsdoc/index.html
 *
 * @todo - have a custom loader for webpack that can convert this to ES5 and
 * minify it in a self-contained way at the time it is required so that we can
 * use ES6 and multiple files.
 *
 * @todo - should all thrown errors send a message to the parent?
 *
 * @param {object} Paho
 *   The Paho instance to use for server communication.  This should be passed
 *   in as `window.parent.Paho` to prevent the Paho library from being
 *   duplicated for every CLSP iframe.
 *
 * @export - the function that provides the Router and constants
 */
/* harmony default export */ function Router(Paho) {
  /**
   * A Router that can be used to set up a CLSP connection to the specified
   * host and port, using the provided clientId that will be a part of
   * every message that is passed from this iframe window to the parent window,
   * so that the the Conduit Collection can identify what Conduit the message
   * is for.
   *
   * @param {String} logId
   *   a string that identifies this router in log messages
   * @param {String} clientId
   *   the guid to be used to construct the topic
   * @param {String} host
   *   the host (url or ip) of the SFS that is providing the stream
   * @param {Number} port
   *   the port the stream is served over
   * @param {Boolean} useSSL
   *   true to request the stream over clsps, false to request the stream over clsp
   * @param {Object} options
   */
  function Router (
    logId,
    clientId,
    host,
    port,
    useSSL,
    options,
  ) {
    Router.constructorArgumentsBouncer(
      logId,
      clientId,
      host,
      port,
      useSSL,
      options,
    );

    this.logId = logId;

    try {
      this.logger = options.Logger.factory(`Router ${this.logId}`, 'color: maroon;');
    }
    catch (error) {
      console.error(error);
      throw new Error('Error while constructing Logger!');
    }

    this.clientId = clientId;

    this.host = host;
    this.port = port;
    this.useSSL = useSSL;

    this.logger.debug('Constructing...');

    this.Reconnect = null;

    try {
      // @todo - there is a "private" method named "_doConnect" in the paho
      // library that is responsible for instantiating the WebSocket.  We have
      // seen at least 1 instance where the instantiation of the WebSocket fails
      // which was due to the error "ERR_NAME_NOT_RESOLVED", but it does not
      // seem like this error is "passed" up to the caller (e.g. Router.connect)
      // and therefore we cannot respond to it.  If we could, perhaps we could
      // attempt to reconnect, or at least send a message to Router's parent.
      // Given this, should we override Paho.MQTT.Client._doConnect and wrap
      // the original prototype method call in a try/catch that we can control
      // and respond to?  I'm not even sure that that would solve the problem.
      // Presumably, the instantiation of the WebSocket would throw, which would
      // be caught by our Router.connect try/catch block...
      this.clspClient = new Paho.MQTT.Client(
        this.host,
        this.port,
        '/mqtt',
        this.clientId,
      );
    }
    catch (error) {
      const message = new Error('Error while constructing Paho Client!');
      this.logger.critical(message);
      this.logger.critical(error);
      throw message;
    }

    this.clspClient.onConnectionLost = this._onConnectionLost.bind(this);
    this.clspClient.onMessageArrived = this._onMessageArrived.bind(this);
    this.clspClient.onMessageDelivered = this._onMessageDelivered.bind(this);

    this.boundWindowMessageEventHandler = this._windowMessageEventHandler.bind(this);

    window.addEventListener(
      'message',
      this.boundWindowMessageEventHandler,
      false,
    );

    this.CONNECTION_TIMEOUT = options.CONNECTION_TIMEOUT;
    this.KEEP_ALIVE_INTERVAL = options.KEEP_ALIVE_INTERVAL;
    this.PUBLISH_TIMEOUT = options.PUBLISH_TIMEOUT;

    this.isDestroyed = false;
    this.isDestroyComplete = false;
  }

  Router.constructorArgumentsBouncer = function (
    logId,
    clientId,
    host,
    port,
    useSSL,
    options,
  ) {
    if (typeof Paho !== 'object') {
      throw new Error('Paho is required to construct a Router');
    }
    if (typeof Paho.MQTT !== 'object') {
      throw new Error('Paho.MQTT is required to construct a Router');
    }
    if (typeof Paho.MQTT.Client !== 'function') {
      throw new Error('Paho.MQTT.Client is required to construct a Router');
    }
    if (typeof Paho.MQTT.Message !== 'function') {
      throw new Error('Paho.MQTT.Message is required to construct a Router');
    }
    if (logId === undefined) {
      throw new Error('`logId` is required to construct a Router');
    }
    if (clientId === undefined) {
      throw new Error('`clientId` is required to construct a Router');
    }
    if (host === undefined) {
      throw new Error('`host` is required to construct a Router');
    }
    if (port === undefined) {
      throw new Error('`port` is required to construct a Router');
    }
    if (useSSL === undefined) {
      throw new Error('`useSSL` is required to construct a Router');
    }
    if (typeof options !== 'object') {
      throw new Error('`options` is required to construct a Router');
    }
    if (options.Logger === undefined) {
      throw new Error('`options.Logger` is required to construct a Router');
    }
    if (options.CONNECTION_TIMEOUT === undefined) {
      throw new Error('`options.CONNECTION_TIMEOUT` is required to construct a Router');
    }
    if (options.KEEP_ALIVE_INTERVAL === undefined) {
      throw new Error('`options.KEEP_ALIVE_INTERVAL` is required to construct a Router');
    }
    if (options.PUBLISH_TIMEOUT === undefined) {
      throw new Error('`options.PUBLISH_TIMEOUT` is required to construct a Router');
    }
  };

  Router.pahoErrorCodes = {
    NOT_CONNECTED: 'AMQJS0011E',
    ALREADY_CONNECTED: 'AMQJS0011E',
  };

  // All events that are emitted by the Router are prefixed with `clsp_router`
  Router.events = {
    // Triggered when the Router is successfully instantiated.
    // Can only be triggered at time of router instantiation.
    CREATE_SUCCESS: 'clsp_router_create_success',
    // Triggered when there is an error during Router instantiation.
    // Can only be triggered at time of router instantiation.
    CREATE_FAILURE: 'clsp_router_create_failure',
    // Triggered when the connection to the CLSP server is established.
    // Can only be triggered at time of connection.
    CONNECT_SUCCESS: 'clsp_router_connect_success',
    // Triggered when trying to connect to the CLSP server fails.
    // Can only be triggered at time of connection.
    CONNECT_FAILURE: 'clsp_router_connect_failure',
    // Triggered when the connection to the CLSP server has been established, but is later lost.
    // Can be triggered for as long as the connection is open.
    CONNECTION_LOST: 'clsp_router_connection_lost',
    // Triggered when the connection to the CLSP server is terminated normally.
    // Can only be triggered at time of disconnection.
    DISCONNECT_SUCCESS: 'clsp_router_disconnect_success',
    DISCONNECT_FAILURE: 'clsp_router_disconnect_failure',
    // Triggered when a message is successfully published to the server
    // Can only be triggered on publish
    PUBLISH_SUCCESS: 'clsp_router_publish_success',
    // Triggered when a message fails to be published to the server
    // Can only be triggered on publish
    PUBLISH_FAILURE: 'clsp_router_publish_failure',
    // Triggered when trying to subscribe to a topic fails.
    // Can only be triggered when a subscribe is attempted.
    SUBSCRIBE_FAILURE: 'clsp_router_subscribe_failure',
    // When successfully unsubscribed from a topic
    // Can only be triggered when an unsubscribe is attempted.
    UNSUBSCRIBE_SUCCESS: 'clsp_router_unsubscribe_success',
    // When trying to unsubscribe from a topic fails.
    // Can only be triggered when an unsubscribe is attempted.
    UNSUBSCRIBE_FAILURE: 'clsp_router_unsubscribe_failure',
    // Triggered when a segment / moof is transmitted.
    // Can be triggered for as long as the connection is open.
    MESSAGE_ARRIVED: 'clsp_router_message_arrived',
    // Triggered when an error is encountered while processing window messages.
    // Can be triggered any time.
    WINDOW_MESSAGE_FAIL: 'clsp_router_window_message_fail',
  };

  Router.commands = {
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    PUBLISH: 'publish',
    SUBSCRIBE: 'subscribe',
    UNSUBSCRIBE: 'unsubscribe',
    SEND: 'send',
  };

  Router.factory = function (
    logId,
    clientId,
    host,
    port,
    useSSL,
    options,
  ) {
    return new Router(
      logId,
      clientId,
      host,
      port,
      useSSL,
      options,
    );
  };

  /**
   * @private
   *
   * Post a "message" with the current `clientId` to the parent window.
   *
   * @param {Object} message
   *   The message to send to the parent window
   *
   * @returns {void}
   */
  Router.prototype._sendToParentWindow = function (message) {
    this.logger.debug('Sending message to parent window...');

    if (this.isDestroyed) {
      return;
    }

    if (typeof message !== 'object') {
      throw new Error('_sendToParentWindow must be passed an object');
    }

    message.clientId = this.clientId;

    switch (message.event) {
      case Router.events.CREATE_SUCCESS:
      case Router.events.CONNECT_SUCCESS:
      case Router.events.DISCONNECT_SUCCESS: {
        // no validation needed
        break;
      }
      case Router.events.MESSAGE_ARRIVED: {
        if (!Object.prototype.hasOwnProperty.call(message, 'destinationName') ||
          !Object.prototype.hasOwnProperty.call(message, 'payloadString') ||
          !Object.prototype.hasOwnProperty.call(message, 'payloadBytes')
        ) {
          throw new Error('improperly formatted "data" message sent to _sendToParentWindow');
        }

        break;
      }
      case Router.events.UNSUBSCRIBE_SUCCESS: {
        if (!Object.prototype.hasOwnProperty.call(message, 'event') ||
          !Object.prototype.hasOwnProperty.call(message, 'topic') ||
          !Object.prototype.hasOwnProperty.call(message, 'response')
        ) {
          throw new Error('improperly formatted "unsubscribe success" message sent to _sendToParentWindow');
        }

        break;
      }
      case Router.events.CONNECT_FAILURE:
      case Router.events.CONNECTION_LOST:
      case Router.events.SUBSCRIBE_FAILURE:
      case Router.events.UNSUBSCRIBE_FAILURE:
      case Router.events.WINDOW_MESSAGE_FAIL: {
        if (!Object.prototype.hasOwnProperty.call(message, 'reason')) {
          throw new Error('improperly formatted "fail" message sent to _sendToParentWindow');
        }

        break;
      }
      case Router.events.PUBLISH_SUCCESS: {
        if (!message.publishId) {
          throw new Error('publish message must contain a publishId');
        }

        if (!message.topic) {
          throw new Error('publish message must contain a topic');
        }

        break;
      }
      case Router.events.PUBLISH_FAILURE: {
        if (!message.publishId) {
          throw new Error('publish message must contain a publishId');
        }

        if (!Object.prototype.hasOwnProperty.call(message, 'reason')) {
          throw new Error('improperly formatted "fail" message sent to _sendToParentWindow');
        }

        break;
      }
      default: {
        throw new Error('Unknown event ' + message.event + ' sent to _sendToParentWindow');
      }
    }

    try {
      window.parent.postMessage(message, '*');
    }
    catch (error) {
      // When the connection to the SFS fails, and the conduit is destroyed,
      // there is still a message that is attempted to be sent to the parent.
      // In this case, the only way this "orphaned" iframe object can
      // communicate with the console is by throwing an error.  Therefore, it is
      // difficult to debug and I do not know what the final message is.  Having
      // the error written to the console here will still allow errors under
      // "normal" operations to be written to the console, but will suppress the
      // final unwanted error.

      console.error(error);
    }
  };

  /**
   * @private
   *
   * To be called when a message has arrived in this Paho.MQTT.client
   *
   * The idea here is that when the server sends a CLSP message, whether a
   * moof, moov, or something else, that data needs to be sent to the appropriate
   * player (client).  So when this router gets that chunk of data, it sends it
   * back to the Conduit with the clientId, and the Conduit is then responsible
   * for passing it to the appropriate player.
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @param {Paho.MQTT.Message} clspMessage
   *   The incoming message
   *
   * @returns {void}
   */
  Router.prototype._onMessageArrived = function (clspMessage) {
    this.logger.debug('Received CLSP message...');

    try {
      let payloadString = '';

      try {
        payloadString = clspMessage.payloadString;
      }
      catch (error) {
        // I have no idea what is going on here, but every single time we do the
        // assignment above, an error is thrown.  When I console.log(payloadString)
        // it appears to be an empty string.  However, if that assignment is not
        // done, no video gets displayed!!
        // There should be some way to only use the payloadBytes here...
      }

      this._sendToParentWindow({
        event: Router.events.MESSAGE_ARRIVED,
        destinationName: clspMessage.destinationName,
        payloadString, // @todo - why is this necessary when it doesn't exist?
        payloadBytes: clspMessage.payloadBytes || null,
      });
    }
    catch (error) {
      this.logger.error(error);
    }
  };

  /**
   * @private
   *
   * To be called when a message has been published by this CLSP client.
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @param {Paho.MQTT.Message} clspMessage
   *   The message that was delivered
   *
   * @returns {void}
   */
  Router.prototype._onMessageDelivered = function (clspMessage) {
    this.logger.debug('Delivered CLSP message...');

    if (clspMessage._onDelivered) {
      clspMessage._onDelivered();
    }
  };

  Router.prototype._onCommandReceived = function (command, message, event) {
    switch (command) {
      case Router.commands.SUBSCRIBE: {
        this._subscribe(message.topic);
        break;
      }
      case Router.commands.UNSUBSCRIBE: {
        this._unsubscribe(message.topic);
        break;
      }
      case Router.commands.PUBLISH: {
        let payload = null;

        try {
          payload = JSON.stringify(message.data);
        }
        catch (error) {
          this.logger.error('ERROR: Unable to handle the "publish" window message event!');
          this.logger.error('json stringify error: ' + message.data);

          // @todo - should we throw here?
          // throw error;
          return;
        }

        this._publish(
          message.publishId,
          message.topic,
          payload,
        );
        break;
      }
      case Router.commands.CONNECT: {
        this.connect();
        break;
      }
      case Router.commands.DISCONNECT: {
        this.disconnect();
        break;
      }
      case Router.commands.SEND: {
        this._publish(
          message.publishId,
          message.topic,
          message.byteArray,
        );
        break;
      }
      default: {
        this.logger.error('Unknown Command: "' + command + '"');
      }
    }
  };

  /**
   * @private
   *
   * Any time a "message" event occurs on the window, respond to it by
   * inspecting the message's "method" property and taking the appropriate
   * action.
   *
   * @param {Object} event
   *   The window message event
   *
   * @returns {void}
   */
  Router.prototype._windowMessageEventHandler = function (event) {
    const message = event.data;

    if (!message) {
      return;
    }

    const method = message.method;

    if (!method) {
      return;
    }

    this.logger.debug('Handling incoming window message for "' + method + '"...');

    try {
      this._onCommandReceived(method, message, event);
    }
    catch (error) {
      this.logger.error(error);

      this._sendToParentWindow({
        event: Router.events.WINDOW_MESSAGE_FAIL,
        reason: 'window message event failure',
      });
    }
  };

  /**
   * @private
   *
   * Success handler for the CLSP client "connect".  Registers the window
   * message event handler, and notifies the parent window that this client is
   * "ready".
   *
   * @todo - track the "connected" status to prevent multiple window message
   * event handlers from being attached
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @param {Object} response
   *   The response object
   *
   * @returns {void}
   */
  Router.prototype._connect_onSuccess = function (response) {
    this.logger.info('Successfully established CLSP connection');

    this._sendToParentWindow({
      event: Router.events.CONNECT_SUCCESS,
    });
  };

  /**
   * @private
   *
   * Failure handler for CLSP client "connect".  Sends a "fail" message to the
   * parent window
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @param {Object} response
   *   The response object
   *
   * @returns {void}
   */
  Router.prototype._connect_onFailure = function (response) {
    this.logger.info('CLSP Connection Failure!');

    this._sendToParentWindow({
      event: Router.events.CONNECT_FAILURE,
      reason: 'Connection Failed - Error code ' + parseInt(response.errorCode) + ': ' + response.errorMessage,
    });
  };

  /**
   * @private
   *
   * Called when an clspClient connection has been lost
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @param {Object} response
   *   The response object
   * @param {Object} data
   *   An optional data parameter, only used when this is called manually,
   *   meaning when it is used outside of the Paho Client callback
   *
   * @returns {void}
   */
  Router.prototype._onConnectionLost = function (response, data = {}) {
    this.logger.debug('CLSP connection lost');

    const errorCode = parseInt(response.errorCode);

    if (errorCode === 0) {
      // The connection was "properly" terminated
      this._sendToParentWindow({
        event: Router.events.DISCONNECT_SUCCESS,
        data,
      });

      return;
    }

    this.logger.warn('CLSP connection lost improperly!');

    this._sendToParentWindow({
      event: Router.events.CONNECTION_LOST,
      reason: 'connection lost error code "' + errorCode + '" with message: ' + response.errorMessage,
      data,
    });
  };

  /**
   * Call this when the Router has received a command, but the connection to
   * the server no longer exists.  Paho does not appear to handle this
   * situation gracefully.
   */
  Router.prototype._connectionWasLost = function (data) {
    this.logger.debug('CLSP Connection was lost while trying to perform another action');

    // Spoof the clspClient response...
    const response = {
      errorCode: 0,
    };

    this._onConnectionLost(response, data);
  };

  /**
   * @private
   *
   * Success handler for CLSP client "subscribe".
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @param {String} topic
   *   The topic that was successfully subscribed to
   * @param {Object} response
   *   The response object
   *
   * @returns {void}
   */
  Router.prototype._subscribe_onSuccess = function (topic, response) {
    this.logger.debug('Successfully subscribed to topic "' + topic + '"');
    // @todo
  };

  /**
   * @private
   *
   * Failure handler for CLSP "subscribe".  Sends a "fail" message to the parent
   * window
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @param {String} topic
   *   The topic that was attempted to be subscribed to
   * @param {Object} response
   *   The response object
   *
   * @returns {void}
   */
  Router.prototype._subscribe_onFailure = function (topic, response) {
    this.logger.error('Failed to subscribe to topic "' + topic + '"');

    this._sendToParentWindow({
      event: Router.events.SUBSCRIBE_FAILURE,
      reason: 'Subscribe Failed - Error code ' + parseInt(response.errorCode) + ': ' + response.errorMessage,
    });
  };

  /**
   * @private
   *
   * Start receiving messages for the given topic.
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @param {String} topic
   *   The topic to subscribe to
   *
   * @returns {void}
   */
  Router.prototype._subscribe = function (topic) {
    this.logger.debug('Subscribing to topic "' + topic + '"');

    if (!topic) {
      throw new Error('topic is a required argument when subscribing');
    }

    // @todo - unsubscribe and publish have a check for isConnected - is that
    // needed here, too?

    this.clspClient.subscribe(topic, {
      onSuccess: this._subscribe_onSuccess.bind(this, topic),
      onFailure: this._subscribe_onFailure.bind(this, topic),
    });
  };

  /**
   * @private
   *
   * Success handler for "unsubscribe".
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @param {String} topic
   *   The topic that was successfully unsubscribed from
   * @param {Object} response
   *   The response object
   *
   * @returns {void}
   */
  Router.prototype._unsubscribe_onSuccess = function (topic, response) {
    this.logger.info('Successfully unsubscribed from topic "' + topic + '"');

    this._sendToParentWindow({
      event: Router.events.UNSUBSCRIBE_SUCCESS,
      topic,
      response,
    });
  };

  /**
   * @private
   *
   * Failure handler for "unsubscribe".  Sends a "fail" message to the parent
   * window
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @param {String} topic
   *   The topic that was successfully subscribed to
   * @param {Object} response
   *   The response object
   *
   * @returns {void}
   */
  Router.prototype._unsubscribe_onFailure = function (topic, response) {
    this.logger.warn('Failed to unsubscribe from topic "' + topic + '"');

    this._sendToParentWindow({
      event: Router.events.UNSUBSCRIBE_FAILURE,
      reason: 'Unsubscribe Failed - Error code ' + parseInt(response.errorCode) + ': ' + response.errorMessage,
    });
  };

  /**
   * @private
   *
   * Stop receiving messages for the given topic
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @param {String} topic
   *   The topic to unsubscribe from
   *
   * @returns {void}
   */
  Router.prototype._unsubscribe = function (topic) {
    this.logger.info('Unsubscribing from topic "' + topic + '"');

    if (!topic) {
      throw new Error('topic is a required argument when unsubscribing');
    }

    // Paho doesn't seem to handle unsubscribe while disconnected gracefully
    if (!this.clspClient.isConnected()) {
      return this._unsubscribe_onSuccess(topic);
    }

    this.clspClient.unsubscribe(topic, {
      onSuccess: this._unsubscribe_onSuccess.bind(this, topic),
      onFailure: this._unsubscribe_onFailure.bind(this, topic),
    });
  };

  Router.prototype._publish_onSuccess = function (publishId, topic) {
    this.logger.info('Successfully published topic "' + topic + '" with id "' + publishId + '"');

    this._sendToParentWindow({
      event: Router.events.PUBLISH_SUCCESS,
      publishId,
      topic,
    });
  };

  Router.prototype._publish_onFailure = function (publishId, topic, reason) {
    this.logger.info('Successfully published topic "' + topic + '" with id "' + publishId + '"');

    this._sendToParentWindow({
      event: Router.events.PUBLISH_FAILURE,
      publishId,
      reason,
    });
  };

  /**
   * @private
   *
   * Publish a message to the clients that are listening for the given topic
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Message.html
   *
   * @param {String|ArrayBuffer} payload
   *   The message data to be sent
   * @param {String} topic
   *   The topic to publish to
   *
   * @returns {void}
   */
  Router.prototype._publish = function (
    publishId,
    topic,
    payload,
  ) {
    this.logger.debug('Publishing to topic "' + topic + '"');

    if (!payload) {
      throw new Error('payload is a required argument when publishing');
    }

    if (!topic) {
      throw new Error('topic is a required argument when publishing');
    }

    // Paho doesn't seem to handle publish while disconnected gracefully
    if (!this.clspClient.isConnected()) {
      // @todo - this hasn't been tested...
      // return this._connectionWasLost({
      //   publishId: publishId,
      //   topic: topic,
      // });
      return this._publish_onSuccess(publishId, topic);
    }

    const self = this;

    const clspMessage = new Paho.MQTT.Message(payload);

    clspMessage.destinationName = topic;

    // I tried setting the quality of service to 2, which has the highest level
    // of reliability, but it seems that Paho doesn't clean up after itself
    // or have sane (or any) timeouts or something.  When this is set to 2, over
    // time, local storage will fill up, and all CLSP will cease to work.  Not
    // to mention the fact that local storage refuses additional writes.
    // clspMessage.qos = 2; // qos: exactly once

    let publishTimeout = setTimeout(function () {
      clearTimeout(publishTimeout);
      publishTimeout = null;

      const reason = 'publish operation for "' + topic + '" timed out after ' + self.PUBLISH_TIMEOUT + ' seconds.';

      self._publish_onFailure(publishId, topic, reason);
    }, this.PUBLISH_TIMEOUT * 1000);

    // custom property
    clspMessage._onDelivered = function (clspMessage) {
      if (!publishTimeout) {
        // the publish operation timed out and has already been rejected
        return;
      }

      clearTimeout(publishTimeout);
      publishTimeout = null;

      self._publish_onSuccess(publishId, topic);
    };

    // @todo - this can fail if the client is not connected
    this.clspClient.publish(clspMessage);
  };

  /**
   * Connect this Messaging client to its server
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Message.html
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @returns {void}
   */
  Router.prototype.connect = function () {
    this.logger.info('Connecting...');

    // last will message sent on disconnect
    const willMessage = new Paho.MQTT.Message(JSON.stringify({
      clientId: this.clientId,
    }));

    willMessage.destinationName = 'iov/clientDisconnect';

    const connectionOptions = {
      timeout: this.CONNECTION_TIMEOUT,
      keepAliveInterval: this.KEEP_ALIVE_INTERVAL,
      onSuccess: this._connect_onSuccess.bind(this),
      onFailure: this._connect_onFailure.bind(this),
      willMessage,
      // @todo - should `reconnect` be set here?
    };

    if (this.useSSL === true) {
      connectionOptions.useSSL = true;
    }

    try {
      this.clspClient.connect(connectionOptions);
      this.logger.info('Connected');
    }
    catch (error) {
      if (error.message.startsWith(Router.pahoErrorCodes.ALREADY_CONNECTED)) {
        // if we're already connected, there's no error to report
        return;
      }

      this.logger.error('Failed to connect', error);

      this._sendToParentWindow({
        event: Router.events.CONNECT_FAILURE,
        reason: 'General error when trying to connect.',
      });
    }
  };

  /**
   * Disconnect the messaging client from the server.  To get confirmation of
   * the disconnection, the caller must listen for the following event:
   * `Router.events.CONNECTION_LOST`
   *
   * @see - https://www.eclipse.org/paho/files/jsdoc/Paho.MQTT.Client.html
   *
   * @returns {void}
   */
  Router.prototype.disconnect = function () {
    this.logger.info('Disconnecting');

    try {
      // Note we have to handle this condition manually.  If you try to
      // disconnect from the clspClient while it isn't connected, it will never
      // call the _onConnectionLost callback...
      if (!this.clspClient.isConnected()) {
        this._connectionWasLost();
      }
      else {
        this.clspClient.disconnect();
      }
    }
    catch (error) {
      if (error.message.startsWith(Router.pahoErrorCodes.NOT_CONNECTED)) {
        // if we're not connected when we attempted to disconnect, there's no
        // error to report
        return;
      }

      this.logger.error('ERROR while disconnecting');
      this.logger.error(error);

      throw error;
    }
  };

  /**
   * Destroy the Router and free all resources
   *
   * @returns {void}
   */
  Router.prototype.destroy = function () {
    this.logger.info('Destroying...');

    if (this.isDestroyed) {
      return;
    }

    this.isDestroyed = true;

    window.removeEventListener('message', this.boundWindowMessageEventHandler);

    this.boundWindowMessageEventHandler = null;

    this.disconnect();

    // @todo - is there a way to "destroy" the client?  I didn't see anything
    // in the documentation
    this.clspClient = null;

    this.isDestroyComplete = false;

    this.logger.info('destroy complete');
  };

  return Router;
}

;// ./src/js/ClspClient/Router/RouterBaseManager.js







function RouterBaseManager_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, RouterBaseManager_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function RouterBaseManager_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (RouterBaseManager_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * The RouterBaseManager is a base class that is meant to provide some things
 * (e.g. state, events, etc) that are common to all Router Manager classes.
 */



var _Router = Router(),
  commands = _Router.commands,
  events = _Router.events;
var RouterBaseManager = /*#__PURE__*/function (_EventEmitter) {
  /**
   * @private
   *
   * @param {String} logId
   *   a string that identifies this router in log messages
   * @param {String} clientId
   *   the guid to be used to construct the topic
   */
  function RouterBaseManager(logId, clientId) {
    var _this;
    _classCallCheck(this, RouterBaseManager);
    _this = RouterBaseManager_callSuper(this, RouterBaseManager, [logId]);
    if (!logId) {
      throw new Error('logId is required to construct a new RouterStatsManager instance.');
    }
    if (!clientId) {
      throw new Error('clientId is required to construct a new RouterStatsManager instance.');
    }
    _this.logId = logId;
    _this.clientId = clientId;
    return _this;
  }
  _inherits(RouterBaseManager, _EventEmitter);
  return _createClass(RouterBaseManager);
}(EventEmitter);
/**
 * @static
 *
 * The commands that can be issued to the Router via Window Messages
 */
_defineProperty(RouterBaseManager, "routerCommands", commands);
/**
 * @static
 *
 * The events that the Router will broadcast via Window Messages
 */
_defineProperty(RouterBaseManager, "routerEvents", events);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/set-timeout.js
var set_timeout = __webpack_require__(6255);
var set_timeout_default = /*#__PURE__*/__webpack_require__.n(set_timeout);
// EXTERNAL MODULE: ./node_modules/promise-timeout/index.js
var promise_timeout = __webpack_require__(7320);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols.js
var get_own_property_symbols = __webpack_require__(6100);
var get_own_property_symbols_default = /*#__PURE__*/__webpack_require__.n(get_own_property_symbols);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/filter.js
var filter = __webpack_require__(6319);
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor.js
var object_get_own_property_descriptor = __webpack_require__(8928);
var object_get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(object_get_own_property_descriptor);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors.js
var get_own_property_descriptors = __webpack_require__(6751);
var get_own_property_descriptors_default = /*#__PURE__*/__webpack_require__.n(get_own_property_descriptors);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/object/define-properties.js
var define_properties = __webpack_require__(5110);
var define_properties_default = /*#__PURE__*/__webpack_require__.n(define_properties);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/object/define-property.js
var object_define_property = __webpack_require__(1549);
var object_define_property_default = /*#__PURE__*/__webpack_require__.n(object_define_property);
;// ./src/js/ClspClient/Router/iframeEventHandlers.js
/**
 * Note that this file and `Router.js` contain code that will be directly
 * injected into an iframe.  It will undergo NO processing by babel, webpack,
 * etc.  Therefore, it must be written using a JavaScript spec that is natively
 * supported by the browser.  For now, that spec is ES5.  DO NOT put any code
 * in these files that needs to be transpiled.
 *
 * The only exception here is the `export` statement.  The `export` statement
 * is allowed and necessary because this file will be loaded by webpack.  Even
 * though it is loaded by webpack, the value that is returned by the `export`
 * is in no way processed or transformed.
 *
 * @todo - determine a processing method that will allow us to write code using
 * the latest spec, but still inject working code into the iframe.
 *
 * @returns {object}
 *   An object containing the properties `onload` and `onunload`, which are to
 *   be used as the event listeners for the corresponding events on the `<body>`
 *   tag of the iframe.
 */
/* harmony default export */ function iframeEventHandlers() {
  // @todo - if we can somehow get an event to fire from here when the iframe
  // is unloaded, it would make the iframe handling significantly more elegant
  // and resilient...
  return {
    /**
     * The `onload` event handler for the `<body> onload` event.  This event
     * handler will instantiate the Router.
     *
     * On success or failure, a message will be sent to the parent window to
     * indicate success or failure.
     *
     * @param {string} logId
     *   a string that identifies this Conduit / Router in log messages
     * @param {class} Router
     *   The Router class
     * @param {object} config
     *   An object containing all necessary Router config options
     *
     * @returns {Router|null}
     *   The instantiated router, or `null` if an error is encountered
     */
    onload: function (logId, clientId, Router, config) {
      try {
        // @todo - validate arguments
        const router = Router.factory(
          config.logId,
          config.clientId,
          config.host,
          config.port,
          config.useSSL,
          {
            CONNECTION_TIMEOUT: config.CONNECTION_TIMEOUT,
            KEEP_ALIVE_INTERVAL: config.KEEP_ALIVE_INTERVAL,
            PUBLISH_TIMEOUT: config.PUBLISH_TIMEOUT,
            Logger: config.Logger,
          },
        );

        router._sendToParentWindow({
          event: Router.events.CREATE_SUCCESS,
        });

        router.logger.info(logId + ' onload - Router created');

        return router;
      }
      catch (error) {
        console.error(logId + ' onload - Error while loading:');
        console.error(error);

        window.parent.postMessage({
          event: Router.events.CREATE_FAILURE,
          reason: error,
        }, '*');

        return null;
      }
    },

    /**
     * The `onunload` event handler for the `<body> onunload` event.  This
     * event handler will destroy this iframe's Router if it exists.
     *
     * @param {string} logId
     *   a string that identifies this Conduit / Router in log messages
     * @param {Router} router
     *   The router that was instantiated for this iframe
     *
     * @returns {void}
     */
    onunload: function (logId, clientId, router) {
      // @todo - use this to detect an externally destroyed iframe
      // window.parent.postMessage({
      //   clientId: clientId,
      //   event: 'iframe-onunload',
      // }, '*');

      // @todo - validate arguments

      if (!router) {
        console.warn(logId + ' onunload - Router not instantiated, exiting...');
        return;
      }

      try {
        router.logger.info(logId + ' onunload - Router being destroyed in onunload...');
        router.destroy();
        router.logger.info(logId + ' onunload - Router destroyed in onunload');
        // @todo - should this send a message to the parent window, like onload
        // does?
      }
      catch (error) {
        router.logger.error(logId + ' onunload - Error while unloading:');
        router.logger.error(error);
        // @todo - should this send a message to the parent window, like onload
        // does?
      }
    },
  };
}

// EXTERNAL MODULE: ./node_modules/core-js-pure/full/array/is-array.js
var is_array = __webpack_require__(1564);
;// ./node_modules/@babel/runtime-corejs3/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/arrayWithoutHoles.js


function _arrayWithoutHoles(r) {
  if (is_array(r)) return _arrayLikeToArray(r);
}

// EXTERNAL MODULE: ./node_modules/core-js-pure/full/get-iterator-method.js
var get_iterator_method = __webpack_require__(9029);
// EXTERNAL MODULE: ./node_modules/core-js-pure/full/array/from.js
var from = __webpack_require__(8980);
;// ./node_modules/@babel/runtime-corejs3/helpers/esm/iterableToArray.js



function _iterableToArray(r) {
  if ("undefined" != typeof symbol && null != get_iterator_method(r) || null != r["@@iterator"]) return from(r);
}

// EXTERNAL MODULE: ./node_modules/core-js-pure/full/instance/slice.js
var instance_slice = __webpack_require__(4908);
;// ./node_modules/@babel/runtime-corejs3/helpers/esm/unsupportedIterableToArray.js



function _unsupportedIterableToArray(r, a) {
  if (r) {
    var _context;
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = instance_slice(_context = {}.toString.call(r)).call(_context, 8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/parse-int.js
var parse_int = __webpack_require__(6586);
var parse_int_default = /*#__PURE__*/__webpack_require__.n(parse_int);
// EXTERNAL MODULE: ./node_modules/url/url.js
var url_url = __webpack_require__(8835);
;// ./src/js/iov/StreamConfiguration.js
















function ownKeys(e, r) { var t = keys_default()(e); if ((get_own_property_symbols_default())) { var o = get_own_property_symbols_default()(e); r && (o = filter_default()(o).call(o, function (r) { return object_get_own_property_descriptor_default()(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context8, _context9; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? for_each_default()(_context8 = ownKeys(Object(t), !0)).call(_context8, function (r) { _defineProperty(e, r, t[r]); }) : (get_own_property_descriptors_default()) ? define_properties_default()(e, get_own_property_descriptors_default()(t)) : for_each_default()(_context9 = ownKeys(Object(t))).call(_context9, function (r) { object_define_property_default()(e, r, object_get_own_property_descriptor_default()(t, r)); }); } return e; }


var StreamConfiguration = /*#__PURE__*/function () {
  function StreamConfiguration(streamName, host, port, useSSL) {
    var tokenConfig = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    _classCallCheck(this, StreamConfiguration);
    if (!streamName) {
      throw new Error('streamName is required to create a stream configuration.');
    }
    if (!host) {
      throw new Error('host is required to create a stream configuration.');
    }
    if (!port) {
      throw new Error('port is required to create a stream configuration.');
    }
    if (!useSSL && useSSL !== false) {
      throw new Error('useSSL is required to create a stream configuration.');
    }
    if (!tokenConfig || typeof tokenConfig !== 'object') {
      throw new Error('tokenConfig is required to create a stream configuration.');
    }
    this.streamName = streamName;
    this.host = host;
    this.port = port;
    this.useSSL = useSSL;
    this.tokenConfig = tokenConfig;
    this.isDestroyed = false;
    this.isDestroyComplete = false;
  }
  return _createClass(StreamConfiguration, [{
    key: "clone",
    value: function clone(streamConfiguration) {
      if (!StreamConfiguration.isStreamConfiguration(streamConfiguration)) {
        throw new Error('Cannot clone with invalid streamConfiguration');
      }
      var clone = StreamConfiguration.factory.apply(StreamConfiguration, _toConsumableArray(streamConfiguration.toObject()));
      return clone;
    }
  }, {
    key: "toObject",
    value: function toObject() {
      return {
        streamName: this.streamName,
        host: this.host,
        port: this.port,
        useSSL: this.useSSL,
        tokenConfig: _objectSpread({}, this.tokenConfig)
      };
    }
  }, {
    key: "protocol",
    get: function get() {
      return this.useSSL ? 'clsps' : 'clsp';
    }
  }, {
    key: "url",
    get: function get() {
      var _context, _context2, _context3;
      return concat_default()(_context = concat_default()(_context2 = concat_default()(_context3 = "".concat(this.protocol, "://")).call(_context3, this.host, ":")).call(_context2, this.port, "/")).call(_context, this.streamName);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.isDestroyed) {
        return;
      }
      this.isDestroyed = true;
      this.streamName = null;
      this.host = null;
      this.port = null;
      this.useSSL = null;
      this.tokenConfig = null;
      this.isDestroyComplete = false;
      this.logger.info('destroy complete');
    }
  }], [{
    key: "factory",
    value: function factory(streamName, host, port, useSSL, tokenConfig) {
      return new StreamConfiguration(streamName, host, port, useSSL, tokenConfig);
    }
  }, {
    key: "fromObject",
    value: function fromObject(config) {
      if (!config || !(typeof config === 'object')) {
        throw new Error('config must be an object to create a streamConfiguration');
      }
      return StreamConfiguration.factory(config.streamName, config.host, config.port, config.useSSL, _objectSpread({}, config.tokenConfig));
    }
  }, {
    key: "isStreamConfiguration",
    value: function isStreamConfiguration(target) {
      return target instanceof StreamConfiguration;
    }
  }, {
    key: "generateConfigFromUrl",
    value: function generateConfigFromUrl(url) {
      if (!url) {
        throw new Error('No source was given to be parsed!');
      }

      /* eslint-disable-next-line n/no-deprecated-api */
      var parsed = url_url.parse(url);
      var useSSL;
      var defaultPort;
      var b64HashAccessUrl = '';
      var jwt = '';
      parsed.protocol = parsed.protocol.toLowerCase();

      // Chrome is the only browser that allows non-http protocols in
      // the anchor tag's href, so change them all to http here so we
      // get the benefits of the anchor tag's parsing

      if (parsed.protocol === 'clsps:') {
        useSSL = true;
        defaultPort = utils_default().getDefaultStreamPort('clsps');
      } else if (parsed.protocol === 'clsp:') {
        useSSL = false;
        defaultPort = utils_default().getDefaultStreamPort('clsp');
      } else {
        throw new Error('The given source is not a clsp url, and therefore cannot be parsed.');
      }
      var paths = parsed.pathname.split('/');
      var streamName = paths[paths.length - 1];
      var host = parsed.hostname;
      var port = parsed.port;
      if (!port || port.length === 0) {
        port = defaultPort;
      }
      port = parse_int_default()(port);

      // @ is a special address meaning the server that loaded the web page.
      if (host === '@') {
        host = window.location.hostname;
      }

      // URL: clsp[s]://<sfs-addr>[:<port>]/<stream>?token=...
      var qpOffset = index_of_default()(url).call(url, parsed.pathname) + parsed.pathname.length;
      var qrArgs = url.substr(qpOffset).split('?')[1] || '';
      var query = {};
      var pairs = qrArgs.split('&');
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
      }

      // set the jwt token if it's present in the query path
      if (typeof query.token !== 'undefined' && query.token.length > 0) {
        var _context4, _context5, _context6, _context7;
        var jwtUrl = concat_default()(_context4 = concat_default()(_context5 = concat_default()(_context6 = concat_default()(_context7 = "".concat(parsed.protocol, "://")).call(_context7, host, ":")).call(_context6, port, "/")).call(_context5, streamName, "?token=")).call(_context4, query.token);
        b64HashAccessUrl = window.btoa(jwtUrl);
        jwt = query.token;
      }
      return {
        streamName: streamName,
        host: host,
        port: port,
        useSSL: useSSL,
        tokenConfig: {
          b64HashAccessUrl: b64HashAccessUrl,
          jwt: jwt
        }
      };
    }
  }, {
    key: "fromUrl",
    value: function fromUrl(url) {
      var config = StreamConfiguration.generateConfigFromUrl(url);
      return StreamConfiguration.fromObject(config);
    }
  }]);
}();

;// ./src/js/ClspClient/Router/RouterIframeManager.js

















function RouterIframeManager_ownKeys(e, r) { var t = keys_default()(e); if ((get_own_property_symbols_default())) { var o = get_own_property_symbols_default()(e); r && (o = filter_default()(o).call(o, function (r) { return object_get_own_property_descriptor_default()(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function RouterIframeManager_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context18, _context19; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? for_each_default()(_context18 = RouterIframeManager_ownKeys(Object(t), !0)).call(_context18, function (r) { _defineProperty(e, r, t[r]); }) : (get_own_property_descriptors_default()) ? define_properties_default()(e, get_own_property_descriptors_default()(t)) : for_each_default()(_context19 = RouterIframeManager_ownKeys(Object(t))).call(_context19, function (r) { object_define_property_default()(e, r, object_get_own_property_descriptor_default()(t, r)); }); } return e; }



function RouterIframeManager_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, RouterIframeManager_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function RouterIframeManager_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (RouterIframeManager_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function RouterIframeManager_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }







var DEFAULT_ROUTER_CONNECTION_TIMEOUT = 120;
// Setting this to half of the default value to help with SFS memory
// management
var DEFAULT_ROUTER_KEEP_ALIVE_INTERVAL = 30;
// The number of seconds to wait for a "publish" message to be delivered
var DEFAULT_ROUTER_PUBLISH_TIMEOUT = (utils_default()).DEFAULT_STREAM_TIMEOUT;
var RouterIframeManager = /*#__PURE__*/function (_RouterBaseManager) {
  /**
   * @private
   *
   * @param {String} logId
   *   a string that identifies this router in log messages
   * @param {String} clientId
   *   the guid to be used to construct the topic
   * @param {StreamConfiguration} streamConfiguration
   *   The stream configuration to pull from the CLSP server / SFS
   * @param {Element} containerElement
   *   The container of the video element and where the iframe will be inserted
   */
  function RouterIframeManager(logId, clientId, streamConfiguration, containerElement) {
    var _this;
    _classCallCheck(this, RouterIframeManager);
    _this = RouterIframeManager_callSuper(this, RouterIframeManager, [logId, clientId]);
    if (!StreamConfiguration.isStreamConfiguration(streamConfiguration)) {
      throw new Error('invalid streamConfiguration passed to Router Iframe Manager constructor');
    }
    if (!containerElement) {
      throw new Error('containerElement is required to construct a new Router Iframe Manager instance');
    }

    // Passed state
    _this.streamConfiguration = streamConfiguration;
    _this.containerElement = containerElement;

    // Managed state
    _this.iframe = null;

    // State flags
    _this.isCreated = false;
    _this.hasIframeDestroyedExternallyEventBeenEmitted = false;

    // These can be configured manually after construction
    _this.ROUTER_CONNECTION_TIMEOUT = DEFAULT_ROUTER_CONNECTION_TIMEOUT;
    _this.ROUTER_KEEP_ALIVE_INTERVAL = DEFAULT_ROUTER_KEEP_ALIVE_INTERVAL;
    _this.ROUTER_PUBLISH_TIMEOUT = DEFAULT_ROUTER_PUBLISH_TIMEOUT;
    return _this;
  }

  /**
   * @async
   *
   * Create the iframe and the Router needed to get the stream from the server.
   *
   * @returns Promise
   *   Resolves when the Router has been successfully created.
   *   Rejects upon failure to create the Router.
   */
  _inherits(RouterIframeManager, _RouterBaseManager);
  return _createClass(RouterIframeManager, [{
    key: "create",
    value: (function () {
      var _create2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.isDestroyed) {
                _context.next = 2;
                break;
              }
              throw new Error('Tried to create a destroyed Router Iframe Manager!');
            case 2:
              if (!this.isCreated) {
                _context.next = 5;
                break;
              }
              this.logger.warn('Router Iframe Manager already created...');
              return _context.abrupt("return");
            case 5:
              this.logger.debug('Initializing...');
              _context.prev = 6;
              _context.next = 9;
              return (0,promise_timeout/* timeout */.w)(this._create(), 2 * 1000);
            case 9:
              this.logger.info('Router created successfully');
              this.isCreated = true;
              _context.next = 17;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](6);
              this.logger.error('Failed to create the Iframe/Router!');
              this.logger.error(_context.t0);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 13]]);
      }));
      function create() {
        return _create2.apply(this, arguments);
      }
      return create;
    }())
  }, {
    key: "_create",
    value: function _create() {
      var _this2 = this;
      return new (core_js_stable_promise_default())(function (resolve, reject) {
        _this2._onRouterCreated = function (error) {
          if (error) {
            return reject(error);
          }
          resolve();
        };
        _this2.iframe = _this2._generateIframe();

        // @todo - if the Iov were to create a wrapper around the video element
        // that it manages (rather than expecting one to already be there), each
        // video element and iframe could be contained in a single container,
        // rather than potentially having multiple video elements and multiple
        // iframes contained in a single parent.
        _this2.containerElement.appendChild(_this2.iframe);
      });
    }
  }, {
    key: "_handleRouterCreatedEvent",
    value: function _handleRouterCreatedEvent(eventType, event) {
      if (this.isDestroyed) {
        throw new Error('Tried to create a Router for a destroyed Router Iframe Manager!');
      }

      // @todo - a better check may be `!this.isInitializing`
      if (!this._onRouterCreated) {
        throw new Error('Tried to create Router prior to initialization!');
      }
      if (this.isCreated) {
        throw new Error('Tried to create Router after initialization!');
      }
      switch (eventType) {
        case RouterIframeManager.routerEvents.CREATE_SUCCESS:
          {
            this._onRouterCreated();
            break;
          }
        case RouterIframeManager.routerEvents.CREATE_FAILURE:
          {
            this._onRouterCreated(new Error(event.data.reason));
            break;
          }
        default:
          {
            throw new Error("Unknown eventType: ".concat(eventType));
          }
      }
    }

    /**
     * @private
     *
     * Generate an iframe with an embedded CLSP Router.
     *
     * @returns Element
     */
  }, {
    key: "_generateIframe",
    value: function _generateIframe() {
      var _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15, _context16;
      this.logger.debug('Generating Iframe...');
      var iframe = document.createElement('iframe');
      iframe.setAttribute('id', this.clientId);

      // This iframe should be invisible
      iframe.width = 0;
      iframe.height = 0;
      iframe.setAttribute('style', 'display:none;');
      iframe.srcdoc = concat_default()(_context2 = concat_default()(_context3 = concat_default()(_context4 = concat_default()(_context5 = concat_default()(_context6 = concat_default()(_context7 = concat_default()(_context8 = concat_default()(_context9 = concat_default()(_context10 = concat_default()(_context11 = concat_default()(_context12 = concat_default()(_context13 = concat_default()(_context14 = concat_default()(_context15 = concat_default()(_context16 = "\n      <html>\n        <head>\n          <script type=\"text/javascript\">\n\n            // Configure the CLSP properties\n            window.clspRouterConfig = {\n              logId: '".concat(this.logId, "',\n              clientId: '")).call(_context16, this.clientId, "',\n              host: '")).call(_context15, this.streamConfiguration.host, "',\n              port: ")).call(_context14, this.streamConfiguration.port, ",\n              useSSL: ")).call(_context13, this.streamConfiguration.useSSL, ",\n              CONNECTION_TIMEOUT: ")).call(_context12, this.ROUTER_CONNECTION_TIMEOUT, ",\n              KEEP_ALIVE_INTERVAL: ")).call(_context11, this.ROUTER_KEEP_ALIVE_INTERVAL, ",\n              PUBLISH_TIMEOUT: ")).call(_context10, this.ROUTER_PUBLISH_TIMEOUT, ",\n              Logger: (")).call(_context9, Logger_default().toString(), ")(\"")).call(_context8, (utils_default()).version, "\"),\n            };\n\n            window.Router = ")).call(_context7, Router.toString(), "(window.parent.Paho);\n            window.iframeEventHandlers = ")).call(_context6, iframeEventHandlers.toString(), "();\n          </script>\n        </head>\n        <body\n          onload=\"window.router = window.iframeEventHandlers.onload(\n            '")).call(_context5, this.logId, "',\n            '")).call(_context4, this.clientId, "',\n            window.Router,\n            window.clspRouterConfig\n          );\"\n          onunload=\"window.iframeEventHandlers.onunload(\n            '")).call(_context3, this.logId, "',\n            '")).call(_context2, this.clientId, "',\n            window.router\n          );\"\n        >\n          <div id=\"message\"></div>\n        </body>\n      </html>\n    ");
      return iframe;
    }
  }, {
    key: "wasIframeDestroyedExternally",
    value: function wasIframeDestroyedExternally() {
      return !this.iframe.contentWindow;
    }

    /**
     * @private
     *
     * Pass a Router command to the iframe.  Should only ever be invoked in
     * response to a Router Manager command event.
     *
     * @param {Object} message
     *   The message / event data to send with the command
     */
  }, {
    key: "command",
    value: function command(_command, data) {
      this.logger.debug('Sending a message to the iframe...');
      if (this.isDestroyComplete) {
        this.logger.warn('Cannot send message via destroyed iframe', _command, data);
        return;
      }
      if (this.wasIframeDestroyedExternally()) {
        if (this.isDestroyed) {
          this.logger.info('Iframe was destroyed externally while in process of destroying');
          return;
        }

        // @todo - maybe this should warn, but there are multiple commands that
        // still come through when the iframe is destroyed externally...
        this.logger.info('Cannot process command because the iframe is destroyed.');
        if (this.hasIframeDestroyedExternallyEventBeenEmitted) {
          return;
        }
        this.hasIframeDestroyedExternallyEventBeenEmitted = true;

        // In the normal course of operation, sometimes other libraries or
        // implementations will delete the iframe or a parent component
        // rather than letting the CLSP Player manage it.  In this instance,
        // we recognize that this happened, but do not show nor throw an error.
        this.logger.info('Iframe destroyed externally!');
        this.emit(RouterIframeManager.events.IFRAME_DESTROYED_EXTERNALLY);
        return;
      }
      try {
        var message = RouterIframeManager_objectSpread({
          method: _command
        }, data);

        // @todo - we should not be dispatching to '*' - we should provide the SFS
        // host here instead
        // @see - https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
        this.iframe.contentWindow.postMessage(message, '*');
      } catch (error) {
        // @todo - can we do anything when this error is encountered
        this.logger.error("Failed while trying to execute command ".concat(error));
        this.logger.error(error);
      }
    }
  }, {
    key: "_destroyIframe",
    value: function _destroyIframe() {
      if (this.isDestroyComplete) {
        return;
      }

      // The Router will be destroyed along with the iframe
      this.iframe.parentNode.removeChild(this.iframe);
      this.iframe.srcdoc = '';
      this.iframe = null;
      // Calling this doesn't seem to work...
      // this.iframe.remove();
    }
  }, {
    key: "_destroy",
    value: function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              this._destroyIframe();

              // The caller must destroy the streamConfiguration
              this.streamConfiguration = null;
              this.containerElement = null;
              _context17.next = 5;
              return RouterIframeManager_superPropGet(RouterIframeManager, "_destroy", this, 3)([]);
            case 5:
            case "end":
              return _context17.stop();
          }
        }, _callee2, this);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }()
  }], [{
    key: "factory",
    value: function factory(logId, clientId, streamConfiguration, containerElement) {
      return new RouterIframeManager(logId, clientId, streamConfiguration, containerElement);
    }
  }]);
}(RouterBaseManager);
/**
 * @static
 *
 * The events that this RouterStatsManager will emit.
 */
_defineProperty(RouterIframeManager, "events", {
  IFRAME_DESTROYED_EXTERNALLY: 'iframe-destroyed-externally'
});
/**
 * @static
 *
 * The Router events that this Router Manager is responsible for
 */
_defineProperty(RouterIframeManager, "routerEvents", {
  CREATE_SUCCESS: RouterBaseManager.routerEvents.CREATE_SUCCESS,
  CREATE_FAILURE: RouterBaseManager.routerEvents.CREATE_FAILURE
});

;// ./src/js/ClspClient/Router/RouterTransactionManager.js















function RouterTransactionManager_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, RouterTransactionManager_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function RouterTransactionManager_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (RouterTransactionManager_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function RouterTransactionManager_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }




var DEFAULT_TRANSACTION_TIMEOUT = 5;
var RouterTransactionManager = /*#__PURE__*/function (_RouterBaseManager) {
  function RouterTransactionManager(logId, clientId, routerIframeManager) {
    var _this;
    _classCallCheck(this, RouterTransactionManager);
    _this = RouterTransactionManager_callSuper(this, RouterTransactionManager, [logId, clientId, routerIframeManager]);
    if (!routerIframeManager) {
      throw new Error('Tried to instantiate a RouterTransactionManager without a routerIframeManager!');
    }
    _this.routerIframeManager = routerIframeManager;
    _this.isHalting = false;
    _this.isHalted = false;
    _this.iframeWasDestroyedExternally = false;
    _this.publishHandlers = {};
    _this.pendingTransactions = {};
    _this.subscribeHandlers = {};
    _this.unsubscribeHandlers = {};
    _this.unsubscribesInProgress = {};
    _this.TRANSACTION_TIMEOUT = DEFAULT_TRANSACTION_TIMEOUT;

    // @todo - this seems too tightly coupled...  It's needed to detect when an
    // error should be shown for unsubscribes and publishes
    _this.routerIframeManager.on(RouterIframeManager.events.IFRAME_DESTROYED_EXTERNALLY, function () {
      _this.iframeWasDestroyedExternally = true;
    });
    return _this;
  }

  /**
   * Issue a command to the Router
   *
   * @param {*} type
   */
  _inherits(RouterTransactionManager, _RouterBaseManager);
  return _createClass(RouterTransactionManager, [{
    key: "issueCommand",
    value: function issueCommand(command) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.isDestroyed) {
        this.logger.warn("Cannot issue command \"".concat(command, "\" to Router after destruction"));
        return;
      }
      this.logger.debug("Issuing command ".concat(command, " to Router..."));
      this.routerIframeManager.command(command, data);
    }
  }, {
    key: "_formatTransactionResponsePayload",
    value: function _formatTransactionResponsePayload(response) {
      var payloadString = response.payloadString;

      // @todo - why is this necessary?  and why is this only ever necessary
      // in a transaction?  Is this only for moovs or something?
      if (response.payloadString) {
        try {
          response.payloadString = JSON.parse(payloadString) || {};
        } catch (error) {
          this.logger.warn('Failed to parse payloadString');
          this.logger.warn(error);
          response.payloadString = payloadString;
        }
      }
      return response;
    }

    /**
     * Request
     *
     * When asking the server for something, we do not get a response right away.
     * Instead, we must perform the following steps:
     *
     * 1. generate a unique string, which will be sent to the server as the "response topic"
     * 1. subscribe
     *
     * @todo - this needs to be refactored to use PromiseTimeout
     *
     * @param {String} topic
     *   The topic to perform a transaction on
     * @param {Object} messageData
     *   The data to be published
     *
     * @returns {Promise}
     *   Resolves when the transaction successfully finishes
     *   Rejects if there is any error or timeout during the transaction
     */
  }, {
    key: "transaction",
    value: function transaction(requestTopic) {
      var _this2 = this;
      var messageData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var timeoutDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.TRANSACTION_TIMEOUT;
      var responseTopic = arguments.length > 3 ? arguments[3] : undefined;
      this.logger.debug("transaction for ".concat(requestTopic, "..."));
      var transactionId = esm_browser_v4();

      // @todo - this responseTopic override is only ever used for getting a
      // moov for a stream.  In that use case, the resp_topic is never specified
      // in the message.  This condition and workflow works, but seems less
      // elegant than it could be.
      if (!responseTopic) {
        var _context;
        responseTopic = concat_default()(_context = "".concat(this.clientId, "/transaction/")).call(_context, transactionId);
        messageData.resp_topic = responseTopic;
      }
      this.pendingTransactions[transactionId] = {
        id: transactionId,
        hasTimedOut: false,
        timeout: null
      };
      return new (core_js_stable_promise_default())(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(resolve, reject) {
          var finished;
          return regenerator_default().wrap(function _callee2$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                finished = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(error, response) {
                    return regenerator_default().wrap(function _callee$(_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.prev = 0;
                          _context2.next = 3;
                          return _this2.unsubscribe(responseTopic);
                        case 3:
                          if (_this2.pendingTransactions[transactionId].timeout) {
                            clearTimeout(_this2.pendingTransactions[transactionId].timeout);
                            _this2.pendingTransactions[transactionId].timeout = null;
                          }
                          if (!error) {
                            _context2.next = 6;
                            break;
                          }
                          throw error;
                        case 6:
                          resolve(_this2._formatTransactionResponsePayload(response));
                          _context2.next = 12;
                          break;
                        case 9:
                          _context2.prev = 9;
                          _context2.t0 = _context2["catch"](0);
                          reject(_context2.t0);
                        case 12:
                        case "end":
                          return _context2.stop();
                      }
                    }, _callee, null, [[0, 9]]);
                  }));
                  return function finished(_x3, _x4) {
                    return _ref2.apply(this, arguments);
                  };
                }();
                _context4.prev = 1;
                _this2.pendingTransactions[transactionId].timeout = set_timeout_default()(function () {
                  var _context3;
                  // @todo - somehow, this condition is possible...
                  // Encountered when disconnecting from the network / internet while
                  // testing
                  if (!_this2.pendingTransactions || !_this2.pendingTransactions[transactionId]) {
                    _this2.logger.warn("Pending transaction for ".concat(transactionId, " was not cancelled..."));
                    return;
                  }
                  if (_this2.pendingTransactions[transactionId].hasTimedOut) {
                    return;
                  }
                  _this2.pendingTransactions[transactionId].hasTimedOut = true;
                  finished(new Error(concat_default()(_context3 = "Transaction for ".concat(requestTopic, " timed out after ")).call(_context3, timeoutDuration, " seconds")));
                }, timeoutDuration * 1000);

                // Step 1:
                // We subscribe to the responseTopic, which we are going to pass to the
                // server in the next step.  When the server starts broadcasting the
                // response to our request on this responseTopic, we will already be
                // listening.  We have to be listening first because, since this is a
                // transaction, the server will only broadcast the response once.
                _this2.subscribe(responseTopic, function (response) {
                  finished(null, response);
                });

                // Step 2:
                // We publish to the requestTopic, which is like a CLSP server REST
                // endpoint.  The server has to know how to respond to the specific
                // requestTopic, but our subscriptionTopic (which is also defined in
                // `message.resp_topic`) is arbitrary and defined by us (the client),
                // though in order to be useful, it must be globally unique.  Once we
                // publish to the requestTopic and the server successfully receives and
                // processes the request, it will start broadcasting on the resp_topic
                // we defined, which we subscribed to in the previous step.
                _context4.next = 6;
                return _this2.publish(requestTopic, messageData);
              case 6:
                _context4.next = 11;
                break;
              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);
                finished(_context4.t0);
              case 11:
              case "end":
                return _context4.stop();
            }
          }, _callee2, null, [[1, 8]]);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }

    /**
     * @async
     *
     * Publishing something to the CLSP server means that you send a request and
     * get a confirmation of deliver from Paho.  It's different from the
     * transaction in that you do not need to subscribe to a topic to get a
     * response/ack from the server (because you don't expect a response from the
     * server).  All transactions use publish in addition to sub/unsub.
     *
     * Publish actions include:
     * - stopping a stream
     * - sending stats
     *
     * @param {String} topic
     *   The topic to publish to
     * @param {Object} data
     *   The data to publish
     *
     * @returns {Promise}
     *   Resolves when publish operation is successful
     *   Rejects when publish operation fails
     */
  }, {
    key: "publish",
    value: (function () {
      var _publish2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(topic, data) {
        var timeout,
          publishId,
          _context5,
          _context9,
          _context6,
          _context7,
          _context8,
          _args3 = arguments;
        return regenerator_default().wrap(function _callee3$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              timeout = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : this.TRANSACTION_TIMEOUT;
              if (!this.isDestroyComplete) {
                _context10.next = 4;
                break;
              }
              this.logger.info("Tried to publish to topic \"".concat(topic, "\" while destroyed"));
              return _context10.abrupt("return");
            case 4:
              this.logger.debug("Publishing to topic \"".concat(topic, "\""));

              // There can be `n` publishes for 1 topic, e.g. `iov/stats`
              publishId = esm_browser_v4();
              _context10.prev = 6;
              _context10.next = 9;
              return (0,promise_timeout/* timeout */.w)(this._publish(publishId, topic, data), timeout * 1000);
            case 9:
              this.logger.info(concat_default()(_context5 = "Successfully published to topic \"".concat(topic, "\" with id \"")).call(_context5, publishId, "\""));
              _context10.next = 26;
              break;
            case 12:
              _context10.prev = 12;
              _context10.t0 = _context10["catch"](6);
              if (!this.isDestroyed) {
                _context10.next = 17;
                break;
              }
              this.logger.info(concat_default()(_context6 = "Publish to topic \"".concat(topic, "\" with id \"")).call(_context6, publishId, "\" failed while destroying"));
              return _context10.abrupt("return");
            case 17:
              if (!(this.isHalting || this.isHalted)) {
                _context10.next = 20;
                break;
              }
              this.logger.info(concat_default()(_context7 = "Publish to topic \"".concat(topic, "\" with id \"")).call(_context7, publishId, "\" failed while halting/halted"));
              return _context10.abrupt("return");
            case 20:
              if (!this.iframeWasDestroyedExternally) {
                _context10.next = 23;
                break;
              }
              this.logger.info(concat_default()(_context8 = "Publish to topic \"".concat(topic, "\" with id \"")).call(_context8, publishId, "\" failed while iframe was destroyed externally"));
              return _context10.abrupt("return");
            case 23:
              this.logger.error(concat_default()(_context9 = "Failed to publish to topic \"".concat(topic, "\" with id \"")).call(_context9, publishId, "\""));
              this.logger.error(_context10.t0);
              throw _context10.t0;
            case 26:
              _context10.prev = 26;
              delete this.publishHandlers[publishId];
              return _context10.finish(26);
            case 29:
            case "end":
              return _context10.stop();
          }
        }, _callee3, this, [[6, 12, 26, 29]]);
      }));
      function publish(_x5, _x6) {
        return _publish2.apply(this, arguments);
      }
      return publish;
    }()
    /**
     * @private
     */
    )
  }, {
    key: "_publish",
    value: function _publish(publishId, topic, data) {
      var _this3 = this;
      return new (core_js_stable_promise_default())(function (resolve, reject) {
        _this3.publishHandlers[publishId] = function (error) {
          if (error) {
            return reject(error);
          }
          resolve();
        };
        _this3.issueCommand(RouterTransactionManager.routerCommands.PUBLISH, {
          publishId: publishId,
          topic: topic,
          data: data
        });
      });
    }
  }, {
    key: "_handlePublishRouterEvent",
    value: function _handlePublishRouterEvent(eventType, event) {
      var publishId = event.data.publishId;
      if (!publishId) {
        throw new Error('Cannot handle publish event without publishId');
      }
      if (!this.publishHandlers[publishId]) {
        var _context11;
        this.logger.warn(concat_default()(_context11 = "No handler for publishId \"".concat(publishId, "\" for publish event \"")).call(_context11, eventType, "\""));
        return;
      }
      switch (eventType) {
        case RouterTransactionManager.routerEvents.PUBLISH_SUCCESS:
          {
            this.publishHandlers[publishId]();
            break;
          }
        case RouterTransactionManager.routerEvents.PUBLISH_FAILURE:
          {
            this.publishHandlers[publishId](new Error(event.data.reason));
            break;
          }
        default:
          {
            throw new Error("Unknown eventType: ".concat(eventType));
          }
      }
    }

    /**
     * Register a handler that will being listening to a topic until that topic
     * is unsubscribed from.
     *
     * Note that currently, the only use cases for a "persistent" subscription
     * are stream resync and the actual stream itself.  All other subscribe use
     * cases are transactional, and therefore use the `transaction` method.  Use
     * this `subscribe` method cautiously / sparingly.
     *
     * @param {String} topic
     *   The topic to subscribe to
     * @param {RouterTransactionManager-subscribeHandler} handler
     *   The callback for the subscribe operation
     */
  }, {
    key: "subscribe",
    value: function subscribe(topic, handler) {
      this.logger.debug("Subscribing to topic \"".concat(topic, "\""));
      this.subscribeHandlers[topic] = handler;
      this.issueCommand(RouterTransactionManager.routerCommands.SUBSCRIBE, {
        topic: topic
      });
    }
  }, {
    key: "_handleMessageArrivedRouterEvent",
    value: function _handleMessageArrivedRouterEvent(eventType, event) {
      if (this.isDestroyComplete) {
        throw new Error('Tried to handle Router message arrived event after destroy was complete!');
      }
      var message = event.data;
      var topic = message.destinationName;
      if (!topic) {
        throw new Error('Cannot handle subscribe event without a topic');
      }
      if (!this.subscribeHandlers[topic]) {
        var _context12;
        // @todo - this should trigger a warning, not an info, but it happens
        // when switching tabs, which is too much noise in the console.
        this.logger.info(concat_default()(_context12 = "No handler for subscribe topic \"".concat(topic, "\" for message event \"")).call(_context12, eventType, "\""));
        return;
      }
      switch (eventType) {
        case RouterTransactionManager.routerEvents.MESSAGE_ARRIVED:
          {
            this.subscribeHandlers[topic](message, event);
            break;
          }
        default:
          {
            throw new Error("Unknown eventType: ".concat(eventType));
          }
      }
    }

    /**
     * @async
     *
     * Stop listening to a topic
     *
     * @param {String} topic
     *   The topic to unsubscribe from
     */
  }, {
    key: "unsubscribe",
    value: (function () {
      var _unsubscribe2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(topic) {
        var timeout,
          _args4 = arguments;
        return regenerator_default().wrap(function _callee4$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              timeout = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : this.TRANSACTION_TIMEOUT;
              if (!this.isDestroyComplete) {
                _context13.next = 4;
                break;
              }
              this.logger.info("Tried to unsubscribe from topic \"".concat(topic, "\" while destroyed"));
              return _context13.abrupt("return");
            case 4:
              if (!this.unsubscribesInProgress[topic]) {
                _context13.next = 7;
                break;
              }
              this.logger.info("Already unsubscribing from ".concat(topic));
              return _context13.abrupt("return");
            case 7:
              this.logger.debug("Unsubscribing from topic \"".concat(topic, "\""));
              _context13.prev = 8;
              // When data is received for a topic that is subscribed to, but that we
              // are about to unsubscribe from, stop processing that topic data.
              delete this.subscribeHandlers[topic];
              this.unsubscribesInProgress[topic] = true;
              _context13.next = 13;
              return (0,promise_timeout/* timeout */.w)(this._unsubscribe(topic), timeout * 1000);
            case 13:
              this.logger.info("Successfully unsubscribed from topic \"".concat(topic, "\""));
              _context13.next = 29;
              break;
            case 16:
              _context13.prev = 16;
              _context13.t0 = _context13["catch"](8);
              if (!this.isDestroyed) {
                _context13.next = 21;
                break;
              }
              this.logger.info("Unsubscribe from topic \"".concat(topic, "\" failed while destroying"));
              return _context13.abrupt("return");
            case 21:
              if (!(this.isHalting || this.isHalted)) {
                _context13.next = 24;
                break;
              }
              this.logger.info("Unsubscribe from topic \"".concat(topic, "\" failed while halting/halted"));
              return _context13.abrupt("return");
            case 24:
              if (!this.iframeWasDestroyedExternally) {
                _context13.next = 27;
                break;
              }
              this.logger.info("Unsubscribe from topic \"".concat(topic, "\" failed while iframe was destroyed externally"));
              return _context13.abrupt("return");
            case 27:
              this.logger.info("Failed to unsubscribe from topic \"".concat(topic, "\""));
              throw _context13.t0;
            case 29:
              _context13.prev = 29;
              delete this.unsubscribesInProgress[topic];
              delete this.unsubscribeHandlers[topic];
              return _context13.finish(29);
            case 33:
            case "end":
              return _context13.stop();
          }
        }, _callee4, this, [[8, 16, 29, 33]]);
      }));
      function unsubscribe(_x7) {
        return _unsubscribe2.apply(this, arguments);
      }
      return unsubscribe;
    }()
    /**
     * @private
     */
    )
  }, {
    key: "_unsubscribe",
    value: function _unsubscribe(topic) {
      var _this4 = this;
      return new (core_js_stable_promise_default())(function (resolve, reject) {
        _this4.unsubscribeHandlers[topic] = function (error) {
          if (error) {
            return reject(error);
          }
          resolve();
        };
        _this4.issueCommand(RouterTransactionManager.routerCommands.UNSUBSCRIBE, {
          topic: topic
        });
      });
    }
  }, {
    key: "_handleUnsubscribeRouterEvent",
    value: function _handleUnsubscribeRouterEvent(eventType, event) {
      var topic = event.data.topic;
      if (this.isDestroyComplete) {
        throw new Error('Tried to check unsubscribe handler after destroy was complete!');
      }
      if (!topic) {
        throw new Error('Cannot handle unsubscribe event without a topic');
      }
      if (!this.unsubscribeHandlers[topic]) {
        var _context14;
        this.logger.warn(concat_default()(_context14 = "No handler for topic \"".concat(topic, "\" for unsubscribe event \"")).call(_context14, eventType, "\""));
        return;
      }
      switch (eventType) {
        case RouterTransactionManager.routerEvents.UNSUBSCRIBE_SUCCESS:
          {
            this.unsubscribeHandlers[topic]();
            break;
          }
        case RouterTransactionManager.routerEvents.UNSUBSCRIBE_FAILURE:
          {
            this.unsubscribeHandlers[topic](new Error(event.data.reason));
            break;
          }
        default:
          {
            throw new Error("Unknown eventType: ".concat(eventType));
          }
      }
    }
  }, {
    key: "onRouterEvent",
    value: function onRouterEvent(eventType, event) {
      if (this.isDestroyComplete) {
        throw new Error("Tried to handle Router event ".concat(eventType, " after destroy was complete!"));
      }
      switch (eventType) {
        case RouterTransactionManager.routerEvents.PUBLISH_SUCCESS:
        case RouterTransactionManager.routerEvents.PUBLISH_FAILURE:
          {
            this._handlePublishRouterEvent(eventType, event);
            break;
          }
        case RouterTransactionManager.routerEvents.UNSUBSCRIBE_SUCCESS:
        case RouterTransactionManager.routerEvents.UNSUBSCRIBE_FAILURE:
          {
            this._handleUnsubscribeRouterEvent(eventType, event);
            break;
          }
        case RouterTransactionManager.routerEvents.MESSAGE_ARRIVED:
          {
            this._handleMessageArrivedRouterEvent(eventType, event);
            break;
          }
        default:
          {
            throw new Error("Unknown eventType: ".concat(eventType));
          }
      }
    }
  }, {
    key: "halt",
    value: function () {
      var _halt = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5() {
        var _this5 = this;
        var transactionId, pendingTransaction, subscribedTopics;
        return regenerator_default().wrap(function _callee5$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!this.isDestroyed) {
                _context15.next = 3;
                break;
              }
              this.logger.info('Tried to halt while destroyed');
              return _context15.abrupt("return");
            case 3:
              if (!(this.isHalting || this.isHalted)) {
                _context15.next = 6;
                break;
              }
              this.logger.info('Tried to halt while halting/halted');
              return _context15.abrupt("return");
            case 6:
              this.logger.info('Halting all handlers...');
              this.isHalting = true;
              for (transactionId in this.pendingTransactions) {
                pendingTransaction = this.pendingTransactions[transactionId];
                if (pendingTransaction.timeout) {
                  clearTimeout(pendingTransaction.timeout);
                  pendingTransaction.timeout = null;
                }
              }
              this.pendingTransactions = {};
              this.unsubscribeHandlers = {};
              this.publishHandlers = {};
              subscribedTopics = keys_default()(this.subscribeHandlers); // @todo - error handling
              _context15.next = 15;
              return core_js_stable_promise_default().allSettled(map_default()(subscribedTopics).call(subscribedTopics, function (topic) {
                return _this5.unsubscribe(topic);
              }));
            case 15:
              this.subscribeHandlers = {};
              this.unsubscribesInProgress = {};
              this.isHalting = false;
              this.isHalted = true;
              this.logger.info('Finished halting all handlers');
            case 20:
            case "end":
              return _context15.stop();
          }
        }, _callee5, this);
      }));
      function halt() {
        return _halt.apply(this, arguments);
      }
      return halt;
    }()
    /**
     * @todo - provide method description
     *
     * @todo - return a Promise
     *
     * @param {String} topic
     *   The topic to send to
     * @param {Array} byteArray
     *   The raw data to send
     */
  }, {
    key: "directSend",
    value: function directSend(topic, byteArray) {
      this.logger.debug('directSend...');
      this.issueCommand(RouterTransactionManager.routerCommands.SEND, {
        topic: topic,
        byteArray: byteArray
      });
    }
  }, {
    key: "_destroy",
    value: function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6() {
        return regenerator_default().wrap(function _callee6$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return this.halt();
            case 2:
              this.pendingTransactions = null;
              this.unsubscribeHandlers = null;
              this.publishHandlers = null;
              this.subscribeHandlers = null;
              this.unsubscribesInProgress = null;
              _context16.next = 9;
              return RouterTransactionManager_superPropGet(RouterTransactionManager, "_destroy", this, 3)([]);
            case 9:
            case "end":
              return _context16.stop();
          }
        }, _callee6, this);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }()
  }], [{
    key: "factory",
    value: function factory(logId, clientId, routerIframeManager) {
      return new RouterTransactionManager(logId, clientId, routerIframeManager);
    }
  }]);
}(RouterBaseManager);
/**
 * @static
 *
 * The Router events that this Router Manager is responsible for
 */
_defineProperty(RouterTransactionManager, "routerEvents", {
  PUBLISH_SUCCESS: RouterBaseManager.routerEvents.PUBLISH_SUCCESS,
  PUBLISH_FAILURE: RouterBaseManager.routerEvents.PUBLISH_FAILURE,
  UNSUBSCRIBE_SUCCESS: RouterBaseManager.routerEvents.UNSUBSCRIBE_SUCCESS,
  UNSUBSCRIBE_FAILURE: RouterBaseManager.routerEvents.UNSUBSCRIBE_FAILURE,
  MESSAGE_ARRIVED: RouterBaseManager.routerEvents.MESSAGE_ARRIVED
});

;// ./src/js/ClspClient/Router/RouterStreamManager.js
















function RouterStreamManager_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, RouterStreamManager_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function RouterStreamManager_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (RouterStreamManager_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function RouterStreamManager_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }



var DEFAULT_STREAM_DATA_TIMEOUT_DURATION = (utils_default()).DEFAULT_STREAM_TIMEOUT;
var DEFAULT_MOOV_TIMEOUT_DURATION = (utils_default()).DEFAULT_STREAM_TIMEOUT;
var DEFAULT_FIRST_MOOF_TIMEOUT_DURATION = (utils_default()).DEFAULT_STREAM_TIMEOUT;
var DEFAULT_MOOF_TIMEOUT_DURATION = (utils_default()).DEFAULT_STREAM_TIMEOUT;
var RouterStreamManager = /*#__PURE__*/function (_RouterBaseManager) {
  function RouterStreamManager(logId, clientId, streamConfiguration, routerTransactionManager) {
    var _context;
    var _this;
    _classCallCheck(this, RouterStreamManager);
    _this = RouterStreamManager_callSuper(this, RouterStreamManager, [logId, clientId]);
    if (!StreamConfiguration.isStreamConfiguration(streamConfiguration)) {
      throw new Error('A StreamConfiguration is required to instantiate a RouterStreamManager');
    }
    if (!routerTransactionManager) {
      throw new Error('A RouterTransactionManager is required to instantiate a RouterStreamManager');
    }
    _this.streamConfiguration = streamConfiguration;
    _this.routerTransactionManager = routerTransactionManager;
    _this.STREAM_DATA_TIMEOUT_DURATION = DEFAULT_STREAM_DATA_TIMEOUT_DURATION;
    _this.MOOV_TIMEOUT_DURATION = DEFAULT_MOOV_TIMEOUT_DURATION;
    _this.FIRST_MOOF_TIMEOUT_DURATION = DEFAULT_FIRST_MOOF_TIMEOUT_DURATION;
    _this.MOOF_TIMEOUT_DURATION = DEFAULT_MOOF_TIMEOUT_DURATION;
    _this.streamName = _this.streamConfiguration.streamName;
    _this.moovRequestTopic = concat_default()(_context = "".concat(_this.clientId, "/init-segment/")).call(_context, parse_int_default()(Math.random() * 1000000));
    _this.guid = null;
    _this.firstMoofTimeout = null;
    _this.moofTimeout = null;
    _this.isPlaying = false;
    _this.isStopping = false;
    return _this;
  }

  /**
   * @async
   *
   * If the jwt is valid or if we are not using jwt, perform the necessary
   * operations to retrieve stream segments (moofs).  The actual "playing"
   * occurs in the player, since it involves taking those received stream
   * segments and using MSE to display them.
   *
   * @returns {Promise}
   *   * Resolves once the first moof has been received
   *   * Rejects if the moov or first moof time out
   */
  _inherits(RouterStreamManager, _RouterBaseManager);
  return _createClass(RouterStreamManager, [{
    key: "play",
    value: (function () {
      var _play = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
        var _this2 = this;
        var _yield$this$_requestS, guid, mimeCodec, _yield$this$_requestM, moov;
        return regenerator_default().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.isDestroyed) {
                _context2.next = 3;
                break;
              }
              this.logger.info('Tried to play from destroyed RouterStreamManager');
              return _context2.abrupt("return");
            case 3:
              _context2.prev = 3;
              if (!this._hasJWTTokenConfig()) {
                _context2.next = 8;
                break;
              }
              _context2.next = 7;
              return this._validateJWT();
            case 7:
              this.streamName = _context2.sent;
            case 8:
              this.logger.info('Play is requesting stream...');
              _context2.next = 11;
              return this._requestStreamData();
            case 11:
              _yield$this$_requestS = _context2.sent;
              guid = _yield$this$_requestS.guid;
              mimeCodec = _yield$this$_requestS.mimeCodec;
              this.guid = guid;
              this.routerTransactionManager.subscribe("iov/video/".concat(this.guid, "/resync"), function () {
                // @todo - what about a resync stream error?  is there any data that can
                // be passed with the event?
                _this2.emit(RouterStreamManager.events.RESYNC_STREAM_COMPLETE, {
                  guid: _this2.guid,
                  streamName: _this2.streamName
                });
              });

              // Get the moov first
              _context2.next = 18;
              return this._requestMoov();
            case 18:
              _yield$this$_requestM = _context2.sent;
              moov = _yield$this$_requestM.moov;
              _context2.next = 22;
              return this._requestMoofs();
            case 22:
              this.isPlaying = true;
              return _context2.abrupt("return", {
                guid: guid,
                mimeCodec: mimeCodec,
                moov: moov
              });
            case 26:
              _context2.prev = 26;
              _context2.t0 = _context2["catch"](3);
              this.logger.error("Error trying to play stream ".concat(this.streamName));
              _context2.next = 31;
              return this.stop();
            case 31:
              throw _context2.t0;
            case 32:
            case "end":
              return _context2.stop();
          }
        }, _callee, this, [[3, 26]]);
      }));
      function play() {
        return _play.apply(this, arguments);
      }
      return play;
    }()
    /**
     * @async
     *
     * Stop the stream.  Multiple topics will be unsubscribed from, and the stop
     * topic will be published.
     *
     * @returns {void}
     */
    )
  }, {
    key: "stop",
    value: (function () {
      var _stop = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _this3 = this;
        var results, errors;
        return regenerator_default().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this._clearFirstMoofTimeout();
              this._clearMoofTimeout();
              if (!this.isDestroyComplete) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              if (this.isPlaying) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return");
            case 6:
              if (this.guid) {
                _context3.next = 9;
                break;
              }
              // @todo - is this condition a symptom of a problem?
              this.logger.info("Trying to stop stream ".concat(this.streamName, " with no guid!"));
              return _context3.abrupt("return");
            case 9:
              this.isStopping = true;
              _context3.next = 12;
              return core_js_stable_promise_default().allSettled([
              // Stop listening for the moov
              this.routerTransactionManager.unsubscribe(this.moovRequestTopic),
              // Stop listening for moofs
              this.routerTransactionManager.unsubscribe("iov/video/".concat(this.guid, "/live")),
              // Stop listening for resync events
              this.routerTransactionManager.unsubscribe("iov/video/".concat(this.guid, "/resync")),
              // Tell the server we've stopped
              this.routerTransactionManager.publish("iov/video/".concat(this.guid, "/stop"), {
                clientId: this.clientId
              })]);
            case 12:
              results = _context3.sent;
              this.guid = null;
              this.isPlaying = false;
              this.isStopping = false;
              errors = reduce_default()(results).call(results, function (acc, cur) {
                if (cur.status !== 'fulfilled') {
                  acc.push(cur);
                }
                return acc;
              }, []);
              if (!errors.length) {
                _context3.next = 21;
                break;
              }
              this.logger.warn('Error(s) encountered while stopping:');
              for_each_default()(errors).call(errors, function (error) {
                _this3.logger.error(error.reason);
              });

              // @todo - is there a better way to do this?
              throw errors[0].reason;
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
    /**
     * @async
     *
     * Get the list of available CLSP streams from the SFS
     *
     * Note - this isn't currently used anywhere
     *
     * @returns {Object}
     *   @todo
     */
    )
  }, {
    key: "getStreamList",
    value: (function () {
      var _getStreamList = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
        var _yield$this$routerTra, streamList;
        return regenerator_default().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.logger.debug('Getting Stream List...');
              _context4.next = 3;
              return this.routerTransactionManager.transaction('iov/video/list');
            case 3:
              _yield$this$routerTra = _context4.sent;
              streamList = _yield$this$routerTra.payloadString;
              return _context4.abrupt("return", streamList);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee3, this);
      }));
      function getStreamList() {
        return _getStreamList.apply(this, arguments);
      }
      return getStreamList;
    }()
    /**
     * @returns @private
     *
     * Validate that the stream configuration has a valid jwt token configuration
     *
     * @returns {boolean}
     *   true if token config present and has a jwt token with a length > 0
     */
    )
  }, {
    key: "_hasJWTTokenConfig",
    value: function _hasJWTTokenConfig() {
      if (this.streamConfiguration.tokenConfig && this.streamConfiguration.tokenConfig.jwt && this.streamConfiguration.tokenConfig.jwt.length > 0) {
        return true;
      } else {
        return false;
      }
    }

    /**
     * @private
     *
     * @async
     *
     * Validate the jwt that this instance was constructed with.
     *
     * @returns {String}
     *   the stream name
     */
  }, {
    key: "_validateJWT",
    value: (function () {
      var _validateJWT2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4() {
        var _yield$this$routerTra2, response, t, streamName;
        return regenerator_default().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.logger.debug('Validating JWT...');

              // response ->  {"status": 200, "target_url": "clsp://sfs1/fakestream", "error": null}
              _context5.next = 3;
              return this.routerTransactionManager.transaction('iov/jwtValidate', {
                b64HashURL: this.streamConfiguration.tokenConfig.b64HashAccessUrl,
                token: this.streamConfiguration.tokenConfig.jwt
              });
            case 3:
              _yield$this$routerTra2 = _context5.sent;
              response = _yield$this$routerTra2.payloadString;
              if (response.error !== '') {
                this.emit(RouterStreamManager.events.JWT_AUTHORIZATION_FAILURE, {
                  error: response.error
                });
              }
              if (!(response.status !== 200)) {
                _context5.next = 8;
                break;
              }
              throw new Error(response.error);
            case 8:
              // TODO, figure out how to handle a change in the sfs url from the
              // clsp-jwt from the target url returned from decrypting the hash
              // token.
              // Example:
              //    user enters 'clsp-jwt://sfs1?token=...' for source
              //    clspUrl = 'clsp://SFS2/streamOnDifferentSfs
              // --- due to the videojs architecture i don't see a clean way of doing this.
              // ==============================================================================
              //    The only way I can see doing this cleanly is to change videojs itself to
              //    allow the 'canHandleSource' function in ClspSourceHandler to return a
              //    promise not a value, then ascychronously find out if it can play this
              //    source after making the call to decrypt the hash token.22
              // =============================================================================
              // Note: this could go away in architecture 2.0 if CLSP was a cluster in this
              // case what is now the sfs ip address in clsp url will always be the same it will
              // be the public ip of cluster gateway.
              t = response.target_url.split('/'); // get the actual stream name
              streamName = t[t.length - 1];
              return _context5.abrupt("return", streamName);
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this);
      }));
      function _validateJWT() {
        return _validateJWT2.apply(this, arguments);
      }
      return _validateJWT;
    }()
    /**
     * @private
     *
     * @async
     *
     * Get the `guid` and `mimeCodec` for the stream.  The guid serves as a stream
     * instance for a given camera or video feed, and is needed to make requests
     * for the stream instance.
     *
     * @returns {Object}
     *   The video metadata, including the `guid` and `mimeCodec` properties.
     */
    )
  }, {
    key: "_requestStreamData",
    value: (function () {
      var _requestStreamData2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5() {
        var payload, _yield$this$routerTra3, videoMetaData;
        return regenerator_default().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.logger.debug('Requesting Stream...');
              if (this._hasJWTTokenConfig()) {
                payload = {
                  clientId: this.clientId,
                  token: this.streamConfiguration.tokenConfig.jwt
                };
              } else {
                payload = {
                  clientId: this.clientId
                };
              }

              // NOTE - when the "/request" request times out, it means there is a
              // significant problem with this stream on the SFS (perhaps it doesn't
              // exist?).  As opposed to the "/play" request timing out...
              // @todo - add a condition for this
              _context6.next = 4;
              return this.routerTransactionManager.transaction("iov/video/".concat(window.btoa(this.streamName), "/request"), payload, this.STREAM_DATA_TIMEOUT_DURATION);
            case 4:
              _yield$this$routerTra3 = _context6.sent;
              videoMetaData = _yield$this$routerTra3.payloadString;
              if (videoMetaData.mimeCodec) {
                _context6.next = 8;
                break;
              }
              throw new Error('Error while requesting stream: mimeCodec was not received!');
            case 8:
              if (videoMetaData.guid) {
                _context6.next = 10;
                break;
              }
              throw new Error('Error while requesting stream: guid was not received!');
            case 10:
              return _context6.abrupt("return", videoMetaData);
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee5, this);
      }));
      function _requestStreamData() {
        return _requestStreamData2.apply(this, arguments);
      }
      return _requestStreamData;
    }())
  }, {
    key: "_clearFirstMoofTimeout",
    value: function _clearFirstMoofTimeout() {
      if (this.firstMoofTimeout) {
        clearTimeout(this.firstMoofTimeout);
        this.firstMoofTimeout = null;
      }
    }
  }, {
    key: "_clearMoofTimeout",
    value: function _clearMoofTimeout() {
      if (this.moofTimeout) {
        clearTimeout(this.moofTimeout);
        this.moofTimeout = null;
      }
    }

    /**
     * @private
     *
     * @async
     *
     * Request the moov from the SFS
     *
     * @returns {Object}
     *   The moov
     */
  }, {
    key: "_requestMoov",
    value: (function () {
      var _requestMoov2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6() {
        var payload, _yield$this$routerTra4, moov;
        return regenerator_default().wrap(function _callee6$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!this.isDestroyed) {
                _context7.next = 2;
                break;
              }
              throw new Error('Tried to request moov while destroyed');
            case 2:
              this.logger.info('Requesting the moov...');
              if (this.guid) {
                _context7.next = 5;
                break;
              }
              throw new Error('The guid must be set before requesting the moov');
            case 5:
              if (this._hasJWTTokenConfig()) {
                payload = {
                  initSegmentTopic: this.moovRequestTopic,
                  clientId: this.clientId,
                  token: this.streamConfiguration.tokenConfig.jwt
                };
              } else {
                payload = {
                  initSegmentTopic: this.moovRequestTopic,
                  clientId: this.clientId
                };
              }

              // NOTE - when the "/play" request times out, it means the SFS can correctly
              // handle your request for this stream, but something is wrong with the
              // stream on the SFS.
              // @todo - add a condition for this
              _context7.next = 8;
              return this.routerTransactionManager.transaction("iov/video/".concat(this.guid, "/play"), payload, this.MOOV_TIMEOUT_DURATION,
              // We must override the subscribe topic to get the moov
              this.moovRequestTopic);
            case 8:
              _yield$this$routerTra4 = _context7.sent;
              moov = _yield$this$routerTra4.payloadBytes;
              return _context7.abrupt("return", {
                moov: moov
              });
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee6, this);
      }));
      function _requestMoov() {
        return _requestMoov2.apply(this, arguments);
      }
      return _requestMoov;
    }()
    /**
     * @private
     *
     * @async
     *
     * Request moofs from the SFS.  Should only be called after getting the moov.
     *
     * @returns {Promise}
     *   * Resolves when the first moof is received
     *   * Rejects if the first moof is not received within the time defined by
     *     FIRST_MOOF_TIMEOUT_DURATION
     */
    )
  }, {
    key: "_requestMoofs",
    value: (function () {
      var _requestMoofs2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7() {
        var _this4 = this;
        return regenerator_default().wrap(function _callee7$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!this.isDestroyed) {
                _context9.next = 2;
                break;
              }
              throw new Error('Tried to request moofs while destroyed');
            case 2:
              this.logger.info('Setting up moof listener...');
              if (this.guid) {
                _context9.next = 5;
                break;
              }
              throw new Error('The guid must be set before requesting moofs');
            case 5:
              return _context9.abrupt("return", new (core_js_stable_promise_default())(function (resolve, reject) {
                var hasFirstMoofTimedOut = false;
                var hasReceivedFirstMoof = false;
                _this4.firstMoofTimeout = set_timeout_default()(function () {
                  var _context8;
                  if (hasFirstMoofTimedOut) {
                    return;
                  }
                  hasFirstMoofTimedOut = true;
                  _this4._clearFirstMoofTimeout();
                  reject(new Error(concat_default()(_context8 = "First moof for stream ".concat(_this4.streamName, " timed out after ")).call(_context8, _this4.FIRST_MOOF_TIMEOUT_DURATION, " seconds")));
                }, _this4.FIRST_MOOF_TIMEOUT_DURATION * 1000);
                var moofReceivedTopic = "iov/video/".concat(_this4.guid, "/live");

                // Set up the listener for the stream itself (the moof video segments)
                _this4.routerTransactionManager.subscribe(moofReceivedTopic, function (clspMessage) {
                  if (_this4.isDestroyed) {
                    _this4.logger.info('Received moof while destroyed!');
                    return;
                  }
                  if (!hasReceivedFirstMoof) {
                    // If we received the first moof after the timeout, do nothing
                    if (hasFirstMoofTimedOut) {
                      _this4.logger.warn('Received first moof, but moofTimeout has already occurred...');
                      return;
                    }

                    // If the firstMoofTimeout still exists, cancel it, since the request
                    // did not timeout
                    _this4._clearFirstMoofTimeout();

                    // Since this is the first moof, resolve
                    hasReceivedFirstMoof = true;

                    // Resolve here the first time, but keep going to actually process
                    // the moof.
                    resolve({
                      moofReceivedTopic: moofReceivedTopic
                    });
                  }
                  _this4._clearMoofTimeout();
                  _this4.moofTimeout = set_timeout_default()(function () {
                    if (_this4.isDestroyed) {
                      _this4.logger.info('Moof timeout reached while destroyed');
                      return;
                    }
                    _this4.emit(RouterStreamManager.events.VIDEO_SEGMENT_TIMEOUT, {
                      timeout: _this4.MOOF_TIMEOUT_DURATION
                    });
                  }, _this4.MOOF_TIMEOUT_DURATION * 1000);
                  _this4.emit(RouterStreamManager.events.VIDEO_SEGMENT_RECEIVED, {
                    clspMessage: clspMessage
                  });
                });
              }));
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee7, this);
      }));
      function _requestMoofs() {
        return _requestMoofs2.apply(this, arguments);
      }
      return _requestMoofs;
    }()
    /**
     * @async
     *
     * Clean up and dereference the necessary properties.  Will also stop the
     * stream.
     *
     * @returns {void}
     */
    )
  }, {
    key: "_destroy",
    value: (function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee8() {
        return regenerator_default().wrap(function _callee8$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return this.stop();
            case 3:
              _context10.next = 9;
              break;
            case 5:
              _context10.prev = 5;
              _context10.t0 = _context10["catch"](0);
              this.logger.error('Failed to stop when destroying!');
              this.logger.error(_context10.t0);
            case 9:
              this.streamConfiguration = null;
              this.routerTransactionManager = null;
              this.streamName = null;
              this.moovRequestTopic = null;
              this.guid = null;
              this.firstMoofTimeout = null;
              this.moofTimeout = null;
              _context10.next = 18;
              return RouterStreamManager_superPropGet(RouterStreamManager, "_destroy", this, 3)([]);
            case 18:
            case "end":
              return _context10.stop();
          }
        }, _callee8, this, [[0, 5]]);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }())
  }], [{
    key: "factory",
    value: function factory(logId, clientId, streamConfiguration, routerTransactionManager) {
      return new RouterStreamManager(logId, clientId, streamConfiguration, routerTransactionManager);
    }
  }]);
}(RouterBaseManager);
/**
 * @static
 *
 * The events that this RouterConnectionManager will emit.
 */
_defineProperty(RouterStreamManager, "events", {
  RESYNC_STREAM_COMPLETE: 'resync-stream-complete',
  VIDEO_SEGMENT_RECEIVED: 'video-segment-received',
  VIDEO_SEGMENT_TIMEOUT: 'video-segment-timeout',
  JWT_AUTHORIZATION_FAILURE: 'jwt-authorization-failure'
});
/**
 * @static
 *
 * The Router events that this Router Manager is responsible for
 */
_defineProperty(RouterStreamManager, "routerEvents", {});

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/set-interval.js
var set_interval = __webpack_require__(4607);
var set_interval_default = /*#__PURE__*/__webpack_require__.n(set_interval);
;// ./src/js/ClspClient/Router/RouterStatsManager.js











function RouterStatsManager_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, RouterStatsManager_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function RouterStatsManager_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (RouterStatsManager_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function RouterStatsManager_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var DEFAULT_PUBLISH_STATS_INTERVAL = 5;
var RouterStatsManager = /*#__PURE__*/function (_RouterBaseManager) {
  function RouterStatsManager(logId, clientId, routerTransactionManager) {
    var _this;
    _classCallCheck(this, RouterStatsManager);
    _this = RouterStatsManager_callSuper(this, RouterStatsManager, [logId, clientId]);
    if (!routerTransactionManager) {
      throw new Error('A RouterTransactionManager is required to instantiate a RouterStatsManager');
    }
    _this.routerTransactionManager = routerTransactionManager;
    _this.statsMsg = {
      byteCount: 0,
      inkbps: 0,
      host: document.location.host,
      clientId: _this.clientId
    };
    _this.publishInterval = null;
    _this.isStopped = true;

    // configurable state
    _this.PUBLISH_STATS_INTERVAL = DEFAULT_PUBLISH_STATS_INTERVAL;
    return _this;
  }

  /**
   * Update the stats byte count with the byteArray / segment.  To be called
   * when the segment is appended to the MSE SourceBuffer.
   *
   * @param {*} byteArray
   */
  _inherits(RouterStatsManager, _RouterBaseManager);
  return _createClass(RouterStatsManager, [{
    key: "updateByteCount",
    value: function updateByteCount(byteArray) {
      if (this.isDestroyed) {
        this.logger.info('Tried to updateByteCount while destroyed');
        return;
      }
      this.logger.silly('Updating bytecount...');
      this.statsMsg.byteCount += byteArray.length;
    }

    /**
     * We have to send stats to the server at least once per minute, or else the
     * CLSP service will stop streaming to this Router.
     *
     * @returns {void}
     */
  }, {
    key: "start",
    value: function start() {
      var _this2 = this;
      if (this.isDestroyed) {
        this.logger.info('Tried to start while destroyed');
        return;
      }
      if (this.publishInterval) {
        this.stop();
      }
      this.logger.info('Starting stats publishing...');
      this.publishInterval = set_interval_default()(function () {
        _this2._publishStats();
      }, this.PUBLISH_STATS_INTERVAL * 1000);
      this.isStopped = false;
    }

    /**
     * Stop publishing stats to the server.  Do this When we no longer want to
     * stream to the Router.
     *
     * @returns {void}
     */
  }, {
    key: "stop",
    value: function stop() {
      if (this.isDestroyComplete) {
        this.logger.info('Tried to stop while destroyed');
        return;
      }
      this.logger.info('Stopping stats publishing...');
      if (this.publishInterval) {
        clearInterval(this.publishInterval);
        this.publishInterval = null;
      }
      this.isStopped = true;
    }

    /**
     * @private
     *
     * @async
     *
     * Send stats to the server.
     *
     * @returns {void}
     */
  }, {
    key: "_publishStats",
    value: (function () {
      var _publishStats2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.isDestroyed) {
                _context.next = 3;
                break;
              }
              this.logger.info('Tried to _publishStats while destroyed');
              return _context.abrupt("return");
            case 3:
              this.statsMsg.inkbps = this.statsMsg.byteCount * 8 / 30000.0;
              this.statsMsg.byteCount = 0;
              _context.prev = 5;
              this.logger.info('About to send stats message...');
              _context.next = 9;
              return this.routerTransactionManager.publish('iov/stats', this.statsMsg);
            case 9:
              this.logger.debug('iov status', this.statsMsg);
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);
              // This prevents the errors from displaying when stopped, e.g. after the
              // iframe has been destroyed
              if (!this.isStopped) {
                this.logger.error('Error while publishing stats!');
                this.logger.error(_context.t0);
                this.emit(RouterStatsManager.events.PUBLISH_FAILURE, {
                  error: _context.t0
                });

                // If any publish operation fails, do not continue to try to send stats
                // messages.  It is up to the caller how to respond.
                this.stop();
              }
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 12]]);
      }));
      function _publishStats() {
        return _publishStats2.apply(this, arguments);
      }
      return _publishStats;
    }())
  }, {
    key: "_destroy",
    value: function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.stop();
              this.statsMsg = null;
              this.routerTransactionManager = null;
              _context2.next = 5;
              return RouterStatsManager_superPropGet(RouterStatsManager, "_destroy", this, 3)([]);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }()
  }], [{
    key: "factory",
    value: function factory(logId, clientId, routerTransactionManager) {
      return new RouterStatsManager(logId, clientId, routerTransactionManager);
    }
  }]);
}(RouterBaseManager);
/**
 * @static
 *
 * The events that this RouterStatsManager will emit.
 */
_defineProperty(RouterStatsManager, "events", {
  PUBLISH_FAILURE: 'publish-failed'
});
/**
 * @static
 *
 * The Router events that this Router Manager is responsible for
 */
_defineProperty(RouterStatsManager, "routerEvents", {});

;// ./src/js/ClspClient/Router/RouterConnectionManager.js












function RouterConnectionManager_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, RouterConnectionManager_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function RouterConnectionManager_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (RouterConnectionManager_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function RouterConnectionManager_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }





// If 3 reconnection attempts fail, allow the caller to decided what to do
var DEFAULT_MAX_RECONNECTION_ATTEMPTS = 3;
var DEFAULT_MAX_RECONNECTION_TIME = 0;
// When trying to reconnect, try every 5 seconds for the first 2 minutes, then
// try every 30 seconds after 2 minutes.
var DEFAULT_IMMEDIATE_RECONNECTION_DELAY = 5;
var DEFAULT_IMMEDIATE_RECONNECTION_DURATION = 120;
var DEFAULT_RECONNECTION_DELAY = 30;
var RouterConnectionManager = /*#__PURE__*/function (_RouterBaseManager) {
  function RouterConnectionManager(logId, clientId, routerTransactionManager) {
    var _this;
    _classCallCheck(this, RouterConnectionManager);
    _this = RouterConnectionManager_callSuper(this, RouterConnectionManager, [logId, clientId]);
    if (!routerTransactionManager) {
      throw new Error('A RouterTransactionManager is required to instantiate a RouterConnectionManager');
    }
    _this.routerTransactionManager = routerTransactionManager;
    _this.statsManager = RouterStatsManager.factory(_this.logId, _this.clientId, _this.routerTransactionManager);
    _this.statsManager.on(RouterStatsManager.events.PUBLISH_FAILURE, function (data) {
      // @todo - maybe wait for 2 or 3 failures before reconnecting?
      _this.logger.warn('Publish stats failure - attempting to reconnect...');
      _this.reconnect();
    });

    // configurable state
    _this.MAX_RECONNECTION_ATTEMPTS = DEFAULT_MAX_RECONNECTION_ATTEMPTS;
    _this.MAX_RECONNECTION_TIME = DEFAULT_MAX_RECONNECTION_TIME;
    _this.IMMEDIATE_RECONNECTION_DELAY = DEFAULT_IMMEDIATE_RECONNECTION_DELAY;
    _this.IMMEDIATE_RECONNECTION_DURATION = DEFAULT_IMMEDIATE_RECONNECTION_DURATION;
    _this.RECONNECTION_DELAY = DEFAULT_RECONNECTION_DELAY;

    // state flags
    _this.isConnected = false;
    _this.isConnecting = false;
    _this.isDisconnecting = false;
    _this.isReconnecting = false;

    // listeners
    _this._onConnect = null;
    _this._onDisconnect = null;
    return _this;
  }

  /**
   * @async
   *
   * After initialization, call this to establish the connection to the server.
   * It's really just a wrapper around reconnect that emits a different event.
   *
   * @param {} emit
   *
   * @returns {void}
   */
  _inherits(RouterConnectionManager, _RouterBaseManager);
  return _createClass(RouterConnectionManager, [{
    key: "connect",
    value: (function () {
      var _connect2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
        var emit,
          _args = arguments;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              emit = _args.length > 0 && _args[0] !== undefined ? _args[0] : true;
              _context.prev = 1;
              _context.next = 4;
              return this.reconnect(false);
            case 4:
              if (!this.isDestroyed) {
                _context.next = 7;
                break;
              }
              this.logger.info('Destroy occurred before the connection finished');
              return _context.abrupt("return");
            case 7:
              if (!this.isDisconnecting) {
                _context.next = 10;
                break;
              }
              this.logger.info('Disconnection occurred before the connection finished');
              return _context.abrupt("return");
            case 10:
              if (emit) {
                this.emit(RouterConnectionManager.events.CONNECT_SUCCESS);
              }
              _context.next = 18;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              this.logger.error('Failed to connect');
              this.logger.error(_context.t0);
              if (emit) {
                this.emit(RouterConnectionManager.events.CONNECT_FAILURE, {
                  error: _context.t0
                });
              }
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 13]]);
      }));
      function connect() {
        return _connect2.apply(this, arguments);
      }
      return connect;
    }()
    /**
     * Do not call this method directly!  Only use the `connect` method.
     *
     * @returns Promise
     *   Resolves when the connection is successfully established.
     *   Rejects upon failure to connect after a number of retries.
     */
    )
  }, {
    key: "_connect",
    value: function _connect() {
      var _this2 = this;
      return new (core_js_stable_promise_default())(function (resolve, reject) {
        _this2._onConnect = function (error) {
          _this2._onConnect = null;
          if (error) {
            return reject(error);
          }
          resolve();
        };
        _this2.routerTransactionManager.issueCommand(RouterConnectionManager.routerCommands.CONNECT);
      });
    }
  }, {
    key: "_handleConnectRouterEvent",
    value: function _handleConnectRouterEvent(eventType, event) {
      switch (eventType) {
        case RouterConnectionManager.routerEvents.CONNECT_SUCCESS:
          {
            this._onConnect();
            break;
          }
        case RouterConnectionManager.routerEvents.CONNECT_FAILURE:
          {
            this._onConnect(new Error(event.data.reason));
            break;
          }
        default:
          {
            throw new Error("Unknown eventType: ".concat(eventType));
          }
      }
    }

    /**
     * @async
     *
     * Attempt to reconnect a certain number of times
     *
     * @returns {Promise}
     */
  }, {
    key: "reconnect",
    value: (function () {
      var _reconnect2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        var emit,
          reconnectionStartedAt,
          stopTryingToReconnectAt,
          _args2 = arguments;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              emit = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : true;
              if (!this.isDestroyed) {
                _context2.next = 4;
                break;
              }
              this.logger.info('Tried to reconnect on destroyed RouterConnectionManager');
              return _context2.abrupt("return");
            case 4:
              if (!this.isDisconnecting) {
                _context2.next = 7;
                break;
              }
              this.logger.info('Tried to reconnect while there was a disconnection in progress');
              return _context2.abrupt("return");
            case 7:
              if (!this.isConnecting) {
                _context2.next = 10;
                break;
              }
              this.logger.info('Connection already in progress');
              return _context2.abrupt("return");
            case 10:
              if (!this.isReconnecting) {
                _context2.next = 13;
                break;
              }
              this.logger.info('A reconnection attempt is already in progress');
              return _context2.abrupt("return");
            case 13:
              this.logger.info('Reconnecting...');
              this.isConnecting = true;
              this.isReconnecting = true;
              reconnectionStartedAt = now_default()();
              stopTryingToReconnectAt = this.MAX_RECONNECTION_TIME ? reconnectionStartedAt + this.MAX_RECONNECTION_TIME * 1000 : 0;
              _context2.prev = 18;
              _context2.next = 21;
              return this._reconnect(reconnectionStartedAt, stopTryingToReconnectAt);
            case 21:
              if (!this.isDestroyed) {
                _context2.next = 24;
                break;
              }
              this.logger.info('Destruction occurred before the reconnection finished');
              return _context2.abrupt("return");
            case 24:
              if (!this.isDisconnecting) {
                _context2.next = 27;
                break;
              }
              this.logger.info('Disconnection occurred before the reconnection finished');
              return _context2.abrupt("return");
            case 27:
              this.logger.info('Successfully reconnected!');
              if (emit) {
                this.emit(RouterConnectionManager.events.RECONNECT_SUCCESS);
              }
              _context2.next = 35;
              break;
            case 31:
              _context2.prev = 31;
              _context2.t0 = _context2["catch"](18);
              this.logger.error('Failed to reconnect');
              if (emit) {
                this.emit(RouterConnectionManager.events.RECONNECT_FAILURE, {
                  error: _context2.t0
                });
              }
            case 35:
              _context2.prev = 35;
              this.isConnecting = false;
              this.isReconnecting = false;
              return _context2.finish(35);
            case 39:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[18, 31, 35, 39]]);
      }));
      function reconnect() {
        return _reconnect2.apply(this, arguments);
      }
      return reconnect;
    }()
    /**
     * @private
     * @async
     *
     * Do not call this method directly!  Only use the `reconnect` method.
     */
    )
  }, {
    key: "_reconnect",
    value: (function () {
      var _reconnect3 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(reconnectionStartedAt, stopTryingToReconnectAt) {
        var reconnectionAttempts,
          reconnectionDelay,
          _args3 = arguments;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              reconnectionAttempts = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : 0;
              if (!this.isDestroyed) {
                _context3.next = 4;
                break;
              }
              this.logger.info('Tried to _reconnect on destroyed RouterConnectionManager');
              return _context3.abrupt("return");
            case 4:
              if (!this.isDisconnecting) {
                _context3.next = 7;
                break;
              }
              this.logger.info('Tried to _reconnect while there was a disconnection in progress');
              return _context3.abrupt("return");
            case 7:
              if (!this.isConnected) {
                _context3.next = 10;
                break;
              }
              this.logger.info('Already connected.');
              return _context3.abrupt("return");
            case 10:
              reconnectionAttempts++;
              if (!(this.MAX_RECONNECTION_ATTEMPTS && reconnectionAttempts > this.MAX_RECONNECTION_ATTEMPTS)) {
                _context3.next = 13;
                break;
              }
              throw new Error("Failed to reconnect after ".concat(reconnectionAttempts, " attempts."));
            case 13:
              if (!(this.MAX_RECONNECTION_TIME && now_default()() > stopTryingToReconnectAt)) {
                _context3.next = 15;
                break;
              }
              throw new Error("Failed to reconnect after ".concat(this.MAX_RECONNECTION_TIME, " seconds."));
            case 15:
              if (reconnectionAttempts > 1) {
                this.logger.warn("Reconnection attempt #".concat(reconnectionAttempts, "..."));
              }
              _context3.prev = 16;
              _context3.next = 19;
              return this.disconnect(false);
            case 19:
              _context3.next = 21;
              return (0,promise_timeout/* timeout */.w)(this._connect(), this.IMMEDIATE_RECONNECTION_DELAY * 1000);
            case 21:
              this.isConnected = true;

              // As soon as the connection is made, start publishing stats
              this.statsManager.start();
              this.logger.info("Reconnected successfully after ".concat(reconnectionAttempts, " attempts"));
              _context3.next = 35;
              break;
            case 26:
              _context3.prev = 26;
              _context3.t0 = _context3["catch"](16);
              this.logger.error('Error while trying to reconnect:');
              this.logger.error(_context3.t0);
              reconnectionDelay = now_default()() - reconnectionStartedAt > this.IMMEDIATE_RECONNECTION_DURATION * 1000 ? this.RECONNECTION_DELAY : this.IMMEDIATE_RECONNECTION_DELAY;
              _context3.next = 33;
              return (0,dist.sleepSeconds)(reconnectionDelay);
            case 33:
              _context3.next = 35;
              return this._reconnect(reconnectionStartedAt, stopTryingToReconnectAt, reconnectionAttempts);
            case 35:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[16, 26]]);
      }));
      function _reconnect(_x, _x2) {
        return _reconnect3.apply(this, arguments);
      }
      return _reconnect;
    }()
    /**
     * @async
     *
     * Disconnect from the CLSP server
     */
    )
  }, {
    key: "disconnect",
    value: (function () {
      var _disconnect2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4() {
        var emit,
          _args4 = arguments;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              emit = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : true;
              if (!this.isDestroyComplete) {
                _context4.next = 4;
                break;
              }
              this.logger.info('Tried to disconnect on a destroyed RouterConnectionManager');
              return _context4.abrupt("return");
            case 4:
              if (!this.isDisconnecting) {
                _context4.next = 7;
                break;
              }
              this.logger.info('There is already a disconnection in progress');
              return _context4.abrupt("return");
            case 7:
              if (this.isConnected) {
                _context4.next = 9;
                break;
              }
              return _context4.abrupt("return");
            case 9:
              this.logger.info('Disconnecting...');
              this.isDisconnecting = true;
              _context4.prev = 11;
              // when a stream fails, it no longer needs to send stats to the
              // server, and it may not even be connected to the server
              this.statsManager.stop();
              _context4.next = 15;
              return (0,promise_timeout/* timeout */.w)(this._disconnect(), this.IMMEDIATE_RECONNECTION_DELAY * 1000);
            case 15:
              if (emit) {
                this.emit(RouterConnectionManager.events.DISCONNECT_SUCCESS);
              }
              _context4.next = 28;
              break;
            case 18:
              _context4.prev = 18;
              _context4.t0 = _context4["catch"](11);
              if (!this.isDestroyComplete) {
                _context4.next = 23;
                break;
              }
              this.logger.info('Disconnect failed while destroyed');
              return _context4.abrupt("return");
            case 23:
              if (!this.routerTransactionManager.iframeWasDestroyedExternally) {
                _context4.next = 26;
                break;
              }
              this.logger.info('Disconnect failed while iframe was destroyed externally');
              return _context4.abrupt("return");
            case 26:
              if (emit) {
                this.emit(RouterConnectionManager.events.DISCONNECT_FAILURE, {
                  error: _context4.t0
                });
              }
              throw _context4.t0;
            case 28:
              _context4.prev = 28;
              this._onDisconnect = null;

              // @todo - is this correct in the event of an error while disconnecting?
              this.isConnected = false;
              this.isDisconnecting = false;
              return _context4.finish(28);
            case 33:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[11, 18, 28, 33]]);
      }));
      function disconnect() {
        return _disconnect2.apply(this, arguments);
      }
      return disconnect;
    }())
  }, {
    key: "_disconnect",
    value: function _disconnect() {
      var _this3 = this;
      return new (core_js_stable_promise_default())(function (resolve, reject) {
        _this3._onDisconnect = function (error) {
          if (error) {
            return reject(error);
          }
          resolve();
        };
        _this3.routerTransactionManager.issueCommand(RouterConnectionManager.routerCommands.DISCONNECT);
      });
    }
  }, {
    key: "_handleDisconnectRouterEvent",
    value: function _handleDisconnectRouterEvent(eventType, event) {
      switch (eventType) {
        case RouterConnectionManager.routerEvents.DISCONNECT_SUCCESS:
          {
            this._onDisconnect();
            break;
          }
        case RouterConnectionManager.routerEvents.DISCONNECT_FAILURE:
          {
            this._onDisconnect(new Error(event.data.reason));
            break;
          }
        default:
          {
            throw new Error("Unknown eventType: ".concat(eventType));
          }
      }
    }

    /**
     * Handler for the CONNECTION_LOST event.  Will stop stats and attempt to
     * reconnect.
     *
     * @param {*} event
     */
  }, {
    key: "_handleConnectionLostRouterEvent",
    value: function _handleConnectionLostRouterEvent(event) {
      var eventType = event.data.event;
      this.logger.debug("connection lost \"".concat(eventType, "\" event"));

      // We know we're no longer connected
      this.isConnected = false;

      // As soon as the connection is made, start publishing stats
      this.statsManager.stop();

      // @todo - not sure if this is the right way to handle it - should the
      // caller request the reconnect?  Should this emit a disconnect event
      // instead of trying to reconnect?
      this.reconnect();
      // this.emit(RouterConnectionManager.events.DISCONNECT_SUCCESS, {
      //   reason: event.data.reason,
      // });
    }
  }, {
    key: "onRouterEvent",
    value: function onRouterEvent(eventType, event) {
      if (this.isDestroyComplete) {
        throw new Error("Tried to handle Router event ".concat(eventType, " after destroy was complete!"));
      }
      switch (eventType) {
        case RouterConnectionManager.routerEvents.CONNECT_SUCCESS:
        case RouterConnectionManager.routerEvents.CONNECT_FAILURE:
          {
            this._handleConnectRouterEvent(eventType, event);
            break;
          }
        case RouterConnectionManager.routerEvents.DISCONNECT_SUCCESS:
        case RouterConnectionManager.routerEvents.DISCONNECT_FAILURE:
          {
            this._handleDisconnectRouterEvent(eventType, event);
            break;
          }
        case RouterConnectionManager.routerEvents.CONNECTION_LOST:
          {
            this._handleConnectionLostRouterEvent(event);
            break;
          }
        default:
          {
            throw new Error("Unknown eventType: ".concat(eventType));
          }
      }
    }
  }, {
    key: "_destroy",
    value: function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5() {
        return regenerator_default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return this.disconnect();
            case 3:
              _context5.next = 9;
              break;
            case 5:
              _context5.prev = 5;
              _context5.t0 = _context5["catch"](0);
              this.logger.error('Error while disconnecting while destroying:');
              this.logger.error(_context5.t0);
            case 9:
              _context5.prev = 9;
              _context5.next = 12;
              return this.statsManager.destroy();
            case 12:
              _context5.next = 18;
              break;
            case 14:
              _context5.prev = 14;
              _context5.t1 = _context5["catch"](9);
              this.logger.error('Error while destroying statsManager while destroying:');
              this.logger.error(_context5.t1);
            case 18:
              this.statsManager = null;
              this.routerTransactionManager = null;
              this._onConnect = null;
              this._onDisconnect = null;
              _context5.next = 24;
              return RouterConnectionManager_superPropGet(RouterConnectionManager, "_destroy", this, 3)([]);
            case 24:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 5], [9, 14]]);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }()
  }], [{
    key: "factory",
    value: function factory(logId, clientId, routerTransactionManager) {
      return new RouterConnectionManager(logId, clientId, routerTransactionManager);
    }
  }]);
}(RouterBaseManager);
/**
 * @static
 *
 * The events that this RouterConnectionManager will emit.
 */
_defineProperty(RouterConnectionManager, "events", {
  // Emitted when a connection attempt
  CONNECT_SUCCESS: 'connect-success',
  CONNECT_FAILURE: 'connect-failure',
  RECONNECT_SUCCESS: 'reconnect-success',
  RECONNECT_FAILURE: 'reconnect-failure',
  DISCONNECT_SUCCESS: 'disconnect-success',
  DISCONNECT_FAILURE: 'disconnect-failure'
});
/**
 * @static
 *
 * The Router events that this Router Manager is responsible for
 */
_defineProperty(RouterConnectionManager, "routerEvents", {
  CONNECT_SUCCESS: RouterBaseManager.routerEvents.CONNECT_SUCCESS,
  CONNECT_FAILURE: RouterBaseManager.routerEvents.CONNECT_FAILURE,
  DISCONNECT_SUCCESS: RouterBaseManager.routerEvents.DISCONNECT_SUCCESS,
  DISCONNECT_FAILURE: RouterBaseManager.routerEvents.DISCONNECT_FAILURE,
  CONNECTION_LOST: RouterBaseManager.routerEvents.CONNECTION_LOST
});

;// ./src/js/ClspClient/Conduit/Conduit.js











function Conduit_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, Conduit_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function Conduit_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (Conduit_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function Conduit_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/**
 * The Conduit a hidden iframe that is used to establish a dedicated CLSP
 * websocket for a single video. This is basically an in-browser micro service
 * which uses cross-document communication to route data to and from the iframe.
 *
 * This code is a layer of abstraction on top of the CLSP router, and the
 * controller of the iframe that contains the router.
 */







var Conduit = /*#__PURE__*/function (_EventEmitter) {
  /**
   * @private
   *
   * @param {String} logId
   *   a string that identifies this router in log messages
   * @param {String} clientId
   *   the guid to be used to construct the topic
   * @param {StreamConfiguration} streamConfiguration
   *   The stream configuration to pull from the CLSP server / SFS
   * @param {Element} containerElement
   *   The container of the video element and where the Conduit's iframe will be
   *   inserted
   */
  function Conduit(logId, clientId, streamConfiguration, containerElement) {
    var _this;
    _classCallCheck(this, Conduit);
    _this = Conduit_callSuper(this, Conduit, [logId]);
    if (!clientId) {
      throw new Error('clientId is required to construct a new Conduit instance.');
    }
    if (!StreamConfiguration.isStreamConfiguration(streamConfiguration)) {
      throw new Error('invalid streamConfiguration passed to Conduit constructor');
    }
    if (!containerElement) {
      throw new Error('containerElement is required to construct a new Conduit instance');
    }
    _this.clientId = clientId;
    _this.streamConfiguration = streamConfiguration;
    _this.containerElement = containerElement;
    _this.isInitialized = false;
    _this.routerIframeManager = RouterIframeManager.factory(_this.logId, _this.clientId, _this.streamConfiguration, _this.containerElement);
    _this.routerTransactionManager = RouterTransactionManager.factory(_this.logId, _this.clientId, _this.routerIframeManager);
    _this.routerConnectionManager = RouterConnectionManager.factory(_this.logId, _this.clientId, _this.routerTransactionManager);
    _this.routerStreamManager = RouterStreamManager.factory(_this.logId, _this.clientId, _this.streamConfiguration, _this.routerTransactionManager);
    return _this;
  }
  _inherits(Conduit, _EventEmitter);
  return _createClass(Conduit, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
        var _this2 = this;
        return regenerator_default().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.routerIframeManager.on(RouterIframeManager.events.IFRAME_DESTROYED_EXTERNALLY, function () {
                if (_this2.isDestroyed) {
                  _this2.logger.info('Iframe was destroyed externally while in process of destroying');
                  return;
                }
                _this2.emit(Conduit.events.IFRAME_DESTROYED_EXTERNALLY);

                // This doesn't really do anything since the iframe is already
                // destroyed, it just allows the disconnection to run in parallel with
                // the rest of the destroy logic so that by the time the async destroy
                // logic gets to the part where it actually performs the disconnection,
                // it won't have to wait the 5 seconds for the disconnect timeout.
                _this2.routerConnectionManager.disconnect();
              });

              // Allow the caller to react every time there is a reconnection event
              this.routerConnectionManager.on(RouterConnectionManager.events.RECONNECT_SUCCESS, function () {
                _this2.emit(Conduit.events.RECONNECT_SUCCESS);
              });
              this.routerConnectionManager.on(RouterConnectionManager.events.RECONNECT_FAILURE, function (_ref) {
                var error = _ref.error;
                // @todo - currently, the default is to reconnect indefinitely.  but if
                // a reconnection attempt limit is set, what should happen when the
                // reconnection fails for the last time?  does this event indicate that
                // the last reconnection attempt failed and another attempt will not be
                // made?
                _this2.emit(Conduit.events.RECONNECT_FAILURE, {
                  error: error
                });
              });
              this.routerStreamManager.on(RouterStreamManager.events.RESYNC_STREAM_COMPLETE, function (data) {
                // @todo - if a stream has to "resync", how are we supposed to respond
                // to that?
                _this2.emit(Conduit.events.RESYNC_STREAM_COMPLETE, data);
              });

              // This is the big one - transmit the video segments upstreama
              this.routerStreamManager.on(RouterStreamManager.events.VIDEO_SEGMENT_RECEIVED, function (data) {
                // @todo - if a video segment isn't received for some interval after the
                // previous video segment was received, some sort of remediation should
                // take place.
                _this2.emit(Conduit.events.VIDEO_SEGMENT_RECEIVED, data);
              });
              this.routerStreamManager.on(RouterStreamManager.events.VIDEO_SEGMENT_TIMEOUT, function (data) {
                var _context;
                _this2.logger.warn(concat_default()(_context = "Did not receive a video segment for ".concat(_this2.routerStreamManager.streamName, " in ")).call(_context, data.timeout, " seconds, attempting to reconnect..."));

                // No need to await here since we're in an event listener
                _this2.routerConnectionManager.reconnect();
              });

              // Need to make our way up to the IovPlayerCollection to tell it to stop trying to reconnect.  Never gonna work
              // with this jwt token
              this.routerStreamManager.on(RouterStreamManager.events.JWT_AUTHORIZATION_FAILURE, function (data) {
                _this2.emit(Conduit.events.JWT_AUTHORIZATION_FAILURE, data);
              });
              _context2.next = 9;
              return this.routerIframeManager.create();
            case 9:
              this.isInitialized = true;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
    /**
     * Play the configured stream.
     *
     * @returns {object}
     *  - guid
     *  - mimeCodec
     *  - moov
     */
  }, {
    key: "play",
    value: (function () {
      var _play = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _yield$this$routerStr, guid, mimeCodec, moov;
        return regenerator_default().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.isDestroyed) {
                _context3.next = 3;
                break;
              }
              this.logger.info('Tried to play a stream from a destroyed Conduit');
              return _context3.abrupt("return");
            case 3:
              if (this.isInitialized) {
                _context3.next = 6;
                break;
              }
              this.logger.info('Tried to play a stream without first initializing the Conduit');
              return _context3.abrupt("return");
            case 6:
              this.logger.info('Playing...');
              _context3.prev = 7;
              _context3.next = 10;
              return this.routerConnectionManager.connect();
            case 10:
              _context3.next = 17;
              break;
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](7);
              this.logger.error('Error while trying to connect before playing:');
              this.logger.error(_context3.t0);
              throw _context3.t0;
            case 17:
              _context3.prev = 17;
              _context3.next = 20;
              return this.routerStreamManager.play();
            case 20:
              _yield$this$routerStr = _context3.sent;
              guid = _yield$this$routerStr.guid;
              mimeCodec = _yield$this$routerStr.mimeCodec;
              moov = _yield$this$routerStr.moov;
              return _context3.abrupt("return", {
                guid: guid,
                mimeCodec: mimeCodec,
                moov: moov
              });
            case 27:
              _context3.prev = 27;
              _context3.t1 = _context3["catch"](17);
              this.logger.error("Error trying to play stream ".concat(this.routerStreamManager.streamName));

              // @todo - we could retry?
              _context3.next = 32;
              return this.stop();
            case 32:
              throw _context3.t1;
            case 33:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this, [[7, 12], [17, 27]]);
      }));
      function play() {
        return _play.apply(this, arguments);
      }
      return play;
    }()
    /**
     * @async
     *
     * Stop the playing stream.  Makes the necessary calls to the Router Manager
     * instances.
     *
     * @returns {void}
     */
    )
  }, {
    key: "stop",
    value: (function () {
      var _stop = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.logger.info('Stopping stream...');
              _context4.prev = 1;
              _context4.next = 4;
              return this.routerStreamManager.stop();
            case 4:
              _context4.next = 9;
              break;
            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](1);
              // @todo - this is too tightly coupled - the iframe manager should emit
              // an event when this external destruction happens, not expect the caller
              // to check for it...
              if (!this.routerIframeManager.wasIframeDestroyedExternally()) {
                this.logger.error('Error while stopping while destroying');
                this.logger.error(_context4.t0);
              }
            case 9:
              _context4.prev = 9;
              _context4.next = 12;
              return this.routerConnectionManager.disconnect();
            case 12:
              _context4.next = 17;
              break;
            case 14:
              _context4.prev = 14;
              _context4.t1 = _context4["catch"](9);
              // @todo - this is too tightly coupled - the iframe manager should emit
              // an event when this external destruction happens, not expect the caller
              // to check for it...
              if (!this.routerIframeManager.wasIframeDestroyedExternally()) {
                this.logger.error('Error while stopping while destroying');
                this.logger.error(_context4.t1);
              }
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee3, this, [[1, 6], [9, 14]]);
      }));
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
    /**
     * To be called when a segment (moof) is shown (appended to the MSE buffer).
     *
     * In practical terms, this is meant to be called when the moof is appended
     * to the MSE SourceBuffer.  This method is meant to update stats.
     *
     * @param {Array} byteArray
     *   The raw segment / moof
     */
    )
  }, {
    key: "segmentUsed",
    value: function segmentUsed(byteArray) {
      // @todo - this is never used, but existed in the original implementation
      // Used for determining the size of the internal buffer hidden from the MSE
      // api by recording the size and time of each chunk of video upon buffer
      // append and recording the time when the updateend event is called.
      if (this.shouldLogSourceBuffer && this.logSourceBufferTopic) {
        this.routerTransactionManager.directSend(this.logSourceBufferTopic, byteArray);
      }
      this.routerConnectionManager.statsManager.updateByteCount(byteArray);
    }

    /**
     * When the Router sends a message back from its iframe, the Conduit
     * Collection handles it.  If the message was meant for this Conduit, the
     * Conduit Collection will call this method with the event data.
     *
     * @param {Object} event
     *   We expect event to have "data.event", which represents the event that
     *   occurred relative to the clsp stream.  "ready" means the stream is ready,
     *   "fail" means there was an error, "data" means a video segment / moof was
     *   sent.
     */
  }, {
    key: "onRouterEvent",
    value: function onRouterEvent(eventType, event) {
      this.logger.debug("Message received for \"".concat(eventType, "\" event"));
      try {
        switch (eventType) {
          case RouterIframeManager.routerEvents.CREATE_SUCCESS:
          case RouterIframeManager.routerEvents.CREATE_FAILURE:
            {
              this.routerIframeManager._handleRouterCreatedEvent(eventType, event);
              break;
            }
          case RouterConnectionManager.routerEvents.CONNECT_SUCCESS:
          case RouterConnectionManager.routerEvents.CONNECT_FAILURE:
          case RouterConnectionManager.routerEvents.DISCONNECT_SUCCESS:
          case RouterConnectionManager.routerEvents.DISCONNECT_FAILURE:
          case RouterConnectionManager.routerEvents.CONNECTION_LOST:
            {
              this.routerConnectionManager.onRouterEvent(eventType, event);
              break;
            }
          case RouterTransactionManager.routerEvents.UNSUBSCRIBE_SUCCESS:
          case RouterTransactionManager.routerEvents.UNSUBSCRIBE_FAILURE:
          case RouterTransactionManager.routerEvents.PUBLISH_SUCCESS:
          case RouterTransactionManager.routerEvents.PUBLISH_FAILURE:
          case RouterTransactionManager.routerEvents.MESSAGE_ARRIVED:
            {
              this.routerTransactionManager.onRouterEvent(eventType, event);
              break;
            }
          case Conduit.routerEvents.WINDOW_MESSAGE_FAIL:
            {
              // @todo - is disconnecting really the best response to this event?
              // we could broadcast or reconnect or something...
              this.routerConnectionManager.disconnect();
              break;
            }
          // Log the error, but don't throw
          default:
            {
              this.logger.error("No match for event: ".concat(eventType));
            }
        }
      } catch (error) {
        this.logger.error('onMessageError');
        this.logger.error(error);
        this.emit(Conduit.events.ROUTER_EVENT_ERROR, {
          error: error
        });
      }
    }

    /**
     * @async
     *
     * Clean up and dereference the necessary properties.  Will also disconnect
     * and destroy the iframe.
     *
     * @returns {void}
     */
  }, {
    key: "_destroy",
    value: (function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4() {
        return regenerator_default().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return this.stop();
            case 3:
              _context5.next = 9;
              break;
            case 5:
              _context5.prev = 5;
              _context5.t0 = _context5["catch"](0);
              this.logger.error('Error while stopping while destroying');
              this.logger.error(_context5.t0);
            case 9:
              _context5.prev = 9;
              _context5.next = 12;
              return this.routerStreamManager.destroy();
            case 12:
              _context5.next = 18;
              break;
            case 14:
              _context5.prev = 14;
              _context5.t1 = _context5["catch"](9);
              this.logger.error('Error while destroying routerStreamManager while destroying');
              this.logger.error(_context5.t1);
            case 18:
              _context5.prev = 18;
              _context5.next = 21;
              return this.routerConnectionManager.destroy();
            case 21:
              _context5.next = 27;
              break;
            case 23:
              _context5.prev = 23;
              _context5.t2 = _context5["catch"](18);
              this.logger.error('Error while destroying routerConnectionManager while destroying');
              this.logger.error(_context5.t2);
            case 27:
              _context5.prev = 27;
              _context5.next = 30;
              return this.routerTransactionManager.destroy();
            case 30:
              _context5.next = 36;
              break;
            case 32:
              _context5.prev = 32;
              _context5.t3 = _context5["catch"](27);
              this.logger.error('Error while destroying routerTransactionManager while destroying');
              this.logger.error(_context5.t3);
            case 36:
              _context5.prev = 36;
              _context5.next = 39;
              return this.routerIframeManager.destroy();
            case 39:
              _context5.next = 45;
              break;
            case 41:
              _context5.prev = 41;
              _context5.t4 = _context5["catch"](36);
              this.logger.error('Error while destroying routerIframeManager while destroying');
              this.logger.error(_context5.t4);
            case 45:
              this.routerStreamManager = null;
              this.routerConnectionManager = null;
              this.routerTransactionManager = null;
              this.routerIframeManager = null;
              this.clientId = null;
              // The caller must destroy the streamConfiguration
              this.streamConfiguration = null;
              this.containerElement = null;
              _context5.next = 54;
              return Conduit_superPropGet(Conduit, "_destroy", this, 3)([]);
            case 54:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this, [[0, 5], [9, 14], [18, 23], [27, 32], [36, 41]]);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }())
  }], [{
    key: "factory",
    value: function factory(logId, clientId, streamConfiguration, containerElement) {
      return new Conduit(logId, clientId, streamConfiguration, containerElement);
    }
  }]);
}(EventEmitter);
/**
 * @static
 *
 * The events that this RouterStatsManager will emit.
 */
_defineProperty(Conduit, "events", {
  ROUTER_EVENT_ERROR: 'router-event-error',
  RECONNECT_SUCCESS: RouterConnectionManager.events.RECONNECT_SUCCESS,
  RECONNECT_FAILURE: RouterConnectionManager.events.RECONNECT_FAILURE,
  RESYNC_STREAM_COMPLETE: RouterStreamManager.events.RESYNC_STREAM_COMPLETE,
  VIDEO_SEGMENT_RECEIVED: RouterStreamManager.events.VIDEO_SEGMENT_RECEIVED,
  IFRAME_DESTROYED_EXTERNALLY: RouterIframeManager.events.IFRAME_DESTROYED_EXTERNALLY,
  JWT_AUTHORIZATION_FAILURE: RouterStreamManager.events.JWT_AUTHORIZATION_FAILURE
});
/**
 * @static
 *
 * The events that the Router will broadcast via Window Messages
 */
_defineProperty(Conduit, "routerEvents", RouterBaseManager.routerEvents);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/keys.js
var instance_keys = __webpack_require__(5413);
var instance_keys_default = /*#__PURE__*/__webpack_require__.n(instance_keys);
// EXTERNAL MODULE: ./node_modules/paho-mqtt/paho-mqtt.js
var paho_mqtt = __webpack_require__(7924);
var paho_mqtt_default = /*#__PURE__*/__webpack_require__.n(paho_mqtt);
;// ./src/js/ClspClient/Conduit/Paho.js


/**
 * @see - https://www.eclipse.org/paho/index.php?page=clients/js/index.php#
 * @see - https://www.eclipse.org/paho/files/jsdoc/index.html
 */

/* harmony default export */ const Paho = ({
  Paho: (paho_mqtt_default()),
  register: function register() {
    if (window.Paho) {
      return;
    }

    // Even though the export of paho-mqtt is { Client, Message }, there is an
    // internal reference that the library makes to itself, and it expects
    // itself to exist at Paho.MQTT.  For some reason, the library doesn't do
    // this itself, despite it being necessary for the library to work, so we
    // are forced to do it ourselves.
    window.Paho = {
      MQTT: (paho_mqtt_default())
    };
  }
});
;// ./src/js/ClspClient/Conduit/ConduitCollection.js













function ConduitCollection_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, ConduitCollection_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function ConduitCollection_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (ConduitCollection_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ConduitCollection_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }



var collection;
var ConduitCollection = /*#__PURE__*/function (_Destroyable) {
  /**
   * @private
   */
  function ConduitCollection(logId) {
    var _this;
    _classCallCheck(this, ConduitCollection);
    _this = ConduitCollection_callSuper(this, ConduitCollection, [logId]);
    /**
     * @private
     *
     * The listener for the "message" event on the window.  Its job is to
     * identify messages that are intended for a specific Conduit / stream and
     * route them to the correct one.  The most common example of this is when a
     * Router receives a moof/segment from a server, and posts a message to the
     * window.  This listener will route that moof/segment to the proper Conduit.
     *
     * @param {Object} event
     *   The window message event
     *
     * @returns {void}
     */
    _defineProperty(_this, "_routeWindowMessageToTargetConduit", function (event) {
      var clientId = event.data.clientId;
      if (!clientId) {
        // A window message was received that is not related to CLSP
        return;
      }
      _this.logger.debug("Received Window Message event for ".concat(clientId));
      var eventType = event.data.event;
      if (!_this.has(clientId)) {
        var _context, _context2;
        // When the CLSP connection is interupted due to a listener being removed,
        // a fail event is always sent.  It is not necessary to log this as an error
        // in the console, because it is not an error.
        // @todo - the fail event no longer exists (or is it from Paho or
        // something?) - what is the name of the new corresponding event?
        if (eventType === 'fail') {
          return;
        }

        // @todo - use this to detect an externally destroyed iframe
        // if (eventType === 'iframe-onunload') {
        //   console.log(event);
        //   return;
        // }

        // Don't show an error for iovs that have been deleted
        if (includes_default()(_context = _this.deletedConduitClientIds).call(_context, clientId)) {
          _this.logger.warn("Received a message for deleted conduit ".concat(clientId));
          return;
        }
        throw new Error(concat_default()(_context2 = "Unable to route message of type ".concat(eventType, " for Conduit with clientId \"")).call(_context2, clientId, "\".  A Conduit with that clientId does not exist."));
      }

      // Pass the Window Message event to the proper Conduit instance.  All we've
      // done at this point is pass the event to the Conduit that it was intended
      // for.  At this point, the Conduit is responsible for taking the necessary
      // action based on the eventType
      _this.get(clientId).onRouterEvent(eventType, event);
    });
    _this.totalConduitCount = 0;
    _this.conduits = {};
    _this.deletedConduitClientIds = [];
    Paho.register();

    // This is the Window Message listener for EVERY Conduit / Router on the
    // page (assuming you are using the singleton pattern)
    window.addEventListener('message', _this._routeWindowMessageToTargetConduit);
    return _this;
  }
  _inherits(ConduitCollection, _Destroyable);
  return _createClass(ConduitCollection, [{
    key: "create",
    value:
    /**
     * Create a Conduit for a specific stream, and add it to this collection.
     *
     * @returns {Conduit}
     */
    function create(logId, clientId, streamConfiguration, containerElement) {
      var _context3;
      this.logger.debug(concat_default()(_context3 = "creating a conduit with logId ".concat(logId, " and clientId ")).call(_context3, clientId));
      var conduit = Conduit.factory(logId, clientId, streamConfiguration, containerElement);
      this._add(conduit);
      this.totalConduitCount++;
      return conduit;
    }

    /**
     * Add a Conduit instance to this collection.
     *
     * @private
     *
     * @param {Conduit} conduit
     *   The conduit instance to add
     *
     * @returns {this}
     */
  }, {
    key: "_add",
    value: function _add(conduit) {
      var clientId = conduit.clientId;
      this.conduits[clientId] = conduit;
      return this;
    }

    /**
     * Determine whether or not a Conduit with the passed clientId exists in this
     * collection.
     *
     * @param {String} clientId
     *   The clientId of the conduit to find
     *
     * @returns {Boolean}
     *   True if the conduit with the given clientId exists
     *   False if the conduit with the given clientId does not exist
     */
  }, {
    key: "has",
    value: function has(clientId) {
      return Object.prototype.hasOwnProperty.call(this.conduits, clientId);
    }

    /**
     * Get a Conduit with the passed clientId from this collection.
     *
     * @param {String} clientId
     *   The clientId of the conduit instance to get
     *
     * @returns {Conduit|undefined}
     *   If a Conduit with this clientId doest not exist, undefined is returned.
     */
  }, {
    key: "get",
    value: function get(clientId) {
      return this.conduits[clientId];
    }

    /**
     * Remove a conduit instance from this collection and destroy it.
     *
     * @param {String} clientId
     *   The clientId of the conduit to remove and destroy
     *
     * @returns {this}
     */
  }, {
    key: "remove",
    value: (function () {
      var _remove = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(clientId) {
        var conduit;
        return regenerator_default().wrap(function _callee$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              conduit = this.get(clientId);
              if (conduit) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              _context4.next = 5;
              return conduit.destroy();
            case 5:
              delete this.conduits[clientId];
              this.deletedConduitClientIds.push(clientId);
              return _context4.abrupt("return", this);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee, this);
      }));
      function remove(_x) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
    /**
     * Destroy this collection and destroy all conduit instances in it.
     *
     * @returns {void}
     */
    )
  }, {
    key: "_destroy",
    value: (function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        var clientId;
        return regenerator_default().wrap(function _callee2$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              window.removeEventListener('message', this._routeWindowMessageToTargetConduit);
              _context5.t0 = instance_keys_default()((regenerator_default())).call((regenerator_default()), this.conduits);
            case 2:
              if ((_context5.t1 = _context5.t0()).done) {
                _context5.next = 15;
                break;
              }
              clientId = _context5.t1.value;
              _context5.prev = 4;
              _context5.next = 7;
              return this.remove(clientId);
            case 7:
              _context5.next = 13;
              break;
            case 9:
              _context5.prev = 9;
              _context5.t2 = _context5["catch"](4);
              this.logger.error("Error while removing conduit ".concat(clientId, " while destroying"));
              this.logger.error(_context5.t2);
            case 13:
              _context5.next = 2;
              break;
            case 15:
              this.conduits = null;
              this.deletedConduitClientIds = null;
              _context5.next = 19;
              return ConduitCollection_superPropGet(ConduitCollection, "_destroy", this, 3)([]);
            case 19:
            case "end":
              return _context5.stop();
          }
        }, _callee2, this, [[4, 9]]);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }())
  }], [{
    key: "asSingleton",
    value: function asSingleton() {
      if (!collection) {
        collection = ConduitCollection.factory('1');
      }
      return collection;
    }
  }, {
    key: "factory",
    value: function factory(logId) {
      return new ConduitCollection(logId);
    }
  }]);
}(Destroyable);

;// ./src/js/ClspClient/ClspClient.js










function ClspClient_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, ClspClient_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function ClspClient_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (ClspClient_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ClspClient_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }




var ClspClient = /*#__PURE__*/function (_Destroyable) {
  /**
   * @private
   *
   * Create a new CLSP Client
   *
   * @param {String} logId
   *   a string that identifies this router in log messages
   * @param {String} clientId
   *   the guid to be used to construct the topic
   * @param {StreamConfiguration} streamConfiguration
   *   The stream configuration to pull from the CLSP server / SFS
   * @param {Element} containerElement
   *   The container of the video element and where the Conduit's iframe will be
   *   inserted
   */
  function ClspClient(logId, clientId, streamConfiguration, containerElement) {
    var _this;
    _classCallCheck(this, ClspClient);
    _this = ClspClient_callSuper(this, ClspClient, [logId]);
    _this._constructorArgumentsBouncer(clientId, streamConfiguration, containerElement);
    _this.clientId = clientId;
    _this.streamConfiguration = streamConfiguration;
    _this.containerElement = containerElement;
    _this.conduit = ConduitCollection.asSingleton().create(_this.logId, _this.clientId, _this.streamConfiguration, _this.containerElement);
    return _this;
  }
  _inherits(ClspClient, _Destroyable);
  return _createClass(ClspClient, [{
    key: "_constructorArgumentsBouncer",
    value: function _constructorArgumentsBouncer(clientId, streamConfiguration, containerElement) {
      if (!clientId) {
        throw new Error('clientId is required to construct a new Conduit instance.');
      }
      if (!StreamConfiguration.isStreamConfiguration(streamConfiguration)) {
        throw new Error('invalid streamConfiguration passed to Conduit constructor');
      }
      if (!containerElement) {
        throw new Error('containerElement is required to construct a new Conduit instance');
      }
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.isDestroyed) {
                _context.next = 2;
                break;
              }
              throw new Error('Tried to initialize while destroyed');
            case 2:
              _context.next = 4;
              return this.conduit.initialize();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "_destroy",
    value: function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return ConduitCollection.asSingleton().remove(this.clientId);
            case 2:
              this.conduit = null;
              this.streamConfiguration = null;
              this.containerElement = null;
              _context2.next = 7;
              return ClspClient_superPropGet(ClspClient, "_destroy", this, 3)([]);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }()
  }], [{
    key: "factory",
    value:
    /**
     * Create a new CLSP Client
     *
     * @param {String} logId
     *   a string that identifies this router in log messages
     * @param {String} clientId
     *   the guid to be used to construct the topic
     * @param {StreamConfiguration} streamConfiguration
     *   The stream configuration to pull from the CLSP server / SFS
     * @param {Element} containerElement
     *   The container of the video element and where the Conduit's iframe will be
     *   inserted
     */
    function factory(logId, clientId, streamConfiguration, containerElement) {
      return new ClspClient(logId, clientId, streamConfiguration, containerElement);
    }
  }]);
}(Destroyable);
_defineProperty(ClspClient, "events", Conduit.events);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/trim.js
var trim = __webpack_require__(1265);
var trim_default = /*#__PURE__*/__webpack_require__.n(trim);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/url.js
var url = __webpack_require__(6984);
var url_default = /*#__PURE__*/__webpack_require__.n(url);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/weak-map.js
var weak_map = __webpack_require__(7842);
var weak_map_default = /*#__PURE__*/__webpack_require__.n(weak_map);
// EXTERNAL MODULE: ./node_modules/interval-promise/src/index.js
var src = __webpack_require__(2973);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
;// ./src/js/iov/Player/MSE/MediaSourceWrapper.js













function MediaSourceWrapper_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, MediaSourceWrapper_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function MediaSourceWrapper_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (MediaSourceWrapper_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function MediaSourceWrapper_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/**
 * A wrapper for the default browser `window.MediaSource` class
 *
 * @see - https://developers.google.com/web/fundamentals/media/mse/basics
 * @see - https://github.com/nickdesaulniers/netfix/blob/gh-pages/demo/bufferAll.html
 */


var DEFAULT_DURATION = 10;
// Check at this interval to see if the MediaSource is ready
var DEFAULT_IS_READY_INTERVAL = 0.25;
// Give the MediaSource this many seconds to become ready
var DEFAULT_IS_READY_TIMEOUT = 1;
var _MediaSourceWrapper_brand = /*#__PURE__*/new (weak_set_default())();
var _onSourceOpen = /*#__PURE__*/new (weak_map_default())();
var _onSourceEnded = /*#__PURE__*/new (weak_map_default())();
var _onError = /*#__PURE__*/new (weak_map_default())();
var MediaSourceWrapper = /*#__PURE__*/function (_EventEmitter) {
  /**
   * @private
   *
   * Create a new MediaSourceWrapper, which is a wrapper around `window.MediaSource`
   *
   * @param {string|object} logId
   *   a string that identifies this MediaSourceWrapper in log messages
   *   @see - src/js/utils/Destroyable
   */
  function MediaSourceWrapper(logId) {
    var _this;
    _classCallCheck(this, MediaSourceWrapper);
    _this = MediaSourceWrapper_callSuper(this, MediaSourceWrapper, [logId]);
    /**
     * @private
     *
     * Revoke the objectURL that was created for this MediaSource, if it exists.
     * Meant to help with memory management.
     *
     * @returns {void}
     */
    _classPrivateMethodInitSpec(_this, _MediaSourceWrapper_brand);
    /**
     * @private
     *
     * Event listener for the `sourceopen` event.  Broadcasts an event to
     * indicate that this MediaSource is ready.
     *
     * @todo - Does this realy need to be broadcast up?  Is there ever a
     * situation where `sourceopen` will be emitted more than once for a single
     * MediaSource / SourceBuffer?  If not, this event should only be used
     * privately as part of an initialization method.
     *
     * @param {object} event
     *
     * @returns {void}
     */
    _classPrivateFieldInitSpec(_this, _onSourceOpen, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(event) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.waitUntilReady();
            case 3:
              _context.next = 9;
              break;
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              _this.emit(MediaSourceWrapper.events.SOURCE_OPEN_ERROR, {
                error: _context.t0
              });
              return _context.abrupt("return");
            case 9:
              _context.prev = 9;
              // This can only be set when the media source is open.
              // @todo - does this do memory management for us so we don't have
              // to call remove on the buffer, which is expensive?  It seems
              // like it...
              _this.mediaSource.duration = _this.DURATION;
              _context.next = 19;
              break;
            case 13:
              _context.prev = 13;
              _context.t1 = _context["catch"](9);
              _this.logger.error("Error while setting mediaSource duration to \"".concat(_this.DURATION, "\""));
              _this.logger.error(_context.t1);
              _this.emit(MediaSourceWrapper.events.SOURCE_OPEN_ERROR, {
                error: _context.t1
              });
              return _context.abrupt("return");
            case 19:
              _this.emit(MediaSourceWrapper.events.SOURCE_OPEN, event);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 5], [9, 13]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    /**
     * @private
     *
     * Event listener for the `sourceended` event.  Broadcasts an event to
     * indicate that this MediaSource is finished.
     *
     * @todo - the `sourceended` event is only supposed to be emitted when
     * `mediaSource.endOfStream` is called, which is only ever done inside this
     * class.  This means we should always be in control of when this event
     * occurs, and shouldn't need to broadcast it up.  Is there some other
     * condition which could cause this to be emitted?
     *
     * @param {object} event
     *
     * @returns {void}
     */
    _classPrivateFieldInitSpec(_this, _onSourceEnded, function (event) {
      _this.emit(MediaSourceWrapper.events.SOURCE_ENDED, event);
    });
    /**
     * @private
     *
     * Event listener for the `error` event.  Broadcasts an event to indicate
     * that this MediaSource has encountered an unexpected error.
     *
     * @param {object} event
     *
     * @returns {void}
     */
    _classPrivateFieldInitSpec(_this, _onError, function (event) {
      _this.emit(MediaSourceWrapper.events.ERROR, event);
    });
    _this.mediaSource = new window.MediaSource();

    // @todo - no idea what could cause this situation...
    if (!_this.mediaSource) {
      throw new Error('The video element or mediaSource is not ready!');
    }
    _this.mediaSource.addEventListener('sourceopen', _classPrivateFieldGet(_onSourceOpen, _this));
    _this.mediaSource.addEventListener('sourceended', _classPrivateFieldGet(_onSourceEnded, _this));
    _this.mediaSource.addEventListener('error', _classPrivateFieldGet(_onError, _this));
    _this.objectURL = null;
    _this.DURATION = DEFAULT_DURATION;
    _this.IS_READY_INTERVAL = DEFAULT_IS_READY_INTERVAL;
    _this.IS_READY_TIMEOUT = DEFAULT_IS_READY_TIMEOUT;
    return _this;
  }

  /**
   * Determine if this MediaSource is ready to start using any SourceBuffers
   * it might have.
   *
   * @returns {boolean}
   *   - true if readyState is "open"
   *   - false if readyState is not "open"
   */
  _inherits(MediaSourceWrapper, _EventEmitter);
  return _createClass(MediaSourceWrapper, [{
    key: "isReady",
    value: function isReady() {
      if (this.isDestroyComplete) {
        return false;
      }

      // found when stress testing many videos, it is possible for the
      // media source ready state not to be open even though
      // source open callback is being called.
      return this.mediaSource.readyState === 'open';
    }

    /**
     * @async
     *
     * Wait for this MediaSource to become ready.
     *
     * @returns {void}
     */
  }, {
    key: "waitUntilReady",
    value: (function () {
      var _waitUntilReady = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
        var _this2 = this;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.isDestroyComplete) {
                _context3.next = 2;
                break;
              }
              throw new Error('MediaSource will not become ready because it has already been destroyed');
            case 2:
              if (!this.isReady()) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              _context3.next = 6;
              return src_default()(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(iteration, stop) {
                  return regenerator_default().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (_this2.isReady()) {
                          stop();
                        }
                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x2, _x3) {
                  return _ref2.apply(this, arguments);
                };
              }(), this.IS_READY_INTERVAL * 1000, {
                iterations: this.IS_READY_TIMEOUT / this.IS_READY_INTERVAL
              });
            case 6:
              if (this.isReady()) {
                _context3.next = 8;
                break;
              }
              throw new Error('MediaSource `readyState` timed out waiting to be `open`!');
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function waitUntilReady() {
        return _waitUntilReady.apply(this, arguments);
      }
      return waitUntilReady;
    }()
    /**
     * Create the objectURL for this MediaSource that is needed to play a stream
     * using an HTML5 `<video>` tag.
     *
     * @see - https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
     *
     * @returns {DOMString|string}
     *   The objectURL that can be set as the `<video>` tag's `src` attribute
     */
    )
  }, {
    key: "asObjectURL",
    value: function asObjectURL() {
      if (this.isDestroyed) {
        throw new Error('Cannot create objectURL while destroyed');
      }
      if (!this.objectURL) {
        // Since the value returned by `createObjectURL` appears to be retained
        // by the `document`, only create one for this instance to reduce the
        // chance of it creating a memory leak.
        this.objectURL = url_default().createObjectURL(this.mediaSource);
      }
      return this.objectURL;
    }
  }, {
    key: "_destroy",
    value: function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4() {
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.mediaSource.removeEventListener('sourceopen', _classPrivateFieldGet(_onSourceOpen, this));
              this.mediaSource.removeEventListener('sourceended', _classPrivateFieldGet(_onSourceEnded, this));
              this.mediaSource.removeEventListener('error', _classPrivateFieldGet(_onError, this));
              _context4.prev = 3;
              _context4.next = 6;
              return this.waitUntilReady();
            case 6:
              // `endOfStream` can only be called when the mediaSource is ready
              this.mediaSource.endOfStream();
              _context4.next = 13;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](3);
              this.logger.info('MediaSource did not become ready while destroying, continuing destroy anyway...');
              this.logger.info(_context4.t0);
            case 13:
              // @todo - can this be done in the SourceBuffer destroy?
              // @todo - if the destroy logic was more properly implemented, this could
              // be done elsewhere...
              _assertClassBrand(_MediaSourceWrapper_brand, this, _removeAllSourceBuffers).call(this);
              // this.mediaSource.removeSourceBuffer(this.sourceBuffer.sourceBuffer);

              _assertClassBrand(_MediaSourceWrapper_brand, this, _revokeObjectURL).call(this);
              _context4.next = 17;
              return MediaSourceWrapper_superPropGet(MediaSourceWrapper, "_destroy", this, 3)([]);
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 9]]);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }()
  }], [{
    key: "isMimeCodecSupported",
    value:
    /**
     * Check to see if the passed mimeCodec is supported by this browser.
     *
     * @see - https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/isTypeSupported
     *
     * @param {string} mimeCodec
     *   The mime code to check for support / compatibility
     *
     * @returns {boolean}
     *   - true if the mimeCodec is supported
     *   - false if the mimeCodec is not supported
     */
    function isMimeCodecSupported(mimeCodec) {
      if (!mimeCodec) {
        return false;
      }
      return window.MediaSource.isTypeSupported(mimeCodec);
    }

    /**
     * Create a new MediaSourceWrapper, which is a wrapper around `window.MediaSource`
     *
     * @param {string|object} logId
     *   a string that identifies this MediaSource in log messages
     *   @see - src/js/utils/Destroyable
     */
  }, {
    key: "factory",
    value: function factory(logId) {
      return new MediaSourceWrapper(logId);
    }
  }]);
}(EventEmitter);
function _revokeObjectURL() {
  if (this.objectURL) {
    url_default().revokeObjectURL(this.objectURL);
  }
  this.objectURL = null;
}
/**
 * @private
 * @deprecated
 *
 * Intended to clear all SourceBuffers from this MediaSource.  We should not
 * need to do this since we are supposed to only have a single SourceBuffer
 * that is privately managed (by the MSEWrapper).
 *
 * @see - https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/sourceBuffers
 *
 * @returns {void}
 */
function _removeAllSourceBuffers() {
  var sourceBuffers = this.mediaSource.sourceBuffers;
  if (sourceBuffers.SourceBuffers) {
    sourceBuffers = sourceBuffers.SourceBuffers();
  }
  for (var i = 0; i < sourceBuffers.length; i++) {
    var sourceBuffer = sourceBuffers[i];
    this.mediaSource.removeSourceBuffer(sourceBuffer);
  }
}
/**
 * Events that are emitted by this MediaSourceWrapper
 */
_defineProperty(MediaSourceWrapper, "events", {
  // --- Custom events
  SOURCE_OPEN_ERROR: 'source-open-error',
  // --- MSE MediaSource events
  // @todo - create an event name that makes sense in layman's terms, such
  // as "INITIALIZED" either here or in MSEWrapper
  SOURCE_OPEN: 'sourceopen',
  // @todo - create an event name that makes sense in layman's terms, such
  // as "FINISHED" either here or in MSEWrapper
  SOURCE_ENDED: 'sourceended',
  ERROR: 'error'
});

;// ./src/js/iov/Player/MSE/SourceBuffer.js


















function SourceBuffer_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, SourceBuffer_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function SourceBuffer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (SourceBuffer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function SourceBuffer_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function SourceBuffer_classPrivateFieldInitSpec(e, t, a) { SourceBuffer_checkPrivateRedeclaration(e, t), t.set(e, a); }
function SourceBuffer_checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function SourceBuffer_classPrivateFieldGet(s, a) { return s.get(SourceBuffer_assertClassBrand(s, a)); }
function SourceBuffer_assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/**
 * A wrapper for the default browser `window.SourceBuffer` class
 *
 * @see - https://developers.google.com/web/fundamentals/media/mse/basics
 * @see - https://github.com/nickdesaulniers/netfix/blob/gh-pages/demo/bufferAll.html
 */




// This is the original error text, but it is subject to change by chrome,
// and we are only checking the part of the error text that contains no
// punctuation (and is all lower case).
// "Failed to execute 'appendBuffer' on 'SourceBuffer': The SourceBuffer is full,
// and cannot free space to append additional buffers.";
var FULL_BUFFER_ERROR = 'and cannot free space to append additional buffers';

// Check at this interval to see if the SourceBuffer is ready
var SourceBuffer_DEFAULT_IS_READY_INTERVAL = 0.25;
// Give the SourceBuffer this many seconds to become ready
var SourceBuffer_DEFAULT_IS_READY_TIMEOUT = 10;
var DEFAULT_DRIFT_THRESHOLD = 2;
var DEFAULT_BUFFER_TRUNCATE_FACTOR = 2;
var _onUpdateEnd = /*#__PURE__*/new (weak_map_default())();
var SourceBuffer_onError = /*#__PURE__*/new (weak_map_default())();
var SourceBuffer = /*#__PURE__*/function (_EventEmitter) {
  /**
   * @private
   *
   * Create a new SourceBuffer, which is a wrapper around `window.SourceBuffer`
   *
   * @param {string|object} logId
   *   a string that identifies this SourceBuffer in log messages
   *   @see - src/js/utils/Destroyable
   * @param {string} mimeCodec
   *   The mime codec of the stream
   * @param {MediaSource} mediaSource
   *   The MediaSource instance to which this SourceBuffer instance will be
   *   added
   */
  function SourceBuffer(logId, mimeCodec, mediaSource) {
    var _this;
    _classCallCheck(this, SourceBuffer);
    _this = SourceBuffer_callSuper(this, SourceBuffer, [logId]);
    _defineProperty(_this, "mimeCodec", null);
    _defineProperty(_this, "mediaSource", null);
    _defineProperty(_this, "sourceBuffer", null);
    _defineProperty(_this, "timeBuffered", null);
    /**
     * Event listener for the `updateend` event from the window.SourceBuffer
     * instance
     *
     * @param {objec} event
     */
    SourceBuffer_classPrivateFieldInitSpec(_this, _onUpdateEnd, function (event) {
      if (_this.isDestroyComplete) {
        throw new Error('Received `updateend` event while destroyed!');
      }
      if (_this.shouldAbortOnNextUpdateEnd) {
        try {
          _this.metric('sourceBuffer.abort', 1);
          _this.sourceBuffer.abort();
          _this.shouldAbortOnNextUpdateEnd = false;
        } catch (error) {
          _this.metric('error.sourceBuffer.abort', 1);
          _this.emit(SourceBuffer.events.ABORT_ERROR, {
            error: error
          });
        }
      }
      try {
        // Sometimes the mediaSource is removed while an update is being
        // processed, resulting in an error when trying to read the
        // "buffered" property.
        if (_this.sourceBuffer.buffered.length <= 0) {
          _this.metric('sourceBuffer.updateEnd.bufferLength.empty', 1);
          _this.logger.debug('After updating, the sourceBuffer has no length!');
          return;
        }
      } catch (error) {
        // @todo - do we need to handle this?
        _this.metric('sourceBuffer.updateEnd.bufferLength.error', 1);
        _this.logger.debug('The mediaSource was removed while an update operation was occurring.');
        return;
      }
      _this.emit(SourceBuffer.events.UPDATE_END, event);
    });
    /**
     * Event listener for the `error` event from the window.SourceBuffer instance
     *
     * @param {objec} event
     */
    SourceBuffer_classPrivateFieldInitSpec(_this, SourceBuffer_onError, function (event) {
      _this.emit(SourceBuffer.events.ERROR, event);
    });
    if (!mimeCodec) {
      throw new Error('`mimeCodec` is required to instantiate a SourceBuffer');
    }
    if (!mediaSource) {
      throw new Error('`mediaSource` is required to instantiate a SourceBuffer');
    }
    _this.mimeCodec = mimeCodec;
    _this.mediaSource = mediaSource;
    // @todo - should the MediaSource be responsible for this?
    _this.sourceBuffer = _this.mediaSource.mediaSource.addSourceBuffer(_this.mimeCodec);
    _this.sourceBuffer.mode = 'sequence';
    _this.sourceBuffer.addEventListener('updateend', SourceBuffer_classPrivateFieldGet(_onUpdateEnd, _this));
    _this.sourceBuffer.addEventListener('error', SourceBuffer_classPrivateFieldGet(SourceBuffer_onError, _this));
    _this.IS_READY_INTERVAL = SourceBuffer_DEFAULT_IS_READY_INTERVAL;
    _this.IS_READY_TIMEOUT = SourceBuffer_DEFAULT_IS_READY_TIMEOUT;
    _this.DRIFT_THRESHOLD = DEFAULT_DRIFT_THRESHOLD;
    _this.BUFFER_SIZE_LIMIT = SourceBuffer.getDefaultBufferSizeLimit();
    _this.BUFFER_TRUNCATE_VALUE = parse_int_default()(_this.BUFFER_SIZE_LIMIT / DEFAULT_BUFFER_TRUNCATE_FACTOR);
    return _this;
  }

  /**
   * Determine if this SourceBuffer is ready to start accepting video segments.
   *
   * @returns {boolean}
   *   - true if readyState is "open"
   *   - false if readyState is not "open"
   */
  _inherits(SourceBuffer, _EventEmitter);
  return _createClass(SourceBuffer, [{
    key: "isReady",
    value: function isReady() {
      if (this.isDestroyComplete) {
        return false;
      }
      return this.sourceBuffer.updating === false;
    }

    /**
     * @async
     *
     * Wait for this SourceBuffer to become ready.
     *
     * @returns {void}
     */
  }, {
    key: "waitUntilReady",
    value: (function () {
      var _waitUntilReady = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _this2 = this;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.isDestroyComplete) {
                _context2.next = 2;
                break;
              }
              throw new Error('SourceBuffer will not become ready because it has already been destroyed');
            case 2:
              if (!this.isReady()) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              _context2.next = 6;
              return src_default()(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(iteration, stop) {
                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (_this2.isReady()) {
                          stop();
                        }
                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }(), this.IS_READY_INTERVAL * 1000, {
                iterations: this.IS_READY_TIMEOUT / this.IS_READY_INTERVAL
              });
            case 6:
              if (this.isReady()) {
                _context2.next = 8;
                break;
              }
              throw new Error('SourceBuffer `updating` timed out!');
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function waitUntilReady() {
        return _waitUntilReady.apply(this, arguments);
      }
      return waitUntilReady;
    }()
    /**
     * Append a video segment to the MSE SourceBuffer's internal buffer, which
     * will then display it as video in the browser.
     *
     * @param {object} queuedVideoSegment
     *   The video segment from the MSE queue that is to be shown
     */
    )
  }, {
    key: "append",
    value: function append(queuedVideoSegment) {
      if (this.isDestroyComplete) {
        return;
      }
      this.logger.silly('Appending to the sourceBuffer...');
      var timestamp = queuedVideoSegment.timestamp,
        byteArray = queuedVideoSegment.byteArray;
      var estimatedDrift = (now_default()() - timestamp) / 1000;
      if (estimatedDrift > this.DRIFT_THRESHOLD) {
        this.emit(SourceBuffer.events.DRIFT_THRESHOLD_EXCEEDED, {
          estimatedDrift: estimatedDrift,
          driftThreshold: this.DRIFT_THRESHOLD
        });
        return;
      }
      this.logger.silly("Appending to the buffer with an estimated drift of ".concat(estimatedDrift));

      // this.metric('sourceBuffer.append', 1);

      try {
        // never encountered this block but docs say you shouldn't append when the sourcebuffer is  updating
        if (this.sourceBuffer.updating) {
          this.logger.warn('Source buffer is still updating! Cannot append!');
          return;
        }
        this.sourceBuffer.appendBuffer(byteArray);
      } catch (error) {
        // This try block accounts for the possibility that the clear operation
        // throws.
        try {
          var _context3;
          if (error.message && includes_default()(_context3 = error.message.toLowerCase()).call(_context3, FULL_BUFFER_ERROR)) {
            // @todo - make this a valid metric
            // this.metric('error.sourceBuffer.filled', 1);

            // If the buffer is full, we will flush it
            this.logger.warn('source buffer is full, about to flush it...');
            this.clear();
          } else {
            throw error;
          }
        } finally {
          this.metric('error.sourceBuffer.append', 1);
        }
      }
    }

    /**
     * Schedule an abort for the next possible time.
     *
     * @returns {void}
     */
  }, {
    key: "abort",
    value: function abort() {
      this.shouldAbortOnNextUpdateEnd = true;
    }

    /** Detect a gap in the buffered time ranges */
  }, {
    key: "gapInBufferedRanges",
    value: function gapInBufferedRanges(rangeIndex) {
      var bufferedRanges = this.sourceBuffer.buffered;

      // only a single range present or last range
      if (bufferedRanges.length <= 1 || rangeIndex + 1 === bufferedRanges.length) {
        return false;
      }
      var currentEnd = bufferedRanges.end(rangeIndex);
      var nextStart = bufferedRanges.start(rangeIndex + 1);

      // compare against the next range and see if there's a hole
      var gap = nextStart - currentEnd;
      if (gap > 0) {
        return true;
      }
      return false;
    }

    /**
     * Calculate size and time information about the current state of the buffer.
     *
     * @todo - provide better description
     */
  }, {
    key: "getTimes",
    value: function getTimes() {
      if (this.isDestroyComplete) {
        return null;
      }
      this.logger.silly('getBufferTimes...');
      var bufferTimesAry = [];
      try {
        var previousBufferSize = this.timeBuffered;
        var bufferedRanges = this.sourceBuffer.buffered;
        this.logger.debug('this.sourceBuffer.buffered length: ' + bufferedRanges.length);
        for (var i = 0; i < bufferedRanges.length; i++) {
          var _context4, _context5;
          this.logger.info(concat_default()(_context4 = concat_default()(_context5 = "Range ".concat(i, ": ")).call(_context5, bufferedRanges.start(i), " to ")).call(_context4, bufferedRanges.end(i), " seconds"));
          var bufferTimeStart = bufferedRanges.start(i);
          var bufferTimeEnd = bufferedRanges.end(i);
          var currentBufferSize = bufferTimeEnd - bufferTimeStart;
          bufferTimesAry.push({
            previousBufferSize: previousBufferSize,
            currentBufferSize: currentBufferSize,
            bufferTimeStart: bufferTimeStart,
            bufferTimeEnd: bufferTimeEnd
          });
        }
        var lastRange = bufferedRanges.length - 1;
        this.timeBuffered = bufferedRanges.end(lastRange) - bufferedRanges.start(lastRange);
        this.logger.silly('getBufferTimes finished successfully...');
        return bufferTimesAry;
      } catch (error) {
        this.logger.info('Failed to getBufferTimes...');
        return null;
      }
    }

    /**
     * Trim the SourceBuffer to help with memory management and to help keep the
     * video stream near-real time (?)
     *
     * @todo - under what circumstances should this be called?  Right now, it is
     * called after EVERY UPDATE_END event!  Is that correct / necessary? Maybe
     * it should only be called every other time, or every 5th time...
     *
     * @param {object[]|null} info
     *   optional, SourceBuffer time info
     * @param {boolean} shouldClear
     *   optional, defaults to false
     *   if true, will clear the entire SourceBuffer's internal buffer
     */
  }, {
    key: "trim",
    value: function trim() {
      var timeRanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getTimes();
      var shouldClear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.isDestroyComplete) {
        return;
      }
      this.logger.debug('time buffered: ' + this.timeBuffered);
      if (!timeRanges || timeRanges.length === 0) {
        this.logger.debug('Tried to trim buffer, failed to get buffer times...');
        return;
      }
      var firstTimeRange = timeRanges.shift();
      this.logger.silly('trimBuffer...');
      this.metric('sourceBuffer.lastKnownBufferSize', this.timeBuffered);
      var shouldTrim = shouldClear || this.timeBuffered > this.BUFFER_SIZE_LIMIT;
      if (!shouldTrim) {
        this.logger.debug('No need to trim');
        return;
      }

      // @todo - should we wait for isReady here?
      if (!this.isReady()) {
        this.logger.info('Need to trim, but not ready...');
        return;
      }
      try {
        // @todo - Trimming is the biggest performance problem we have with this
        // player. Can you figure out how to manage the memory usage without
        // causing the streams to stutter?
        this.metric('sourceBuffer.trim', this.BUFFER_TRUNCATE_VALUE);
        if (shouldClear) {
          this.logger.debug('Clearing buffer...');
          this.sourceBuffer.remove(firstTimeRange.bufferTimeStart, Infinity);
          this.logger.debug('Successfully cleared buffer...');
        } else {
          var trimEndTime = firstTimeRange.bufferTimeStart + this.BUFFER_TRUNCATE_VALUE;
          this.logger.debug('Trimming buffer...');
          this.sourceBuffer.remove(firstTimeRange.bufferTimeStart, trimEndTime);
          this.logger.debug('Successfully trimmed buffer...');
        }
      } catch (error) {
        if (error.constructor.name === 'DOMException') {
          this.logger.info('Encountered DOMException while trying to trim buffer');
          // @todo - every time the mseWrapper is destroyed, there is a
          // sourceBuffer error.  No need to log that, but you should fix it
          return;
        }
        this.logger.debug('trimBuffer failure!');
        throw error;
      }
    }

    /**
     * Completely clear / flush the SourceBuffer's internal buffer.
     *
     * To be called when the buffer is full, prior to the destruction of the
     * parent MediaSource, and during destruction of this SourceBuffer.
     *
     * @todo - it would be better if we could either destroy the SourceBuffer
     * before destroying the parent MediaSource...
     */
  }, {
    key: "clear",
    value: function clear() {
      var _context6;
      this.logger.info('Clearing buffer...');
      trim_default()(_context6 = this).call(_context6, undefined, true);
    }
  }, {
    key: "metric",
    value:
    // @todo @metrics
    function metric() {}
  }, {
    key: "_destroy",
    value: function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
        var _this3 = this;
        return regenerator_default().wrap(function _callee3$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return new (core_js_stable_promise_default())(function (resolve, reject) {
                var _finish = function finish() {
                  _this3.sourceBuffer.removeEventListener('updateend', _finish);
                  resolve();
                };
                if (!_this3.sourceBuffer) {
                  return resolve();
                }
                _this3.sourceBuffer.addEventListener('updateend', _finish);
                _this3.abort();

                // @todo - this is a hack - sometimes, the trimBuffer operation does not cause an update
                // on the sourceBuffer.  This acts as a timeout to ensure the destruction of this mseWrapper
                // instance can complete.
                _this3.logger.debug('giving sourceBuffer some time to finish updating itself...');
                set_timeout_default()(_finish, 1000);
              });
            case 2:
              try {
                this.clear();
              } catch (error) {
                this.logger.error('Error while clearing the buffer while destroying, continuing destroy anyway...');
                this.logger.error(error);
              }
              this.sourceBuffer.removeEventListener('updateend', SourceBuffer_classPrivateFieldGet(_onUpdateEnd, this));
              this.sourceBuffer.removeEventListener('error', SourceBuffer_classPrivateFieldGet(SourceBuffer_onError, this));

              // this.mediaSource.mediaSource.removeSourceBuffer(this.sourceBuffer);

              this.mimeCodec = null;
              this.mediaSource = null;
              this.sourceBuffer = null;
              this.timeBuffered = null;
              _context7.next = 11;
              return SourceBuffer_superPropGet(SourceBuffer, "_destroy", this, 3)([]);
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee3, this);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }()
  }], [{
    key: "getDefaultBufferSizeLimit",
    value: function getDefaultBufferSizeLimit() {
      // These default buffer values provide the best results in my testing.
      // It keeps the memory usage as low as is practical, and rarely causes
      // the video to stutter.
      return 90 + Math.floor(Math.random() * 200);
    }

    /**
     * Create a new SourceBuffer, which is a wrapper around `window.SourceBuffer`
     *
     * @param {string|object} logId
     *   a string that identifies this SourceBuffer in log messages
     *   @see - src/js/utils/Destroyable
     * @param {string} mimeCodec
     *   The mime codec of the stream
     * @param {MediaSource} mediaSource
     *   The MediaSource instance to which this SourceBuffer instance will be
     *   added
     */
  }, {
    key: "factory",
    value: function factory(logId, mimeCodec, mediaSource) {
      return new SourceBuffer(logId, mimeCodec, mediaSource);
    }
  }]);
}(EventEmitter);
/**
 * Events that are emitted by this SourceBuffer
 */
_defineProperty(SourceBuffer, "events", {
  // --- Custom Events
  ABORT_ERROR: 'abort-error',
  DRIFT_THRESHOLD_EXCEEDED: 'drift-threshold-exceeded',
  // --- MSE Source Buffer Events
  // @todo - create an event name that makes sense in layman's terms, such
  // as "???" either here or in MSEWrapper
  UPDATE_END: 'updateend',
  ERROR: 'error'
});

;// ./src/js/iov/Player/MSE/MSEWrapper.js









var _MSEWrapper;





function MSEWrapper_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, MSEWrapper_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function MSEWrapper_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (MSEWrapper_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function MSEWrapper_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function MSEWrapper_classPrivateMethodInitSpec(e, a) { MSEWrapper_checkPrivateRedeclaration(e, a), a.add(e); }
function MSEWrapper_checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function MSEWrapper_assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/**
 * An orchestrator of MediaSources and Sourcebuffers.
 *
 * @see - https://developers.google.com/web/fundamentals/media/mse/basics
 * @see - https://github.com/nickdesaulniers/netfix/blob/gh-pages/demo/bufferAll.html
 */





// import { mp4toJSON } from './mp4-inspect';

var DEFAULT_APPENDS_WITH_SAME_TIME_END_THRESHOLD = 1;
var _MSEWrapper_brand = /*#__PURE__*/new (weak_set_default())();
var MSEWrapper = /*#__PURE__*/function (_EventEmitter) {
  /**
   * @private
   *
   * Create a new SourceBuffer, which is a wrapper around `window.SourceBuffer`
   *
   * @param {string|object} logId
   *   a string that identifies this SourceBuffer in log messages
   *   @see - src/js/utils/Destroyable
   */
  function MSEWrapper(logId) {
    var _this;
    _classCallCheck(this, MSEWrapper);
    _this = MSEWrapper_callSuper(this, MSEWrapper, [logId]);
    MSEWrapper_classPrivateMethodInitSpec(_this, _MSEWrapper_brand);
    _this.segmentQueue = [];
    _this.sequenceNumber = 0;
    _this.mediaSource = null;
    _this.sourceBuffer = null;
    _this.appendsSinceTimeEndUpdated = 0;

    // @todo @metrics
    // this.metrics = {};

    _this.APPENDS_WITH_SAME_TIME_END_THRESHOLD = DEFAULT_APPENDS_WITH_SAME_TIME_END_THRESHOLD;
    return _this;
  }
  _inherits(MSEWrapper, _EventEmitter);
  return _createClass(MSEWrapper, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
        var _this2 = this;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.isDestroyed) {
                _context.next = 2;
                break;
              }
              throw new Error('Tried to initialize while destroyed');
            case 2:
              this.metric('mediaSource.created', 1);

              // Kill the existing media source
              _context.next = 5;
              return this.destroyMediaSource();
            case 5:
              this.mediaSource = MediaSourceWrapper.factory(this.logId);
              this.mediaSource.on(MediaSourceWrapper.events.ERROR, function (event) {
                _this2.emit(MSEWrapper.events.MEDIA_SOURCE_ERROR, event);
              });
              if (this.sourceBuffer) {
                this.sourceBuffer.abort();
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "initializeSourceBuffer",
    value: function () {
      var _initializeSourceBuffer = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(mimeCodec) {
        var _this3 = this;
        return regenerator_default().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.isDestroyed) {
                _context3.next = 2;
                break;
              }
              throw new Error('Tried to initialize source buffer while destroyed');
            case 2:
              this.logger.info('initializeSourceBuffer...');
              _context3.prev = 3;
              _context3.next = 6;
              return this.mediaSource.waitUntilReady();
            case 6:
              _context3.next = 12;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](3);
              this.logger.error('Cannot create the sourceBuffer if the mediaSource is not ready.');
              throw _context3.t0;
            case 12:
              if (!this.sourceBuffer) {
                _context3.next = 15;
                break;
              }
              _context3.next = 15;
              return this.sourceBuffer.destroy();
            case 15:
              this.sourceBuffer = SourceBuffer.factory(this.logId, mimeCodec, this.mediaSource);
              this.metric('sourceBuffer.created', 1);
              this.sourceBuffer.on(SourceBuffer.events.ERROR, function (event) {
                _this3.emit(MSEWrapper.events.SOURCE_BUFFER_ERROR, event);
              });
              this.sourceBuffer.on(SourceBuffer.events.UPDATE_END, function (event) {
                MSEWrapper_assertClassBrand(_MSEWrapper_brand, _this3, _onSourceBufferUpdateEnd).call(_this3);
              });
              this.sourceBuffer.on(SourceBuffer.events.DRIFT_THRESHOLD_EXCEEDED, function (event) {
                var _context2;
                var estimatedDrift = event.estimatedDrift,
                  driftThreshold = event.driftThreshold;
                _this3.logger.info(concat_default()(_context2 = "Estimated drift of ".concat(estimatedDrift, " is above the ")).call(_context2, driftThreshold, " threshold.  Flushing queue..."));

                // @todo - perhaps we should re-add the last segment to the queue with a fresh
                // timestamp?  I think one cause of stream freezing is the sourceBuffer getting
                // starved, but I don't know if that's correct
                MSEWrapper_assertClassBrand(_MSEWrapper_brand, _this3, _flushQueue).call(_this3);
              });
              this.sourceBuffer.on(SourceBuffer.events.ABORT_ERROR, function (_ref) {
                var error = _ref.error;
                // @todo - what do we do here?
                _this3.logger.error('Error while aborting SourceBuffer!');
                _this3.logger.error(error);
              });
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this, [[3, 8]]);
      }));
      function initializeSourceBuffer(_x) {
        return _initializeSourceBuffer.apply(this, arguments);
      }
      return initializeSourceBuffer;
    }()
  }, {
    key: "appendMoov",
    value: function appendMoov(moov) {
      if (this.isDestroyed) {
        return;
      }
      this.logger.info('appendMoov');
      if (!moov) {
        throw new Error('Must provide a moov to append!');
      }
      this.metric('sourceBuffer.lastMoovSize', moov.length);

      // console.log(mp4toJSON(moov));

      this.metric('queue.appendMoov', 1);
      MSEWrapper_assertClassBrand(_MSEWrapper_brand, this, _queueSegment).call(this, moov);

      // This may throw - the caller must catch the error
      MSEWrapper_assertClassBrand(_MSEWrapper_brand, this, _processNextInQueue).call(this);
    }

    /**
     *
     * @param {*} videoSegment
     *   The moof / bytearray
     */
  }, {
    key: "showVideoSegment",
    value: function showVideoSegment(videoSegment) {
      if (this.isDestroyed) {
        return;
      }
      this.logger.silly('showVideoSegment');
      if (!videoSegment) {
        throw new Error('Must provide a moof to append!');
      }
      this.metric('sourceBuffer.lastMoofSize', videoSegment.length);

      // console.log(mp4toJSON(videoSegment));

      this.metric('queue.append', 1);
      MSEWrapper_assertClassBrand(_MSEWrapper_brand, this, _queueSegment).call(this, MSEWrapper_assertClassBrand(_MSEWrapper_brand, this, _formatMoof).call(this, videoSegment));
      this.sequenceNumber++;

      // This may throw - the caller must catch the error
      MSEWrapper_assertClassBrand(_MSEWrapper_brand, this, _processNextInQueue).call(this);
    }
  }, {
    key: "destroyMediaSource",
    value: // @todo - this logic needs to be consolidated into MediaSource or
    // SourceBuffer
    function () {
      var _destroyMediaSource = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.mediaSource) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              this.metric('sourceBuffer.destroyed', 1);
              this.logger.info('Destroying mediaSource...');
              try {
                if (this.sourceBuffer) {
                  // We must do this PRIOR to the sourceBuffer being destroyed, to ensure that the
                  // 'buffered' property is still available, which is necessary for completely
                  // emptying the sourceBuffer.
                  this.sourceBuffer.clear();
                }
              } catch (error) {
                MSEWrapper_assertClassBrand(_MSEWrapper_brand, this, _onSourceBufferTrimError).call(this, error);
              }
              _context4.prev = 5;
              if (!this.sourceBuffer) {
                _context4.next = 9;
                break;
              }
              _context4.next = 9;
              return this.sourceBuffer.waitUntilReady();
            case 9:
              _context4.next = 15;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](5);
              this.logger.error('Error: sourceBuffer did not become ready, going to try to destry mediasource anyway!');
              this.logger.error(_context4.t0);
            case 15:
              _context4.next = 17;
              return this.mediaSource.destroy();
            case 17:
              if (this.sourceBuffer) {
                // @todo - is this happening at the right time, or should it happen
                // prior to removing the source buffers?
                this.sourceBuffer.abort();
              }
              this.metric('mediaSource.destroyed', 1);
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee3, this, [[5, 11]]);
      }));
      function destroyMediaSource() {
        return _destroyMediaSource.apply(this, arguments);
      }
      return destroyMediaSource;
    }() // @todo @metrics
  }, {
    key: "metric",
    value: function metric(type, value) {
      // if (!this.options || !this.options.enableMetrics) {
      //   return;
      // }

      // if (!MSEWrapper.METRIC_TYPES.includes(type)) {
      //   // @todo - should this throw?
      //   return;
      // }

      // switch (type) {
      //   case 'sourceBuffer.lastKnownBufferSize':
      //   case 'sourceBuffer.lastMoofSize': {
      //     this.metrics[type] = value;
      //     break;
      //   }
      //   default: {
      //     if (!Object.prototype.hasOwnProperty.call(this.metrics, type)) {
      //       this.metrics[type] = 0;
      //     }

      //     this.metrics[type] += value;
      //   }
      // }

      // this.trigger('metric', {
      //   type,
      //   value: this.metrics[type],
      // });
    }
  }, {
    key: "_destroy",
    value: function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4() {
        return regenerator_default().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return this.destroyMediaSource();
            case 3:
              _context5.next = 9;
              break;
            case 5:
              _context5.prev = 5;
              _context5.t0 = _context5["catch"](0);
              this.logger.error('Error while destroying mediaSource while destroying!');
              this.logger.error(_context5.t0);
            case 9:
              _context5.prev = 9;
              _context5.next = 12;
              return this.sourceBuffer.destroy();
            case 12:
              _context5.next = 18;
              break;
            case 14:
              _context5.prev = 14;
              _context5.t1 = _context5["catch"](9);
              this.logger.error('Error while destroying sourceBuffer while destroying!');
              this.logger.error(_context5.t1);
            case 18:
              // We make NO assumptions here about what instance properties are
              // needed during the asynchronous destruction of the source buffer,
              // therefore we wait until it is finished to free all of these
              // resources.
              this.mediaSource = null;
              this.sourceBuffer = null;
              this.previousTimeEnd = null;
              this.segmentQueue = null;

              // @todo @metrics
              // this.metrics = null;
              _context5.next = 24;
              return MSEWrapper_superPropGet(MSEWrapper, "_destroy", this, 3)([]);
            case 24:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this, [[0, 5], [9, 14]]);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }()
  }], [{
    key: "factory",
    value:
    // @todo @metrics
    // static METRIC_TYPES = [
    //   'mediaSource.created',
    //   'mediaSource.destroyed',
    //   'objectURL.created',
    //   'objectURL.revoked',
    //   'mediaSource.reinitialized',
    //   'sourceBuffer.created',
    //   'sourceBuffer.destroyed',
    //   'queue.added',
    //   'queue.removed',
    //   'sourceBuffer.append',
    //   'error.sourceBuffer.append',
    //   'frameDrop.hiddenTab',
    //   'queue.mediaSourceNotReady',
    //   'queue.sourceBufferNotReady',
    //   'queue.shift',
    //   'queue.append',
    //   'sourceBuffer.lastKnownBufferSize',
    //   'sourceBuffer.trim',
    //   'sourceBuffer.trim.error',
    //   'sourceBuffer.updateEnd',
    //   'sourceBuffer.updateEnd.bufferLength.empty',
    //   'sourceBuffer.updateEnd.bufferLength.error',
    //   'sourceBuffer.updateEnd.removeEvent',
    //   'sourceBuffer.updateEnd.appendEvent',
    //   'sourceBuffer.updateEnd.bufferFrozen',
    //   'sourceBuffer.abort',
    //   'error.sourceBuffer.abort',
    //   'sourceBuffer.lastMoofSize',
    // ];

    /**
     * Create a new SourceBuffer, which is a wrapper around `window.SourceBuffer`
     *
     * @param {string|object} logId
     *   a string that identifies this SourceBuffer in log messages
     *   @see - src/js/utils/Destroyable
     */
    function factory(logId) {
      return new MSEWrapper(logId);
    }
  }]);
}(EventEmitter);
_MSEWrapper = MSEWrapper;
function _flushQueue() {
  this.metric('queue.removed', this.segmentQueue.length + 1);
  this.segmentQueue = [];
}
function _queueSegment(videoSegment) {
  if (this.segmentQueue.length) {
    this.logger.debug("Queueing segment.  The queue currently has ".concat(this.segmentQueue.length, " segments."));
  } else {
    this.logger.silly('Queueing segment.  The queue is currently empty.');
  }
  this.metric('queue.added', 1);
  this.segmentQueue.push({
    timestamp: now_default()(),
    byteArray: videoSegment
  });
}
/**
 * The source buffer append operation may throw - it is up to the caller
 * to catch the error!
 */
function _processNextInQueue() {
  if (this.isDestroyed) {
    return;
  }
  this.logger.silly('#processNextInQueue');
  if (utils_default().isDocumentHidden()) {
    this.logger.debug('Tab not in focus - dropping frame...');
    this.metric('frameDrop.hiddenTab', 1);
    this.metric('queue.cannotProcessNext', 1);
    this.segmentQueue.shift();
    return;
  }

  // Do not wait until ready since we're dealing with a live stream
  if (!this.mediaSource.isReady()) {
    this.logger.info('The mediaSource is not ready');
    this.metric('queue.mediaSourceNotReady', 1);
    this.metric('queue.cannotProcessNext', 1);
    this.segmentQueue.shift();
    return;
  }

  // @todo - if the initialization logic was more properly implemented, this
  // check wouldn't be necessary
  if (!this.sourceBuffer) {
    this.logger.info('Tried to play before the SourceBuffer was initialized');
    return;
  }

  // Do not wait until ready since we're dealing with a live stream
  if (!this.sourceBuffer.isReady()) {
    this.logger.debug('The sourceBuffer is not ready');
    this.metric('queue.sourceBufferNotReady', 1);
    this.metric('queue.cannotProcessNext', 1);
    this.segmentQueue.shift();
    return;
  }

  // Only append a videoSegment if there is a videoSegment to append
  if (this.segmentQueue.length > 0) {
    this.logger.silly('appending to source buffer');
    this.metric('queue.shift', 1);
    this.metric('queue.canProcessNext', 1);
    this.sourceBuffer.append(this.segmentQueue.shift());
    return;
  }
  this.logger.debug('No videoSegments in queue');
}
function _formatMoof(moof) {
  // We must overwrite the sequence number locally, because it
  // the sequence that comes from the server will not necessarily
  // start at zero.  It should start from zero locally.  This
  // requirement may have changed with more recent versions of the
  // browser, but it appears to make the video play a little more
  // smoothly
  moof[20] = (this.sequenceNumber & 0xFF000000) >> 24;
  moof[21] = (this.sequenceNumber & 0x00FF0000) >> 16;
  moof[22] = (this.sequenceNumber & 0x0000FF00) >> 8;
  moof[23] = this.sequenceNumber & 0xFF;
  return moof;
}
function _onSourceBufferTrimError(error) {
  this.metric('sourceBuffer.trim.error', 1);

  // observed this fail during a memry snapshot in chrome
  // otherwise no observed failure, so ignore exception.
  this.logger.error('sourceBuffer.remove --> Error while trimming sourceBuffer');
  this.logger.error(error);
}
function _onVideoSegmentShown(info) {
  if (!info) {
    throw new Error('Info must be passed to process video segment shown event!');
  }
  this.logger.silly('On video segment shown...');
  this.metric('sourceBuffer.updateEnd.appendEvent', 1);

  // The current buffer size should always be bigger.If it isn't, there is a problem,
  // and we need to reinitialize or something.  Sometimes the buffer is the same.  This is
  // allowed for consecutive appends, but only a configurable number of times.  The default
  // is 1.  It's possible we don't properly handle time gaps in fragments.
  // This is why the bosch camera has issues when in IBP or IBBP.
  this.logger.debug('Appends with same time end: ' + this.appendsSinceTimeEndUpdated);

  // have seen video moofs with a previousTimeEnd in the sub 1 range 0.034, new segments getting processed,
  // but bufferTimeEnd not incrementing. Might be able to remove this.previousTimeEnd check
  // however we can be less intrusive for now as a check for < 1 to catch the current case that's causing
  // black streams. bufferTimeEnd was not incrementing due to improper handling of multiple TimeRanges
  // if (this.previousTimeEnd == 0 && info.bufferTimeEnd <= this.previousTimeEnd) {
  if (info.bufferTimeEnd <= this.previousTimeEnd) {
    this.logger.info('previoustimeend: ' + this.previousTimeEnd + ', buffertimeend: ' + info.bufferTimeEnd);
    this.appendsSinceTimeEndUpdated += 1;
    this.metric('sourceBuffer.updateEnd.bufferFrozen', 1);

    // append threshold with same time end has been crossed.  Reinitialize frozen stream.
    if (this.appendsSinceTimeEndUpdated > this.APPENDS_WITH_SAME_TIME_END_THRESHOLD) {
      this.logger.warn('Stream frozen. Reinitializing');
      this.emit(_MSEWrapper.events.STREAM_FROZEN);
    }
    return;
  }
  this.appendsSinceTimeEndUpdated = 0;
  this.previousTimeEnd = info.bufferTimeEnd;
  this.emit(_MSEWrapper.events.VIDEO_SEGMENT_SHOWN, {
    info: info
  });
  try {
    var _context6;
    trim_default()(_context6 = this.sourceBuffer).call(_context6);
  } catch (error) {
    MSEWrapper_assertClassBrand(_MSEWrapper_brand, this, _onSourceBufferTrimError).call(this, error);
  }
}
function _onSourceBufferUpdateEnd() {
  this.logger.silly('onUpdateEnd');
  this.metric('sourceBuffer.updateEnd', 1);

  // @todo - it is likely possible to move the use of info here into the
  // SourceBuffer implementation to reduce coupling
  var infoAry = this.sourceBuffer.getTimes();
  var latestInfo = infoAry[infoAry.length - 1];
  MSEWrapper_assertClassBrand(_MSEWrapper_brand, this, _onVideoSegmentShown).call(this, latestInfo);
  try {
    MSEWrapper_assertClassBrand(_MSEWrapper_brand, this, _processNextInQueue).call(this);
  } catch (error) {
    this.logger.info('Error while showing video segment!');
    this.emit(_MSEWrapper.events.SHOW_VIDEO_SEGMENT_ERROR, {
      error: error
    });
  }
}
/**
 * Events that are emitted by this MSEWrapper
 */
_defineProperty(MSEWrapper, "events", {
  METRIC: 'metric',
  STREAM_FROZEN: 'stream-frozen',
  VIDEO_SEGMENT_SHOWN: 'video-segment-shown',
  SHOW_VIDEO_SEGMENT_ERROR: 'show-video-segment-error',
  MEDIA_SOURCE_ERROR: 'unexpected-media-source-error',
  SOURCE_BUFFER_ERROR: 'unexpected-source-buffer-error'
});

;// ./src/js/iov/Player/IovPlayer.js









var _IovPlayer;




function IovPlayer_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, IovPlayer_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function IovPlayer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (IovPlayer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function IovPlayer_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function IovPlayer_classPrivateMethodInitSpec(e, a) { IovPlayer_checkPrivateRedeclaration(e, a), a.add(e); }
function IovPlayer_checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function IovPlayer_assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }









var DEFAULT_ENABLE_METRICS = false;
var DEFAULT_SEGMENT_INTERVAL_SAMPLE_SIZE = 5;
var DEFAULT_DRIFT_CORRECTION_CONSTANT = 2;

/**
 * Responsible for receiving stream input and routing it to the media source
 * buffer for rendering on the video tag. There is some 'light' reworking of
 * the binary data that is required.
 *
 * @todo - this class should have no knowledge of videojs or its player, since
 * it is supposed to be capable of playing video by itself.  The plugin that
 * uses this player should have all of the videojs logic, and none should
 * exist here.
*/
var _IovPlayer_brand = /*#__PURE__*/new (weak_set_default())();
var IovPlayer = /*#__PURE__*/function (_EventEmitter) {
  /**
   * @private
   *
   * Construct a new IovPlayer
   *
   * @param {string} logId
   *   a string that identifies this IovPlayer in log messages
   * @param {HTMLElement} containerElement
   *   The container element that will contain the iframe
   * @param {HTMLElement} videoElement
   *   The video element that will be used to play the CLSP stream
   */
  function IovPlayer(logId, id, containerElement, videoElement) {
    var _this;
    _classCallCheck(this, IovPlayer);
    _this = IovPlayer_callSuper(this, IovPlayer, [logId]);
    IovPlayer_classPrivateMethodInitSpec(_this, _IovPlayer_brand);
    _defineProperty(_this, "isInitialized", false);
    _defineProperty(_this, "isInitializing", false);
    _defineProperty(_this, "isRestarting", false);
    _defineProperty(_this, "isTryingToPlay", false);
    _defineProperty(_this, "isStopping", false);
    _defineProperty(_this, "isStopped", false);
    _defineProperty(_this, "clspClientCount", 0);
    _defineProperty(_this, "clspClient", null);
    _defineProperty(_this, "streamConfiguration", null);
    _defineProperty(_this, "firstFrameShown", false);
    _defineProperty(_this, "mseWrapper", null);
    _defineProperty(_this, "moov", null);
    _defineProperty(_this, "latestSegmentReceivedAt", null);
    _defineProperty(_this, "segmentIntervalAverage", null);
    _defineProperty(_this, "intervalBetweenSegments", null);
    _defineProperty(_this, "segmentIntervals", []);
    _defineProperty(_this, "ENABLE_METRICS", DEFAULT_ENABLE_METRICS);
    _defineProperty(_this, "SEGMENT_INTERVAL_SAMPLE_SIZE", DEFAULT_SEGMENT_INTERVAL_SAMPLE_SIZE);
    _defineProperty(_this, "DRIFT_CORRECTION_CONSTANT", DEFAULT_DRIFT_CORRECTION_CONSTANT);
    if (isNil_default()(id)) {
      throw new Error('Tried to construct without an id');
    }
    if (!containerElement) {
      throw new Error('Tried to construct without a container element');
    }
    if (!videoElement) {
      throw new Error('Tried to construct without a video element');
    }
    _this.id = id;
    _this.containerElement = containerElement;
    _this.videoElement = videoElement;

    // @todo @metrics
    // this.metrics = {};
    return _this;
  }
  _inherits(IovPlayer, _EventEmitter);
  return _createClass(IovPlayer, [{
    key: "setStreamConfiguration",
    value: function setStreamConfiguration(streamConfiguration) {
      if (this.isDestroyed) {
        this.logger.error('Tried to setStreamConfiguration while destroyed');
        return;
      }
      if (!StreamConfiguration.isStreamConfiguration(streamConfiguration)) {
        throw new Error('Tried to set invalid streamConfiguration!');
      }
      this.streamConfiguration = streamConfiguration;
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _this2 = this;
        var force,
          _args2 = arguments;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              force = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              if (!this.isDestroyed) {
                _context2.next = 4;
                break;
              }
              this.logger.error('Tried to initialize while destroyed');
              return _context2.abrupt("return");
            case 4:
              if (!this.isInitializing) {
                _context2.next = 7;
                break;
              }
              this.logger.info('Initialization already in progress');
              return _context2.abrupt("return");
            case 7:
              if (!(this.isInitialized && !force)) {
                _context2.next = 10;
                break;
              }
              this.logger.info('Already initialized');
              return _context2.abrupt("return");
            case 10:
              this.isInitialized = false;
              this.isInitializing = true;
              this.logger.info("Initializing with ".concat(this.streamConfiguration.streamName));
              _context2.prev = 13;
              this.clientId = IovPlayer.generateClientId();
              if (!this.clspClient) {
                _context2.next = 18;
                break;
              }
              _context2.next = 18;
              return this.clspClient.destroy();
            case 18:
              this.clspClient = null;
              this.clspClient = ClspClient.factory(IovPlayer_assertClassBrand(_IovPlayer_brand, this, _generateClspClientLogId).call(this), this.clientId, this.streamConfiguration, this.containerElement);

              // @todo - don't use the conduit events here

              this.clspClient.conduit.on(ClspClient.events.RECONNECT_SUCCESS, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _this2.logger.info('ClspClient reconnected, restarting...');

                      // @todo - is there a more performant way to do this?
                      _context.prev = 1;
                      _context.next = 4;
                      return _this2.restart();
                    case 4:
                      _context.next = 11;
                      break;
                    case 6:
                      _context.prev = 6;
                      _context.t0 = _context["catch"](1);
                      _this2.logger.error('Error while restarting after reconnection!');
                      _this2.logger.error(_context.t0);

                      // @todo - there could be a dedicated event for this...
                      _this2.emit(IovPlayer.events.RECONNECT_FAILURE, {
                        error: _context.t0
                      });
                    case 11:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[1, 6]]);
              })));
              this.clspClient.conduit.on(ClspClient.events.RECONNECT_FAILURE, function (_ref2) {
                var error = _ref2.error;
                _this2.emit(IovPlayer.events.RECONNECT_FAILURE, {
                  error: error
                });
              });
              this.clspClient.conduit.on(ClspClient.events.ROUTER_EVENT_ERROR, function (_ref3) {
                var error = _ref3.error;
                _this2.emit(IovPlayer.events.ROUTER_EVENT_ERROR, {
                  error: error
                });
              });

              // @todo - the intended resync logic doesn't currently work, so we have
              // to emit an error on successful resync to force a restart...
              this.clspClient.conduit.on(ClspClient.events.RESYNC_STREAM_COMPLETE, function (data) {
                _this2.logger.warn("Resyncing stream ".concat(data.streamName, "..."));

                // spoofing an error...
                _this2.emit(IovPlayer.events.RECONNECT_FAILURE, {
                  error: new Error('Resync detected')
                });

                // @todo - we should be able to do something like this...
                // // No need to await since we're inside an event listener
                // this.#reinitializeMseWrapper();
              });
              this.clspClient.conduit.on(ClspClient.events.VIDEO_SEGMENT_RECEIVED, function (data) {
                IovPlayer_assertClassBrand(_IovPlayer_brand, _this2, _showVideoSegment).call(_this2, data.clspMessage.payloadBytes);
              });
              this.clspClient.conduit.on(ClspClient.events.IFRAME_DESTROYED_EXTERNALLY, function () {
                if (_this2.isDestroyed) {
                  _this2.logger.info('Iframe was destroyed externally while in process of destroying');
                  return;
                }
                _this2.emit(IovPlayer.events.IFRAME_DESTROYED_EXTERNALLY);
              });
              this.clspClient.conduit.on(ClspClient.events.JWT_AUTHORIZATION_FAILURE, function (data) {
                _this2.emit(IovPlayer.events.JWT_AUTHORIZATION_FAILURE, {
                  error: data.error,
                  playerId: _this2.id
                });
              });
              _context2.next = 29;
              return this.clspClient.initialize();
            case 29:
              this.isInitialized = true;
            case 30:
              _context2.prev = 30;
              this.isInitializing = false;
              return _context2.finish(30);
            case 33:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[13,, 30, 33]]);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "restart",
    value: function () {
      var _restart = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
        var needToReinitialize;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.isDestroyed) {
                _context3.next = 3;
                break;
              }
              this.logger.error('Tried to restart while destroyed');
              return _context3.abrupt("return");
            case 3:
              if (!this.isRestarting) {
                _context3.next = 6;
                break;
              }
              this.logger.info('Restart already in progress');
              return _context3.abrupt("return");
            case 6:
              if (!this.isInitializing) {
                _context3.next = 9;
                break;
              }
              this.logger.info('Cannot restart, initialization already in progress');
              return _context3.abrupt("return");
            case 9:
              this.logger.info('restart');
              this.isRestarting = true;
              _context3.prev = 11;
              // @todo - this has not yet been tested for memory leaks
              // If the src attribute is missing, it means we must reinitialize.  This can
              // happen if the video was loaded while the page was not visible, e.g.
              // document.hidden === true, which can happen when switching tabs.
              // @todo - is there a more "proper" way to do this?
              needToReinitialize = !this.videoElement.src;
              _context3.next = 15;
              return this.stop();
            case 15:
              _context3.next = 17;
              return this.initialize(needToReinitialize);
            case 17:
              _context3.next = 19;
              return this.play();
            case 19:
              if (!needToReinitialize) {
                _context3.next = 29;
                break;
              }
              _context3.prev = 20;
              _context3.next = 23;
              return IovPlayer_assertClassBrand(_IovPlayer_brand, this, _html5Play).call(this);
            case 23:
              _context3.next = 29;
              break;
            case 25:
              _context3.prev = 25;
              _context3.t0 = _context3["catch"](20);
              this.logger.error('Error while trying to play CLSP video from video element...');
              throw _context3.t0;
            case 29:
              _context3.prev = 29;
              this.isRestarting = false;
              return _context3.finish(29);
            case 32:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[11,, 29, 32], [20, 25]]);
      }));
      function restart() {
        return _restart.apply(this, arguments);
      }
      return restart;
    }()
    /**
     * Note that if an error is thrown during play, the IovPlayer instance should
     * be destroyed to free resources.
     */
  }, {
    key: "play",
    value: (function () {
      var _play = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4() {
        var _yield$this$clspClien, mimeCodec, moov;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.isDestroyed) {
                _context4.next = 3;
                break;
              }
              this.logger.info('Tried to play while destroyed');
              return _context4.abrupt("return");
            case 3:
              if (!(!this.isInitialized || this.isInitializing)) {
                _context4.next = 5;
                break;
              }
              throw new Error('Tried to play before initializing!');
            case 5:
              if (this.isStopping) {
                // @todo - what to do in this case?
              }
              if (!this.isTryingToPlay) {
                _context4.next = 9;
                break;
              }
              this.logger.info('Already trying to play');
              return _context4.abrupt("return");
            case 9:
              this.logger.info('play');
              this.isTryingToPlay = true;
              _context4.prev = 11;
              _context4.next = 14;
              return this.clspClient.conduit.play();
            case 14:
              _yield$this$clspClien = _context4.sent;
              mimeCodec = _yield$this$clspClien.mimeCodec;
              moov = _yield$this$clspClien.moov;
              if (MediaSourceWrapper.isMimeCodecSupported(mimeCodec)) {
                _context4.next = 20;
                break;
              }
              this.emit(IovPlayer.events.UNSUPPORTED_MIME_CODEC, {
                mimeCodec: mimeCodec
              });
              throw new Error("Unsupported mime codec: ".concat(mimeCodec));
            case 20:
              this.moov = moov;
              this.mimeCodec = mimeCodec;
              _context4.next = 24;
              return IovPlayer_assertClassBrand(_IovPlayer_brand, this, _reinitializeMseWrapper).call(this, false);
            case 24:
              this.isPlaying = true;
              this.isStopped = false;
            case 26:
              _context4.prev = 26;
              this.isTryingToPlay = false;
              return _context4.finish(26);
            case 29:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[11,, 26, 29]]);
      }));
      function play() {
        return _play.apply(this, arguments);
      }
      return play;
    }()
    /**
     * @returns {Promise}
     */
    )
  }, {
    key: "stop",
    value: (function () {
      var _stop = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5() {
        return regenerator_default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!this.isDestroyComplete) {
                _context5.next = 2;
                break;
              }
              throw new Error('Tried to stop after destroyed!');
            case 2:
              if (this.isInitialized) {
                _context5.next = 4;
                break;
              }
              throw new Error('Tried to stop before initializing!');
            case 4:
              if (!this.isStopped) {
                _context5.next = 7;
                break;
              }
              this.logger.info('Already stopped');
              return _context5.abrupt("return");
            case 7:
              if (!this.isStopping) {
                _context5.next = 10;
                break;
              }
              this.logger.info('Already stopping');
              return _context5.abrupt("return");
            case 10:
              this.logger.info('stop...');
              this.isStopping = true;
              this.moov = null;
              _context5.prev = 13;
              _context5.prev = 14;
              _context5.next = 17;
              return this.clspClient.conduit.stop();
            case 17:
              _context5.next = 23;
              break;
            case 19:
              _context5.prev = 19;
              _context5.t0 = _context5["catch"](14);
              this.logger.error('failed to stop the clspClient');
              this.logger.error(_context5.t0);
            case 23:
              _context5.prev = 23;
              _context5.next = 26;
              return IovPlayer_assertClassBrand(_IovPlayer_brand, this, _destroyMseWrapper).call(this);
            case 26:
              _context5.next = 32;
              break;
            case 28:
              _context5.prev = 28;
              _context5.t1 = _context5["catch"](23);
              this.logger.error('Failed to destroy mseWrapper while stopping, continuing anyway...');
              this.logger.error(_context5.t1);
            case 32:
              this.logger.info('stop succeeded');
              _context5.next = 39;
              break;
            case 35:
              _context5.prev = 35;
              _context5.t2 = _context5["catch"](13);
              this.logger.error('stop failed...');
              throw _context5.t2;
            case 39:
              _context5.prev = 39;
              this.isStopping = false;
              // @todo - it may not be stopped...
              this.isStopped = true;
              return _context5.finish(39);
            case 43:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[13, 35, 39, 43], [14, 19], [23, 28]]);
      }));
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }())
  }, {
    key: "_destroy",
    value: (
    /**
     * @async
     */
    function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6() {
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return this.stop();
            case 3:
              _context6.next = 9;
              break;
            case 5:
              _context6.prev = 5;
              _context6.t0 = _context6["catch"](0);
              this.logger.error('Error encountered while trying to stop during Iov Player destroy, continuing with destroy...');
              this.logger.error(_context6.t0);
            case 9:
              _context6.next = 11;
              return this.clspClient.destroy();
            case 11:
              this.clspClient = null;
              // The caller must destroy the streamConfiguration
              this.streamConfiguration = null;
              this.firstFrameShown = null;
              this.moov = null;
              this.latestSegmentReceivedAt = null;
              this.segmentIntervalAverage = null;
              this.intervalBetweenSegments = null;
              this.segmentIntervals = null;

              // @todo @metrics
              // this.metrics = null;
              _context6.next = 21;
              return IovPlayer_superPropGet(IovPlayer, "_destroy", this, 3)([]);
            case 21:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 5]]);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }())
  }], [{
    key: "factory",
    value:
    // @todo @metrics
    // static METRIC_TYPES = [
    //   'sourceBuffer.bufferTimeEnd',
    //   'video.currentTime',
    //   'video.drift',
    //   'video.driftCorrection',
    //   'video.intervalBetweenSegments',
    //   'video.segmentIntervalAverage',
    // ];

    /**
     * Construct a new IovPlayer
     *
     * @param {string} logId
     *   a string that identifies this IovPlayer in log messages
     * @param {HTMLElement} containerElement
     *   The container element that will contain the iframe
     * @param {HTMLElement} videoElement
     *   The video element that will be used to play the CLSP stream
     */
    function factory(logId, id, containerElement, videoElement) {
      return new IovPlayer(logId, id, containerElement, videoElement);
    }
  }, {
    key: "generateClientId",
    value: function generateClientId() {
      // This MUST be globally unique!  The CLSP server will broadcast the stream
      // to a topic that contains this id, so if there is ANY other client
      // connected that has the same id anywhere in the world, the stream to all
      // clients that use that topic will fail.  This is why we use guids rather
      // than an incrementing integer.
      //
      // We prefix it with the project name and version for server debugging
      // purposes.
      //
      // Note - this must not contain the '+' character
      // @todo - the caller should be able to provide a prefix or something
      return [(utils_default()).name, utils_default().version.replace('+', '-build-'), esm_browser_v4()].join('--');
    }
  }]);
}(EventEmitter);
_IovPlayer = IovPlayer;
function _destroyMseWrapper() {
  return _destroyMseWrapper2.apply(this, arguments);
}
function _destroyMseWrapper2() {
  _destroyMseWrapper2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7() {
    return regenerator_default().wrap(function _callee7$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          if (!this.mseWrapper) {
            _context8.next = 7;
            break;
          }
          _context8.prev = 1;
          _context8.next = 4;
          return this.mseWrapper.destroy();
        case 4:
          _context8.prev = 4;
          this.mseWrapper = null;
          return _context8.finish(4);
        case 7:
        case "end":
          return _context8.stop();
      }
    }, _callee7, this, [[1,, 4, 7]]);
  }));
  return _destroyMseWrapper2.apply(this, arguments);
}
function _reinitializeMseWrapper() {
  return _reinitializeMseWrapper2.apply(this, arguments);
}
function _reinitializeMseWrapper2() {
  _reinitializeMseWrapper2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee11() {
    var _this3 = this;
    var shouldEmitOnError,
      _args11 = arguments;
    return regenerator_default().wrap(function _callee11$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          shouldEmitOnError = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : true;
          if (!this.isDestroyed) {
            _context12.next = 4;
            break;
          }
          this.logger.warn('Tried to reinitializeMseWrapper while destroyed...');
          return _context12.abrupt("return");
        case 4:
          this.logger.info('reinitializeMseWrapper');
          _context12.prev = 5;
          _context12.next = 8;
          return IovPlayer_assertClassBrand(_IovPlayer_brand, this, _destroyMseWrapper).call(this);
        case 8:
          _context12.next = 14;
          break;
        case 10:
          _context12.prev = 10;
          _context12.t0 = _context12["catch"](5);
          this.logger.error('Failed to destroy mseWrapper while reinitializing mseWrapper, continuing anyway...');
          this.logger.error(_context12.t0);
        case 14:
          this.mseWrapper = null;
          this.mseWrapper = MSEWrapper.factory(this.logId, this.videoElement);
          this.mseWrapper.on(MSEWrapper.events.METRIC, function (_ref4) {
            var type = _ref4.type,
              value = _ref4.value;
            IovPlayer_assertClassBrand(_IovPlayer_brand, _this3, _metric).call(_this3, type, value);
          });

          // Error events

          this.mseWrapper.on(MSEWrapper.events.SHOW_VIDEO_SEGMENT_ERROR, function (_ref5) {
            var error = _ref5.error;
            // internal error, this has been observed to happen the tab
            // in the browser where this video player lives is hidden
            // then reselected. 'ex' is undefined the error is bug
            // within the MSE C++ implementation in the browser.
            _this3.logger.error('Error while showing video segment!');
            _this3.logger.error(error);

            // No need to await since we're inside an event listener
            IovPlayer_assertClassBrand(_IovPlayer_brand, _this3, _reinitializeMseWrapper).call(_this3);
          });
          this.mseWrapper.on(MSEWrapper.events.MEDIA_SOURCE_ERROR, function (event) {
            _this3.logger.warn('mediaSource.generic --> mediaSource error');
            // @todo - sometimes, this error is an event rather than an error!
            // If different onError calls use different method signatures, that
            // needs to be accounted for in the MSEWrapper, and the actual error
            // that was thrown must ALWAYS be the first argument here.  As a
            // shortcut, we can log `...args` here instead.
            _this3.logger.error(event);

            // No need to await since we're inside an event listener
            IovPlayer_assertClassBrand(_IovPlayer_brand, _this3, _reinitializeMseWrapper).call(_this3);
          });
          this.mseWrapper.on(MSEWrapper.events.SOURCE_BUFFER_ERROR, function (event) {
            _this3.logger.debug('sourceBuffer.generic --> sourceBuffer error');
            // console.log(event);

            // No need to await since we're inside an event listener
            IovPlayer_assertClassBrand(_IovPlayer_brand, _this3, _reinitializeMseWrapper).call(_this3);
          });
          this.mseWrapper.on(MSEWrapper.events.STREAM_FROZEN, function () {
            _this3.logger.info('stream appears to be frozen - reinitializing...');

            // No need to await since we're inside an event listener
            IovPlayer_assertClassBrand(_IovPlayer_brand, _this3, _reinitializeMseWrapper).call(_this3);
          });

          // Non-Error events

          this.mseWrapper.on(MSEWrapper.events.VIDEO_SEGMENT_SHOWN, /*#__PURE__*/function () {
            var _ref7 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee8(_ref6) {
              var info;
              return regenerator_default().wrap(function _callee8$(_context9) {
                while (1) switch (_context9.prev = _context9.next) {
                  case 0:
                    info = _ref6.info;
                    if (!_this3.isDestroyed) {
                      _context9.next = 4;
                      break;
                    }
                    _this3.logger.warn('Got video segement while destroyed...');
                    return _context9.abrupt("return");
                  case 4:
                    _this3.logger.silly('On Append Finish...');
                    if (!_this3.firstFrameShown) {
                      _this3.firstFrameShown = true;

                      // Since the video element can be shared with other IovPlayers, we only
                      // associate the video element with an IovPlayer after that IovPlayer
                      // has shown its first frame.
                      _this3.videoElement.id = _this3.clientId;
                      _this3.videoElement.dataset.name = _this3.streamConfiguration.streamName;
                      _this3.emit(_IovPlayer.events.FIRST_FRAME_SHOWN);
                    }
                    _this3.drift = info.bufferTimeEnd - _this3.videoElement.currentTime;
                    IovPlayer_assertClassBrand(_IovPlayer_brand, _this3, _metric).call(_this3, 'sourceBuffer.bufferTimeEnd', info.bufferTimeEnd);
                    IovPlayer_assertClassBrand(_IovPlayer_brand, _this3, _metric).call(_this3, 'video.currentTime', _this3.videoElement.currentTime);
                    IovPlayer_assertClassBrand(_IovPlayer_brand, _this3, _metric).call(_this3, 'video.drift', _this3.drift);
                    if (_this3.drift > _this3.segmentIntervalAverage / 1000 + _this3.DRIFT_CORRECTION_CONSTANT) {
                      IovPlayer_assertClassBrand(_IovPlayer_brand, _this3, _metric).call(_this3, 'video.driftCorrection', 1);
                      _this3.videoElement.currentTime = info.bufferTimeEnd;
                    }
                    if (!(_this3.videoElement.paused === true)) {
                      _context9.next = 23;
                      break;
                    }
                    _this3.logger.info('Video is paused!');
                    _context9.prev = 13;
                    _context9.next = 16;
                    return IovPlayer_assertClassBrand(_IovPlayer_brand, _this3, _html5Play).call(_this3);
                  case 16:
                    _context9.next = 23;
                    break;
                  case 18:
                    _context9.prev = 18;
                    _context9.t0 = _context9["catch"](13);
                    _this3.logger.error('Error while trying to play CLSP video from video element...');
                    _this3.logger.error(_context9.t0);

                    // No need to await since we're inside an event listener
                    IovPlayer_assertClassBrand(_IovPlayer_brand, _this3, _reinitializeMseWrapper).call(_this3);
                  case 23:
                  case "end":
                    return _context9.stop();
                }
              }, _callee8, null, [[13, 18]]);
            }));
            return function (_x) {
              return _ref7.apply(this, arguments);
            };
          }());
          _context12.prev = 22;
          _context12.next = 25;
          return this.mseWrapper.initialize();
        case 25:
          // @todo - this is what actually gives the HTML5 video element the
          // ability to play video.  Remember, though, this videoElement is
          // potentially shared with other IovPlayers.  Therefore, it would be
          // better if:
          // 1 - it was guaranteed that the stream was actually being received from
          //     the SFS prior to potentially taking src control away from another,
          //     already-playing IovPlayer
          // 2 - since there is this struggle for control between IovPlayers, it
          //     would be even better if there were a way for the IovPlayerController
          //     to handle this...
          // Therefore, this needs to have some relationship to either the play
          // operation or VIDEO_SEGMENT_RECEIVED events or something...
          this.videoElement.src = '';
          this.videoElement.src = this.mseWrapper.mediaSource.asObjectURL();

          // Error events

          this.mseWrapper.mediaSource.on(MediaSourceWrapper.events.SOURCE_OPEN_ERROR, function (_ref8) {
            var error = _ref8.error;
            _this3.logger.error('Failed to initialize mediaSource - Error on "sourceopen" event:');
            _this3.logger.error(error);

            // No need to await since we're inside an event listener
            IovPlayer_assertClassBrand(_IovPlayer_brand, _this3, _reinitializeMseWrapper).call(_this3);
          });

          // Non-Error events

          // When the MediaSource first becomes ready, send it the moov
          // @todo - all of this logic should be handled by the MSEWrapper!!
          this.mseWrapper.mediaSource.on(MediaSourceWrapper.events.SOURCE_OPEN, /*#__PURE__*/function () {
            var _ref9 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee9(event) {
              return regenerator_default().wrap(function _callee9$(_context10) {
                while (1) switch (_context10.prev = _context10.next) {
                  case 0:
                    _this3.logger.info('on mediaSource sourceopen');
                    _context10.prev = 1;
                    _context10.prev = 2;
                    _context10.next = 5;
                    return _this3.mseWrapper.initializeSourceBuffer(_this3.mimeCodec);
                  case 5:
                    _context10.next = 11;
                    break;
                  case 7:
                    _context10.prev = 7;
                    _context10.t0 = _context10["catch"](2);
                    _this3.logger.warn('Error while initializing SourceBuffer!');
                    throw _context10.t0;
                  case 11:
                    _this3.emit(_IovPlayer.events.VIDEO_INFO_RECEIVED);
                    _context10.prev = 12;
                    _this3.mseWrapper.appendMoov(_this3.moov);
                    _context10.next = 20;
                    break;
                  case 16:
                    _context10.prev = 16;
                    _context10.t1 = _context10["catch"](12);
                    // internal error, this has been observed to happen the tab
                    // in the browser where this video player lives is hidden
                    // then reselected. 'ex' is undefined the error is bug
                    // within the MSE C++ implementation in the browser.
                    _this3.logger.warn('Error while appending moov!');
                    throw _context10.t1;
                  case 20:
                    _context10.next = 26;
                    break;
                  case 22:
                    _context10.prev = 22;
                    _context10.t2 = _context10["catch"](1);
                    _this3.logger.warn(_context10.t2);

                    // @todo - this is not the proper event to emit here, but it will
                    // work for now becauase it will force the iov to recreate the player.
                    // In testing, it was found that under certain circumstances, the
                    // mimeCodec can be undefined, yet the SourceBuffer will still somehow
                    // be attempted to be initialized.
                    // One of the conditions that causes this problem is when resync
                    // stream is triggered.
                    _this3.emit(_IovPlayer.events.REINITIALZE_ERROR, {
                      error: _context10.t2
                    });
                  case 26:
                  case "end":
                    return _context10.stop();
                }
              }, _callee9, null, [[1, 22], [2, 7], [12, 16]]);
            }));
            return function (_x2) {
              return _ref9.apply(this, arguments);
            };
          }());
          this.mseWrapper.mediaSource.on(MediaSourceWrapper.events.SOURCE_ENDED, /*#__PURE__*/function () {
            var _ref10 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee10(event) {
              return regenerator_default().wrap(function _callee10$(_context11) {
                while (1) switch (_context11.prev = _context11.next) {
                  case 0:
                    _this3.logger.info('on mediaSource sourceended');
                    _context11.prev = 1;
                    _context11.next = 4;
                    return _this3.stop();
                  case 4:
                    _context11.next = 10;
                    break;
                  case 6:
                    _context11.prev = 6;
                    _context11.t0 = _context11["catch"](1);
                    _this3.logger.error('Error while stopping in SOURCE_ENDED event!');
                    _this3.logger.error(_context11.t0);
                  case 10:
                  case "end":
                    return _context11.stop();
                }
              }, _callee10, null, [[1, 6]]);
            }));
            return function (_x3) {
              return _ref10.apply(this, arguments);
            };
          }());
          _context12.next = 39;
          break;
        case 32:
          _context12.prev = 32;
          _context12.t1 = _context12["catch"](22);
          if (!shouldEmitOnError) {
            _context12.next = 38;
            break;
          }
          // Because this method is called in so many places, handle the error here.
          // This also makes it so that all of the event listeners don't have to
          // catch the error thrown by this method, which if not caught would result
          // in an uncaught error exception.
          this.emit(_IovPlayer.events.REINITIALZE_ERROR, {
            error: _context12.t1
          });
          _context12.next = 39;
          break;
        case 38:
          throw _context12.t1;
        case 39:
        case "end":
          return _context12.stop();
      }
    }, _callee11, this, [[5, 10], [22, 32]]);
  }));
  return _reinitializeMseWrapper2.apply(this, arguments);
}
function _html5Play() {
  return _html5Play2.apply(this, arguments);
}
function _html5Play2() {
  _html5Play2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee12() {
    return regenerator_default().wrap(function _callee12$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return this.videoElement.play();
        case 2:
        case "end":
          return _context13.stop();
      }
    }, _callee12, this);
  }));
  return _html5Play2.apply(this, arguments);
}
function _generateClspClientLogId() {
  var _context7;
  return concat_default()(_context7 = "".concat(this.logId, ".clspClient:")).call(_context7, ++this.clspClientCount);
}
function _showVideoSegment(videoSegement) {
  // @todo - this seems like a hack...
  if (this.isStopped) {
    return;
  }
  this.emit(_IovPlayer.events.VIDEO_RECEIVED);
  // @todo @metrics
  IovPlayer_assertClassBrand(_IovPlayer_brand, this, _getSegmentIntervalMetrics).call(this);

  // Sometimes, the first moof arrives before the mseWrapper has finished
  // being initialized, so we will need to drop those frames
  if (!this.mseWrapper) {
    return;
  }

  // If the document is hidden, don't pass the moofs to the appropriate
  // handler. The moofs occur at a rate that will exhaust the browser
  // tab resources, ultimately resulting in a crash if given enough time.
  // @todo - this check should probably be moved to the MSEWrapper
  if (utils_default().isDocumentHidden()) {
    this.logger.info('Document is in hidden state, not appending moof');
    return;
  }
  try {
    this.mseWrapper.showVideoSegment(videoSegement);
    this.clspClient.conduit.segmentUsed(videoSegement);
  } catch (error) {
    // internal error, this has been observed to happen the tab
    // in the browser where this video player lives is hidden
    // then reselected. 'ex' is undefined the error is bug
    // within the MSE C++ implementation in the browser.
    this.logger.error('Error while trying to show video segment!');
    this.logger.error(error);

    // no need to await this since it's only ever called in an event handler
    IovPlayer_assertClassBrand(_IovPlayer_brand, this, _reinitializeMseWrapper).call(this);
  }
}
/**
 * @private
 *
 * Track segment interval metrics to help account for drift
 *
 * @returns {void}
 */
function _getSegmentIntervalMetrics() {
  if (!this.latestSegmentReceivedAt) {
    this.latestSegmentReceivedAt = now_default()();
    return;
  }
  var previousSegmentReceivedAt = this.latestSegmentReceivedAt;
  this.latestSegmentReceivedAt = now_default()();
  this.intervalBetweenSegments = this.latestSegmentReceivedAt - previousSegmentReceivedAt;

  // @todo - Do we really need to check for the case where two segments
  // arrive at exactly the same time?
  if (!this.intervalBetweenSegments) {
    return;
  }
  if (this.segmentIntervals.length >= this.SEGMENT_INTERVAL_SAMPLE_SIZE) {
    this.segmentIntervals.shift();
  }
  this.segmentIntervals.push(this.intervalBetweenSegments);
  var segmentIntervalSum = 0;
  for (var i = 0; i < this.segmentIntervals.length; i++) {
    segmentIntervalSum += this.segmentIntervals[i];
  }
  this.segmentIntervalAverage = segmentIntervalSum / this.segmentIntervals.length;
  IovPlayer_assertClassBrand(_IovPlayer_brand, this, _metric).call(this, 'video.intervalBetweenSegments', this.intervalBetweenSegments);
  IovPlayer_assertClassBrand(_IovPlayer_brand, this, _metric).call(this, 'video.segmentIntervalAverage', this.segmentIntervalAverage);
}
// @todo @metrics
/**
 * @private
 *
 * @deprecated
 */
function _metric(type, value) {
  // if (!this.ENABLE_METRICS) {
  //   return;
  // }

  // if (!IovPlayer.METRIC_TYPES.includes(type)) {
  //   // @todo - should this throw?
  //   return;
  // }

  // switch (type) {
  //   case 'video.driftCorrection': {
  //     if (!this.metrics[type]) {
  //       this.metrics[type] = 0;
  //     }

  //     this.metrics[type] += value;

  //     break;
  //   }
  //   default: {
  //     this.metrics[type] = value;
  //   }
  // }

  // this.trigger('metric', {
  //   type,
  //   value: this.metrics[type],
  // });
}
/**
 * @static
 *
 * The events that this IovPlayer will emit.
 */
_defineProperty(IovPlayer, "events", {
  METRIC: 'metric',
  UNSUPPORTED_MIME_CODEC: 'unsupportedMimeCodec',
  FIRST_FRAME_SHOWN: 'firstFrameShown',
  VIDEO_RECEIVED: 'videoReceived',
  VIDEO_INFO_RECEIVED: 'videoInfoReceived',
  REINITIALZE_ERROR: 'reinitialize-error',
  IFRAME_DESTROYED_EXTERNALLY: Conduit.events.IFRAME_DESTROYED_EXTERNALLY,
  RECONNECT_FAILURE: Conduit.events.RECONNECT_FAILURE,
  ROUTER_EVENT_ERROR: Conduit.events.ROUTER_EVENT_ERROR,
  JWT_AUTHORIZATION_FAILURE: Conduit.events.JWT_AUTHORIZATION_FAILURE
});

;// ./src/js/iov/Player/IovPlayerCollection.js








var _IovPlayerCollection;











function IovPlayerCollection_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, IovPlayerCollection_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function IovPlayerCollection_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (IovPlayerCollection_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function IovPlayerCollection_classPrivateMethodInitSpec(e, a) { IovPlayerCollection_checkPrivateRedeclaration(e, a), a.add(e); }
function IovPlayerCollection_checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function IovPlayerCollection_assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }




var DEFAULT_MAX_RETRIES_ON_PLAY_ERROR = 100;
var _IovPlayerCollection_brand = /*#__PURE__*/new (weak_set_default())();
var IovPlayerCollection = /*#__PURE__*/function (_EventEmitter) {
  /**
   * @private
   */
  function IovPlayerCollection(logId) {
    var _this;
    _classCallCheck(this, IovPlayerCollection);
    _this = IovPlayerCollection_callSuper(this, IovPlayerCollection, [logId]);
    IovPlayerCollection_classPrivateMethodInitSpec(_this, _IovPlayerCollection_brand);
    _this.initialize();
    _this.MAX_RETRIES_ON_PLAY_ERROR = DEFAULT_MAX_RETRIES_ON_PLAY_ERROR;
    return _this;
  }
  _inherits(IovPlayerCollection, _EventEmitter);
  return _createClass(IovPlayerCollection, [{
    key: "initialize",
    value: function initialize() {
      this.logger.info('Initializing');
      this.players = {};
      this.playerStack = [];
      this.playerLogMessageIds = {};
      this.retryAttempts = {};
      this.mostRecentlyPlayedId = null;
      this.mostRecentlyAddedId = null;
      this.totalPlayersAdded = 0;
      this.pendingRemoval = {};
    }
  }, {
    key: "generatePlayerLogId",
    value: function generatePlayerLogId(streamName) {
      var _context, _context2;
      return concat_default()(_context = concat_default()(_context2 = "".concat(this.logId, ".player:")).call(_context2, this.totalPlayersAdded, ":")).call(_context, streamName);
    }
  }, {
    key: "create",
    value: function () {
      var _create2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(containerElement, videoElement, streamConfiguration) {
        var iovPlayer, id;
        return regenerator_default().wrap(function _callee$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              iovPlayer = this._create(containerElement, videoElement, streamConfiguration);
              id = iovPlayer.id;
              IovPlayerCollection_assertClassBrand(_IovPlayerCollection_brand, this, _add).call(this, iovPlayer);
              _context3.next = 5;
              return IovPlayerCollection_assertClassBrand(_IovPlayerCollection_brand, this, _play).call(this, id);
            case 5:
              return _context3.abrupt("return", id);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee, this);
      }));
      function create(_x, _x2, _x3) {
        return _create2.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: "_create",
    value: function _create(containerElement, videoElement, streamConfiguration) {
      var _this2 = this;
      if (!containerElement) {
        throw new Error('A container element is required to create an IovPlayer');
      }
      if (!videoElement) {
        throw new Error('A video element is required to create an IovPlayer');
      }
      if (!streamConfiguration) {
        throw new Error('stream configuration is required to create an IovPlayer');
      }
      this.totalPlayersAdded++;
      var id = esm_browser_v4();
      var iovPlayer = IovPlayer.factory(this.generatePlayerLogId(streamConfiguration.streamName), id, containerElement, videoElement);
      iovPlayer.setStreamConfiguration(streamConfiguration);

      // Tell the IOV to start tearing it all down...
      iovPlayer.on(IovPlayer.events.IFRAME_DESTROYED_EXTERNALLY, function () {
        if (_this2.isDestroyed) {
          _this2.logger.info('Iframe was destroyed externally while in process of destroying');
          return;
        }
        _this2.emit(IovPlayerCollection.events.IFRAME_DESTROYED_EXTERNALLY, {
          id: id
        });
      });

      // Needed for videojs plugin
      iovPlayer.on(IovPlayer.events.VIDEO_RECEIVED, function () {
        _this2.emit(IovPlayerCollection.events.VIDEO_RECEIVED, {
          id: id
        });
      });

      // Needed for videojs plugin
      iovPlayer.on(IovPlayer.events.VIDEO_INFO_RECEIVED, function () {
        _this2.emit(IovPlayerCollection.events.VIDEO_INFO_RECEIVED, {
          id: id
        });
      });
      iovPlayer.on(IovPlayer.events.FIRST_FRAME_SHOWN, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // Needed for videojs plugin
              _this2.emit(IovPlayerCollection.events.FIRST_FRAME_SHOWN, {
                id: id
              });
              _this2.mostRecentlyPlayedId = id;
              try {
                // Only destroy all previous rather than all other players because a
                // more recently added player may exist that has not had its first
                // frame shown yet
                _this2.logger.info("First frame received for ".concat(_this2.playerLogMessageIds[id], ", destroying all previous players..."));
                _this2.destroyAllPreviousPlayers(id);
              } catch (error) {
                _this2.logger.error("Error while destroying previous players for ".concat(_this2.playerLogMessageIds[id]));
                _this2.logger.error(error);
              }
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee2);
      })));
      iovPlayer.on(IovPlayer.events.RECONNECT_FAILURE, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _this2.logger.info("Critical player error RECONNECT_FAILURE for player ".concat(_this2.playerLogMessageIds[id]));
              _context5.next = 4;
              return IovPlayerCollection_assertClassBrand(_IovPlayerCollection_brand, _this2, _handleCriticalIovPlayerError).call(_this2, id, IovPlayer.events.RECONNECT_FAILURE);
            case 4:
              _context5.next = 10;
              break;
            case 6:
              _context5.prev = 6;
              _context5.t0 = _context5["catch"](0);
              _this2.logger.error("Error while handling player error RECONNECT_FAILURE for player ".concat(_this2.playerLogMessageIds[id]));
              _this2.logger.error(_context5.t0);
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee3, null, [[0, 6]]);
      })));
      iovPlayer.on(IovPlayer.events.ROUTER_EVENT_ERROR, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4() {
        return regenerator_default().wrap(function _callee4$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _this2.logger.info("Critical player error ROUTER_EVENT_ERROR for player ".concat(_this2.playerLogMessageIds[id]));
              _context6.next = 4;
              return IovPlayerCollection_assertClassBrand(_IovPlayerCollection_brand, _this2, _handleCriticalIovPlayerError).call(_this2, id, IovPlayer.events.ROUTER_EVENT_ERROR);
            case 4:
              _context6.next = 10;
              break;
            case 6:
              _context6.prev = 6;
              _context6.t0 = _context6["catch"](0);
              _this2.logger.error("Error while handling player error ROUTER_EVENT_ERROR for player ".concat(_this2.playerLogMessageIds[id]));
              _this2.logger.error(_context6.t0);
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee4, null, [[0, 6]]);
      })));
      iovPlayer.on(IovPlayer.events.REINITIALZE_ERROR, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5() {
        return regenerator_default().wrap(function _callee5$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _this2.logger.info("Critical player error REINITIALZE_ERROR for player ".concat(_this2.playerLogMessageIds[id]));
              _context7.next = 4;
              return IovPlayerCollection_assertClassBrand(_IovPlayerCollection_brand, _this2, _handleCriticalIovPlayerError).call(_this2, id, IovPlayer.events.REINITIALZE_ERROR);
            case 4:
              _context7.next = 10;
              break;
            case 6:
              _context7.prev = 6;
              _context7.t0 = _context7["catch"](0);
              _this2.logger.error("Error while handling player error REINITIALZE_ERROR for player ".concat(_this2.playerLogMessageIds[id]));
              _this2.logger.error(_context7.t0);
            case 10:
            case "end":
              return _context7.stop();
          }
        }, _callee5, null, [[0, 6]]);
      })));
      iovPlayer.on(IovPlayer.events.JWT_AUTHORIZATION_FAILURE, function (data) {
        _this2.logger.error("Critical JWT authorization error: ".concat(data.error));
        // prevent any retries
        _this2.retryAttempts[id] = _this2.MAX_RETRIES_ON_PLAY_ERROR + 1;
      });
      return iovPlayer;
    }
  }, {
    key: "destroyAllPreviousPlayers",
    value: function () {
      var _destroyAllPreviousPlayers = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6(id) {
        var _context8, _context9;
        var index, idsToRemove;
        return regenerator_default().wrap(function _callee6$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              index = index_of_default()(_context8 = this.playerStack).call(_context8, id);
              if (!(index === -1)) {
                _context10.next = 3;
                break;
              }
              return _context10.abrupt("return");
            case 3:
              idsToRemove = slice_default()(_context9 = this.playerStack).call(_context9, 0, index);
              _context10.prev = 4;
              _context10.next = 7;
              return this.removeMany(idsToRemove);
            case 7:
              _context10.next = 13;
              break;
            case 9:
              _context10.prev = 9;
              _context10.t0 = _context10["catch"](4);
              this.logger.error("Error(s) while destroying players before ".concat(this.playerLogMessageIds[id], ", continuing anyway..."));
              this.logger.error(_context10.t0);
            case 13:
            case "end":
              return _context10.stop();
          }
        }, _callee6, this, [[4, 9]]);
      }));
      function destroyAllPreviousPlayers(_x4) {
        return _destroyAllPreviousPlayers.apply(this, arguments);
      }
      return destroyAllPreviousPlayers;
    }()
  }, {
    key: "has",
    value: function has(id) {
      if (isNil_default()(id)) {
        return false;
      }
      if (this.pendingRemoval[id]) {
        return false;
      }
      return Object.prototype.hasOwnProperty.call(this.players, id);
    }
  }, {
    key: "get",
    value: function get(id) {
      if (!this.has(id)) {
        return null;
      }
      return this.players[id];
    }
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7(id) {
        var _context11;
        var iovPlayer, playerLogMessageId, index, _context12, stackLength;
        return regenerator_default().wrap(function _callee7$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              iovPlayer = this.get(id);
              if (!(iovPlayer === null)) {
                _context13.next = 3;
                break;
              }
              return _context13.abrupt("return");
            case 3:
              iovPlayer.logger.info('IovPlayerCollection - removing player...');
              playerLogMessageId = this.playerLogMessageIds[id];
              this.pendingRemoval[id] = true;

              // It is no longer the most recently played
              if (this.mostRecentlyPlayedId === id) {
                this.mostRecentlyPlayedId = null;
              }

              // remove it from the stack
              index = index_of_default()(_context11 = this.playerStack).call(_context11, id);
              if (index !== -1) {
                splice_default()(_context12 = this.playerStack).call(_context12, index, 1);
              }

              // it is no longer the most recently added
              if (this.mostRecentlyAddedId === id) {
                stackLength = this.playerStack.length;
                if (stackLength === 0) {
                  this.mostRecentlyAddedId = null;
                } else {
                  this.mostRecentlyAddedId = this.playerStack[stackLength - 1];
                }
              }

              // remove it from all internal state
              delete this.players[id];
              delete this.playerLogMessageIds[id];
              delete this.pendingRemoval[id];
              _context13.prev = 13;
              _context13.next = 16;
              return iovPlayer.destroy();
            case 16:
              _context13.next = 22;
              break;
            case 18:
              _context13.prev = 18;
              _context13.t0 = _context13["catch"](13);
              this.logger.error("Error destroying IovPlayer ".concat(playerLogMessageId, " while removing, continuing anyway"));
              this.logger.error(_context13.t0);
            case 22:
            case "end":
              return _context13.stop();
          }
        }, _callee7, this, [[13, 18]]);
      }));
      function remove(_x5) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }, {
    key: "removeMany",
    value: function () {
      var _removeMany = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee8(ids) {
        var _this3 = this;
        var removeOperations, results, errors;
        return regenerator_default().wrap(function _callee8$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              removeOperations = map_default()(ids).call(ids, function (id) {
                return _this3.remove(id);
              });
              _context14.next = 3;
              return core_js_stable_promise_default().allSettled(removeOperations);
            case 3:
              results = _context14.sent;
              errors = reduce_default()(results).call(results, function (acc, cur) {
                if (cur.status !== 'fulfilled') {
                  acc.push(cur);
                }
                return acc;
              }, []);
              if (!errors.length) {
                _context14.next = 9;
                break;
              }
              this.logger.error('Error(s) encountered while destroying IovPlayer(s) during removeMany...');
              for_each_default()(errors).call(errors, function (error) {
                _this3.logger.error(error.reason);
              });
              throw errors[0].reason;
            case 9:
            case "end":
              return _context14.stop();
          }
        }, _callee8, this);
      }));
      function removeMany(_x6) {
        return _removeMany.apply(this, arguments);
      }
      return removeMany;
    }()
  }, {
    key: "removeAll",
    value: function () {
      var _removeAll = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee9() {
        var playerIds;
        return regenerator_default().wrap(function _callee9$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              playerIds = keys_default()(this.players);
              _context15.next = 3;
              return this.removeMany(playerIds);
            case 3:
            case "end":
              return _context15.stop();
          }
        }, _callee9, this);
      }));
      function removeAll() {
        return _removeAll.apply(this, arguments);
      }
      return removeAll;
    }()
  }, {
    key: "_destroy",
    value: function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee10() {
        return regenerator_default().wrap(function _callee10$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              _context16.next = 3;
              return this.removeAll();
            case 3:
              _context16.next = 9;
              break;
            case 5:
              _context16.prev = 5;
              _context16.t0 = _context16["catch"](0);
              this.logger.error('Error(s) encountered while removing while destroying, continuing anyway...');
              this.logger.error(_context16.t0);
            case 9:
              this.players = null;
              this.playerLogMessageIds = null;
              this.pendingRemoval = null;
              this.playerStack = null;
            case 13:
            case "end":
              return _context16.stop();
          }
        }, _callee10, this, [[0, 5]]);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }()
  }], [{
    key: "factory",
    value: function factory(logId) {
      return new IovPlayerCollection(logId);
    }
  }]);
}(EventEmitter);
_IovPlayerCollection = IovPlayerCollection;
function _handleCriticalIovPlayerError(_x7, _x8) {
  return _handleCriticalIovPlayerError2.apply(this, arguments);
}
function _handleCriticalIovPlayerError2() {
  _handleCriticalIovPlayerError2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee11(id, eventName) {
    var _context19;
    var _context18, _context20;
    return regenerator_default().wrap(function _callee11$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          if (!(id === this.mostRecentlyPlayedId || id === this.mostRecentlyAddedId)) {
            _context21.next = 12;
            break;
          }
          this.logger.info(concat_default()(_context18 = "Active IovPlayer ".concat(this.playerLogMessageIds[id], " emitted the \"")).call(_context18, eventName, "\" event, recreating it..."));
          _context21.prev = 2;
          _context21.next = 5;
          return IovPlayerCollection_assertClassBrand(_IovPlayerCollection_brand, this, _recreate).call(this, id);
        case 5:
          _context21.next = 11;
          break;
        case 7:
          _context21.prev = 7;
          _context21.t0 = _context21["catch"](2);
          this.logger.error("Error while recreating ".concat(this.playerLogMessageIds[id]));
          this.logger.error(_context21.t0);
        case 11:
          return _context21.abrupt("return");
        case 12:
          this.logger.info(concat_default()(_context19 = "Stale IovPlayer ".concat(this.playerLogMessageIds[id], " emitted the \"")).call(_context19, eventName, "\" event, destroying it..."));
          _context21.prev = 13;
          _context21.next = 16;
          return this.remove(id);
        case 16:
          _context21.next = 22;
          break;
        case 18:
          _context21.prev = 18;
          _context21.t1 = _context21["catch"](13);
          this.logger.error(concat_default()(_context20 = "Error while removing Stale IovPlayer ".concat(this.playerLogMessageIds[id], " during \"")).call(_context20, eventName, "\" event, continuing anyway..."));
          this.logger.error(_context21.t1);
        case 22:
        case "end":
          return _context21.stop();
      }
    }, _callee11, this, [[2, 7], [13, 18]]);
  }));
  return _handleCriticalIovPlayerError2.apply(this, arguments);
}
function _replaceInStack(oldId, newId) {
  var _context17;
  var index = index_of_default()(_context17 = this.playerStack).call(_context17, oldId);
  if (index === -1) {
    throw new Error("Cannot replace ".concat(this.playerLogMessageIds[oldId], " in stack because it doesn't exist in the stack..."));
  }
  this.playerStack[index] = newId;
}
function _recreate(_x9) {
  return _recreate2.apply(this, arguments);
}
function _recreate2() {
  _recreate2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee12(oldId) {
    var _this4 = this;
    var oldIovPlayer, oldPlayerLogMessageId, iovPlayer, id;
    return regenerator_default().wrap(function _callee12$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          oldIovPlayer = this.get(oldId);
          if (!(oldIovPlayer === null)) {
            _context22.next = 3;
            break;
          }
          throw new Error("Cannot recreate IovPlayer with non-existent id ".concat(oldId));
        case 3:
          oldPlayerLogMessageId = this.playerLogMessageIds[oldId];
          iovPlayer = this._create(oldIovPlayer.containerElement, oldIovPlayer.videoElement, oldIovPlayer.streamConfiguration);
          id = iovPlayer.id;
          this.players[id] = iovPlayer;
          this.playerLogMessageIds[id] = this.totalPlayersAdded;
          this.retryAttempts[id] = 0;
          IovPlayerCollection_assertClassBrand(_IovPlayerCollection_brand, this, _replaceInStack).call(this, oldId, id);
          if (this.mostRecentlyAddedId === oldId) {
            this.mostRecentlyAddedId = id;
          }
          if (this.mostRecentlyPlayedId === oldId) {
            this.mostRecentlyPlayedId = id;
          }

          // We do not need to await this
          this.remove(oldId)["catch"](function (error) {
            _this4.logger.error("Error while removing player ".concat(oldPlayerLogMessageId, " while recreating, continuing anyway..."));
            _this4.logger.error(error);
          });
          _context22.next = 15;
          return IovPlayerCollection_assertClassBrand(_IovPlayerCollection_brand, this, _play).call(this, id);
        case 15:
        case "end":
          return _context22.stop();
      }
    }, _callee12, this);
  }));
  return _recreate2.apply(this, arguments);
}
function _play(_x10) {
  return _play2.apply(this, arguments);
}
function _play2() {
  _play2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee13(id) {
    var iovPlayer, _context23;
    return regenerator_default().wrap(function _callee13$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          iovPlayer = this.get(id);
          if (!(iovPlayer === null)) {
            _context24.next = 3;
            break;
          }
          throw new Error("Cannot play - IovPlayer id ".concat(id, " doesn't exist"));
        case 3:
          _context24.prev = 3;
          _context24.next = 6;
          return iovPlayer.initialize();
        case 6:
          _context24.next = 8;
          return iovPlayer.play();
        case 8:
          iovPlayer.logger.info('Play succeeded!');
          _context24.next = 26;
          break;
        case 11:
          _context24.prev = 11;
          _context24.t0 = _context24["catch"](3);
          this.logger.error("Error while trying to play IovPlayer ".concat(this.playerLogMessageIds[id], "..."));
          this.logger.error(_context24.t0);
          if (!(this.MAX_RETRIES_ON_PLAY_ERROR > 0 && this.retryAttempts[id] <= this.MAX_RETRIES_ON_PLAY_ERROR)) {
            _context24.next = 21;
            break;
          }
          this.logger.warn(concat_default()(_context23 = "Retry play attempt #".concat(this.retryAttempts[id]++, " for player ")).call(_context23, this.playerLogMessageIds[id], "..."));
          _context24.next = 19;
          return IovPlayerCollection_assertClassBrand(_IovPlayerCollection_brand, this, _play).call(this, id);
        case 19:
          _context24.next = 26;
          break;
        case 21:
          this.logger.error('Destroying IovPlayer after exhausting play and retry attempts');
          // emit an error event to the iov
          this.emit(_IovPlayerCollection.events.DISPLAY_ERROR_MSG, {
            error: _context24.t0
          });
          _context24.next = 25;
          return this.remove(id);
        case 25:
          throw _context24.t0;
        case 26:
        case "end":
          return _context24.stop();
      }
    }, _callee13, this, [[3, 11]]);
  }));
  return _play2.apply(this, arguments);
}
function _add(iovPlayer) {
  var id = iovPlayer.id;
  if (this.has(id)) {
    throw new Error('Cannot add an iovPlayer without a unique id');
  }
  this.players[id] = iovPlayer;
  this.playerLogMessageIds[id] = this.totalPlayersAdded;
  this.retryAttempts[id] = 0;
  this.mostRecentlyAddedId = id;
  this.playerStack.push(id);
}
_defineProperty(IovPlayerCollection, "events", {
  // Needed for videojs plugin
  VIDEO_RECEIVED: IovPlayer.events.VIDEO_RECEIVED,
  // Needed for videojs plugin
  VIDEO_INFO_RECEIVED: IovPlayer.events.VIDEO_INFO_RECEIVED,
  FIRST_FRAME_SHOWN: IovPlayer.events.FIRST_FRAME_SHOWN,
  IFRAME_DESTROYED_EXTERNALLY: IovPlayer.events.IFRAME_DESTROYED_EXTERNALLY,
  DISPLAY_ERROR_MSG: IovPlayer.events.DISPLAY_ERROR_MSG
});

;// ./src/js/iov/Iov.js













function Iov_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, Iov_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function Iov_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (Iov_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function Iov_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function Iov_classPrivateMethodInitSpec(e, a) { Iov_checkPrivateRedeclaration(e, a), a.add(e); }
function Iov_checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function Iov_assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/**
 * The Iov is responsible for:
 * - providing an interface to callers trying to play CLSP streams
 * - managing the container and video elements used for playing CLSP streams
 *
 * The caller should only ever interact with an Iov instance and the Iov
 * Collection singleton.
 */








var Iov_DEFAULT_ENABLE_METRICS = false;
var DEFAULT_CONNECTION_CHANGE_PLAY_DELAY = 5;
var CONTAINER_CLASS = 'clsp-player-container';
var VIDEO_CLASS = 'clsp-player';
var LOADING_ANIMATION_CLASS = 'clsp-player-loading-animation';
var ERROR_MSG_CLASS = 'clsp-player-error-msg';

/**
 * Internet of Video client. This module uses the MediaSource API to
 * deliver video content streamed through CLSP from distributed sources.
 */
var _Iov_brand = /*#__PURE__*/new (weak_set_default())();
var Iov = /*#__PURE__*/function (_EventEmitter) {
  function Iov(logId, id, config) {
    var _this;
    _classCallCheck(this, Iov);
    if (!utils_default().supported()) {
      throw new Error('You are using an unsupported browser - Unable to play CLSP video');
    }
    _this = Iov_callSuper(this, Iov, [logId]);
    Iov_classPrivateMethodInitSpec(_this, _Iov_brand);
    _defineProperty(_this, "onConnectionChange", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!utils_default().isOnline()) {
              _context.next = 12;
              break;
            }
            _this.logger.info('Back online...');
            _context.prev = 2;
            _context.next = 5;
            return _this.restart();
          case 5:
            _context.next = 11;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            _this.logger.error('Error while trying to restart during online event');
            _this.logger.error(_context.t0);
          case 11:
            return _context.abrupt("return");
          case 12:
            _this.logger.info('Offline!');
            _context.prev = 13;
            _context.next = 16;
            return _this.stop();
          case 16:
            _context.next = 22;
            break;
          case 18:
            _context.prev = 18;
            _context.t1 = _context["catch"](13);
            _this.logger.error('Error encountered while stopping during offline event:');
            _this.logger.error(_context.t1);
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 7], [13, 18]]);
    })));
    _defineProperty(_this, "onVisibilityChange", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!utils_default().isDocumentHidden()) {
              _context2.next = 11;
              break;
            }
            _context2.prev = 1;
            _context2.next = 4;
            return _this.stop();
          case 4:
            _context2.next = 10;
            break;
          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](1);
            _this.logger.error('Error while trying to stop during visibilityChange event');
            _this.logger.error(_context2.t0);
          case 10:
            return _context2.abrupt("return");
          case 11:
            _this.logger.info('Back in focus...');
            if (_this.streamConfiguration) {
              _context2.next = 14;
              break;
            }
            return _context2.abrupt("return");
          case 14:
            _context2.prev = 14;
            _context2.next = 17;
            return _this.restart();
          case 17:
            _context2.next = 23;
            break;
          case 19:
            _context2.prev = 19;
            _context2.t1 = _context2["catch"](14);
            _this.logger.error('Error while restarting during onVisibilityChange!');
            _this.logger.error(_context2.t1);
          case 23:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 6], [14, 19]]);
    })));
    _defineProperty(_this, "getErrorMsgContainer", function () {
      return _this.containerElement.getElementsByClassName(ERROR_MSG_CLASS)[0];
    });
    _defineProperty(_this, "getLoadingAnimation", function () {
      // Returns an HTMLCollection [] with all the loading animations
      // that exist in the container.
      return _this.containerElement.getElementsByClassName(LOADING_ANIMATION_CLASS);
    });
    _defineProperty(_this, "destroyAllLoadingAnimations", function () {
      // Remove all loading animations within the container.
      var loadingElements = _this.getLoadingAnimation();
      for (var i = 0; i < loadingElements.length; i++) {
        loadingElements[i].remove();
      }
    });
    _defineProperty(_this, "createLoadingAnimation", function () {
      // If loading animation already exists, end function.
      var loadingElements = _this.getLoadingAnimation();
      if (loadingElements.length > 0) {
        return;
      }

      // Create loading div element.
      var loadingDiv = document.createElement('div');
      loadingDiv.classList.add(LOADING_ANIMATION_CLASS);

      // Add loading div to the container.
      _this.containerElement.insertBefore(loadingDiv, _this.videoElement);
    });
    _defineProperty(_this, "clearErrorMsg", function () {
      _this.getErrorMsgContainer().style.display = 'none';
      _this.getErrorMsgContainer().innerHTML = '';
    });
    _defineProperty(_this, "displayErrorMsg", function (errorMsg) {
      var errorMsgContainer = _this.getErrorMsgContainer();
      errorMsgContainer.style.display = 'block';
      errorMsgContainer.innerHTML = errorMsg;
    });
    /**
     * If an existing container exists for holding an error msg, clear it.
     * Otherwise, create a new container element for holding an error msg.
     */
    _defineProperty(_this, "initializeErrorMsgContainer", function () {
      if (_this.getErrorMsgContainer() === undefined) {
        var errorDiv = document.createElement('div');
        errorDiv.classList.add(ERROR_MSG_CLASS);
        _this.containerElement.insertBefore(errorDiv, _this.videoElement);
      } else {
        _this.clearErrorMsg();
      }
    });
    if (isNil_default()(id)) {
      throw new Error('id is required to construct an Iov');
    }
    if (!config) {
      throw new Error('Tried to construct without config');
    }

    // @todo @metrics
    // this.metrics = {};

    _this.id = id;
    _this.shouldRetainVideoElement = false;
    _this.containerElement = null;
    _this.videoElement = null;
    _this._config = config;
    // It's worth noting here that regardless of whether or not the caller
    // passes in a videoElement to be reused, the Iov instance will always use
    // the same videoElement for all IovPlayers until the Iov is destroyed.
    // This is different from the previous implementation, which would use a
    // different videoElement for every changeSrc command.
    Iov_assertClassBrand(_Iov_brand, _this, _initializeElements).call(_this, config);
    var visibilityChangeEventName = (utils_default()).windowStateNames.visibilityChangeEventName;
    if (visibilityChangeEventName) {
      document.addEventListener(visibilityChangeEventName, _this.onVisibilityChange, false);
    }
    window.addEventListener('online', _this.onConnectionChange, false);
    window.addEventListener('offline', _this.onConnectionChange, false);

    // These can be configured manually after construction
    _this.ENABLE_METRICS = Iov_DEFAULT_ENABLE_METRICS;
    _this.CONNECTION_CHANGE_PLAY_DELAY = DEFAULT_CONNECTION_CHANGE_PLAY_DELAY;
    _this.iovPlayerCollection = IovPlayerCollection.factory("".concat(_this.logId, ".iovPlayerCollection"));

    // Needed for videojs plugin
    _this.iovPlayerCollection.on(IovPlayerCollection.events.FIRST_FRAME_SHOWN, function () {
      _this.emit(Iov.events.FIRST_FRAME_SHOWN);
    });

    // Needed for videojs plugin
    _this.iovPlayerCollection.on(IovPlayerCollection.events.VIDEO_RECEIVED, function () {
      _this.emit(Iov.events.VIDEO_RECEIVED);
    });

    // Needed for videojs plugin
    _this.iovPlayerCollection.on(IovPlayerCollection.events.VIDEO_INFO_RECEIVED, function () {
      _this.emit(Iov.events.VIDEO_INFO_RECEIVED);
    });

    // This means there's no chance of retrying...
    _this.iovPlayerCollection.on(IovPlayerCollection.events.IFRAME_DESTROYED_EXTERNALLY, function () {
      if (_this.isDestroyed) {
        _this.logger.info('Iframe was destroyed externally while in process of destroying');
        return;
      }
      _this.emit(Iov.events.IFRAME_DESTROYED_EXTERNALLY);
    });
    _this.iovPlayerCollection.on(IovPlayerCollection.events.DISPLAY_ERROR_MSG, function (error) {
      _this.logger.info('Displaying error msg to user');
      _this.videoElement.src = '';
      _this.displayErrorMsg(error.error.message);
    });
    return _this;
  }
  _inherits(Iov, _EventEmitter);
  return _createClass(Iov, [{
    key: "changeSrc",
    value: (
    /**
     * @param {StreamConfiguration|String} url
     *   The StreamConfiguration or url of the new stream
     */
    function () {
      var _changeSrc = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(url) {
        var _this2 = this;
        var iovPlayerId;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.isDestroyed) {
                _context4.next = 3;
                break;
              }
              this.logger.info('Tried to changeSrc while destroyed');
              return _context4.abrupt("return");
            case 3:
              this.logger.info('Changing Stream...');
              if (url) {
                _context4.next = 6;
                break;
              }
              throw new Error('url is required to changeSrc');
            case 6:
              this.streamConfiguration = StreamConfiguration.isStreamConfiguration(url) ? url : StreamConfiguration.fromUrl(url);
              if (!utils_default().isDocumentHidden()) {
                _context4.next = 10;
                break;
              }
              // @todo - it would be better to do something other than just log info
              // here...
              this.logger.info('Tried to changeSrc while tab was hidden!');
              return _context4.abrupt("return");
            case 10:
              if (utils_default().isOnline()) {
                _context4.next = 13;
                break;
              }
              // @todo - display 'no internet connection' indicator
              this.logger.info('Tried to changeSrc while not connected to the internet!');
              return _context4.abrupt("return");
            case 13:
              this.createLoadingAnimation();
              this.initializeErrorMsgContainer();
              _context4.next = 17;
              return (0,dist.sleepSeconds)(Math.random());
            case 17:
              _context4.prev = 17;
              _context4.next = 20;
              return this.iovPlayerCollection.create(this.containerElement, this.videoElement, this.streamConfiguration);
            case 20:
              iovPlayerId = _context4.sent;
              _context4.next = 29;
              break;
            case 23:
              _context4.prev = 23;
              _context4.t0 = _context4["catch"](17);
              this.logger.error("Error while creating / playing the player for stream ".concat(this.streamConfiguration.streamName));
              this.logger.error(_context4.t0);
              this.destroyAllLoadingAnimations();
              throw _context4.t0;
            case 29:
              if (iovPlayerId) {
                _context4.next = 32;
                break;
              }
              this.destroyAllLoadingAnimations();
              throw new Error('IovPlayer was created, but no id was returned');
            case 32:
              _context4.next = 34;
              return new (core_js_stable_promise_default())(function (resolve, reject) {
                _this2.iovPlayerCollection.on(IovPlayerCollection.events.FIRST_FRAME_SHOWN, /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(_ref3) {
                    var id;
                    return regenerator_default().wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          id = _ref3.id;
                          // Ensuring that n number of loading animations are removed.
                          _this2.destroyAllLoadingAnimations();

                          // This first frame shown was for a different player
                          if (!(iovPlayerId !== id)) {
                            _context3.next = 4;
                            break;
                          }
                          return _context3.abrupt("return");
                        case 4:
                          _this2.logger.info('Next player has received its first frame...');
                          _context3.next = 7;
                          return (0,dist.sleepSeconds)(_this2.SHOW_NEXT_VIDEO_DELAY);
                        case 7:
                          _context3.prev = 7;
                          if (!_this2.isDestroyed) {
                            _context3.next = 10;
                            break;
                          }
                          throw new Error('Next player received first frame while destroyed!');
                        case 10:
                          resolve();
                          _context3.next = 17;
                          break;
                        case 13:
                          _context3.prev = 13;
                          _context3.t0 = _context3["catch"](7);
                          _this2.logger.error('Error while handling first frame shown event!');
                          reject(_context3.t0);
                        case 17:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3, null, [[7, 13]]);
                  }));
                  return function (_x2) {
                    return _ref4.apply(this, arguments);
                  };
                }());
              });
            case 34:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[17, 23]]);
      }));
      function changeSrc(_x) {
        return _changeSrc.apply(this, arguments);
      }
      return changeSrc;
    }())
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5() {
        return regenerator_default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!this.isDestroyComplete) {
                _context5.next = 2;
                break;
              }
              throw new Error('Tried to stop while destroyed');
            case 2:
              if (!this.isStopping) {
                _context5.next = 5;
                break;
              }
              this.logger.info('Already stopping');
              return _context5.abrupt("return");
            case 5:
              this.isStopping = true;
              _context5.prev = 6;
              _context5.next = 9;
              return this.iovPlayerCollection.removeAll();
            case 9:
              _context5.prev = 9;
              this.isStopping = false;
              return _context5.finish(9);
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[6,, 9, 12]]);
      }));
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
  }, {
    key: "restart",
    value: function () {
      var _restart = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6() {
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!this.isDestroyed) {
                _context6.next = 2;
                break;
              }
              throw new Error('Tried to restart while destroyed');
            case 2:
              // @todo - this is a blunt instrument - is there a more performant (but
              // still reliable) way to restart the player as opposed to destroying it and
              // creating a new one?
              this.logger.info('Restart');
              _context6.prev = 3;
              _context6.next = 6;
              return this.stop();
            case 6:
              _context6.next = 12;
              break;
            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](3);
              this.logger.warn('Failed to stop while restarting, continuing anyway...');
              this.logger.error(_context6.t0);
            case 12:
              _context6.prev = 12;
              _context6.next = 15;
              return this.changeSrc(this.streamConfiguration);
            case 15:
              _context6.next = 21;
              break;
            case 17:
              _context6.prev = 17;
              _context6.t1 = _context6["catch"](12);
              this.logger.error('Failed to changeSrc while restarting!');

              // @todo - on failure, should we continue retrying?  maybe not since play
              // has its own retry logic in IovPlayerCollection
              throw _context6.t1;
            case 21:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[3, 8], [12, 17]]);
      }));
      function restart() {
        return _restart.apply(this, arguments);
      }
      return restart;
    }()
  }, {
    key: "enterFullscreen",
    value: function enterFullscreen() {
      if (!window.document.fullscreenElement) {
        // Since the iov and player take control of the video element and its
        // parent, ask the parent for fullscreen since the video elements will be
        // destroyed and recreated when changing sources
        this.containerElement.requestFullscreen();
      }
    }
  }, {
    key: "exitFullscreen",
    value: function exitFullscreen() {
      if (window.document.exitFullscreen) {
        window.document.exitFullscreen();
      }
    }
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      if (!window.document.fullscreenElement) {
        this.enterFullscreen();
      } else {
        this.exitFullscreen();
      }
    }

    // @todo @metrics
  }, {
    key: "metric",
    value: function metric(type, value) {
      // if (!this.ENABLE_METRICS) {
      //   return;
      // }

      // if (!Iov.METRIC_TYPES.includes(type)) {
      //   // @todo - should this throw?
      //   return;
      // }

      // this.metrics[type] = value;

      // this.trigger('metric', {
      //   type,
      //   value: this.metrics[type],
      // });
    }

    /**
     * Dereference the necessary properties, clear any intervals and timeouts, and
     * remove any listeners.  Will also destroy the player.
     *
     * @returns {Promise}
     */
  }, {
    key: "_destroy",
    value: (function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7() {
        var timeStarted, visibilityChangeEventName, timeFinished, timeToDestroy;
        return regenerator_default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              timeStarted = now_default()();
              visibilityChangeEventName = (utils_default()).windowStateNames.visibilityChangeEventName;
              if (visibilityChangeEventName) {
                document.removeEventListener(visibilityChangeEventName, this.onVisibilityChange);
              }
              window.removeEventListener('online', this.onConnectionChange);
              window.removeEventListener('offline', this.onConnectionChange);
              _context7.prev = 5;
              _context7.next = 8;
              return this.stop();
            case 8:
              _context7.next = 14;
              break;
            case 10:
              _context7.prev = 10;
              _context7.t0 = _context7["catch"](5);
              this.logger.error('Error while stopping while destroying');
              this.logger.error(_context7.t0);
            case 14:
              _context7.prev = 14;
              _context7.next = 17;
              return this.iovPlayerCollection.destroy();
            case 17:
              _context7.next = 23;
              break;
            case 19:
              _context7.prev = 19;
              _context7.t1 = _context7["catch"](14);
              this.logger.error('Error while destroying IOV Player Collection while destroying');
              this.logger.error(_context7.t1);
            case 23:
              this.streamConfiguration = null;
              Iov_assertClassBrand(_Iov_brand, this, _uninitializeElements).call(this);
              this._config = null;

              // @todo @metrics
              // this.metrics = null;
              _context7.next = 28;
              return Iov_superPropGet(Iov, "_destroy", this, 3)([]);
            case 28:
              timeFinished = now_default()();
              timeToDestroy = (timeFinished - timeStarted) / 1000;
              this.logger.info("Destroy complete in ".concat(timeToDestroy, " seconds..."));
            case 31:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[5, 10], [14, 19]]);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }())
  }, {
    key: "destroy",
    value: function () {
      var _destroy3 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee8() {
        return regenerator_default().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              // Since this Iov instance may be destroyed without the caller's explicit
              // invocation (e.g. when the iframe is destroyed externally), emit an event
              // that the caller may listen to to know when this Iov has been destroyed
              this.emit(Iov.events.DESTROYING, {
                iov: this
              });
              _context8.next = 3;
              return Iov_superPropGet(Iov, "destroy", this, 3)([]);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function destroy() {
        return _destroy3.apply(this, arguments);
      }
      return destroy;
    }()
  }], [{
    key: "factory",
    value: function factory(logId, id, config) {
      return new Iov(logId, id, config);
    }
  }]);
}(EventEmitter);
function _initializeElements(_ref5) {
  var videoElementId = _ref5.videoElementId,
    videoElement = _ref5.videoElement,
    containerElementId = _ref5.containerElementId,
    containerElement = _ref5.containerElement;
  this.logger.info('Initializing elements...');
  if (containerElementId) {
    containerElement = document.getElementById(containerElementId);
  }

  // at this point, the container element may still be falsy.  we'll handle
  // that after we determine the video element
  this.containerElement = containerElement;

  // If one or the other was passed in, CLSP Player will NOT be responsible
  // for the creation and possible deletion of any video elements on the DOM
  if (videoElementId || videoElement) {
    this.shouldRetainVideoElement = true;
  }
  if (videoElementId) {
    videoElement = document.getElementById(videoElementId);
  }
  this.videoElement = videoElement;
  if (this.shouldRetainVideoElement && !this.videoElement) {
    if (videoElementId) {
      throw new Error("Unable to get element with id: \"".concat(videoElementId, "\""));
    }
    throw new Error('No video element or id was passed');
  }

  // If we don't have either the container or the video element at this
  // point, then the caller didn't pass any elements to us.  We need at least
  // of those 2 to create a player.
  if (!this.videoElement && !this.containerElement) {
    throw new Error('Must pass at least 1 valid container or video element or id');
  }
  if (!this.videoElement) {
    videoElement = document.createElement('video');
    containerElement.appendChild(videoElement);
    this.videoElement = videoElement;
  }
  if (!this.containerElement) {
    this.containerElement = this.videoElement.parentNode;
  }

  // One final sanity check
  if (!this.containerElement || !this.videoElement) {
    throw new Error('Unable to get both the container and video elements');
  }
  this.containerElement.classList.add(CONTAINER_CLASS);
  this.videoElement.classList.add(VIDEO_CLASS);
  this.videoElement.muted = true;
  this.videoElement.playsinline = true;
}
function _uninitializeElements() {
  this.logger.info('Unnitializing elements...');

  // Ensures all loading animations are cleaned up.
  this.destroyAllLoadingAnimations();
  this.containerElement.classList.remove(CONTAINER_CLASS);
  this.videoElement.classList.remove(VIDEO_CLASS);

  // Setting the src of the video element to an empty string is
  // the only reliable way we have found to ensure that MediaSource,
  // SourceBuffer, and various Video elements are properly dereferenced
  // to avoid memory leaks
  // @todo - should these occur after stop? is there a reason they're done
  // in this order?
  this.videoElement.src = '';

  // If the CLSP Player was responsible for creating the video element,
  // completely remove it
  if (!this.shouldRetainVideoElement) {
    this.containerElement.removeChild(this.videoElement);
    this.videoElement.remove();
  }
  this.videoElement = null;
  this.containerElement = null;
}
_defineProperty(Iov, "events", {
  METRIC: 'metric',
  FIRST_FRAME_SHOWN: IovPlayer.events.FIRST_FRAME_SHOWN,
  VIDEO_RECEIVED: IovPlayer.events.VIDEO_RECEIVED,
  VIDEO_INFO_RECEIVED: IovPlayer.events.VIDEO_INFO_RECEIVED,
  IFRAME_DESTROYED_EXTERNALLY: IovPlayer.events.IFRAME_DESTROYED_EXTERNALLY,
  DESTROYING: 'destroying'
});

;// ./src/js/iov/IovCollection.js










function IovCollection_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, IovCollection_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function IovCollection_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (IovCollection_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function IovCollection_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }




// @todo - this could cause an overflow!
var totalIovCount = 0;
var IovCollection_collection;

/**
 * The Iov Collection is meant to be a singleton, and is meant to manage all
 * Iovs in a given browser window/document.  There are certain centralized
 * functions it is meant to perform, such as generating the guids that are
 * needed to establish a connection to a unique topic on the SFS, and to listen
 * to window messages and route the relevant messages to the appropriate Iov
 * instance.
 */
var IovCollection = /*#__PURE__*/function (_Destroyable) {
  /**
   * @private
   */
  function IovCollection() {
    var _this;
    _classCallCheck(this, IovCollection);
    // @todo - right now, only a single collection (index 0) is supported
    _this = IovCollection_callSuper(this, IovCollection, ['0']);
    _this.iovs = {};
    _this.pendingRemoval = {};
    return _this;
  }

  /**
   * Create an Iov for a specific stream, and add it to this collection.
   *
   * @param {String} url
   *   The url to the clsp stream
   *
   * @returns {Iov}
   */
  _inherits(IovCollection, _Destroyable);
  return _createClass(IovCollection, [{
    key: "create",
    value: function create() {
      var _this2 = this;
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var id = totalIovCount;
      totalIovCount++;
      this.logger.info("Creating Iov ".concat(id));
      var iov = Iov.factory("iov:".concat(id), id, config);
      this.logger.info("Created Iov ".concat(id));
      iov.on(Iov.events.IFRAME_DESTROYED_EXTERNALLY, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              iov.logger.info('IovCollection: iframe was destroyed, removing iov...');
              _context.prev = 1;
              _context.next = 4;
              return _this2.remove(iov.id);
            case 4:
              _context.next = 10;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              iov.logger.error('IovCollection: error while removing iov from collection!');
              iov.logger.error(_context.t0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 6]]);
      })));
      this.add(iov);
      return iov;
    }

    /**
     * Add an Iov instance to this collection.  It can then be accessed by its id.
     *
     * @param {Iov} iov
     *   The iov instance to add
     *
     * @returns {this}
     */
  }, {
    key: "add",
    value: function add(iov) {
      var id = iov.id;
      if (isNil_default()(id)) {
        throw new Error('Tried to add Iov without id');
      }
      if (this.has(id)) {
        throw new Error('Cannot add an Iov with a previously-used id');
      }
      this.logger.info("Adding Iov ".concat(id));
      this.iovs[id] = iov;
      return this;
    }

    /**
     * Determine whether or not an iov with the passed id exists in this
     * collection.
     *
     * @param {String} id
     *   The id of the iov to find
     *
     * @returns {Boolean}
     *   True if the iov with the given id exists
     *   False if the iov with the given id does not exist
     */
  }, {
    key: "has",
    value: function has(id) {
      if (isNil_default()(id)) {
        return false;
      }
      if (this.pendingRemoval[id]) {
        return false;
      }
      return Object.prototype.hasOwnProperty.call(this.iovs, id);
    }

    /**
     * Get an iov with the passed id from this collection.
     *
     * @param {String} id
     *   The id of the iov instance to get
     *
     * @returns {Iov|null}
     *   If an iov with this id doest not exist, undefined is returned.
     */
  }, {
    key: "get",
    value: function get(id) {
      if (!this.has(id)) {
        return null;
      }
      return this.iovs[id];
    }

    /**
     * Remove an iov instance from this collection and destroy it.
     *
     * @param {String} id
     *   The id of the iov to remove and destroy
     *
     * @returns {this}
     */
  }, {
    key: "remove",
    value: (function () {
      var _remove = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(id) {
        var iov;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              iov = this.get(id);
              if (!(iov === null)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _context2.prev = 3;
              this.pendingRemoval[id] = true;
              delete this.iovs[id];
              iov.logger.info('IovCollection - removing iov...');
              _context2.next = 9;
              return iov.destroy();
            case 9:
              _context2.next = 15;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](3);
              this.logger.error("Error destroying Iov ".concat(id, " while removing"));
              this.logger.error(_context2.t0);
            case 15:
              delete this.pendingRemoval[id];
              return _context2.abrupt("return", this);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 11]]);
      }));
      function remove(_x) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
    /**
     * Destroy this collection and destroy all iov instances in this collection.
     *
     * @returns {void}
     */
    )
  }, {
    key: "_destroy",
    value: (function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
        var id;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = instance_keys_default()((regenerator_default())).call((regenerator_default()), this.iovs);
            case 1:
              if ((_context3.t1 = _context3.t0()).done) {
                _context3.next = 14;
                break;
              }
              id = _context3.t1.value;
              _context3.prev = 3;
              _context3.next = 6;
              return this.remove(id);
            case 6:
              _context3.next = 12;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t2 = _context3["catch"](3);
              this.logger.error("Error while removing IOV ".concat(id, " while destroying"));
              this.logger.error(_context3.t2);
            case 12:
              _context3.next = 1;
              break;
            case 14:
              // @todo - is it safe to dereference these?
              this.iovs = null;
              this.pendingRemoval = null;
              _context3.next = 18;
              return IovCollection_superPropGet(IovCollection, "_destroy", this, 3)([]);
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[3, 8]]);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }())
  }], [{
    key: "asSingleton",
    value: function asSingleton() {
      if (!IovCollection_collection) {
        IovCollection_collection = IovCollection.factory();
      }
      return IovCollection_collection;
    }

    /**
     * @private
     */
  }, {
    key: "factory",
    value: function factory() {
      return new IovCollection();
    }
  }]);
}(Destroyable);

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/arrayWithHoles.js

function _arrayWithHoles(r) {
  if (is_array(r)) return r;
}

// EXTERNAL MODULE: ./node_modules/core-js-pure/full/instance/push.js
var push = __webpack_require__(3520);
;// ./node_modules/@babel/runtime-corejs3/helpers/esm/iterableToArrayLimit.js



function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof symbol && get_iterator_method(r) || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (push(a).call(a, e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// ./node_modules/@babel/runtime-corejs3/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/array/is-array.js
var array_is_array = __webpack_require__(6615);
var array_is_array_default = /*#__PURE__*/__webpack_require__.n(array_is_array);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js-stable/object/entries.js
var entries = __webpack_require__(8573);
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);
;// ./src/js/iov/TourController.js

















function TourController_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, TourController_isNativeReflectConstruct() ? construct_default()(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function TourController_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(construct_default()(Boolean, [], function () {})); } catch (t) {} return (TourController_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function TourController_superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }


var DEFAULT_TOUR_INTERVAL_DURATION = 10;
var DEFAULT_TOUR_PRELOAD_DURATION = 9;
var tourCount = 0;
var TourController = /*#__PURE__*/function (_EventEmitter) {
  function TourController(iovCollection, videoElementId) {
    var _this;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, TourController);
    _this = TourController_callSuper(this, TourController, [tourCount]);
    tourCount++;
    _this.iovCollection = iovCollection;
    _this.startTime = null;
    _this.streamConfigurations = [];
    _this.iov = null;
    _this.currentIndex = 0;
    _this.interval = null;
    _this.videoElementId = videoElementId;
    _this.pendingChangeSrcs = {};
    _this.options = {
      onLoaded: options.onLoad || function () {},
      onShown: options.onShown || function () {}
    };

    // These can be configured manually after construction
    _this.TOUR_INTERVAL_DURATION = DEFAULT_TOUR_INTERVAL_DURATION;
    _this.TOUR_PRELOAD_DURATION = DEFAULT_TOUR_PRELOAD_DURATION;
    return _this;
  }
  _inherits(TourController, _EventEmitter);
  return _createClass(TourController, [{
    key: "addUrls",
    value: function addUrls(urls) {
      if (!array_is_array_default()(urls)) {
        urls = [urls];
      }
      for (var i = 0; i < urls.length; i++) {
        this.streamConfigurations.push(StreamConfiguration.fromUrl(urls[i]));
      }
    }
  }, {
    key: "_cancelChangeSrc",
    value: function _cancelChangeSrc(changeSrcId) {
      if (!Object.prototype.hasOwnProperty.call(this.pendingChangeSrcs, changeSrcId)) {
        return;
      }
      this.iov.cancelChangeSrc(changeSrcId);
      if (this.pendingChangeSrcs[changeSrcId].timeout) {
        clearTimeout(this.pendingChangeSrcs[changeSrcId].timeout);
        this.pendingChangeSrcs[changeSrcId].timeout = null;
      }
      delete this.pendingChangeSrcs[changeSrcId];
    }
  }, {
    key: "_cancelAllChangeSrcs",
    value: function _cancelAllChangeSrcs() {
      for (var _i = 0, _Object$entries = entries_default()(this.pendingChangeSrcs); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 1),
          changeSrcId = _Object$entries$_i[0];
        this._cancelChangeSrc(changeSrcId);
      }
    }
  }, {
    key: "_changeSrc",
    value: function _changeSrc(index, streamConfiguration) {
      var _this2 = this;
      var stopTryingToPlayerAfter = this.TOUR_INTERVAL_DURATION + this.TOUR_PRELOAD_DURATION;
      var preloadTimeout = null;
      var changeSrcTimeout = null;
      var changeSrcId = null;
      this._cancelAllChangeSrcs();
      return new (core_js_stable_promise_default())(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(resolve, reject) {
          var onSuccess, onError, _this2$iov$changeSrc, _changeSrcId, firstFrameReceivedPromise;
          return regenerator_default().wrap(function _callee$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                onSuccess = function onSuccess() {
                  _this2.logger.debug("Successfull played ".concat(streamConfiguration.streamName));
                  if (preloadTimeout) {
                    clearTimeout(preloadTimeout);
                    preloadTimeout = null;
                  }
                  if (changeSrcTimeout) {
                    clearTimeout(changeSrcTimeout);
                    changeSrcTimeout = null;
                  }
                  delete _this2.pendingChangeSrcs[changeSrcId];
                  _this2.options.onLoaded(null, index, streamConfiguration);
                  resolve();
                };
                onError = function onError(error) {
                  _this2.logger.error(error);
                  _this2._cancelChangeSrc(changeSrcId);

                  // Note that we cancel the preloadTimeout here - an error could occur
                  // before the configured preload time, but we expect the caller (next)
                  // to perform the preload timeout task of showing the next stream
                  if (preloadTimeout) {
                    clearTimeout(preloadTimeout);
                    preloadTimeout = null;
                  }
                  if (changeSrcTimeout) {
                    clearTimeout(changeSrcTimeout);
                    changeSrcTimeout = null;
                  }
                  _this2.options.onLoaded(error, index, streamConfiguration);
                  reject(error);
                }; // If the stream hasn't loaded during the configured preload time, show
                // the empty player to let the user know there is an error
                preloadTimeout = set_timeout_default()(function () {
                  if (preloadTimeout) {
                    clearTimeout(preloadTimeout);
                    preloadTimeout = null;
                  }
                  _this2._showNextStream(0, index, streamConfiguration);
                }, _this2.TOUR_PRELOAD_DURATION * 1000);

                // There is a network timeout configured for playing the stream, which if
                // reached will throw an error at changeSrc.  However, the tour interval
                // may be shorter than the network timeout.  Therefore, if the stream has
                // not loaded during the timeout interval, we need to stop trying to load
                // it.
                changeSrcTimeout = set_timeout_default()(function () {
                  var _context;
                  onError(new Error(concat_default()(_context = "Failed to play ".concat(streamConfiguration.streamName, " after ")).call(_context, stopTryingToPlayerAfter, " seconds")));
                }, stopTryingToPlayerAfter * 1000);
                _context2.prev = 4;
                _this2$iov$changeSrc = _this2.iov.changeSrc(streamConfiguration, false), _changeSrcId = _this2$iov$changeSrc.id, firstFrameReceivedPromise = _this2$iov$changeSrc.firstFrameReceivedPromise;
                changeSrcId = _changeSrcId;
                _this2.pendingChangeSrcs[changeSrcId] = {
                  id: changeSrcId,
                  timeout: changeSrcTimeout
                };
                _context2.next = 10;
                return firstFrameReceivedPromise;
              case 10:
                onSuccess();
                _context2.next = 16;
                break;
              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](4);
                onError(_context2.t0);
              case 16:
              case "end":
                return _context2.stop();
            }
          }, _callee, null, [[4, 13]]);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "_showNextStream",
    value: function _showNextStream(nextStartTime, index, streamConfiguration) {
      var _this3 = this;
      var show = function show() {
        _this3.iov.showNextStream();
        _this3.options.onShown(null, index, streamConfiguration);
      };
      if (!nextStartTime) {
        show();
        return;
      }
      var showAfter = this.TOUR_PRELOAD_DURATION * 1000 - (now_default()() - nextStartTime);
      if (showAfter <= 0) {
        show();
        return;
      }
      set_timeout_default()(function () {
        show();
      }, showAfter);
    }
  }, {
    key: "next",
    value: function () {
      var _next = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        var playImmediately,
          resetTimer,
          nextStartTime,
          streamConfiguration,
          index,
          playSucceeded,
          _args2 = arguments;
        return regenerator_default().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              playImmediately = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              resetTimer = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
              nextStartTime = playImmediately ? 0 : now_default()(); // Start the tour list over again once the end of the stream list is reached
              if (this.currentIndex === this.streamConfigurations.length) {
                this.currentIndex = 0;
              }
              streamConfiguration = this.streamConfigurations[this.currentIndex];
              this.currentIndex++;

              // Store this locally.  Since this is asynchronous, and since next can be
              // called multiple times in a row, we don't want to read this.currentIndex
              // later and have it be the wrong incremented value.
              index = this.currentIndex;
              playSucceeded = false;
              _context3.prev = 8;
              _context3.next = 11;
              return this._changeSrc(index, streamConfiguration);
            case 11:
              playSucceeded = true;
              this._showNextStream(nextStartTime, index, streamConfiguration);
              _context3.next = 20;
              break;
            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](8);
              this.logger.error("Failed to play ".concat(streamConfiguration.streamName));
              this.logger.error(_context3.t0);
              if (!playSucceeded) {
                // Even if the stream doesn't load, we need to show the empty player
                this._showNextStream(nextStartTime, index, streamConfiguration);
              }
            case 20:
              if (!resetTimer) {
                _context3.next = 24;
                break;
              }
              clearInterval(this.interval);
              _context3.next = 24;
              return this.resume(true);
            case 24:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this, [[8, 15]]);
      }));
      function next() {
        return _next.apply(this, arguments);
      }
      return next;
    }()
  }, {
    key: "previous",
    value: function () {
      var _previous = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // @todo - this seems hacky
              if (this.currentIndex === 0) {
                this.currentIndex = this.streamConfigurations.length - 2;
              } else if (this.currentIndex === 1) {
                this.currentIndex = this.streamConfigurations.length - 1;
              } else {
                this.currentIndex -= 2;
              }
              _context4.next = 3;
              return this.next(true, true);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee3, this);
      }));
      function previous() {
        return _previous.apply(this, arguments);
      }
      return previous;
    }()
  }, {
    key: "resume",
    value: function () {
      var _resume = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4() {
        var _this4 = this;
        var force,
          wait,
          _args4 = arguments;
        return regenerator_default().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              force = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : false;
              wait = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : true;
              if (!(!force && this.interval)) {
                _context5.next = 4;
                break;
              }
              return _context5.abrupt("return");
            case 4:
              if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
              }
              if (this.nextTimeout) {
                clearTimeout(this.nextTimeout);
                this.nextTimeout = null;
              }
              if (wait) {
                _context5.next = 9;
                break;
              }
              _context5.next = 9;
              return this.next(true);
            case 9:
              this.pause();
              this.nextTimeout = set_timeout_default()(function () {
                if (_this4.nextTimeout) {
                  clearTimeout(_this4.nextTimeout);
                  _this4.nextTimeout = null;
                }

                // When the tour resumes, we want to preload the next video for the
                // configured number of seconds
                _this4.next();

                // We want all subsequent preloads to start at the configured interval
                // duration relative to the first preload (above), rather than relative
                // to the time the videos are visible.  This will ensure the videos are
                // preloading the configured amount of time before they should become
                // visible
                _this4.interval = set_interval_default()(function () {
                  _this4.next();
                }, _this4.TOUR_INTERVAL_DURATION * 1000);
              }, (this.TOUR_INTERVAL_DURATION - this.TOUR_PRELOAD_DURATION) * 1000);
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this);
      }));
      function resume() {
        return _resume.apply(this, arguments);
      }
      return resume;
    }()
    /**
     * This is meant to be the entry point to the tour.  It should only be called
     * once, at the beginning, to start the tour.
     */
  }, {
    key: "start",
    value: (function () {
      var _start = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5() {
        return regenerator_default().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.iov = this.iovCollection.create({
                videoElementId: this.videoElementId
              });
              _context6.next = 3;
              return this.resume(true, false);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee5, this);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }())
  }, {
    key: "pause",
    value: function pause() {
      if (!this.interval) {
        return;
      }
      clearInterval(this.interval);
      this.interval = null;
    }
  }, {
    key: "stop",
    value: function stop() {
      this.pause();
      this.currentIndex = 0;
    }
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6() {
        return regenerator_default().wrap(function _callee6$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.stop();
              _context7.next = 3;
              return this.resume(true);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee6, this);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }, {
    key: "fullscreen",
    value: function fullscreen() {
      if (!this.iov) {
        return;
      }
      this.iov.toggleFullscreen();
    }

    /**
     * Destroy this tour and all associated streamConfigurations and iovs
     */
  }, {
    key: "_destroy",
    value: (function () {
      var _destroy2 = _asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7() {
        var i;
        return regenerator_default().wrap(function _callee7$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              this._cancelAllChangeSrcs();
              this.pause();
              for (i = 0; i < this.streamConfigurations.length; i++) {
                this.streamConfigurations[i].destroy();
              }
              this.streamConfigurations = null;
              if (!this.iov) {
                _context8.next = 15;
                break;
              }
              _context8.prev = 5;
              _context8.next = 8;
              return this.iovCollection.remove(this.iov.id);
            case 8:
              _context8.next = 14;
              break;
            case 10:
              _context8.prev = 10;
              _context8.t0 = _context8["catch"](5);
              this.logger.error("Error while removing IOV ".concat(this.iov.id, " while destroying"));
              this.logger.error(_context8.t0);
            case 14:
              this.iov = null;
            case 15:
              this.iovCollection = null;
              this.videoElementId = null;
              _context8.next = 19;
              return TourController_superPropGet(TourController, "_destroy", this, 3)([]);
            case 19:
            case "end":
              return _context8.stop();
          }
        }, _callee7, this, [[5, 10]]);
      }));
      function _destroy() {
        return _destroy2.apply(this, arguments);
      }
      return _destroy;
    }())
  }], [{
    key: "factory",
    value: function factory(iovCollection, videoElementId, options) {
      return new TourController(iovCollection, videoElementId, options);
    }
  }]);
}(EventEmitter);

;// ./src/js/index.js







})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});